/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		168707334958949:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + window["webpackManifest"][chunkId];
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// expose the chunks object
/******/ 	__webpack_require__.s = installedChunks;
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(342);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(449)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(458);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(170);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(459);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(147)('wks');
	var uid = __webpack_require__(95);
	var Symbol = __webpack_require__(7).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(159);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.toggleLoader = toggleLoader;
	/* Action types */
	var TOGGLE_LOADER = exports.TOGGLE_LOADER = 'TOGGLE_LOADER';
	
	/* Action creators */
	
	function toggleLoader(loading) {
	  return {
	    type: TOGGLE_LOADER,
	    loading: loading
	  };
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.linkResolver = linkResolver;
	exports.navResolver = navResolver;
	exports.elementInViewport = elementInViewport;
	exports.elementVisible = elementVisible;
	exports.calcParallax = calcParallax;
	exports.assertUserDevice = assertUserDevice;
	exports.assertViewport = assertViewport;
	exports.makeContentRenderable = makeContentRenderable;
	/**
	 * Link Resolver
	 */
	
	function linkResolver(type, uid) {
	  if (type === null || uid === null) return undefined;
	  var queryPage = __webpack_require__(180)("./" + type + '/' + uid + '.json');
	  var url = queryPage.url;
	  return url;
	}
	
	/**
	 * Navigation Resolver
	 */
	
	function navResolver(type, uid) {
	  if (type === null || uid === null) return undefined;
	  var navigation = __webpack_require__(180)("./" + type + '/' + uid + '.json');
	  return navigation.data.navigation_items;
	}
	
	/**
	 * Entire element In Viewport
	 * @param {DOMElement} el The DOM Element to query
	 */
	
	function elementInViewport(el) {
	  var rect = el.getBoundingClientRect();
	  if (typeof window !== 'undefined') {
	    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /*or $(window).height() */ && rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
	    ;
	  }
	  return false;
	}
	
	/**
	 * Element Partially In Viewport
	 * @param {DOMElement} el The DOM Element to query
	 */
	
	function elementVisible(el, factorBot, factorTop) {
	  var rect = el.getBoundingClientRect();
	  var bottomFactor = factorBot || 1;
	  var topFactor = factorTop || 1;
	
	  if (typeof window !== 'undefined') {
	    return rect.bottom >= 0 ? rect.bottom <= (window.innerHeight * bottomFactor || document.documentElement.clientHeight * bottomFactor) || rect.top <= (window.innerHeight * topFactor || document.documentElement.clientHeight * topFactor) : false;
	  }
	}
	
	/**
	 * Calculate parallax transform
	 * @param {DOMElement} el The DOM Element to query
	 */
	
	function calcParallax(el, direction, value) {
	  var rect = el.getBoundingClientRect();
	  if (elementVisible(el)) {
	    switch (direction) {
	      case 'left':
	        return 'translate3d(-' + value.x + 'px, 0, 0)';
	      case 'right':
	        return 'translate3d(' + value.x + 'px, 0, 0)';
	      case 'up':
	        return 'translate3d(0, -' + value.y + 'px, 0)';
	      case 'down':
	        return 'translate3d(0, ' + value.y + 'px, 0)';
	      case 'auto':
	      default:
	        return 'translate3d(' + (value.x ? value.x + 'px' : 0) + ', ' + (value.y ? value.y + 'px' : 0) + ', 0)';
	    }
	  }
	}
	
	/**
	 * Device Assertion
	 * Asserts the users device
	 */
	
	function assertUserDevice() {
	  if (typeof navigator !== 'undefined') {
	    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPad/i)) {
	      return 'ios';
	    } else if (navigator.userAgent.match(/Android/i)) {
	      return 'android';
	    }
	  }
	  return 'desktop';
	}
	
	/**
	 * Viewport Assertion
	 * Asserts the user Viewport
	 */
	
	function assertViewport() {
	  if (typeof window !== 'undefined') {
	    var vp = document.body.clientWidth;
	    if (vp < 600) {
	      return 'DEFAULT';
	    } else if (vp < 1024) {
	      return 'MEDIUM';
	    } else if (vp < 1400) {
	      return 'LARGE';
	    } else {
	      return 'MAXWIDTH';
	    }
	  }
	}
	
	/**
	 * Make content renderable when no spans are available
	 *
	 */
	
	function makeContentRenderable(content) {
	  return content.map(function (x) {
	    if (x.type === 'embed' && !x.oembed) {
	      return undefined;
	    }
	    if (!x.spans) {
	      return _extends({}, x, {
	        spans: []
	      });
	    }
	    return x;
	  }).filter(Boolean);
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _buttonModule = __webpack_require__(300);
	
	var _buttonModule2 = _interopRequireDefault(_buttonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Button(_ref) {
	  var children = _ref.children,
	      onClick = _ref.onClick,
	      href = _ref.href,
	      regular = _ref.regular,
	      className = _ref.className,
	      props = _objectWithoutProperties(_ref, ['children', 'onClick', 'href', 'regular', 'className']);
	
	  var cssClass = [_buttonModule2.default.btn].concat(className);
	  if (regular) {
	    cssClass.push(_buttonModule2.default.regular);
	  }
	  if (href) {
	    cssClass.push(_buttonModule2.default.link);
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: cssClass.join(' '), to: href },
	      children
	    );
	  }
	  return _react2.default.createElement(
	    'button',
	    { className: cssClass.join(' '), type: 'button', onClick: onClick },
	    children
	  );
	}
	
	Button.defaultProps = {};
	
	Button.propTypes = {};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(105),
	    getRawTag = __webpack_require__(407),
	    objectToString = __webpack_require__(433);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(23)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(12);
	var ctx = __webpack_require__(129);
	var hide = __webpack_require__(24);
	var has = __webpack_require__(16);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(26);
	var createDesc = __webpack_require__(52);
	module.exports = __webpack_require__(21) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(35);
	var IE8_DOM_DEFINE = __webpack_require__(131);
	var toPrimitive = __webpack_require__(84);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(132);
	var defined = __webpack_require__(73);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(81)('wks');
	var uid = __webpack_require__(53);
	var Symbol = __webpack_require__(13).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(59);
	var createDesc = __webpack_require__(146);
	module.exports = __webpack_require__(37) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(218);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(214);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(219);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(50);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(72);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(71);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(43);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(to) {
	  window.___navigateTo(to);
	};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(136);
	var enumBugKeys = __webpack_require__(74);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(139)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var hide = __webpack_require__(30);
	var has = __webpack_require__(58);
	var SRC = __webpack_require__(95)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(29).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(467);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(468);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(174);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(469);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(470);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(471);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(472);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(175);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(117);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(473);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(474);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(475);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(476);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.bgImageFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(3);
	
	var _reactLazyload = __webpack_require__(115);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _loader = __webpack_require__(10);
	
	var loaderActions = _interopRequireWildcard(_loader);
	
	var _backgroundimageModule = __webpack_require__(299);
	
	var _backgroundimageModule2 = _interopRequireDefault(_backgroundimageModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundImageContainer = function (_React$Component) {
	  _inherits(BackgroundImageContainer, _React$Component);
	
	  function BackgroundImageContainer(props) {
	    _classCallCheck(this, BackgroundImageContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loaded: false
	    };
	    _this.onLoadHandler = _this.onLoadHandler.bind(_this);
	    return _this;
	  }
	
	  BackgroundImageContainer.prototype.onLoadHandler = function onLoadHandler() {
	    this.setState({ loaded: true });
	    this.props.toggleLoader(false);
	  };
	
	  BackgroundImageContainer.prototype.render = function render() {
	    var img = this.props.img;
	
	    var cssClass = [_backgroundimageModule2.default.bgimage];
	    if (this.state.loaded) {
	      cssClass.push(_backgroundimageModule2.default.in);
	    }
	    return _react2.default.createElement(
	      _reactLazyload2.default,
	      { height: img.dimensions.height, once: true },
	      _react2.default.createElement('img', { className: cssClass.join(' '),
	        srcSet: img.tall.url + ' 600w, ' + img.url + ' 1024w',
	        src: '' + img.url,
	        alt: '',
	        sizes: '100vw',
	        onLoad: this.onLoadHandler
	      })
	    );
	  };
	
	  return BackgroundImageContainer;
	}(_react2.default.Component);
	
	BackgroundImageContainer.defaultProps = {};
	
	BackgroundImageContainer.propTypes = {};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    toggleLoader: function toggleLoader(loading) {
	      dispatch(loaderActions.toggleLoader(loading));
	    }
	  };
	};
	
	var BackgroundImage = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BackgroundImageContainer);
	
	exports.default = BackgroundImage;
	var bgImageFragment = exports.bgImageFragment = '** extracted graphql fragment **';

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _iconModule = __webpack_require__(302);
	
	var _iconModule2 = _interopRequireDefault(_iconModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Icon(_ref) {
	  var icon = _ref.icon,
	      small = _ref.small,
	      className = _ref.className,
	      props = _objectWithoutProperties(_ref, ['icon', 'small', 'className']);
	
	  var cssClass = [_iconModule2.default.icon].concat(className);
	  if (small) {
	    cssClass.push(_iconModule2.default.small);
	  }
	  return _react2.default.createElement(
	    'svg',
	    { className: cssClass.join(' ') },
	    _react2.default.createElement('use', { xlinkHref: '/icons.svg#icon-' + icon })
	  );
	}
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mainModule = __webpack_require__(304);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainContainer = function (_React$Component) {
	  _inherits(MainContainer, _React$Component);
	
	  function MainContainer(props) {
	    _classCallCheck(this, MainContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  MainContainer.prototype.render = function render() {
	    var cssClass = [_mainModule2.default.main].concat(this.props.className);
	    return _react2.default.createElement(
	      'main',
	      { className: cssClass.join(' ') },
	      this.props.children
	    );
	  };
	
	  return MainContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var Main = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainContainer);
	
	Main.defaultProps = {};
	
	Main.propTypes = {};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.metaFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(451);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Meta(_ref) {
	  var metaTitle = _ref.metaTitle,
	      description = _ref.description,
	      metaImage = _ref.metaImage,
	      url = _ref.url,
	      title = _ref.title,
	      siteUrl = _ref.siteUrl,
	      props = _objectWithoutProperties(_ref, ['metaTitle', 'description', 'metaImage', 'url', 'title', 'siteUrl']);
	
	  var analytics = '\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag(\'js\', new Date());\n              gtag(\'config\', \'UA-58217635-2\');\n              ';
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement(
	      'title',
	      null,
	      '' + metaTitle
	    ),
	    _react2.default.createElement('meta', { property: 'og:title', content: '' + metaTitle }),
	    _react2.default.createElement('meta', { name: 'twitter:title', content: '' + metaTitle }),
	    description && [_react2.default.createElement('meta', { key: 'desc', name: 'description', content: description }), _react2.default.createElement('meta', { key: 'og-desc', property: 'og:description', content: description }), _react2.default.createElement('meta', { key: 'twitter-desc', name: 'twitter:description', content: description })],
	    url ? _react2.default.createElement('meta', { property: 'og:url', content: '' + siteUrl + url }) : _react2.default.createElement('meta', { property: 'og:url', content: '' + siteUrl }),
	    metaImage && [_react2.default.createElement('meta', { key: 'og-image', property: 'og:image', content: metaImage.url }), _react2.default.createElement('meta', { key: 'twitter-img', name: 'twitter:image', content: metaImage.url })],
	    url && _react2.default.createElement('link', { rel: 'canonical', href: '' + siteUrl + url }),
	    _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	    _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
	    _react2.default.createElement('script', { async: true, src: 'https://www.googletagmanager.com/gtag/js?id=UA-58217635-2' }),
	    _react2.default.createElement(
	      'script',
	      { key: 'analytics' },
	      analytics
	    )
	  );
	}
	
	exports.default = Meta;
	var metaFragment = exports.metaFragment = '** extracted graphql fragment **';

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _navigationModule = __webpack_require__(306);
	
	var _navigationModule2 = _interopRequireDefault(_navigationModule);
	
	var _navigation = __webpack_require__(125);
	
	var navigationActions = _interopRequireWildcard(_navigation);
	
	var _Icon = __webpack_require__(46);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Kolofon = __webpack_require__(191);
	
	var _Kolofon2 = _interopRequireDefault(_Kolofon);
	
	var _helper = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationContainer = function (_React$Component) {
	  _inherits(NavigationContainer, _React$Component);
	
	  function NavigationContainer(props) {
	    _classCallCheck(this, NavigationContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      homelink: props.homelink,
	      backlink: props.back
	    };
	    return _this;
	  }
	
	  NavigationContainer.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.home) {
	      this.props.setHomeLink(this.props.home);
	    }
	  };
	
	  NavigationContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState({
	      homelink: nextProps.homelink,
	      backlink: nextProps.back
	    });
	  };
	
	  NavigationContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.toggleNavigation(false);
	  };
	
	  NavigationContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    var cssClass = [_navigationModule2.default.nav];
	    switch (this.props.x) {
	      case 'left':
	        cssClass.push(_navigationModule2.default.left);
	        break;
	      default:
	        cssClass.push(_navigationModule2.default.right);
	    }
	    switch (this.props.y) {
	      case 'bottom':
	        cssClass.push(_navigationModule2.default.bottom);
	        break;
	      default:
	        cssClass.push(_navigationModule2.default.top);
	    }
	    return _react2.default.createElement(
	      'nav',
	      { className: cssClass.join(' ') },
	      this.props.back && _react2.default.createElement(
	        _Button2.default,
	        { href: this.state.backlink, className: _navigationModule2.default.back },
	        _react2.default.createElement(_Icon2.default, { icon: 'arrow-back', small: true })
	      ),
	      this.props.home && !this.props.onClick && _react2.default.createElement(
	        _Button2.default,
	        { href: this.state.homelink },
	        _react2.default.createElement(_Icon2.default, { icon: 'home', small: true })
	      ),
	      this.props.home && this.props.onClick && _react2.default.createElement(
	        _Button2.default,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(_Icon2.default, { icon: 'home', small: true })
	      ),
	      this.props.nav && _react2.default.createElement(
	        _Button2.default,
	        { onClick: function onClick() {
	            return _this2.props.toggleNavigation(!_this2.props.navToggled);
	          } },
	        _react2.default.createElement(_Icon2.default, { icon: 'bars', small: true })
	      ),
	      this.props.kolofon && _react2.default.createElement(
	        _Button2.default,
	        { href: this.props.kolofon },
	        _react2.default.createElement(_Icon2.default, { icon: 'info', small: true })
	      )
	    );
	  };
	
	  return NavigationContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    homelink: state.navigation.homelink,
	    navToggled: state.navigation.navToggled
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    toggleNavigation: function toggleNavigation(toggle) {
	      dispatch(navigationActions.toggleNavigation(toggle));
	    },
	    setNavigation: function setNavigation(items) {
	      dispatch(navigationActions.setNavigation(items));
	    },
	    setHomeLink: function setHomeLink(url) {
	      dispatch(navigationActions.setHomeLink(url));
	    }
	  };
	};
	
	var Navigation = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavigationContainer);
	
	Navigation.defaultProps = {};
	
	Navigation.propTypes = {};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(54);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var core = __webpack_require__(29);
	var hide = __webpack_require__(30);
	var redefine = __webpack_require__(40);
	var ctx = __webpack_require__(56);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var IE8_DOM_DEFINE = __webpack_require__(261);
	var toPrimitive = __webpack_require__(279);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(37) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(341);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(489);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(497);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(215);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(213);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(127);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(127);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(35);
	var dPs = __webpack_require__(238);
	var enumBugKeys = __webpack_require__(74);
	var IE_PROTO = __webpack_require__(80)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(130)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(232).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(26).f;
	var has = __webpack_require__(16);
	var TAG = __webpack_require__(28)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(81)('keys');
	var uid = __webpack_require__(53);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(73);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(25);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(12);
	var LIBRARY = __webpack_require__(76);
	var wksExt = __webpack_require__(86);
	var defineProperty = __webpack_require__(26).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(28);


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(55);
	var TAG = __webpack_require__(5)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	var document = __webpack_require__(7).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(54);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(59).f;
	var has = __webpack_require__(58);
	var TAG = __webpack_require__(5)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(147)('keys');
	var uid = __webpack_require__(95);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(263);
	var defined = __webpack_require__(88);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(61);
	
	var _PathUtils = __webpack_require__(32);
	
	var _createTransitionManager = __webpack_require__(101);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(61);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(32);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(100);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(154);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(155);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(9);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(18),
	    getPrototype = __webpack_require__(406),
	    isObjectLike = __webpack_require__(19);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define("PrismicReactjs", ["react"], factory);
		else if(typeof exports === 'object')
			exports["PrismicReactjs"] = factory(require("react"));
		else
			root["PrismicReactjs"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 1);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("PrismicHelpers",[],t):"object"==typeof exports?exports.PrismicHelpers=t():e.PrismicHelpers=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var u=n[r]={i:r,l:!1,exports:{}};return e[r].call(u.exports,u,u.exports,t),u.l=!0,u.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var u=n(2),o=r(u),i=n(1),f=r(i);e.exports={Link:o.default,Date:f.default}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){if(!e)return null;var t=24==e.length?e.substring(0,22)+":"+e.substring(22,24):e;return new Date(t)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={url:function(e,t){return"Document"===e.link_type?t?t(e,e.isBroken):"":e.url}}},function(e,t,n){e.exports=n(0)}])});
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(2);
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _prismicHelpers = __webpack_require__(0);
	
	var _prismicHelpers2 = _interopRequireDefault(_prismicHelpers);
	
	var _richtext = __webpack_require__(3);
	
	var _richtext2 = _interopRequireDefault(_richtext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = { Date: _prismicHelpers2.default.Date, RichText: _richtext2.default, Link: _prismicHelpers2.default.Link };
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _prismicRichtext = __webpack_require__(4);
	
	var _prismicRichtext2 = _interopRequireDefault(_prismicRichtext);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prismicHelpers = __webpack_require__(0);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function serialize(linkResolver, type, element, content, children, index) {
	  switch (type) {
	    case _prismicRichtext.Elements.heading1:
	      return serializeStandardTag('h1', element, children, index);
	    case _prismicRichtext.Elements.heading2:
	      return serializeStandardTag('h2', element, children, index);
	    case _prismicRichtext.Elements.heading3:
	      return serializeStandardTag('h3', element, children, index);
	    case _prismicRichtext.Elements.heading4:
	      return serializeStandardTag('h4', element, children, index);
	    case _prismicRichtext.Elements.heading5:
	      return serializeStandardTag('h5', element, children, index);
	    case _prismicRichtext.Elements.heading6:
	      return serializeStandardTag('h6', element, children, index);
	    case _prismicRichtext.Elements.paragraph:
	      return serializeStandardTag('p', element, children, index);
	    case _prismicRichtext.Elements.preformatted:
	      return serializeStandardTag('pre', element, children, index);
	    case _prismicRichtext.Elements.strong:
	      return serializeStandardTag('strong', element, children, index);
	    case _prismicRichtext.Elements.em:
	      return serializeStandardTag('em', element, children, index);
	    case _prismicRichtext.Elements.listItem:
	      return serializeStandardTag('li', element, children, index);
	    case _prismicRichtext.Elements.oListItem:
	      return serializeStandardTag('li', element, children, index);
	    case _prismicRichtext.Elements.list:
	      return serializeStandardTag('ul', element, children, index);
	    case _prismicRichtext.Elements.oList:
	      return serializeStandardTag('ol', element, children, index);
	    case _prismicRichtext.Elements.image:
	      return serializeImage(linkResolver, element, index);
	    case _prismicRichtext.Elements.embed:
	      return serializeEmbed(element, index);
	    case _prismicRichtext.Elements.hyperlink:
	      return serializeHyperlink(linkResolver, element, children, index);
	    case _prismicRichtext.Elements.label:
	      return serializeLabel(element, children, index);
	    case _prismicRichtext.Elements.span:
	      return serializeSpan(content);
	    default:
	      return null;
	  }
	}
	
	function propsWithUniqueKey(props, key) {
	  return Object.assign(props || {}, { key: key });
	}
	
	function serializeStandardTag(tag, element, children, key) {
	  var props = element.label ? Object.assign({}, { className: element.label }) : {};
	  return _react2.default.createElement(tag, propsWithUniqueKey(props, key), children);
	}
	
	function serializeHyperlink(linkResolver, element, children, key) {
	  var targetAttr = element.data.target ? { target: element.data.target } : {};
	  var relAttr = element.data.target ? { rel: 'noopener' } : {};
	  var props = Object.assign({ href: _prismicHelpers.Link.url(element.data, linkResolver) }, targetAttr, relAttr);
	  return _react2.default.createElement('a', propsWithUniqueKey(props, key), children);
	}
	
	function serializeLabel(element, children, key) {
	  var props = element.data ? Object.assign({}, { className: element.data.label }) : {};
	  return _react2.default.createElement('span', propsWithUniqueKey(props, key), children);
	}
	
	function serializeSpan(content) {
	  if (content) {
	    return content.split("\n").reduce(function (acc, p) {
	      if (acc.length === 0) {
	        return [p];
	      } else {
	        var brIndex = (acc.length + 1) / 2 - 1;
	        var br = _react2.default.createElement('br', propsWithUniqueKey({}, brIndex));
	        return acc.concat([br, p]);
	      }
	    }, []);
	  } else {
	    return null;
	  }
	}
	
	function serializeImage(linkResolver, element, key) {
	  var linkUrl = element.linkTo ? _prismicHelpers.Link.url(element.linkTo, linkResolver) : null;
	  var linkTarget = element.linkTo && element.linkTo.target ? { target: element.linkTo.target } : {};
	  var relAttr = linkTarget.target ? { rel: 'noopener' } : {};
	  var img = _react2.default.createElement('img', { src: element.url, alt: element.alt || '' });
	
	  return _react2.default.createElement('p', propsWithUniqueKey({ className: [element.label || '', 'block-img'].join(' ') }, key), linkUrl ? _react2.default.createElement('a', Object.assign({ href: linkUrl }, linkTarget, relAttr), img) : img);
	}
	
	function serializeEmbed(element, key) {
	  var props = Object.assign({
	    "data-oembed": element.oembed.embed_url,
	    "data-oembed-type": element.oembed.type,
	    "data-oembed-provider": element.oembed.provider_name
	  }, element.label ? { className: element.label } : {});
	
	  var embedHtml = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: element.oembed.html } });
	
	  return _react2.default.createElement('div', propsWithUniqueKey(props, key), embedHtml);
	}
	
	exports.default = {
	  asText: function asText(structuredText) {
	    return _prismicRichtext2.default.asText(structuredText);
	  },
	  render: function render(richText, linkResolver, htmlSerializer) {
	    var serializedChildren = _prismicRichtext2.default.serialize(richText, serialize.bind(null, linkResolver), htmlSerializer);
	    return _react2.default.createElement('div', propsWithUniqueKey(), serializedChildren);
	  },
	
	
	  Elements: _prismicRichtext.Elements
	};
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define("PrismicRichtext",[],n):"object"==typeof exports?exports.PrismicRichtext=n():t.PrismicRichtext=n()}(this,function(){return function(t){function n(e){if(r[e])return r[e].exports;var a=r[e]={i:e,l:!1,exports:{}};return t[e].call(a.exports,a,a.exports,n),a.l=!0,a.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=123)}([function(t,n,r){"use strict";function e(t){return function n(r,e){switch(arguments.length){case 0:return n;case 1:return Object(u.a)(r)?n:Object(a.a)(function(n){return t(r,n)});default:return Object(u.a)(r)&&Object(u.a)(e)?n:Object(u.a)(r)?Object(a.a)(function(n){return t(n,e)}):Object(u.a)(e)?Object(a.a)(function(n){return t(r,n)}):t(r,e)}}}n.a=e;var a=r(1),u=r(27)},function(t,n,r){"use strict";function e(t){return function n(r){return 0===arguments.length||Object(a.a)(r)?n:t.apply(this,arguments)}}n.a=e;var a=r(27)},function(t,n,r){"use strict";function e(t){return function n(r,e,i){switch(arguments.length){case 0:return n;case 1:return Object(c.a)(r)?n:Object(u.a)(function(n,e){return t(r,n,e)});case 2:return Object(c.a)(r)&&Object(c.a)(e)?n:Object(c.a)(r)?Object(u.a)(function(n,r){return t(n,e,r)}):Object(c.a)(e)?Object(u.a)(function(n,e){return t(r,n,e)}):Object(a.a)(function(n){return t(r,e,n)});default:return Object(c.a)(r)&&Object(c.a)(e)&&Object(c.a)(i)?n:Object(c.a)(r)&&Object(c.a)(e)?Object(u.a)(function(n,r){return t(n,r,i)}):Object(c.a)(r)&&Object(c.a)(i)?Object(u.a)(function(n,r){return t(n,e,r)}):Object(c.a)(e)&&Object(c.a)(i)?Object(u.a)(function(n,e){return t(r,n,e)}):Object(c.a)(r)?Object(a.a)(function(n){return t(n,e,i)}):Object(c.a)(e)?Object(a.a)(function(n){return t(r,n,i)}):Object(c.a)(i)?Object(a.a)(function(n){return t(r,e,n)}):t(r,e,i)}}}n.a=e;var a=r(1),u=r(0),c=r(27)},function(t,n,r){"use strict";function e(t,n,r){return function(){if(0===arguments.length)return r();var e=Array.prototype.slice.call(arguments,0),c=e.pop();if(!Object(a.a)(c)){for(var i=0;i<t.length;){if("function"==typeof c[t[i]])return c[t[i]].apply(c,e);i+=1}if(Object(u.a)(c))return n.apply(null,e)(c)}return r.apply(this,arguments)}}n.a=e;var a=r(15),u=r(43)},function(t,n,r){"use strict";n.a={init:function(){return this.xf["@@transducer/init"]()},result:function(t){return this.xf["@@transducer/result"](t)}}},function(t,n,r){"use strict";var e=r(12),a=r(1),u=r(0),c=r(29),i=Object(u.a)(function(t,n){return 1===t?Object(a.a)(n):Object(e.a)(t,Object(c.a)(t,[],n))});n.a=i},function(t,n,r){"use strict";function e(t,n){return Object.prototype.hasOwnProperty.call(n,t)}n.a=e},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(30),c=r(8),i=r(134),o=r(5),s=r(13),f=Object(e.a)(Object(a.a)(["fantasy-land/map","map"],i.a,function(t,n){switch(Object.prototype.toString.call(n)){case"[object Function]":return Object(o.a)(n.length,function(){return t.call(this,n.apply(this,arguments))});case"[object Object]":return Object(c.a)(function(r,e){return r[e]=t(n[e]),r},{},Object(s.a)(n));default:return Object(u.a)(t,n)}}));n.a=f},function(t,n,r){"use strict";function e(t,n,r){for(var e=0,a=r.length;e<a;){if((n=t["@@transducer/step"](n,r[e]))&&n["@@transducer/reduced"]){n=n["@@transducer/value"];break}e+=1}return t["@@transducer/result"](n)}function a(t,n,r){for(var e=r.next();!e.done;){if((n=t["@@transducer/step"](n,e.value))&&n["@@transducer/reduced"]){n=n["@@transducer/value"];break}e=r.next()}return t["@@transducer/result"](n)}function u(t,n,r,e){return t["@@transducer/result"](r[e](Object(s.a)(t["@@transducer/step"],t),n))}function c(t,n,r){if("function"==typeof t&&(t=Object(o.a)(t)),Object(i.a)(r))return e(t,n,r);if("function"==typeof r["fantasy-land/reduce"])return u(t,n,r,"fantasy-land/reduce");if(null!=r[f])return a(t,n,r[f]());if("function"==typeof r.next)return a(t,n,r);if("function"==typeof r.reduce)return u(t,n,r,"reduce");throw new TypeError("reduce: list must be array or iterable")}n.a=c;var i=r(31),o=r(66),s=r(67),f="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator"},function(t,n,r){"use strict";var e=r(0),a=r(157),u=Object(e.a)(function(t,n){return Object(a.a)(t,n,[],[])});n.a=u},function(t,n,r){"use strict";function e(t,n){t=t||[],n=n||[];var r,e=t.length,a=n.length,u=[];for(r=0;r<e;)u[u.length]=t[r],r+=1;for(r=0;r<a;)u[u.length]=n[r],r+=1;return u}n.a=e},function(t,n,r){"use strict";var e=r(23),a=r(2),u=Object(a.a)(Object(e.a)("slice",function(t,n,r){return Array.prototype.slice.call(r,t,n)}));n.a=u},function(t,n,r){"use strict";function e(t,n){switch(t){case 0:return function(){return n.apply(this,arguments)};case 1:return function(t){return n.apply(this,arguments)};case 2:return function(t,r){return n.apply(this,arguments)};case 3:return function(t,r,e){return n.apply(this,arguments)};case 4:return function(t,r,e,a){return n.apply(this,arguments)};case 5:return function(t,r,e,a,u){return n.apply(this,arguments)};case 6:return function(t,r,e,a,u,c){return n.apply(this,arguments)};case 7:return function(t,r,e,a,u,c,i){return n.apply(this,arguments)};case 8:return function(t,r,e,a,u,c,i,o){return n.apply(this,arguments)};case 9:return function(t,r,e,a,u,c,i,o,s){return n.apply(this,arguments)};case 10:return function(t,r,e,a,u,c,i,o,s,f){return n.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(6),u=r(68),c=!{toString:null}.propertyIsEnumerable("toString"),i=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],o=function(){return arguments.propertyIsEnumerable("length")}(),s=function(t,n){for(var r=0;r<t.length;){if(t[r]===n)return!0;r+=1}return!1},f="function"!=typeof Object.keys||o?function(t){if(Object(t)!==t)return[];var n,r,e=[],f=o&&Object(u.a)(t);for(n in t)!Object(a.a)(n,t)||f&&"length"===n||(e[e.length]=n);if(c)for(r=i.length-1;r>=0;)n=i[r],Object(a.a)(n,t)&&!s(e,n)&&(e[e.length]=n),r-=1;return e}:function(t){return Object(t)!==t?[]:Object.keys(t)},l=Object(e.a)(f);n.a=l},function(t,n,r){"use strict";var e=r(2),a=r(8),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";n.a=Array.isArray||function(t){return null!=t&&t.length>=0&&"[object Array]"===Object.prototype.toString.call(t)}},function(t,n,r){"use strict";function e(t){return t&&t["@@transducer/reduced"]?t:{"@@transducer/value":t,"@@transducer/reduced":!0}}n.a=e},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return function(){return t}});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n>t?n:t});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=n,e=0;e<t.length;){if(null==r)return;r=r[t[e]],e+=1}return r});n.a=a},function(t,n,r){"use strict";function e(t,n){return Object(a.a)(n,t,0)>=0}n.a=e;var a=r(84)},function(t,n,r){"use strict";var e=r(0),a=r(7),u=r(44),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t),n)});n.a=c},function(t,n,r){"use strict";function e(t){return"[object String]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";function e(t,n){return function(){var r=arguments.length;if(0===r)return n();var e=arguments[r-1];return Object(a.a)(e)||"function"!=typeof e[t]?n.apply(this,arguments):e[t].apply(e,Array.prototype.slice.call(arguments,0,r-1))}}n.a=e;var a=r(15)},function(t,n,r){"use strict";var e=r(1),a=r(156),u=Object(e.a)(function(t){return Object(a.a)(t,[])});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(22),u=Object(e.a)(function(t,n){var r=t<0?n.length+t:t;return Object(a.a)(n)?n.charAt(r):n[r]});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(34),u=r(5),c=r(24),i=Object(e.a)(function(t,n){return Object(u.a)(t+1,function(){var r=arguments[t];if(null!=r&&Object(a.a)(r[n]))return r[n].apply(r,Array.prototype.slice.call(arguments,0,t));throw new TypeError(Object(c.a)(r)+' does not have a method named "'+n+'"')})});n.a=i},function(t,n,r){"use strict";function e(t){return null!=t&&"object"==typeof t&&!0===t["@@functional/placeholder"]}n.a=e},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Number(t)+Number(n)});n.a=a},function(t,n,r){"use strict";function e(t,n,r){return function(){for(var c=[],i=0,o=t,s=0;s<n.length||i<arguments.length;){var f;s<n.length&&(!Object(u.a)(n[s])||i>=arguments.length)?f=n[s]:(f=arguments[i],i+=1),c[s]=f,Object(u.a)(f)||(o-=1),s+=1}return o<=0?r.apply(this,c):Object(a.a)(o,e(t,c,r))}}n.a=e;var a=r(12),u=r(27)},function(t,n,r){"use strict";function e(t,n){for(var r=0,e=n.length,a=Array(e);r<e;)a[r]=t(n[r]),r+=1;return a}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(15),u=r(22),c=Object(e.a)(function(t){return!!Object(a.a)(t)||!!t&&"object"==typeof t&&!Object(u.a)(t)&&(1===t.nodeType?!!t.length:0===t.length||t.length>0&&t.hasOwnProperty(0)&&t.hasOwnProperty(t.length-1))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e={};for(var a in r)e[a]=r[a];return e[t]=n,e});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){switch(t){case 0:return function(){return n.call(this)};case 1:return function(t){return n.call(this,t)};case 2:return function(t,r){return n.call(this,t,r)};case 3:return function(t,r,e){return n.call(this,t,r,e)};case 4:return function(t,r,e,a){return n.call(this,t,r,e,a)};case 5:return function(t,r,e,a,u){return n.call(this,t,r,e,a,u)};case 6:return function(t,r,e,a,u,c){return n.call(this,t,r,e,a,u,c)};case 7:return function(t,r,e,a,u,c,i){return n.call(this,t,r,e,a,u,c,i)};case 8:return function(t,r,e,a,u,c,i,o){return n.call(this,t,r,e,a,u,c,i,o)};case 9:return function(t,r,e,a,u,c,i,o,s){return n.call(this,t,r,e,a,u,c,i,o,s)};case 10:return function(t,r,e,a,u,c,i,o,s,f){return n.call(this,t,r,e,a,u,c,i,o,s,f)};default:throw new Error("First argument to nAry must be a non-negative integer no greater than ten")}});n.a=a},function(t,n,r){"use strict";function e(t){return"[object Function]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(76),u=Object(e.a)(function(t){return Object(a.a)(t.length,t)});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(22),u=Object(e.a)(function(t){return Object(a.a)(t)?t.split("").reverse().join(""):Array.prototype.slice.call(t,0).reverse()});n.a=u},function(t,n,r){"use strict";function e(t,n,r){for(var e=0,a=r.length;e<a;){if(t(n,r[e]))return!0;e+=1}return!1}n.a=e},function(t,n,r){"use strict";var e=r(86),a=r(0),u=r(53),c=Object(a.a)(function(t,n){return Object(u.a)(Object(e.a)(t),n)});n.a=c},function(t,n,r){"use strict";var e=r(29),a=r(3),u=r(6),c=r(8),i=r(167),o=Object(e.a)(4,[],Object(a.a)([],i.a,function(t,n,r,e){return Object(c.a)(function(e,a){var c=r(a);return e[c]=t(Object(u.a)(c,e)?e[c]:n,a),e},{},e)}));n.a=o},function(t,n,r){"use strict";var e=r(1),a=r(5),u=Object(e.a)(function(t){return Object(a.a)(t.length,function(n,r){var e=Array.prototype.slice.call(arguments,0);return e[0]=r,e[1]=n,t.apply(this,e)})});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(7),u=Object(e.a)(function(t,n){return function(r){return function(e){return Object(a.a)(function(t){return n(t,e)},r(t(e)))}}});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(55),u=r(62),c=Object(e.a)(function t(n,r,e){return Object(u.a)(function(r,e,u){return Object(a.a)(e)&&Object(a.a)(u)?t(n,e,u):n(r,e,u)},r,e)});n.a=c},function(t,n,r){"use strict";function e(t){return"function"==typeof t["@@transducer/step"]}n.a=e},function(t,n,r){"use strict";var e=r(0),a=r(19),u=Object(e.a)(function(t,n){return Object(a.a)([t],n)});n.a=u},function(t,n,r){"use strict";var e=r(10),a=r(0),u=r(8),c=r(7),i=Object(a.a)(function(t,n){return"function"==typeof n["fantasy-land/ap"]?n["fantasy-land/ap"](t):"function"==typeof t.ap?t.ap(n):"function"==typeof t?function(r){return t(r)(n(r))}:Object(u.a)(function(t,r){return Object(e.a)(t,Object(c.a)(r,n))},[],t)});n.a=i},function(t,n,r){"use strict";n.a=Number.isInteger||function(t){return t<<0===t}},function(t,n,r){"use strict";var e=r(1),a=r(5),u=Object(e.a)(function(t){return Object(a.a)(t.length,t)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(77),c=r(146),i=r(7),o=Object(e.a)(Object(a.a)(["fantasy-land/chain","chain"],c.a,function(t,n){return"function"==typeof n?function(r){return t(n(r))(r)}:Object(u.a)(!1)(Object(i.a)(t,n))}));n.a=o},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return null===t?"Null":void 0===t?"Undefined":Object.prototype.toString.call(t).slice(8,-1)});n.a=a},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("compose requires at least one argument");return a.a.apply(this,Object(u.a)(arguments))}n.a=e;var a=r(81),u=r(36)},function(t,n,r){"use strict";var e=r(23),a=r(1),u=r(11),c=Object(a.a)(Object(e.a)("tail",Object(u.a)(1,1/0)));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(15),u=r(34),c=r(22),i=r(24),o=Object(e.a)(function(t,n){if(Object(a.a)(t)){if(Object(a.a)(n))return t.concat(n);throw new TypeError(Object(i.a)(n)+" is not an array")}if(Object(c.a)(t)){if(Object(c.a)(n))return t+n;throw new TypeError(Object(i.a)(n)+" is not a string")}if(null!=t&&Object(u.a)(t["fantasy-land/concat"]))return t["fantasy-land/concat"](n);if(null!=t&&Object(u.a)(t.concat))return t.concat(n);throw new TypeError(Object(i.a)(t)+' does not have a method named "concat" or "fantasy-land/concat"')});n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(54),c=r(55),i=r(8),o=r(162),s=r(13),f=Object(e.a)(Object(a.a)(["filter"],o.a,function(t,n){return Object(c.a)(n)?Object(i.a)(function(r,e){return t(n[e])&&(r[e]=n[e]),r},{},Object(s.a)(n)):Object(u.a)(t,n)}));n.a=f},function(t,n,r){"use strict";function e(t,n){for(var r=0,e=n.length,a=[];r<e;)t(n[r])&&(a[a.length]=n[r]),r+=1;return a}n.a=e},function(t,n,r){"use strict";function e(t){return"[object Object]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(2),a=r(65),u=r(17),c=Object(e.a)(function(t,n,r){return Object(a.a)(Object(u.a)(n),t,r)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(175),c=r(11),i=Object(e.a)(Object(a.a)(["take"],u.a,function(t,n){return Object(c.a)(0,t<0?1/0:t,n)}));n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(59),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";function e(t){return t}n.a=e},function(t,n,r){"use strict";var e=r(58),a=r(101),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(220);n.a="function"==typeof Object.assign?Object.assign:e.a},function(t,n,r){"use strict";var e=r(2),a=r(6),u=Object(e.a)(function(t,n,r){var e,u={};for(e in n)Object(a.a)(e,n)&&(u[e]=Object(a.a)(e,r)?t(e,n[e],r[e]):n[e]);for(e in r)Object(a.a)(e,r)&&!Object(a.a)(e,u)&&(u[e]=r[e]);return u});n.a=u},function(t,n,r){"use strict";n.__esModule=!0,n.NODE_TYPES={heading1:"heading1",heading2:"heading2",heading3:"heading3",heading4:"heading4",heading5:"heading5",heading6:"heading6",paragraph:"paragraph",preformatted:"preformatted",strong:"strong",em:"em",listItem:"list-item",oListItem:"o-list-item",list:"group-list-item",oList:"group-o-list-item",image:"image",embed:"embed",hyperlink:"hyperlink",label:"label",span:"span"},n.PRIORITIES=(e={},e[n.NODE_TYPES.heading1]=4,e[n.NODE_TYPES.heading2]=4,e[n.NODE_TYPES.heading3]=4,e[n.NODE_TYPES.heading4]=4,e[n.NODE_TYPES.heading5]=4,e[n.NODE_TYPES.heading6]=4,e[n.NODE_TYPES.paragraph]=3,e[n.NODE_TYPES.preformatted]=5,e[n.NODE_TYPES.strong]=6,e[n.NODE_TYPES.em]=6,e[n.NODE_TYPES.oList]=1,e[n.NODE_TYPES.list]=1,e[n.NODE_TYPES.listItem]=1,e[n.NODE_TYPES.oListItem]=1,e[n.NODE_TYPES.image]=1,e[n.NODE_TYPES.embed]=1,e[n.NODE_TYPES.hyperlink]=3,e[n.NODE_TYPES.label]=4,e[n.NODE_TYPES.span]=7,e);var e},function(t,n,r){"use strict";function e(t){return t.sort(function(t,n){if(t.isParentOf(n))return-1;if(n.isParentOf(t))return 1;var r=d.PRIORITIES[t.type]-d.PRIORITIES[n.type];return 0===r?t.text.length-n.text.length:r})}function a(t,n,r){return r.start<n.start?{inner:j.SpanNode.slice(r,n.start,r.end,t),outer:j.SpanNode.slice(r,r.start,n.start,t)}:r.end>n.end?{inner:j.SpanNode.slice(r,r.start,n.end,t),outer:j.SpanNode.slice(r,n.end,r.end,t)}:{inner:r}}function u(t,n){var r=n.others.reduce(function(r,e){var u=r.inner,c=r.outer,i=a(t,n.elected,e);return{inner:u.concat(i.inner),outer:i.outer?c.concat(i.outer):c}},{inner:[],outer:[]}),e=r.inner,u=r.outer;return[n.elected.setChildren(f(t,e,n.elected.boundaries()))].concat(l(t,u))}function c(t,n){return n.reduce(function(n,r){var e=p.last(n);if(e){if(e.some(function(t){return t.isParentOf(r)}))return p.init(n).concat([e.concat(r)]);var a=p.last(e);return a&&t(a,r)?p.init(n).concat([e.concat(r)]):n.concat([[r]])}return[[r]]},[])}function i(t){var n=function(t,n){return t.start-n.start},r=function(t,n){return t.end-n.end},e=p.sortWith([n,r],t);return c(function(t,n){return t.end>=n.start},e)}function o(t){if(0===t.length)throw new Error("Unable to elect node on empty list");var n=e(t);return{elected:n[0],others:n.slice(1)}}function s(t,n,r){return n.reduce(function(e,a,u){var c=[],i=0===u&&a.start>r.lower,o=u===n.length-1&&r.upper>a.end;if(i){var s=new j.TextNode(r.lower,a.start,t.slice(r.lower,a.start));c=c.concat(s)}else{var f=n[u-1];if(f&&a.start>f.end){var l=t.slice(f.end,a.start),s=new j.TextNode(f.end,a.start,l);c=c.concat(s)}}if(c=c.concat(a),o){var s=new j.TextNode(a.end,r.upper,t.slice(a.end,r.upper));c=c.concat(s)}return e.concat(c)},[])}function f(t,n,r){if(n.length>0)return s(t,l(t,n),r);var e=t.slice(r.lower,r.upper);return[new j.TextNode(r.lower,r.upper,e)]}function l(t,n){var r=p.sortBy(function(t){return t.start},n),e=i(r),a=e.map(o),c=p.flatten(a.map(function(n){return u(t,n)}));return p.sortBy(function(t){return t.start},c)}function v(t){var n=t.spans.map(function(n){var r=t.text.slice(n.start,n.end);return new j.SpanNode(n.start,n.end,n.type,r,[],n)}),r={lower:0,upper:t.text.length};return f(t.text,n,r)}n.__esModule=!0;var p=r(126),b=r(121),O=r(326),d=r(63),j=r(122),h=function(){function t(){}return t.fromRichText=function(t){return{key:b.default(),children:t.reduce(function(t,n,r){if(O.RichTextBlock.isEmbedBlock(n.type)||O.RichTextBlock.isImageBlock(n.type))return t.concat(new j.BlockNode(n.type,n));var e=v(n),a=t[t.length-1];if(O.RichTextBlock.isListItem(n.type)&&a&&a instanceof j.ListBlockNode){var u=new j.ListItemBlockNode(n,e),c=a.addChild(u);return p.init(t).concat(c)}if(O.RichTextBlock.isOrderedListItem(n.type)&&a&&a instanceof j.OrderedListBlockNode){var i=new j.OrderedListItemBlockNode(n,e),c=a.addChild(i);return p.init(t).concat(c)}if(O.RichTextBlock.isListItem(n.type)){var u=new j.ListItemBlockNode(n,e),o=new j.ListBlockNode(O.RichTextBlock.emptyList(),[u]);return t.concat(o)}if(O.RichTextBlock.isOrderedListItem(n.type)){var i=new j.OrderedListItemBlockNode(n,e),s=new j.OrderedListBlockNode(O.RichTextBlock.emptyOrderedList(),[i]);return t.concat(s)}return t.concat(new j.BlockNode(n.type,n,e))},[])}},t.NODE_TYPES=d.NODE_TYPES,t}();n.default=h},function(t,n,r){"use strict";var e=r(10),a=r(2),u=Object(a.a)(function(t,n,r){if(n>=r.length||n<-r.length)return r;var a=n<0?r.length:0,u=a+n,c=Object(e.a)(r);return c[u]=t(r[u]),c});n.a=u},function(t,n,r){"use strict";function e(t){return new a(t)}n.a=e;var a=function(){function t(t){this.f=t}return t.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},t.prototype["@@transducer/result"]=function(t){return t},t.prototype["@@transducer/step"]=function(t,n){return this.f(t,n)},t}()},function(t,n,r){"use strict";var e=r(12),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)(t.length,function(){return t.apply(n,arguments)})});n.a=u},function(t,n,r){"use strict";var e=r(6),a=Object.prototype.toString,u=function(){return"[object Arguments]"===a.call(arguments)?function(t){return"[object Arguments]"===a.call(t)}:function(t){return Object(e.a)("callee",t)}};n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t&&n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(71),c=Object(e.a)(Object(a.a)(["any"],u.a,function(t,n){for(var r=0;r<n.length;){if(t(n[r]))return!0;r+=1}return!1}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.any=!1}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.any||(t=this.xf["@@transducer/step"](t,!1)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)&&(this.any=!0,t=Object(a.a)(this.xf["@@transducer/step"](t,!0))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t.apply(this,n)});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(13),u=Object(e.a)(function(t){for(var n=Object(a.a)(t),r=n.length,e=[],u=0;u<r;)e[u]=t[n[u]],u+=1;return e});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(6),u=r(15),c=r(46),i=r(32),o=r(75),s=Object(e.a)(function t(n,r,e){if(0===n.length)return r;var s=n[0];if(n.length>1){var f=!Object(o.a)(e)&&Object(a.a)(s,e)?e[s]:Object(c.a)(n[1])?[]:{};r=t(Array.prototype.slice.call(n,1),r,f)}if(Object(c.a)(s)&&Object(u.a)(e)){var l=[].concat(e);return l[s]=r,l}return Object(i.a)(s,r,e)});n.a=s},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return null==t});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(8),u=r(45),c=r(5),i=r(7),o=Object(e.a)(function(t,n){var r=Object(c.a)(t,n);return Object(c.a)(t,function(){return Object(a.a)(u.a,Object(i.a)(r,arguments[0]),Array.prototype.slice.call(arguments,1))})});n.a=o},function(t,n,r){"use strict";function e(t){return function n(r){for(var e,u,c,i=[],o=0,s=r.length;o<s;){if(Object(a.a)(r[o]))for(e=t?n(r[o]):r[o],c=0,u=e.length;c<u;)i[i.length]=e[c],c+=1;else i[i.length]=r[o];o+=1}return i}}n.a=e;var a=r(31)},function(t,n,r){"use strict";function e(t,n,r,c){var i=function(a){for(var u=n.length,i=0;i<u;){if(t===n[i])return r[i];i+=1}n[i+1]=t,r[i+1]=a;for(var o in t)a[o]=c?e(t[o],n,r,!0):t[o];return a};switch(Object(u.a)(t)){case"Object":return i({});case"Array":return i([]);case"Date":return new Date(t.valueOf());case"RegExp":return Object(a.a)(t);default:return t}}n.a=e;var a=r(79),u=r(49)},function(t,n,r){"use strict";function e(t){return new RegExp(t.source,(t.global?"g":"")+(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.sticky?"y":"")+(t.unicode?"u":""))}n.a=e},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return!t});n.a=a},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("pipe requires at least one argument");return Object(a.a)(arguments[0].length,Object(c.a)(u.a,arguments[0],Object(i.a)(arguments)))}n.a=e;var a=r(12),u=r(153),c=r(14),i=r(51)},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("composeK requires at least one argument");var t=Array.prototype.slice.call(arguments),n=t.pop();return Object(u.a)(u.a.apply(this,Object(c.a)(a.a,t)),n)}n.a=e;var a=r(48),u=r(50),c=r(7)},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("pipeP requires at least one argument");return Object(a.a)(arguments[0].length,Object(c.a)(u.a,arguments[0],Object(i.a)(arguments)))}n.a=e;var a=r(12),u=r(155),c=r(14),i=r(51)},function(t,n,r){"use strict";function e(t,n,r){var e,u;if("function"==typeof t.indexOf)switch(typeof n){case"number":if(0===n){for(e=1/n;r<t.length;){if(0===(u=t[r])&&1/u===e)return r;r+=1}return-1}if(n!==n){for(;r<t.length;){if("number"==typeof(u=t[r])&&u!==u)return r;r+=1}return-1}return t.indexOf(n,r);case"string":case"boolean":case"function":case"undefined":return t.indexOf(n,r);case"object":if(null===n)return t.indexOf(n,r)}for(;r<t.length;){if(Object(a.a)(t[r],n))return r;r+=1}return-1}n.a=e;var a=r(9)},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t===n?0!==t||1/t==1/n:t!==t&&n!==n});n.a=a},function(t,n,r){"use strict";function e(t){return function(){return!t.apply(this,arguments)}}n.a=e},function(t,n,r){"use strict";var e=r(0),a=r(47),u=r(33),c=Object(e.a)(function(t,n){if(t>10)throw new Error("Constructor with greater than ten arguments");return 0===t?function(){return new n}:Object(a.a)(Object(u.a)(t,function(t,r,e,a,u,c,i,o,s,f){switch(arguments.length){case 1:return new n(t);case 2:return new n(t,r);case 3:return new n(t,r,e);case 4:return new n(t,r,e,a);case 5:return new n(t,r,e,a,u);case 6:return new n(t,r,e,a,u,c);case 7:return new n(t,r,e,a,u,c,i);case 8:return new n(t,r,e,a,u,c,i,o);case 9:return new n(t,r,e,a,u,c,i,o,s);case 10:return new n(t,r,e,a,u,c,i,o,s,f)}}))});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(30),u=r(5),c=r(18),i=r(21),o=r(14),s=Object(e.a)(function(t,n){return Object(u.a)(Object(o.a)(c.a,0,Object(i.a)("length",n)),function(){var r=arguments,e=this;return t.apply(e,Object(a.a)(function(t){return t.apply(e,r)},n))})});n.a=s},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return null==n||n!==n?t:n});n.a=a},function(t,n,r){"use strict";var e=r(20),a=r(0),u=Object(a.a)(function(t,n){for(var r=[],a=0,u=t.length;a<u;)Object(e.a)(t[a],n)||Object(e.a)(t[a],r)||(r[r.length]=t[a]),a+=1;return r});n.a=u},function(t,n,r){"use strict";var e=r(37),a=r(2),u=Object(a.a)(function(t,n,r){for(var a=[],u=0,c=n.length;u<c;)Object(e.a)(t,n[u],r)||Object(e.a)(t,n[u],a)||a.push(n[u]),u+=1;return a});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r={};for(var e in n)r[e]=n[e];return delete r[t],r});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e=Array.prototype.slice.call(r,0);return e.splice(t,n),e});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(172),c=r(11),i=Object(e.a)(Object(a.a)(["drop"],u.a,function(t,n){return Object(c.a)(Math.max(0,t),1/0,n)}));n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.pred=t,this.lastValue=void 0,this.seenFirstValue=!1}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){var r=!1;return this.seenFirstValue?this.pred(this.lastValue,n)&&(r=!0):this.seenFirstValue=!0,this.lastValue=n,r?t:this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(95),c=r(97),i=Object(e.a)(Object(a.a)([],u.a,function(t,n){var r=[],e=1,a=n.length;if(0!==a)for(r[0]=n[0];e<a;)t(Object(c.a)(r),n[e])||(r[r.length]=n[e]),e+=1;return r}));n.a=i},function(t,n,r){"use strict";var e=r(25),a=Object(e.a)(-1);n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t||n});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(68),u=r(15),c=r(55),i=r(22),o=Object(e.a)(function(t){return null!=t&&"function"==typeof t["fantasy-land/empty"]?t["fantasy-land/empty"]():null!=t&&null!=t.constructor&&"function"==typeof t.constructor["fantasy-land/empty"]?t.constructor["fantasy-land/empty"]():null!=t&&"function"==typeof t.empty?t.empty():null!=t&&null!=t.constructor&&"function"==typeof t.constructor.empty?t.constructor.empty():Object(u.a)(t)?[]:Object(i.a)(t)?"":Object(c.a)(t)?{}:Object(a.a)(t)?function(){return arguments}():void 0});n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(94),u=Object(e.a)(function(t,n){return Object(a.a)(t>=0?n.length-t:0,n)});n.a=u},function(t,n,r){"use strict";var e=r(216),a=r(0),u=Object(a.a)(function(t,n){for(var r,a,u=new e.a,c=[],i=0;i<n.length;)a=n[i],r=t(a),u.add(r)&&c.push(a),i+=1;return c});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r={};return r[t]=n,r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return null!=n&&n.constructor===t||n instanceof t});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(88),u=Object(e.a)(function(t){return Object(a.a)(function(){return Array.prototype.slice.call(arguments,0)},t)});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(106),u=Object(e.a)(function(t){return null!=t&&Object(a.a)(t.length)?t.length:NaN});n.a=u},function(t,n,r){"use strict";function e(t){return"[object Number]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(108),u=Object(e.a)(function(t){return Object(a.a)(t)/t.length});n.a=u},function(t,n,r){"use strict";var e=r(28),a=r(14),u=Object(a.a)(e.a,0);n.a=u},function(t,n,r){"use strict";var e=r(12),a=r(0),u=r(6),c=Object(a.a)(function(t,n){var r={};return Object(e.a)(n.length,function(){var e=t.apply(this,arguments);return Object(u.a)(e,r)||(r[e]=n.apply(this,arguments)),r[e]})});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t*n});n.a=a},function(t,n,r){"use strict";var e=r(2),a=function(t){return{value:t,map:function(n){return a(n(t))}}},u=Object(e.a)(function(t,n,r){return t(function(t){return a(n(t))})(r).value});n.a=u},function(t,n,r){"use strict";function e(t){return Object(u.a)(function(n,r){return Object(a.a)(Math.max(0,n.length-r.length),function(){return n.apply(this,t(r,arguments))})})}n.a=e;var a=r(12),u=r(0)},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r={},e=0,a=t.length;e<a;){var u=t[e];r[u]=n[u],e+=1}return r});n.a=a},function(t,n,r){"use strict";var e=r(10),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)([t],n)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(5),u=Object(e.a)(function(t,n){return Object(a.a)(n.length,function(){for(var r=[],e=0;e<n.length;)r.push(n[e].call(this,arguments[e])),e+=1;return t.apply(this,r.concat(Array.prototype.slice.call(arguments,n.length)))})});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=r.length-1;e>=0;)n=t(r[e],n),e-=1;return n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r,e=Number(n),a=0;if(e<0||isNaN(e))throw new RangeError("n must be a non-negative number");for(r=new Array(e);a<e;)r[a]=t(a),a+=1;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(45),u=r(7),c=r(114),i=r(116),o=Object(e.a)(function(t,n){return"function"==typeof n.sequence?n.sequence(t):Object(i.a)(function(t,n){return Object(a.a)(Object(u.a)(c.a,t),n)},t([]),n)});n.a=o},function(t,n,r){"use strict";var e=r(37),a=r(0),u=Object(a.a)(function(t,n){for(var r,a=0,u=n.length,c=[];a<u;)r=n[a],Object(e.a)(t,r,c)||(c[c.length]=r),a+=1;return c});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(6),u=Object(e.a)(function(t,n){for(var r in t)if(Object(a.a)(r,t)&&!t[r](n[r]))return!1;return!0});n.a=u},function(t,n,r){"use strict";function e(){var t=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(n){var r=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"==n?r:3&r|8).toString(16)})}n.__esModule=!0,n.default=e},function(t,n,r){"use strict";var e=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,n){t.__proto__=n}||function(t,n){for(var r in n)n.hasOwnProperty(r)&&(t[r]=n[r])};return function(n,r){function e(){this.constructor=n}t(n,r),n.prototype=null===r?Object.create(r):(e.prototype=r.prototype,new e)}}();n.__esModule=!0;var a=r(121),u=r(63),c=function(){function t(t,n,r){this.key=a.default(),this.type=t,this.element=n,this.children=r}return t}();n.Node=c;var i=function(t){function n(n,r,e,a,u,c){var i=t.call(this,e,c,u)||this;return i.start=n,i.end=r,i.text=a,i.children=u,i}return e(n,t),n.prototype.boundaries=function(){return{lower:this.start,upper:this.end}},n.prototype.isParentOf=function(t){return this.start<=t.start&&this.end>=t.end},n.prototype.setChildren=function(t){return new n(this.start,this.end,this.type,this.text,t,this.element)},n.slice=function(t,r,e,a){return new n(r,e,t.type,a.slice(r,e),t.children,t.element)},n}(c);n.SpanNode=i;var o=function(t){function n(n,r,e){var a={type:u.NODE_TYPES.span,start:n,end:r,text:e};return t.call(this,n,r,u.NODE_TYPES.span,e,[],a)||this}return e(n,t),n}(i);n.TextNode=o;var s=function(t){function n(n,r,e){return void 0===e&&(e=[]),t.call(this,n,r,e)||this}return e(n,t),n}(c);n.BlockNode=s;var f=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.listItem,n,r)||this}return e(n,t),n}(s);n.ListItemBlockNode=f;var l=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.oListItem,n,r)||this}return e(n,t),n}(s);n.OrderedListItemBlockNode=l;var v=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.oList,n,r)||this}return e(n,t),n.prototype.addChild=function(t){var r=this.children.concat(t);return new n(this.element,r)},n}(s);n.OrderedListBlockNode=v;var p=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.list,n,r)||this}return e(n,t),n.prototype.addChild=function(t){var r=this.children.concat(t);return new n(this.element,r)},n}(s);n.ListBlockNode=p},function(t,n,r){t.exports=r(124)},function(t,n,r){"use strict";n.__esModule=!0;var e=r(125),a=r(64),u=r(327);t.exports={asText:e.default,asTree:a.default.fromRichText,serialize:u.default,Elements:a.default.NODE_TYPES}},function(t,n,r){"use strict";function e(t,n){var r="string"==typeof n?n:" ";return t.map(function(t){return t.text}).join(r)}n.__esModule=!0,n.default=e},function(t,n,r){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=r(127);r.d(n,"F",function(){return e.a});var a=r(128);r.d(n,"T",function(){return a.a});var u=r(129);r.d(n,"__",function(){return u.a});var c=r(28);r.d(n,"add",function(){return c.a});var i=r(130);r.d(n,"addIndex",function(){return i.a});var o=r(65);r.d(n,"adjust",function(){return o.a});var s=r(131);r.d(n,"all",function(){return s.a});var f=r(133);r.d(n,"allPass",function(){return f.a});var l=r(17);r.d(n,"always",function(){return l.a});var v=r(69);r.d(n,"and",function(){return v.a});var p=r(70);r.d(n,"any",function(){return p.a});var b=r(135);r.d(n,"anyPass",function(){return b.a});var O=r(45);r.d(n,"ap",function(){return O.a});var d=r(136);r.d(n,"aperture",function(){return d.a});var j=r(139);r.d(n,"append",function(){return j.a});var h=r(72);r.d(n,"apply",function(){return h.a});var y=r(140);r.d(n,"applySpec",function(){return y.a});var g=r(141);r.d(n,"applyTo",function(){return g.a});var m=r(142);r.d(n,"ascend",function(){return m.a});var x=r(32);r.d(n,"assoc",function(){return x.a});var w=r(74);r.d(n,"assocPath",function(){return w.a});var E=r(143);r.d(n,"binary",function(){return E.a});var _=r(67);r.d(n,"bind",function(){return _.a});var S=r(144);r.d(n,"both",function(){return S.a});var N=r(145);r.d(n,"call",function(){return N.a});var T=r(48);r.d(n,"chain",function(){return T.a});var P=r(149);r.d(n,"clamp",function(){return P.a});var A=r(150);r.d(n,"clone",function(){return A.a});var k=r(151);r.d(n,"comparator",function(){return k.a});var I=r(152);r.d(n,"complement",function(){return I.a});var D=r(50);r.d(n,"compose",function(){return D.a});var B=r(82);r.d(n,"composeK",function(){return B.a});var L=r(154);r.d(n,"composeP",function(){return L.a});var Y=r(52);r.d(n,"concat",function(){return Y.a});var R=r(163);r.d(n,"cond",function(){return R.a});var q=r(164);r.d(n,"construct",function(){return q.a});var C=r(87);r.d(n,"constructN",function(){return C.a});var W=r(165);r.d(n,"contains",function(){return W.a});var M=r(88);r.d(n,"converge",function(){return M.a});var F=r(166);r.d(n,"countBy",function(){return F.a});var U=r(47);r.d(n,"curry",function(){return U.a});var z=r(5);r.d(n,"curryN",function(){return z.a});var K=r(168);r.d(n,"dec",function(){return K.a});var V=r(89);r.d(n,"defaultTo",function(){return V.a});var $=r(169);r.d(n,"descend",function(){return $.a});var H=r(90);r.d(n,"difference",function(){return H.a});var J=r(91);r.d(n,"differenceWith",function(){return J.a});var X=r(92);r.d(n,"dissoc",function(){return X.a});var Z=r(170);r.d(n,"dissocPath",function(){return Z.a});var G=r(171);r.d(n,"divide",function(){return G.a});var Q=r(94);r.d(n,"drop",function(){return Q.a});var tt=r(173);r.d(n,"dropLast",function(){return tt.a});var nt=r(177);r.d(n,"dropLastWhile",function(){return nt.a});var rt=r(180);r.d(n,"dropRepeats",function(){return rt.a});var et=r(96);r.d(n,"dropRepeatsWith",function(){return et.a});var at=r(181);r.d(n,"dropWhile",function(){return at.a});var ut=r(183);r.d(n,"either",function(){return ut.a});var ct=r(99);r.d(n,"empty",function(){return ct.a});var it=r(184);r.d(n,"endsWith",function(){return it.a});var ot=r(185);r.d(n,"eqBy",function(){return ot.a});var st=r(186);r.d(n,"eqProps",function(){return st.a});var ft=r(9);r.d(n,"equals",function(){return ft.a});var lt=r(187);r.d(n,"evolve",function(){return lt.a});var vt=r(53);r.d(n,"filter",function(){return vt.a});var pt=r(188);r.d(n,"find",function(){return pt.a});var bt=r(190);r.d(n,"findIndex",function(){return bt.a});var Ot=r(192);r.d(n,"findLast",function(){return Ot.a});var dt=r(194);r.d(n,"findLastIndex",function(){return dt.a});var jt=r(196);r.d(n,"flatten",function(){return jt.a});var ht=r(40);r.d(n,"flip",function(){return ht.a});var yt=r(197);r.d(n,"forEach",function(){return yt.a});var gt=r(198);r.d(n,"forEachObjIndexed",function(){return gt.a});var mt=r(199);r.d(n,"fromPairs",function(){return mt.a});var xt=r(200);r.d(n,"groupBy",function(){return xt.a});var wt=r(201);r.d(n,"groupWith",function(){return wt.a});var Et=r(202);r.d(n,"gt",function(){return Et.a});var _t=r(203);r.d(n,"gte",function(){return _t.a});var St=r(204);r.d(n,"has",function(){return St.a});var Nt=r(205);r.d(n,"hasIn",function(){return Nt.a});var Tt=r(206);r.d(n,"head",function(){return Tt.a});var Pt=r(85);r.d(n,"identical",function(){return Pt.a});var At=r(58);r.d(n,"identity",function(){return At.a});var kt=r(207);r.d(n,"ifElse",function(){return kt.a});var It=r(208);r.d(n,"inc",function(){return It.a});var Dt=r(209);r.d(n,"indexBy",function(){return Dt.a});var Bt=r(210);r.d(n,"indexOf",function(){return Bt.a});var Lt=r(211);r.d(n,"init",function(){return Lt.a});var Yt=r(212);r.d(n,"innerJoin",function(){return Yt.a});var Rt=r(213);r.d(n,"insert",function(){return Rt.a});var qt=r(214);r.d(n,"insertAll",function(){return qt.a});var Ct=r(215);r.d(n,"intersection",function(){return Ct.a});var Wt=r(217);r.d(n,"intersperse",function(){return Wt.a});var Mt=r(218);r.d(n,"into",function(){return Mt.a});var Ft=r(221);r.d(n,"invert",function(){return Ft.a});var Ut=r(222);r.d(n,"invertObj",function(){return Ut.a});var zt=r(26);r.d(n,"invoker",function(){return zt.a});var Kt=r(103);r.d(n,"is",function(){return Kt.a});var Vt=r(223);r.d(n,"isEmpty",function(){return Vt.a});var $t=r(75);r.d(n,"isNil",function(){return $t.a});var Ht=r(224);r.d(n,"join",function(){return Ht.a});var Jt=r(104);r.d(n,"juxt",function(){return Jt.a});var Xt=r(13);r.d(n,"keys",function(){return Xt.a});var Zt=r(225);r.d(n,"keysIn",function(){return Zt.a});var Gt=r(97);r.d(n,"last",function(){return Gt.a});var Qt=r(226);r.d(n,"lastIndexOf",function(){return Qt.a});var tn=r(105);r.d(n,"length",function(){return tn.a});var nn=r(41);r.d(n,"lens",function(){return nn.a});var rn=r(227);r.d(n,"lensIndex",function(){return rn.a});var en=r(228);r.d(n,"lensPath",function(){return en.a});var an=r(229);r.d(n,"lensProp",function(){return an.a});var un=r(35);r.d(n,"lift",function(){return un.a});var cn=r(76);r.d(n,"liftN",function(){return cn.a});var on=r(230);r.d(n,"lt",function(){return on.a});var sn=r(231);r.d(n,"lte",function(){return sn.a});var fn=r(7);r.d(n,"map",function(){return fn.a});var ln=r(232);r.d(n,"mapAccum",function(){return ln.a});var vn=r(233);r.d(n,"mapAccumRight",function(){return vn.a});var pn=r(234);r.d(n,"mapObjIndexed",function(){return pn.a});var bn=r(235);r.d(n,"match",function(){return bn.a});var On=r(236);r.d(n,"mathMod",function(){return On.a});var dn=r(18);r.d(n,"max",function(){return dn.a});var jn=r(237);r.d(n,"maxBy",function(){return jn.a});var hn=r(107);r.d(n,"mean",function(){return hn.a});var yn=r(238);r.d(n,"median",function(){return yn.a});var gn=r(239);r.d(n,"memoize",function(){return gn.a});var mn=r(109);r.d(n,"memoizeWith",function(){return mn.a});var xn=r(240);r.d(n,"merge",function(){return xn.a});var wn=r(241);r.d(n,"mergeAll",function(){return wn.a});var En=r(242);r.d(n,"mergeDeepLeft",function(){return En.a});var _n=r(243);r.d(n,"mergeDeepRight",function(){return _n.a});var Sn=r(244);r.d(n,"mergeDeepWith",function(){return Sn.a});var Nn=r(42);r.d(n,"mergeDeepWithKey",function(){return Nn.a});var Tn=r(245);r.d(n,"mergeWith",function(){return Tn.a});var Pn=r(62);r.d(n,"mergeWithKey",function(){return Pn.a});var An=r(246);r.d(n,"min",function(){return An.a});var kn=r(247);r.d(n,"minBy",function(){return kn.a});var In=r(248);r.d(n,"modulo",function(){return In.a});var Dn=r(110);r.d(n,"multiply",function(){return Dn.a});var Bn=r(33);r.d(n,"nAry",function(){return Bn.a});var Ln=r(249);r.d(n,"negate",function(){return Ln.a});var Yn=r(250);r.d(n,"none",function(){return Yn.a});var Rn=r(80);r.d(n,"not",function(){return Rn.a});var qn=r(25);r.d(n,"nth",function(){return qn.a});var Cn=r(251);r.d(n,"nthArg",function(){return Cn.a});var Wn=r(252);r.d(n,"o",function(){return Wn.a});var Mn=r(102);r.d(n,"objOf",function(){return Mn.a});var Fn=r(253);r.d(n,"of",function(){return Fn.a});var Un=r(255);r.d(n,"omit",function(){return Un.a});var zn=r(256);r.d(n,"once",function(){return zn.a});var Kn=r(98);r.d(n,"or",function(){return Kn.a});var Vn=r(111);r.d(n,"over",function(){return Vn.a});var $n=r(257);r.d(n,"pair",function(){return $n.a});var Hn=r(258);r.d(n,"partial",function(){return Hn.a});var Jn=r(259);r.d(n,"partialRight",function(){return Jn.a});var Xn=r(260);r.d(n,"partition",function(){return Xn.a});var Zn=r(19);r.d(n,"path",function(){return Zn.a});var Gn=r(261);r.d(n,"pathEq",function(){return Gn.a});var Qn=r(262);r.d(n,"pathOr",function(){return Qn.a});var tr=r(263);r.d(n,"pathSatisfies",function(){return tr.a});var nr=r(264);r.d(n,"pick",function(){return nr.a});var rr=r(113);r.d(n,"pickAll",function(){return rr.a});var er=r(265);r.d(n,"pickBy",function(){return er.a});var ar=r(81);r.d(n,"pipe",function(){return ar.a});var ur=r(266);r.d(n,"pipeK",function(){return ur.a});var cr=r(83);r.d(n,"pipeP",function(){return cr.a});var ir=r(21);r.d(n,"pluck",function(){return ir.a});var or=r(114);r.d(n,"prepend",function(){return or.a});var sr=r(267);r.d(n,"product",function(){return sr.a});var fr=r(268);r.d(n,"project",function(){return fr.a});var lr=r(44);r.d(n,"prop",function(){return lr.a});var vr=r(269);r.d(n,"propEq",function(){return vr.a});var pr=r(270);r.d(n,"propIs",function(){return pr.a});var br=r(271);r.d(n,"propOr",function(){return br.a});var Or=r(272);r.d(n,"propSatisfies",function(){return Or.a});var dr=r(273);r.d(n,"props",function(){return dr.a});var jr=r(274);r.d(n,"range",function(){return jr.a});var hr=r(14);r.d(n,"reduce",function(){return hr.a});var yr=r(39);r.d(n,"reduceBy",function(){return yr.a});var gr=r(116);r.d(n,"reduceRight",function(){return gr.a});var mr=r(275);r.d(n,"reduceWhile",function(){return mr.a});var xr=r(276);r.d(n,"reduced",function(){return xr.a});var wr=r(38);r.d(n,"reject",function(){return wr.a});var Er=r(93);r.d(n,"remove",function(){return Er.a});var _r=r(277);r.d(n,"repeat",function(){return _r.a});var Sr=r(278);r.d(n,"replace",function(){return Sr.a});var Nr=r(36);r.d(n,"reverse",function(){return Nr.a});var Tr=r(279);r.d(n,"scan",function(){return Tr.a});var Pr=r(118);r.d(n,"sequence",function(){return Pr.a});var Ar=r(280);r.d(n,"set",function(){return Ar.a});var kr=r(11);r.d(n,"slice",function(){return kr.a});var Ir=r(281);r.d(n,"sort",function(){return Ir.a});var Dr=r(282);r.d(n,"sortBy",function(){return Dr.a});var Br=r(283);r.d(n,"sortWith",function(){return Br.a});var Lr=r(284);r.d(n,"split",function(){return Lr.a});var Yr=r(285);r.d(n,"splitAt",function(){return Yr.a});var Rr=r(286);r.d(n,"splitEvery",function(){return Rr.a});var qr=r(287);r.d(n,"splitWhen",function(){return qr.a});var Cr=r(288);r.d(n,"startsWith",function(){return Cr.a});var Wr=r(289);r.d(n,"subtract",function(){return Wr.a});var Mr=r(108);r.d(n,"sum",function(){return Mr.a});var Fr=r(290);r.d(n,"symmetricDifference",function(){return Fr.a});var Ur=r(291);r.d(n,"symmetricDifferenceWith",function(){return Ur.a});var zr=r(51);r.d(n,"tail",function(){return zr.a});var Kr=r(57);r.d(n,"take",function(){return Kr.a});var Vr=r(100);r.d(n,"takeLast",function(){return Vr.a});var $r=r(292);r.d(n,"takeLastWhile",function(){return $r.a});var Hr=r(293);r.d(n,"takeWhile",function(){return Hr.a});var Jr=r(295);r.d(n,"tap",function(){return Jr.a});var Xr=r(297);r.d(n,"test",function(){return Xr.a});var Zr=r(117);r.d(n,"times",function(){return Zr.a});var Gr=r(299);r.d(n,"toLower",function(){return Gr.a});var Qr=r(300);r.d(n,"toPairs",function(){return Qr.a});var te=r(301);r.d(n,"toPairsIn",function(){return te.a});var ne=r(24);r.d(n,"toString",function(){return ne.a});var re=r(302);r.d(n,"toUpper",function(){return re.a});var ee=r(303);r.d(n,"transduce",function(){return ee.a});var ae=r(304);r.d(n,"transpose",function(){return ae.a});var ue=r(305);r.d(n,"traverse",function(){return ue.a});var ce=r(306);r.d(n,"trim",function(){return ce.a});var ie=r(307);r.d(n,"tryCatch",function(){return ie.a});var oe=r(49);r.d(n,"type",function(){return oe.a});var se=r(308);r.d(n,"unapply",function(){return se.a});var fe=r(309);r.d(n,"unary",function(){return fe.a});var le=r(310);r.d(n,"uncurryN",function(){return le.a});var ve=r(311);r.d(n,"unfold",function(){return ve.a});var pe=r(312);r.d(n,"union",function(){return pe.a});var be=r(313);r.d(n,"unionWith",function(){return be.a});var Oe=r(60);r.d(n,"uniq",function(){return Oe.a});var de=r(101);r.d(n,"uniqBy",function(){return de.a});var je=r(119);r.d(n,"uniqWith",function(){return je.a});var he=r(314);r.d(n,"unless",function(){return he.a});var ye=r(315);r.d(n,"unnest",function(){return ye.a});var ge=r(316);r.d(n,"until",function(){return ge.a});var me=r(56);r.d(n,"update",function(){return me.a});var xe=r(115);r.d(n,"useWith",function(){return xe.a});var we=r(73);r.d(n,"values",function(){return we.a});var Ee=r(317);r.d(n,"valuesIn",function(){return Ee.a});var _e=r(318);r.d(n,"view",function(){return _e.a});var Se=r(319);r.d(n,"when",function(){return Se.a});var Ne=r(120);r.d(n,"where",function(){return Ne.a});var Te=r(320);r.d(n,"whereEq",function(){return Te.a});var Pe=r(321);r.d(n,"without",function(){return Pe.a});var Ae=r(322);r.d(n,"xprod",function(){return Ae.a});var ke=r(323);r.d(n,"zip",function(){return ke.a});var Ie=r(324);r.d(n,"zipObj",function(){return Ie.a});var De=r(325);r.d(n,"zipWith",function(){return De.a})},function(t,n,r){"use strict";var e=r(17),a=Object(e.a)(!1);n.a=a},function(t,n,r){"use strict";var e=r(17),a=Object(e.a)(!0);n.a=a},function(t,n,r){"use strict";n.a={"@@functional/placeholder":!0}},function(t,n,r){"use strict";var e=r(10),a=r(1),u=r(5),c=Object(a.a)(function(t){return Object(u.a)(t.length,function(){var n=0,r=arguments[0],a=arguments[arguments.length-1],u=Array.prototype.slice.call(arguments,0);return u[0]=function(){var t=r.apply(this,Object(e.a)(arguments,[n,a]));return n+=1,t},t.apply(this,u)})});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(132),c=Object(e.a)(Object(a.a)(["all"],u.a,function(t,n){for(var r=0;r<n.length;){if(!t(n[r]))return!1;r+=1}return!0}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.all=!0}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.all&&(t=this.xf["@@transducer/step"](t,!0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)||(this.all=!1,t=Object(a.a)(this.xf["@@transducer/step"](t,!1))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(5),u=r(18),c=r(21),i=r(14),o=Object(e.a)(function(t){return Object(a.a)(Object(i.a)(u.a,0,Object(c.a)("length",t)),function(){for(var n=0,r=t.length;n<r;){if(!t[n].apply(this,arguments))return!1;n+=1}return!0})});n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.xf["@@transducer/step"](t,this.f(n))},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(5),u=r(18),c=r(21),i=r(14),o=Object(e.a)(function(t){return Object(a.a)(Object(i.a)(u.a,0,Object(c.a)("length",t)),function(){for(var n=0,r=t.length;n<r;){if(t[n].apply(this,arguments))return!0;n+=1}return!1})});n.a=o},function(t,n,r){"use strict";var e=r(137),a=r(0),u=r(3),c=r(138),i=Object(a.a)(Object(u.a)([],c.a,e.a));n.a=i},function(t,n,r){"use strict";function e(t,n){for(var r=0,e=n.length-(t-1),a=new Array(e>=0?e:0);r<e;)a[r]=Array.prototype.slice.call(n,r,r+t),r+=1;return a}n.a=e},function(t,n,r){"use strict";var e=r(10),a=r(0),u=r(4),c=function(){function t(t,n){this.xf=n,this.pos=0,this.full=!1,this.acc=new Array(t)}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.acc=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.store(n),this.full?this.xf["@@transducer/step"](t,this.getCopy()):t},t.prototype.store=function(t){this.acc[this.pos]=t,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},t.prototype.getCopy=function(){return Object(e.a)(Array.prototype.slice.call(this.acc,this.pos),Array.prototype.slice.call(this.acc,0,this.pos))},t}(),i=Object(a.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(10),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)(n,[t])});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(72),u=r(5),c=r(7),i=r(18),o=r(21),s=r(14),f=r(73),l=Object(e.a)(function t(n){return n=Object(c.a)(function(n){return"function"==typeof n?n:t(n)},n),Object(u.a)(Object(s.a)(i.a,0,Object(o.a)("length",Object(f.a)(n))),function(){var t=arguments;return Object(c.a)(function(n){return Object(a.a)(n,t)},n)})});n.a=l},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n(t)});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e=t(n),a=t(r);return e<a?-1:e>a?1:0});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(33),u=Object(e.a)(function(t){return Object(a.a)(2,t)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(34),u=r(69),c=r(35),i=Object(e.a)(function(t,n){return Object(a.a)(t)?function(){return t.apply(this,arguments)&&n.apply(this,arguments)}:Object(c.a)(u.a)(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(47),a=Object(e.a)(function(t){return t.apply(this,Array.prototype.slice.call(arguments,1))});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(147),u=r(7),c=Object(e.a)(function(t,n){return Object(u.a)(t,Object(a.a)(n))});n.a=c},function(t,n,r){"use strict";var e=r(148),a=r(31),u=r(8),c=r(4),i=function(t){return{"@@transducer/init":c.a.init,"@@transducer/result":function(n){return t["@@transducer/result"](n)},"@@transducer/step":function(n,r){var a=t["@@transducer/step"](n,r);return a["@@transducer/reduced"]?Object(e.a)(a):a}}},o=function(t){var n=i(t);return{"@@transducer/init":c.a.init,"@@transducer/result":function(t){return n["@@transducer/result"](t)},"@@transducer/step":function(t,r){return Object(a.a)(r)?Object(u.a)(n,t,r):Object(u.a)(n,t,[r])}}};n.a=o},function(t,n,r){"use strict";function e(t){return{"@@transducer/value":t,"@@transducer/reduced":!0}}n.a=e},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){if(t>n)throw new Error("min must not be greater than max in clamp(min, max, value)");return r<t?t:r>n?n:r});n.a=a},function(t,n,r){"use strict";var e=r(78),a=r(1),u=Object(a.a)(function(t){return null!=t&&"function"==typeof t.clone?t.clone():Object(e.a)(t,[],[],!0)});n.a=u},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return function(n,r){return t(n,r)?-1:t(r,n)?1:0}});n.a=a},function(t,n,r){"use strict";var e=r(35),a=r(80),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";function e(t,n){return function(){return n.call(this,t.apply(this,arguments))}}n.a=e},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("composeP requires at least one argument");return a.a.apply(this,Object(u.a)(arguments))}n.a=e;var a=r(83),u=r(36)},function(t,n,r){"use strict";function e(t,n){return function(){var r=this;return t.apply(r,arguments).then(function(t){return n.call(r,t)})}}n.a=e},function(t,n,r){"use strict";function e(t,n){var r=function(r){var u=n.concat([t]);return Object(a.a)(r,u)?"<Circular>":e(r,u)},f=function(t,n){return Object(u.a)(function(n){return Object(c.a)(n)+": "+r(t[n])},n.slice().sort())};switch(Object.prototype.toString.call(t)){case"[object Arguments]":return"(function() { return arguments; }("+Object(u.a)(r,t).join(", ")+"))";case"[object Array]":return"["+Object(u.a)(r,t).concat(f(t,Object(s.a)(function(t){return/^\d+$/.test(t)},Object(o.a)(t)))).join(", ")+"]";case"[object Boolean]":return"object"==typeof t?"new Boolean("+r(t.valueOf())+")":t.toString();case"[object Date]":return"new Date("+(isNaN(t.valueOf())?r(NaN):Object(c.a)(Object(i.a)(t)))+")";case"[object Null]":return"null";case"[object Number]":return"object"==typeof t?"new Number("+r(t.valueOf())+")":1/t==-1/0?"-0":t.toString(10);case"[object String]":return"object"==typeof t?"new String("+r(t.valueOf())+")":Object(c.a)(t);case"[object Undefined]":return"undefined";default:if("function"==typeof t.toString){var l=t.toString();if("[object Object]"!==l)return l}return"{"+f(t,Object(o.a)(t)).join(", ")+"}"}}n.a=e;var a=r(20),u=r(30),c=r(160),i=r(161),o=r(13),s=r(38)},function(t,n,r){"use strict";function e(t,n,r,e){function i(t,n){return a(t,n,r.slice(),e.slice())}var o=Object(u.a)(t),s=Object(u.a)(n);return!Object(c.a)(function(t,n){return!Object(c.a)(i,n,t)},s,o)}function a(t,n,r,u){if(Object(s.a)(t,n))return!0;var c=Object(l.a)(t);if(c!==Object(l.a)(n))return!1;if(null==t||null==n)return!1;if("function"==typeof t["fantasy-land/equals"]||"function"==typeof n["fantasy-land/equals"])return"function"==typeof t["fantasy-land/equals"]&&t["fantasy-land/equals"](n)&&"function"==typeof n["fantasy-land/equals"]&&n["fantasy-land/equals"](t);if("function"==typeof t.equals||"function"==typeof n.equals)return"function"==typeof t.equals&&t.equals(n)&&"function"==typeof n.equals&&n.equals(t);switch(c){case"Arguments":case"Array":case"Object":if("function"==typeof t.constructor&&"Promise"===Object(i.a)(t.constructor))return t===n;break;case"Boolean":case"Number":case"String":if(typeof t!=typeof n||!Object(s.a)(t.valueOf(),n.valueOf()))return!1;break;case"Date":if(!Object(s.a)(t.valueOf(),n.valueOf()))return!1;break;case"Error":return t.name===n.name&&t.message===n.message;case"RegExp":if(t.source!==n.source||t.global!==n.global||t.ignoreCase!==n.ignoreCase||t.multiline!==n.multiline||t.sticky!==n.sticky||t.unicode!==n.unicode)return!1}for(var v=r.length-1;v>=0;){if(r[v]===t)return u[v]===n;v-=1}switch(c){case"Map":return t.size===n.size&&e(t.entries(),n.entries(),r.concat([t]),u.concat([n]));case"Set":return t.size===n.size&&e(t.values(),n.values(),r.concat([t]),u.concat([n]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var p=Object(f.a)(t);if(p.length!==Object(f.a)(n).length)return!1;var b=r.concat([t]),O=u.concat([n]);for(v=p.length-1;v>=0;){var d=p[v];if(!Object(o.a)(d,n)||!a(n[d],t[d],b,O))return!1;v-=1}return!0}n.a=a;var u=r(158),c=r(37),i=r(159),o=r(6),s=r(85),f=r(13),l=r(49)},function(t,n,r){"use strict";function e(t){for(var n,r=[];!(n=t.next()).done;)r.push(n.value);return r}n.a=e},function(t,n,r){"use strict";function e(t){var n=String(t).match(/^function (\w*)/);return null==n?"":n[1]}n.a=e},function(t,n,r){"use strict";function e(t){return'"'+t.replace(/\\/g,"\\\\").replace(/[\b]/g,"\\b").replace(/\f/g,"\\f").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t").replace(/\v/g,"\\v").replace(/\0/g,"\\0").replace(/"/g,'\\"')+'"'}n.a=e},function(t,n,r){"use strict";var e=function(t){return(t<10?"0":"")+t},a="function"==typeof Date.prototype.toISOString?function(t){return t.toISOString()}:function(t){return t.getUTCFullYear()+"-"+e(t.getUTCMonth()+1)+"-"+e(t.getUTCDate())+"T"+e(t.getUTCHours())+":"+e(t.getUTCMinutes())+":"+e(t.getUTCSeconds())+"."+(t.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z"};n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.f(n)?this.xf["@@transducer/step"](t,n):t},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(12),a=r(1),u=r(7),c=r(18),i=r(14),o=Object(a.a)(function(t){var n=Object(i.a)(c.a,0,Object(u.a)(function(t){return t[0].length},t));return Object(e.a)(n,function(){for(var n=0;n<t.length;){if(t[n][0].apply(this,arguments))return t[n][1].apply(this,arguments);n+=1}})});n.a=o},function(t,n,r){"use strict";var e=r(1),a=r(87),u=Object(e.a)(function(t){return Object(a.a)(t.length,t)});n.a=u},function(t,n,r){"use strict";var e=r(20),a=r(0),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(39),a=Object(e.a)(function(t,n){return t+1},0);n.a=a},function(t,n,r){"use strict";var e=r(29),a=r(6),u=r(4),c=function(){function t(t,n,r,e){this.valueFn=t,this.valueAcc=n,this.keyFn=r,this.xf=e,this.inputs={}}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){var n;for(n in this.inputs)if(Object(a.a)(n,this.inputs)&&(t=this.xf["@@transducer/step"](t,this.inputs[n]),t["@@transducer/reduced"])){t=t["@@transducer/value"];break}return this.inputs=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){var r=this.keyFn(n);return this.inputs[r]=this.inputs[r]||[r,this.valueAcc],this.inputs[r][1]=this.valueFn(this.inputs[r][1],n),t},t}(),i=Object(e.a)(4,[],function(t,n,r,e){return new c(t,n,r,e)});n.a=i},function(t,n,r){"use strict";var e=r(28),a=Object(e.a)(-1);n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e=t(n),a=t(r);return e>a?-1:e<a?1:0});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(46),u=r(32),c=r(92),i=r(93),o=r(56),s=Object(e.a)(function t(n,r){switch(n.length){case 0:return r;case 1:return Object(a.a)(n[0])?Object(i.a)(n[0],1,r):Object(c.a)(n[0],r);default:var e=n[0],s=Array.prototype.slice.call(n,1);return null==r[e]?r:Object(a.a)(n[0])?Object(o.a)(e,t(s,r[e]),r):Object(u.a)(e,t(s,r[e]),r)}});n.a=s},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t/n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.n=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.n>0?(this.n-=1,t):this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(174),c=r(176),i=Object(e.a)(Object(a.a)([],c.a,u.a));n.a=i},function(t,n,r){"use strict";function e(t,n){return Object(a.a)(t<n.length?n.length-t:0,n)}n.a=e;var a=r(57)},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.n=t,this.i=0}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=u.a.result,t.prototype["@@transducer/step"]=function(t,n){this.i+=1;var r=0===this.n?t:this.xf["@@transducer/step"](t,n);return this.n>=0&&this.i>=this.n?Object(a.a)(r):r},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.pos=0,this.full=!1,this.acc=new Array(t)}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=function(t){return this.acc=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.full&&(t=this.xf["@@transducer/step"](t,this.acc[this.pos])),this.store(n),t},t.prototype.store=function(t){this.acc[this.pos]=t,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(178),c=r(179),i=Object(e.a)(Object(a.a)([],c.a,u.a));n.a=i},function(t,n,r){"use strict";function e(t,n){for(var r=n.length-1;r>=0&&t(n[r]);)r-=1;return Object(a.a)(0,r+1,n)}n.a=e;var a=r(11)},function(t,n,r){"use strict";var e=r(0),a=r(8),u=r(4),c=function(){function t(t,n){this.f=t,this.retained=[],this.xf=n}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.retained=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)?this.retain(t,n):this.flush(t,n)},t.prototype.flush=function(t,n){return t=Object(a.a)(this.xf["@@transducer/step"],t,this.retained),this.retained=[],this.xf["@@transducer/step"](t,n)},t.prototype.retain=function(t,n){return this.retained.push(n),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(3),u=r(95),c=r(96),i=r(9),o=Object(e.a)(Object(a.a)([],Object(u.a)(i.a),Object(c.a)(i.a)));n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(182),c=r(11),i=Object(e.a)(Object(a.a)(["dropWhile"],u.a,function(t,n){for(var r=0,e=n.length;r<e&&t(n[r]);)r+=1;return Object(c.a)(r,1/0,n)}));n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){if(this.f){if(this.f(n))return t;this.f=null}return this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(34),u=r(35),c=r(98),i=Object(e.a)(function(t,n){return Object(a.a)(t)?function(){return t.apply(this,arguments)||n.apply(this,arguments)}:Object(u.a)(c.a)(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(9),u=r(100),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t.length,n),t)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(9),u=Object(e.a)(function(t,n,r){return Object(a.a)(t(n),t(r))});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(9),u=Object(e.a)(function(t,n,r){return Object(a.a)(n[t],r[t])});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function t(n,r){var e,a,u,c={};for(a in r)e=n[a],u=typeof e,c[a]="function"===u?e(r[a]):e&&"object"===u?t(e,r[a]):r[a];return c});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(189),c=Object(e.a)(Object(a.a)(["find"],u.a,function(t,n){for(var r=0,e=n.length;r<e;){if(t(n[r]))return n[r];r+=1}}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.found=!1}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,void 0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)&&(this.found=!0,t=Object(a.a)(this.xf["@@transducer/step"](t,n))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(191),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){for(var r=0,e=n.length;r<e;){if(t(n[r]))return r;r+=1}return-1}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.idx=-1,this.found=!1}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,-1)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.idx+=1,this.f(n)&&(this.found=!0,t=Object(a.a)(this.xf["@@transducer/step"](t,this.idx))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(193),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){for(var r=n.length-1;r>=0;){if(t(n[r]))return n[r];r-=1}}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=function(t){return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t,this.last))},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)&&(this.last=n),t},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(195),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){for(var r=n.length-1;r>=0;){if(t(n[r]))return r;r-=1}return-1}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t,this.idx=-1,this.lastIdx=-1}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=function(t){return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t,this.lastIdx))},t.prototype["@@transducer/step"]=function(t,n){return this.idx+=1,this.f(n)&&(this.lastIdx=this.idx),t},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(77),u=Object(e.a)(Object(a.a)(!0));n.a=u},function(t,n,r){"use strict";var e=r(23),a=r(0),u=Object(a.a)(Object(e.a)("forEach",function(t,n){for(var r=n.length,e=0;e<r;)t(n[e]),e+=1;return n}));n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(13),u=Object(e.a)(function(t,n){for(var r=Object(a.a)(n),e=0;e<r.length;){var u=r[e];t(n[u],u,n),e+=1}return n});n.a=u},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){for(var n={},r=0;r<t.length;)n[t[r][0]]=t[r][1],r+=1;return n});n.a=a},function(t,n,r){"use strict";var e=r(23),a=r(0),u=r(39),c=Object(a.a)(Object(e.a)("groupBy",Object(u.a)(function(t,n){return null==t&&(t=[]),t.push(n),t},null)));n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=[],e=0,a=n.length;e<a;){for(var u=e+1;u<a&&t(n[u-1],n[u]);)u+=1;r.push(n.slice(e,u)),e=u}return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t>n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t>=n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(6),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t in n});n.a=a},function(t,n,r){"use strict";var e=r(25),a=Object(e.a)(0);n.a=a},function(t,n,r){"use strict";var e=r(2),a=r(5),u=Object(e.a)(function(t,n,r){return Object(a.a)(Math.max(t.length,n.length,r.length),function(){return t.apply(this,arguments)?n.apply(this,arguments):r.apply(this,arguments)})});n.a=u},function(t,n,r){"use strict";var e=r(28),a=Object(e.a)(1);n.a=a},function(t,n,r){"use strict";var e=r(39),a=Object(e.a)(function(t,n){return n},null);n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(84),u=r(15),c=Object(e.a)(function(t,n){return"function"!=typeof n.indexOf||Object(u.a)(n)?Object(a.a)(n,t,0):n.indexOf(t)});n.a=c},function(t,n,r){"use strict";var e=r(11),a=Object(e.a)(0,-1);n.a=a},function(t,n,r){"use strict";var e=r(37),a=r(2),u=r(54),c=Object(a.a)(function(t,n,r){return Object(u.a)(function(n){return Object(e.a)(t,n,r)},n)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){t=t<r.length&&t>=0?t:r.length;var e=Array.prototype.slice.call(r,0);return e.splice(t,0,n),e});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t=t<r.length&&t>=0?t:r.length,[].concat(Array.prototype.slice.call(r,0,t),n,Array.prototype.slice.call(r,t))});n.a=a},function(t,n,r){"use strict";var e=r(20),a=r(0),u=r(54),c=r(40),i=r(60),o=Object(a.a)(function(t,n){var r,a;return t.length>n.length?(r=t,a=n):(r=n,a=t),Object(i.a)(Object(u.a)(Object(c.a)(e.a)(r),a))});n.a=o},function(t,n,r){"use strict";function e(t,n,r){var e,u=typeof t;switch(u){case"string":case"number":return 0===t&&1/t==-1/0?!!r._items["-0"]||(n&&(r._items["-0"]=!0),!1):null!==r._nativeSet?n?(e=r._nativeSet.size,r._nativeSet.add(t),r._nativeSet.size===e):r._nativeSet.has(t):u in r._items?t in r._items[u]||(n&&(r._items[u][t]=!0),!1):(n&&(r._items[u]={},r._items[u][t]=!0),!1);case"boolean":if(u in r._items){var c=t?1:0;return!!r._items[u][c]||(n&&(r._items[u][c]=!0),!1)}return n&&(r._items[u]=t?[!1,!0]:[!0,!1]),!1;case"function":return null!==r._nativeSet?n?(e=r._nativeSet.size,r._nativeSet.add(t),r._nativeSet.size===e):r._nativeSet.has(t):u in r._items?!!Object(a.a)(t,r._items[u])||(n&&r._items[u].push(t),!1):(n&&(r._items[u]=[t]),!1);case"undefined":return!!r._items[u]||(n&&(r._items[u]=!0),!1);case"object":if(null===t)return!!r._items.null||(n&&(r._items.null=!0),!1);default:return u=Object.prototype.toString.call(t),u in r._items?!!Object(a.a)(t,r._items[u])||(n&&r._items[u].push(t),!1):(n&&(r._items[u]=[t]),!1)}}var a=r(20),u=function(){function t(){this._nativeSet="function"==typeof Set?new Set:null,this._items={}}return t.prototype.add=function(t){return!e(t,!0,this)},t.prototype.has=function(t){return e(t,!1,this)},t}();n.a=u},function(t,n,r){"use strict";var e=r(23),a=r(0),u=Object(a.a)(Object(e.a)("intersperse",function(t,n){for(var r=[],e=0,a=n.length;e<a;)e===a-1?r.push(n[e]):r.push(n[e],t),e+=1;return r}));n.a=u},function(t,n,r){"use strict";var e=r(78),a=r(2),u=r(43),c=r(8),i=r(219),o=Object(a.a)(function(t,n,r){return Object(u.a)(t)?Object(c.a)(n(t),t["@@transducer/init"](),r):Object(c.a)(n(Object(i.a)(t)),Object(e.a)(t,[],[],!1),r)});n.a=o},function(t,n,r){"use strict";function e(t){if(Object(i.a)(t))return t;if(Object(c.a)(t))return s;if("string"==typeof t)return f;if("object"==typeof t)return l;throw new Error("Cannot create transformer for "+t)}n.a=e;var a=r(61),u=r(59),c=r(31),i=r(43),o=r(102),s={"@@transducer/init":Array,"@@transducer/step":function(t,n){return t.push(n),t},"@@transducer/result":u.a},f={"@@transducer/init":String,"@@transducer/step":function(t,n){return t+n},"@@transducer/result":u.a},l={"@@transducer/init":Object,"@@transducer/step":function(t,n){return Object(a.a)(t,Object(c.a)(n)?Object(o.a)(n[0],n[1]):n)},"@@transducer/result":u.a}},function(t,n,r){"use strict";function e(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(t),r=1,e=arguments.length;r<e;){var u=arguments[r];if(null!=u)for(var c in u)Object(a.a)(c,u)&&(n[c]=u[c]);r+=1}return n}n.a=e;var a=r(6)},function(t,n,r){"use strict";var e=r(1),a=r(6),u=r(13),c=Object(e.a)(function(t){for(var n=Object(u.a)(t),r=n.length,e=0,c={};e<r;){var i=n[e],o=t[i],s=Object(a.a)(o,c)?c[o]:c[o]=[];s[s.length]=i,e+=1}return c});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(13),u=Object(e.a)(function(t){for(var n=Object(a.a)(t),r=n.length,e=0,u={};e<r;){var c=n[e];u[t[c]]=c,e+=1}return u});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(99),u=r(9),c=Object(e.a)(function(t){return null!=t&&Object(u.a)(t,Object(a.a)(t))});n.a=c},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(1,"join");n.a=a},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){var n,r=[];for(n in t)r[r.length]=n;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(15),u=r(9),c=Object(e.a)(function(t,n){if("function"!=typeof n.lastIndexOf||Object(a.a)(n)){for(var r=n.length-1;r>=0;){if(Object(u.a)(n[r],t))return r;r-=1}return-1}return n.lastIndexOf(t)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(41),u=r(25),c=r(56),i=Object(e.a)(function(t){return Object(a.a)(Object(u.a)(t),Object(c.a)(t))});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(74),u=r(41),c=r(19),i=Object(e.a)(function(t){return Object(u.a)(Object(c.a)(t),Object(a.a)(t))});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(32),u=r(41),c=r(44),i=Object(e.a)(function(t){return Object(u.a)(Object(c.a)(t),Object(a.a)(t))});n.a=i},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t<n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t<=n});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=0,a=r.length,u=[],c=[n];e<a;)c=t(c[0],r[e]),u[e]=c[1],e+=1;return[c[0],u]});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=r.length-1,a=[],u=[n];e>=0;)u=t(r[e],u[0]),a[e]=u[1],e-=1;return[a,u[0]]});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(8),u=r(13),c=Object(e.a)(function(t,n){return Object(a.a)(function(r,e){return r[e]=t(n[e],e,n),r},{},Object(u.a)(n))});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n.match(t)||[]});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(46),u=Object(e.a)(function(t,n){return Object(a.a)(t)?!Object(a.a)(n)||n<1?NaN:(t%n+n)%n:NaN});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)>t(n)?r:n});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(107),u=Object(e.a)(function(t){var n=t.length;if(0===n)return NaN;var r=2-n%2,e=(n-r)/2;return Object(a.a)(Array.prototype.slice.call(t,0).sort(function(t,n){return t<n?-1:t>n?1:0}).slice(e,e+r))});n.a=u},function(t,n,r){"use strict";var e=r(109),a=r(24),u=Object(e.a)(function(){return Object(a.a)(arguments)});n.a=u},function(t,n,r){"use strict";var e=r(61),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)({},t,n)});n.a=u},function(t,n,r){"use strict";var e=r(61),a=r(1),u=Object(a.a)(function(t){return e.a.apply(null,[{}].concat(t))});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(42),u=Object(e.a)(function(t,n){return Object(a.a)(function(t,n,r){return n},t,n)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(42),u=Object(e.a)(function(t,n){return Object(a.a)(function(t,n,r){return r},t,n)});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(42),u=Object(e.a)(function(t,n,r){return Object(a.a)(function(n,r,e){return t(r,e)},n,r)});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(62),u=Object(e.a)(function(t,n,r){return Object(a.a)(function(n,r,e){return t(r,e)},n,r)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n<t?n:t});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)<t(n)?r:n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t%n});n.a=a},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return-t});n.a=a},function(t,n,r){"use strict";var e=r(86),a=r(0),u=r(3),c=r(71),i=r(70),o=Object(a.a)(Object(e.a)(Object(u.a)(["any"],c.a,i.a)));n.a=o},function(t,n,r){"use strict";var e=r(1),a=r(5),u=r(25),c=Object(e.a)(function(t){var n=t<0?1:t+1;return Object(a.a)(n,function(){return Object(u.a)(t,arguments)})});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(n(r))});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(254),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";function e(t){return[t]}n.a=e},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r={},e={},a=0,u=t.length;a<u;)e[t[a]]=1,a+=1;for(var c in n)e.hasOwnProperty(c)||(r[c]=n[c]);return r});n.a=a},function(t,n,r){"use strict";var e=r(12),a=r(1),u=Object(a.a)(function(t){var n,r=!1;return Object(e.a)(t.length,function(){return r?n:(r=!0,n=t.apply(this,arguments))})});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return[t,n]});n.a=a},function(t,n,r){"use strict";var e=r(10),a=r(112),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(10),a=r(112),u=r(40),c=Object(a.a)(Object(u.a)(e.a));n.a=c},function(t,n,r){"use strict";var e=r(53),a=r(104),u=r(38),c=Object(a.a)([e.a,u.a]);n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(9),u=r(19),c=Object(e.a)(function(t,n,r){return Object(a.a)(Object(u.a)(t,r),n)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(89),u=r(19),c=Object(e.a)(function(t,n,r){return Object(a.a)(t,Object(u.a)(n,r))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(19),u=Object(e.a)(function(t,n,r){return n.length>0&&t(Object(a.a)(n,r))});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r={},e=0;e<t.length;)t[e]in n&&(r[t[e]]=n[t[e]]),e+=1;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r={};for(var e in n)t(n[e],e,n)&&(r[e]=n[e]);return r});n.a=a},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("pipeK requires at least one argument");return a.a.apply(this,Object(u.a)(arguments))}n.a=e;var a=r(82),u=r(36)},function(t,n,r){"use strict";var e=r(110),a=r(14),u=Object(a.a)(e.a,1);n.a=u},function(t,n,r){"use strict";var e=r(30),a=r(58),u=r(113),c=r(115),i=Object(c.a)(e.a,[u.a,a.a]);n.a=i},function(t,n,r){"use strict";var e=r(2),a=r(9),u=Object(e.a)(function(t,n,r){return Object(a.a)(n,r[t])});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(103),u=Object(e.a)(function(t,n,r){return Object(a.a)(t,r[n])});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(6),u=Object(e.a)(function(t,n,r){return null!=r&&Object(a.a)(n,r)?r[n]:t});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r[n])});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=t.length,e=[],a=0;a<r;)e[a]=n[t[a]],a+=1;return e});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(106),u=Object(e.a)(function(t,n){if(!Object(a.a)(t)||!Object(a.a)(n))throw new TypeError("Both arguments to range must be numbers");for(var r=[],e=t;e<n;)r.push(e),e+=1;return r});n.a=u},function(t,n,r){"use strict";var e=r(29),a=r(8),u=r(16),c=Object(e.a)(4,[],function(t,n,r,e){return Object(a.a)(function(r,e){return t(r,e)?n(r,e):Object(u.a)(r)},r,e)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(16),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(17),u=r(117),c=Object(e.a)(function(t,n){return Object(u.a)(Object(a.a)(t),n)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return r.replace(t,n)});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=0,a=r.length,u=[n];e<a;)n=t(n,r[e]),u[e+1]=n,e+=1;return u});n.a=a},function(t,n,r){"use strict";var e=r(2),a=r(17),u=r(111),c=Object(e.a)(function(t,n,r){return Object(u.a)(t,Object(a.a)(n),r)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Array.prototype.slice.call(n,0).sort(t)});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Array.prototype.slice.call(n,0).sort(function(n,r){var e=t(n),a=t(r);return e<a?-1:e>a?1:0})});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Array.prototype.slice.call(n,0).sort(function(n,r){for(var e=0,a=0;0===e&&a<t.length;)e=t[a](n,r),a+=1;return e})});n.a=a},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(1,"split");n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(105),u=r(11),c=Object(e.a)(function(t,n){return[Object(u.a)(0,t,n),Object(u.a)(t,Object(a.a)(n),n)]});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(11),u=Object(e.a)(function(t,n){if(t<=0)throw new Error("First argument to splitEvery must be a positive integer");for(var r=[],e=0;e<n.length;)r.push(Object(a.a)(e,e+=t,n));return r});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=0,e=n.length,a=[];r<e&&!t(n[r]);)a.push(n[r]),r+=1;return[a,Array.prototype.slice.call(n,r)]});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(9),u=r(57),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t.length,n),t)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Number(t)-Number(n)});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(52),u=r(90),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t,n),Object(u.a)(n,t))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(52),u=r(91),c=Object(e.a)(function(t,n,r){return Object(a.a)(Object(u.a)(t,n,r),Object(u.a)(t,r,n))});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(11),u=Object(e.a)(function(t,n){for(var r=n.length-1;r>=0&&t(n[r]);)r-=1;return Object(a.a)(r+1,1/0,n)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(294),c=r(11),i=Object(e.a)(Object(a.a)(["takeWhile"],u.a,function(t,n){for(var r=0,e=n.length;r<e&&t(n[r]);)r+=1;return Object(c.a)(0,r,n)}));n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=u.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.f(n)?this.xf["@@transducer/step"](t,n):Object(a.a)(t)},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(296),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){return t(n),n}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.f(n),this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(79),a=r(0),u=r(298),c=r(24),i=Object(a.a)(function(t,n){if(!Object(u.a)(t))throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received "+Object(c.a)(t));return Object(e.a)(t).test(n)});n.a=i},function(t,n,r){"use strict";function e(t){return"[object RegExp]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(0,"toLowerCase");n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(6),u=Object(e.a)(function(t){var n=[];for(var r in t)Object(a.a)(r,t)&&(n[n.length]=[r,t[r]]);return n});n.a=u},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){var n=[];for(var r in t)n[n.length]=[r,t[r]];return n});n.a=a},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(0,"toUpperCase");n.a=a},function(t,n,r){"use strict";var e=r(8),a=r(66),u=r(5),c=Object(u.a)(4,function(t,n,r,u){return Object(e.a)(t("function"==typeof n?Object(a.a)(n):n),r,u)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){for(var n=0,r=[];n<t.length;){for(var e=t[n],a=0;a<e.length;)void 0===r[a]&&(r[a]=[]),r[a].push(e[a]),a+=1;n+=1}return r});n.a=a},function(t,n,r){"use strict";var e=r(2),a=r(7),u=r(118),c=Object(e.a)(function(t,n,r){return"function"==typeof r["fantasy-land/traverse"]?r["fantasy-land/traverse"](n,t):Object(u.a)(t,Object(a.a)(n,r))});n.a=c},function(t,n,r){"use strict";var e=r(1),a="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff",u="​",c="function"==typeof String.prototype.trim,i=c&&!a.trim()&&u.trim()?function(t){return t.trim()}:function(t){var n=new RegExp("^["+a+"]["+a+"]*"),r=new RegExp("["+a+"]["+a+"]*$");return t.replace(n,"").replace(r,"")},o=Object(e.a)(i);n.a=o},function(t,n,r){"use strict";var e=r(12),a=r(10),u=r(0),c=Object(u.a)(function(t,n){return Object(e.a)(t.length,function(){try{return t.apply(this,arguments)}catch(t){return n.apply(this,Object(a.a)([t],arguments))}})});n.a=c},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return function(){return t(Array.prototype.slice.call(arguments,0))}});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(33),u=Object(e.a)(function(t){return Object(a.a)(1,t)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(5),u=Object(e.a)(function(t,n){return Object(a.a)(t,function(){for(var r,e=1,a=n,u=0;e<=t&&"function"==typeof a;)r=e===t?arguments.length:u+a.length,a=a.apply(this,Array.prototype.slice.call(arguments,u,r)),e+=1,u=r;return a})});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=t(n),e=[];r&&r.length;)e[e.length]=r[0],r=t(r[1]);return e});n.a=a},function(t,n,r){"use strict";var e=r(10),a=r(0),u=r(50),c=r(60),i=Object(a.a)(Object(u.a)(c.a,e.a));n.a=i},function(t,n,r){"use strict";var e=r(10),a=r(2),u=r(119),c=Object(a.a)(function(t,n,r){return Object(u.a)(t,Object(e.a)(n,r))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)?r:n(r)});n.a=a},function(t,n,r){"use strict";var e=r(59),a=r(48),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=r;!t(e);)e=n(e);return e});n.a=a},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){var n,r=[];for(n in t)r[r.length]=t[n];return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=function(t){return{value:t,"fantasy-land/map":function(){return this}}},u=Object(e.a)(function(t,n){return t(a)(n).value});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)?n(r):r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(9),u=r(7),c=r(120),i=Object(e.a)(function(t,n){return Object(c.a)(Object(u.a)(a.a,t),n)});n.a=i},function(t,n,r){"use strict";var e=r(20),a=r(0),u=r(40),c=r(38),i=Object(a.a)(function(t,n){return Object(c.a)(Object(u.a)(e.a)(t),n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r,e=0,a=t.length,u=n.length,c=[];e<a;){for(r=0;r<u;)c[c.length]=[t[e],n[r]],r+=1;e+=1}return c});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=[],e=0,a=Math.min(t.length,n.length);e<a;)r[e]=[t[e],n[e]],e+=1;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=0,e=Math.min(t.length,n.length),a={};r<e;)a[t[r]]=n[r],r+=1;return a});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=[],a=0,u=Math.min(n.length,r.length);a<u;)e[a]=t(n[a],r[a]),a+=1;return e});n.a=a},function(t,n,r){"use strict";n.__esModule=!0;var e=r(63),a=function(){function t(t,n,r){this.type=t,this.text=n,this.spans=r}return t.isEmbedBlock=function(t){return t===e.NODE_TYPES.embed},t.isImageBlock=function(t){return t===e.NODE_TYPES.image},t.isList=function(t){return t===e.NODE_TYPES.list},t.isOrderedList=function(t){return t===e.NODE_TYPES.oList},t.isListItem=function(t){return t===e.NODE_TYPES.listItem},t.isOrderedListItem=function(t){return t===e.NODE_TYPES.oListItem},t.emptyList=function(){return{type:e.NODE_TYPES.list,spans:[],text:""}},t.emptyOrderedList=function(){return{type:e.NODE_TYPES.oList,spans:[],text:""}},t}();n.RichTextBlock=a},function(t,n,r){"use strict";function e(t,n,r){return u.default.fromRichText(t).children.map(function(t,e){return a(t,n,e,r)})}function a(t,n,r,e){function a(t,r){var u=t instanceof c.SpanNode?t.text:null,i=t.children.reduce(function(t,n,r){return t.concat([a(n,r)])},[]);return e&&e(t.type,t.element,u,i,r)||n(t.type,t.element,u,i,r)}return a(t,r)}n.__esModule=!0;var u=r(64),c=r(122);n.default=e}])});
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(60);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(455);
	
	var _scrollParent = __webpack_require__(456);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(454);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(457);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(453);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(168)))

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(118);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(482);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(178);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(487);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(486);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(485);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(177);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(179);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.toggleNavigation = toggleNavigation;
	exports.setNavigation = setNavigation;
	exports.setHomeLink = setHomeLink;
	/* Action types */
	var TOGGLE_NAVIGATION = exports.TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';
	var SET_NAVIGATION = exports.SET_NAVIGATION = 'SET_NAVIGATION';
	var SET_HOME_LINK = exports.SET_HOME_LINK = 'SET_HOME_LINK';
	
	/* Action creators */
	
	function toggleNavigation(toggle) {
	  return {
	    type: TOGGLE_NAVIGATION,
	    toggle: toggle
	  };
	}
	
	function setNavigation(items) {
	  return {
	    type: SET_NAVIGATION,
	    items: items
	  };
	}
	
	function setHomeLink(url) {
	  return {
	    type: SET_HOME_LINK,
	    url: url
	  };
	}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(60);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalInner = __webpack_require__(192);
	
	var _ModalInner2 = _interopRequireDefault(_ModalInner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      show: props.show
	    };
	    _this.handleCancelAction = _this.handleCancelAction.bind(_this);
	    if (typeof window !== 'undefined') {
	      _this.modalRoot = document.getElementById('___gatsby');
	      _this.el = document.createElement('div');
	    }
	    return _this;
	  }
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    if (this.modalRoot) {
	      this.modalRoot.appendChild(this.el);
	    }
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState({
	      show: nextProps.show
	    });
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.modalRoot) {
	      this.modalRoot.removeChild(this.el);
	    }
	  };
	
	  Modal.prototype.handleCancelAction = function handleCancelAction() {
	    this.setState({
	      show: false
	    });
	    this.props.onCancel();
	  };
	
	  Modal.prototype.render = function render() {
	    if (this.el) {
	      return _reactDom2.default.createPortal(_react2.default.createElement(
	        _ModalInner2.default,
	        {
	          show: this.state.show,
	          onCancel: this.handleCancelAction
	        },
	        this.props.children
	      ), this.el);
	    }
	    return null;
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.defaultProps = {
	  selector: '#___gatsby',
	  show: false
	};
	
	Modal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  selector: _propTypes2.default.string,
	  show: _propTypes2.default.bool,
	  onCancel: _propTypes2.default.func.isRequired
	};
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(217);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(216);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(228);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	var document = __webpack_require__(13).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(21) && !__webpack_require__(23)(function () {
	  return Object.defineProperty(__webpack_require__(130)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(128);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(76);
	var $export = __webpack_require__(22);
	var redefine = __webpack_require__(137);
	var hide = __webpack_require__(24);
	var Iterators = __webpack_require__(75);
	var $iterCreate = __webpack_require__(234);
	var setToStringTag = __webpack_require__(79);
	var getPrototypeOf = __webpack_require__(240);
	var ITERATOR = __webpack_require__(28)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(51);
	var createDesc = __webpack_require__(52);
	var toIObject = __webpack_require__(27);
	var toPrimitive = __webpack_require__(84);
	var has = __webpack_require__(16);
	var IE8_DOM_DEFINE = __webpack_require__(131);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(136);
	var hiddenKeys = __webpack_require__(74).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(16);
	var toIObject = __webpack_require__(27);
	var arrayIndexOf = __webpack_require__(230)(false);
	var IE_PROTO = __webpack_require__(80)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(24);


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(7).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(142);
	var $export = __webpack_require__(57);
	var redefine = __webpack_require__(40);
	var hide = __webpack_require__(30);
	var Iterators = __webpack_require__(39);
	var $iterCreate = __webpack_require__(266);
	var setToStringTag = __webpack_require__(91);
	var getPrototypeOf = __webpack_require__(272);
	var ITERATOR = __webpack_require__(5)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(273);
	var enumBugKeys = __webpack_require__(138);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(38);
	var newPromiseCapability = __webpack_require__(90);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(17);
	var aFunction = __webpack_require__(54);
	var SPECIES = __webpack_require__(5)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(56);
	var invoke = __webpack_require__(262);
	var html = __webpack_require__(140);
	var cel = __webpack_require__(89);
	var global = __webpack_require__(7);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(55)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(93);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 151 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(61);
	
	var _PathUtils = __webpack_require__(32);
	
	var _createTransitionManager = __webpack_require__(101);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(32);
	
	var _LocationUtils = __webpack_require__(61);
	
	var _createTransitionManager = __webpack_require__(101);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(156);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(465);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(173);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(107);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(116);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(176);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(119);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(107);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(494);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./article/mentale-mure.json": 366,
		"./article/mure-i-historien.json": 367,
		"./article/mure-og-gadekunst.json": 368,
		"./article/mure-og-magt.json": 369,
		"./article/mure-og-miljo.json": 370,
		"./article/om.json": 371,
		"./case/australien-havene.json": 372,
		"./case/eu-og-middelhavet.json": 373,
		"./case/israel-og-palaestina.json": 374,
		"./case/sydafrika-og-zimbabwe.json": 375,
		"./case/usa-og-mexico.json": 376,
		"./index/index.json": 377,
		"./navigation/cases.json": 378,
		"./navigation/temaer.json": 379
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 180;


/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(3);
	
	var _prismicReactjs = __webpack_require__(114);
	
	var _kolofonModule = __webpack_require__(303);
	
	var _kolofonModule2 = _interopRequireDefault(_kolofonModule);
	
	var _Icon = __webpack_require__(46);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(126);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _helper = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KolofonContainer = function (_React$Component) {
	  _inherits(KolofonContainer, _React$Component);
	
	  function KolofonContainer(props) {
	    _classCallCheck(this, KolofonContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      toggle: false
	    };
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  KolofonContainer.prototype.toggle = function toggle() {
	    this.setState(function (prevState) {
	      return {
	        toggle: !prevState.toggle
	      };
	    });
	  };
	
	  KolofonContainer.prototype.render = function render() {
	    var kolofon = this.props.kolofon;
	
	    var modalClass = [_kolofonModule2.default.modal];
	    if (this.state.toggle) {
	      modalClass.push(_kolofonModule2.default.showModal);
	    }
	    var renderableKolofon = (0, _helper.makeContentRenderable)(kolofon);
	    return [_react2.default.createElement(
	      _Button2.default,
	      { onClick: this.toggle, key: 'kolo_btn' },
	      _react2.default.createElement(_Icon2.default, { icon: 'info' })
	    ), _react2.default.createElement(
	      _Modal2.default,
	      { show: this.state.toggle, onCancel: this.toggle, key: 'kolo_modal' },
	      _react2.default.createElement(
	        'div',
	        { className: modalClass.join(' ') },
	        _prismicReactjs.RichText.render(renderableKolofon)
	      )
	    )];
	  };
	
	  return KolofonContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var Kolofon = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KolofonContainer);
	
	exports.default = Kolofon;
	
	/*
	data {
	  kolofon {
	    type
	    text
	    url
	    spans {
	      start
	      end
	      type
	    }
	  }
	}
	*/

	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _modalModule = __webpack_require__(305);
	
	var _modalModule2 = _interopRequireDefault(_modalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalInner = function (_React$Component) {
	  _inherits(ModalInner, _React$Component);
	
	  function ModalInner(props) {
	    _classCallCheck(this, ModalInner);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      show: props.show
	    };
	    _this.onCancel = _this.onCancel.bind(_this);
	    return _this;
	  }
	
	  ModalInner.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState({
	      show: nextProps.show
	    });
	  };
	
	  ModalInner.prototype.onCancel = function onCancel() {
	    this.props.onCancel();
	  };
	
	  ModalInner.prototype.render = function render() {
	    var cssClass = [_modalModule2.default.modal];
	    if (this.state.show) {
	      cssClass.push(_modalModule2.default.show);
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: cssClass.join(' ') },
	      _react2.default.createElement(
	        'div',
	        { className: _modalModule2.default.container },
	        this.props.children
	      ),
	      _react2.default.createElement('div', {
	        role: 'link',
	        tabIndex: 0,
	        className: _modalModule2.default.background,
	        onClick: this.onCancel
	      })
	    );
	  };
	
	  return ModalInner;
	}(_react2.default.Component);
	
	ModalInner.defaultProps = {
	  show: false
	};
	
	ModalInner.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
	  show: _propTypes2.default.bool,
	  onCancel: _propTypes2.default.func.isRequired
	};
	
	exports.default = ModalInner;
	module.exports = exports['default'];

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(221), __esModule: true };

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(222), __esModule: true };

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(223), __esModule: true };

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(224), __esModule: true };

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(225), __esModule: true };

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(226), __esModule: true };

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(227), __esModule: true };

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(212);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(282);
	__webpack_require__(284);
	__webpack_require__(287);
	__webpack_require__(283);
	__webpack_require__(285);
	__webpack_require__(286);
	module.exports = __webpack_require__(29).Promise;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(12);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(247);
	module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(248);
	var $Object = __webpack_require__(12).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(249);
	module.exports = __webpack_require__(12).Object.keys;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(250);
	module.exports = __webpack_require__(12).Object.setPrototypeOf;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(253);
	__webpack_require__(251);
	__webpack_require__(254);
	__webpack_require__(255);
	module.exports = __webpack_require__(12).Symbol;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(252);
	__webpack_require__(256);
	module.exports = __webpack_require__(86).f('iterator');


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(27);
	var toLength = __webpack_require__(245);
	var toAbsoluteIndex = __webpack_require__(244);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(36);
	var gOPS = __webpack_require__(78);
	var pIE = __webpack_require__(51);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(13).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(128);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(77);
	var descriptor = __webpack_require__(52);
	var setToStringTag = __webpack_require__(79);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(24)(IteratorPrototype, __webpack_require__(28)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(53)('meta');
	var isObject = __webpack_require__(25);
	var has = __webpack_require__(16);
	var setDesc = __webpack_require__(26).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(23)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(36);
	var gOPS = __webpack_require__(78);
	var pIE = __webpack_require__(51);
	var toObject = __webpack_require__(83);
	var IObject = __webpack_require__(132);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(23)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(26);
	var anObject = __webpack_require__(35);
	var getKeys = __webpack_require__(36);
	
	module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(27);
	var gOPN = __webpack_require__(135).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(16);
	var toObject = __webpack_require__(83);
	var IE_PROTO = __webpack_require__(80)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(22);
	var core = __webpack_require__(12);
	var fails = __webpack_require__(23);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(25);
	var anObject = __webpack_require__(35);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(129)(Function.call, __webpack_require__(134).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(82);
	var defined = __webpack_require__(73);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(82);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(82);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(229);
	var step = __webpack_require__(235);
	var Iterators = __webpack_require__(75);
	var toIObject = __webpack_require__(27);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(133)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(22);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(237) });


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(22);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(77) });


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(83);
	var $keys = __webpack_require__(36);
	
	__webpack_require__(241)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(22);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(242).set });


/***/ }),
/* 251 */
/***/ (function(module, exports) {



/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(243)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(133)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(13);
	var has = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(21);
	var $export = __webpack_require__(22);
	var redefine = __webpack_require__(137);
	var META = __webpack_require__(236).KEY;
	var $fails = __webpack_require__(23);
	var shared = __webpack_require__(81);
	var setToStringTag = __webpack_require__(79);
	var uid = __webpack_require__(53);
	var wks = __webpack_require__(28);
	var wksExt = __webpack_require__(86);
	var wksDefine = __webpack_require__(85);
	var enumKeys = __webpack_require__(231);
	var isArray = __webpack_require__(233);
	var anObject = __webpack_require__(35);
	var isObject = __webpack_require__(25);
	var toIObject = __webpack_require__(27);
	var toPrimitive = __webpack_require__(84);
	var createDesc = __webpack_require__(52);
	var _create = __webpack_require__(77);
	var gOPNExt = __webpack_require__(239);
	var $GOPD = __webpack_require__(134);
	var $DP = __webpack_require__(26);
	var $keys = __webpack_require__(36);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(135).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(51).f = $propertyIsEnumerable;
	  __webpack_require__(78).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(76)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(24)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(85)('asyncIterator');


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(85)('observable');


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(246);
	var global = __webpack_require__(13);
	var hide = __webpack_require__(24);
	var Iterators = __webpack_require__(75);
	var TO_STRING_TAG = __webpack_require__(28)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(5)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(30)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(94);
	var toLength = __webpack_require__(150);
	var toAbsoluteIndex = __webpack_require__(277);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(56);
	var call = __webpack_require__(265);
	var isArrayIter = __webpack_require__(264);
	var anObject = __webpack_require__(17);
	var toLength = __webpack_require__(150);
	var getIterFn = __webpack_require__(280);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(37) && !__webpack_require__(139)(function () {
	  return Object.defineProperty(__webpack_require__(89)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(55);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(39);
	var ITERATOR = __webpack_require__(5)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(17);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(270);
	var descriptor = __webpack_require__(146);
	var setToStringTag = __webpack_require__(91);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(30)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(5)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var macrotask = __webpack_require__(149).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(55)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(17);
	var dPs = __webpack_require__(271);
	var enumBugKeys = __webpack_require__(138);
	var IE_PROTO = __webpack_require__(92)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(89)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(140).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(59);
	var anObject = __webpack_require__(17);
	var getKeys = __webpack_require__(143);
	
	module.exports = __webpack_require__(37) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(58);
	var toObject = __webpack_require__(278);
	var IE_PROTO = __webpack_require__(92)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toIObject = __webpack_require__(94);
	var arrayIndexOf = __webpack_require__(259)(false);
	var IE_PROTO = __webpack_require__(92)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(40);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(7);
	var dP = __webpack_require__(59);
	var DESCRIPTORS = __webpack_require__(37);
	var SPECIES = __webpack_require__(5)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(93);
	var defined = __webpack_require__(88);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(93);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(88);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(38);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(87);
	var ITERATOR = __webpack_require__(5)('iterator');
	var Iterators = __webpack_require__(39);
	module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(257);
	var step = __webpack_require__(268);
	var Iterators = __webpack_require__(39);
	var toIObject = __webpack_require__(94);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(141)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(87);
	var test = {};
	test[__webpack_require__(5)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(40)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(142);
	var global = __webpack_require__(7);
	var ctx = __webpack_require__(56);
	var classof = __webpack_require__(87);
	var $export = __webpack_require__(57);
	var isObject = __webpack_require__(38);
	var aFunction = __webpack_require__(54);
	var anInstance = __webpack_require__(258);
	var forOf = __webpack_require__(260);
	var speciesConstructor = __webpack_require__(148);
	var task = __webpack_require__(149).set;
	var microtask = __webpack_require__(269)();
	var newPromiseCapabilityModule = __webpack_require__(90);
	var perform = __webpack_require__(144);
	var promiseResolve = __webpack_require__(145);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(274)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(91)($Promise, PROMISE);
	__webpack_require__(275)(PROMISE);
	Wrapper = __webpack_require__(29)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(267)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(276)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(141)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(57);
	var core = __webpack_require__(29);
	var global = __webpack_require__(7);
	var speciesConstructor = __webpack_require__(148);
	var promiseResolve = __webpack_require__(145);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(57);
	var newPromiseCapability = __webpack_require__(90);
	var perform = __webpack_require__(144);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(281);
	var getKeys = __webpack_require__(143);
	var redefine = __webpack_require__(40);
	var global = __webpack_require__(7);
	var hide = __webpack_require__(30);
	var Iterators = __webpack_require__(39);
	var wks = __webpack_require__(5);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 288 */,
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(291);
	var isArguments = __webpack_require__(290);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(96);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(96);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(151);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(151);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(96);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bgimage":"src-components-BackgroundImage----backgroundimage-module---bgimage---2RBQq","in":"src-components-BackgroundImage----backgroundimage-module---in---1XRDO"};

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"btn":"src-components-Button----button-module---btn---2_6ft","regular":"src-components-Button----button-module---regular---1iOt2","link":"src-components-Button----button-module---link---2_rWP"};

/***/ }),
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"src-components-Icon----icon-module---icon---3TWyF","small":"src-components-Icon----icon-module---small---2l7hP"};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"src-components-Kolofon----kolofon-module---modal---2pzeP","showModal":"src-components-Kolofon----kolofon-module---showModal---2niqI"};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-Main----main-module---main---3mJVT"};

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modal":"src-components-Modal----modal-module---modal---VXcAj","show":"src-components-Modal----modal-module---show---29MIb","container":"src-components-Modal----modal-module---container---3fwTg","background":"src-components-Modal----modal-module---background---2C_gM"};

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nav":"src-components-Navigation----navigation-module---nav---4KTQR","right":"src-components-Navigation----navigation-module---right---_CcLq","top":"src-components-Navigation----navigation-module---top---ldXqQ","left":"src-components-Navigation----navigation-module---left---1qgEK","bottom":"src-components-Navigation----navigation-module---bottom---3_lnp","back":"src-components-Navigation----navigation-module---back---aACqV"};

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(319);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(318);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.4.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(99),ca=__webpack_require__(1),m=__webpack_require__(315),p=__webpack_require__(113),v=__webpack_require__(98),da=__webpack_require__(317),ea=__webpack_require__(320),fa=__webpack_require__(316),ha=__webpack_require__(152);
	function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
	function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
	var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
	B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
	function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
	var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
	function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
	function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
	return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
	function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
	function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
	function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
	function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
	var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
	function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
	function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
	var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
	p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
	function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
	var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
	function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
	function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
	var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
	f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
	function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
	var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
	function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
	60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
	function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
	a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
	var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
	function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
	function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
	[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
	["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
	Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
	function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
	function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
	function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
	function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
	function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
	var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
	detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
	var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
	mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
	e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
	c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
	function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
	function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
	a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
	["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
	var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
	Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
	function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
	var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
	var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
	function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
	var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
	case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
	be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
	if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
	e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
	callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
	function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
	function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
	function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
	function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
	function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
	L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
	h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
	function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
	(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
	g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
	function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
	ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
	c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
	var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
	c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
	function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
	function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
	function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
	function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
	function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
	d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
	function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
	function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
	function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
	function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
	function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
	function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
	g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
	function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
	function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
	function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
	function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
	var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
	b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
	function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
	function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
	d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
	function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
	function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
	a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
	if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
	t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
	g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
	u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
	a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
	a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
	function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
	function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
	function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
	function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
	e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
	function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
	h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
	typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
	g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
	(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
	(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
	(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
	(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
	f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
	b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
	null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
	b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
	R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
	function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
	A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
	a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
	default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
	function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
	e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
	function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
	function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
	function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
	function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
	function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
	(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
	function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
	function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
	void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
	function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
	function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
	function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
	function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
	function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
	function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
	c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
	function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
	function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
	f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
	++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
	D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
	U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
	y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
	top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
	ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
	128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
	function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
	function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
	function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
	function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
	var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
	getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
	function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
	li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
	li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
	function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
	function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
	function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
	var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
	arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
	var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.4.0
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(113),n=__webpack_require__(99),p=__webpack_require__(152),q=__webpack_require__(98),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
	r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
	var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
	G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
	function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
	function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
	var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
	b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
	assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(50);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(72);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(71);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(43);
	
	var _scrollBehavior = __webpack_require__(490);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StateStorage = __webpack_require__(347);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _propTypes2.default.object.isRequired
	};
	
	var ScrollContext = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContext, _React$Component);
	
	  function ScrollContext(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContext);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.registerElement = function (key, element, shouldUpdateScroll) {
	      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
	    };
	
	    _this.unregisterElement = function (key) {
	      _this.scrollBehavior.unregisterElement(key);
	    };
	
	    var history = props.history;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: history.listen,
	      stateStorage: new _StateStorage2.default(),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
	    return _this;
	  }
	
	  ScrollContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history;
	
	    var prevLocation = prevProps.location;
	
	    if (location === prevLocation) {
	      return;
	    }
	
	    var prevRouterProps = {
	      history: prevProps.history,
	      location: prevProps.location
	
	      // The "scroll-behavior" package expects the "action" to be on the location
	      // object so let's copy it over.
	    };location.action = history.action;
	    this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
	  };
	
	  ScrollContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollContext.prototype.getRouterProps = function getRouterProps() {
	    var _props2 = this.props,
	        history = _props2.history,
	        location = _props2.location;
	
	    return { history: history, location: location };
	  };
	
	  ScrollContext.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScrollContext;
	}(_react2.default.Component);
	
	ScrollContext.propTypes = propTypes;
	ScrollContext.childContextTypes = childContextTypes;
	
	exports.default = (0, _reactRouterDom.withRouter)(ScrollContext);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(50);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(72);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(71);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(60);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  scrollKey: _propTypes2.default.string.isRequired,
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _propTypes2.default.object
	};
	
	var ScrollContainer = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, "<ScrollContainer> does not support changing scrollKey.") : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(this.domNode === prevDomNode, "<ScrollContainer> does not support changing DOM node.") : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _stringify = __webpack_require__(211);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(50);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_KEY_PREFIX = "@@scroll|";
	var GATSBY_ROUTER_SCROLL_STATE = "___GATSBY_REACT_ROUTER_SCROLL";
	
	var SessionStorage = function () {
	  function SessionStorage() {
	    (0, _classCallCheck3.default)(this, SessionStorage);
	  }
	
	  SessionStorage.prototype.read = function read(location, key) {
	    var stateKey = this.getStateKey(location, key);
	
	    try {
	      var value = window.sessionStorage.getItem(stateKey);
	      return JSON.parse(value);
	    } catch (e) {
	      console.warn("[gatsby-react-router-scroll] Unable to access sessionStorage; sessionStorage is not available.");
	
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE] && window[GATSBY_ROUTER_SCROLL_STATE][stateKey]) {
	        return window[GATSBY_ROUTER_SCROLL_STATE][stateKey];
	      }
	
	      return {};
	    }
	  };
	
	  SessionStorage.prototype.save = function save(location, key, value) {
	    var stateKey = this.getStateKey(location, key);
	    var storedValue = (0, _stringify2.default)(value);
	
	    try {
	      window.sessionStorage.setItem(stateKey, storedValue);
	    } catch (e) {
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE]) {
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      } else {
	        window[GATSBY_ROUTER_SCROLL_STATE] = {};
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      }
	
	      console.warn("[gatsby-react-router-scroll] Unable to save state in sessionStorage; sessionStorage is not available.");
	    }
	  };
	
	  SessionStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var stateKeyBase = "" + STATE_KEY_PREFIX + location.pathname;
	    return key === null || typeof key === "undefined" ? stateKeyBase : stateKeyBase + "|" + key;
	  };
	
	  return SessionStorage;
	}();
	
	exports.default = SessionStorage;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ScrollBehaviorContext = __webpack_require__(345);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	var _ScrollContainer = __webpack_require__(346);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer2.default;
	exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WvAj9CgAAB5zVqkS","type":"article","uid":"mentale-mure","url":"/mentale-mure","published":"2019-01-29T10:51:32+0000","lang":"da-dk","meta_title":"Mentale mure","meta_description":"I temateksten \"Mentale mure\", der er en del af undervisningsmaterialet OVER MUREN, anlægger vi en sociologisk vinkel på mure og grænser og undersøger, hvordan \"mentale mure\" kan opstå mellem dem, der ligner mig, og dem, jeg opfatter som anderledes.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b64c1465dea82fcc795ea388265c7ed4dc24f948_mentalemure_header.jpg"},"alternate_languages":[],"data":{"pdf":{"link_type":"Media","name":"tema_mentalemure_print.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F984a15c0-14b2-417e-80b2-40e34fe20c3f_tema_mentalemure_print.pdf","size":"6577776"},"url":"/mentale-mure","image":{"dimensions":{"width":750,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f29a5bcb936cc481456a3235f1c2c79b3b9fc0e7_mentalemure_header.jpg","small":{"dimensions":{"width":375,"height":200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/04227acbdb34cdbed902f7e0494d1fa06a2fe33d_mentalemure_header.jpg"},"medium":{"dimensions":{"width":600,"height":320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/62c4026bc751ac33a42be99c125e9f4992858504_mentalemure_header.jpg"}},"title":[{"type":"heading1","text":"Mentale mure","spans":[]}],"content":[{"type":"paragraph","text":"Mure og grænser opstår ikke ud af den blå luft, men bliver som regel skabt på baggrund af et ønske om at beskytte sig selv og sine interesser mod trusler udefra. Truslen og frygten, som en befolkning oplever, kan være helt reel, men tit hænger den også sammen med en forestilling om, at \"vi\" er forskellige fra \"dem\" - og måske endda så forskellige, at det ikke er muligt at leve sammen. Vi kunne kalde den slags forestillinger for ”mentale mure”, og hvordan de bliver til, handler dette tema om.","spans":[{"start":0,"end":496,"type":"strong"}]},{"type":"paragraph","text":"Først skal vi undersøge, hvorfor vi danner meninger om andre mennesker. Derefter kigger vi nærmere på, hvordan vi ofte skaber gruppeidentitet ved at sætte mentale grænser mellem ”os” og ”dem”. Det fører os videre til at analysere, hvordan en nation eller en nationalstat kan blive udgangspunktet for en fælles gruppeidentitet, selvom vi langt fra er ens eller kender alle dem, vi deler nationalitet med. Derefter bevæger vi os ud i en undersøgelse af, hvad der sker, når stereotyper bliver bærende for vores opfattelser af andre mennesker og kan give sig til udtryk som racisme eller xenofobi. Til slut kigger vi på begrebet ”diskurs”, og hvordan diskurser er med til at sætte rammerne for vores opfattelse af virkeligheden. Her skal vi også undersøge, hvilken magt de ord, vi bruger, har.","spans":[{"start":0,"end":789,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Kategoriseringer, fordomme og stereotyper","spans":[]},{"type":"paragraph","text":"For at vores verden kan give mening for os, er det nødvendigt at lave kategoriseringer. Ellers ville verden bestå af støj, rod og kaos. At kategorisere er en mental proces, der betyder, at man inddeler og ordner nogen eller noget i kategorier. Det er den menneskelige hjernes forsøg på at skabe orden i kaos. ","spans":[{"start":70,"end":86,"type":"strong"}]},{"type":"paragraph","text":"En kategorisering bygger ofte på fordomme. En fordom er en forudfattet mening om nogen eller noget og tager udgangspunkt i nogle generelle træk ved en gruppe. En fordom kan være både positiv og negativ. Nogle fordomme er harmløse i den forstand, at de ikke står i vejen for, at vi kan leve med de forskelligheder, vi oplever hos hinanden. Sjællændere og jyder er kendt for at have fordomme om hinanden, der beskriver københavnere som arrogante, højrøstede og fremme i skoene, mens jyderne er nogle bondeknolde, nærige og langsomme. ","spans":[{"start":33,"end":41,"type":"strong"}]},{"type":"paragraph","text":"Fordomme bidrager til dannelsen af stereotyper, som er ensidige og unuancerede forestillinger om en gruppe ofte defineret af etnicitet, religion eller kultur. Stereotyper er mere fastgroede end fordomme og ofte ubevidste. Selvom københavnere og jyder kan have fordomme om hinanden, så ved de fleste også, at den hverken er dækkende eller fyldestgørende. Sådan er det for det meste. Men nogle gange bliver stereotypen styrende for, hvordan vi forstår og møder andre mennesker.","spans":[{"start":35,"end":46,"type":"strong"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/c1196c26a1cc39f064fd75f7df03eb2573342c3c_minstrelshow.png","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Stereotype forestillinger om etniske grupper kan være sejlivede og skadelige. \"Minstrel shows\", hvor hvide klædte sig ud som sorte og karikerede dem som naive, dovne og simple, var voldsomt populære i 1800-tallets USA. Den opfattelse af sorte mennesker, disse shows gav udtryk for, lå også som en klangbund i retfærdiggørelsen af slaveriet og Sydstaternes raceadskillelse - og nogle vil nok hævde, at den stadig lever i bedste velgående.","spans":[{"start":0,"end":437,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Gruppeidentitet og grænsedragninger","spans":[]},{"type":"paragraph","text":"Identitet hænger tæt sammen med at kategorisere. Vi identificerer os selv i modspil og sammenspil med andre mennesker. Når vi møder andre mennesker identificerer os med forskellige grupper, og kategorierne ”dem” og ”os” bliver skabt. Mødet med \"de andre\" er en spændende mulighed for at lære noget om både os selv og dem. Men det fremmede kan også virke skræmmende, fordi det udfordrer os på vores egen identitet.","spans":[]},{"type":"paragraph","text":"Gruppeidentitet skabes oftest ud fra stereotyper om ”de andre”. Nationale eller etniske stereotyper er klichéer om egenskaber ved nationer og folk. På baggrund af en række fordomme, der sjældent bygger på virkelige erfaringer, dannes bestemte opfattelser af karaktertræk hos andre nationale eller etniske befolkningsgrupper. Finner går med kniv, romaer stjæler, japanere er høflige, mexicanere er dovne, thailændere er underdanige og nordmænd er nærmest født med ski på fødderne. Ved at definere, hvad der gør ”dem” anderledes fra ”os”, er stereotyperne med til at skabe en forståelse af, hvem vi selv er. Det er ikke altid let at afgrænse etniske grupper i forhold til hinanden, fordi grænserne mellem ”dem” og ”os” hele tiden ændrer sig. ","spans":[]},{"type":"paragraph","text":"Den norske socialantropolog Fredrik Barth mener, at grænsedragning er helt centralt begreb, når vi taler om gruppeidentitet og etnicitet. Når vi giver udtryk for en forestilling om, at der er noget fælles, der binder en gruppe mennesker sammen, laver vi samtidig en grænsedragning til andre mennesker. Grænsedragninger handler om at skabe identitet og stabilitet ved at identificere sig med en bestemt gruppe, men den samme proces er også med til at fremhæve forskelle mellem ”os” og ”dem”. Når vi taler om etnicitet, opstiller gruppemedlemmerne nogle kriterier, ud fra hvilke man vurderer, hvem der tilhører gruppen, og hvem der ikke hører til. Denne opstilling af kriterier sker som regel som en mere eller mindre ubevidst process baseret på fordomme og stereotyper om dem, man identificerer sig i modsætning til. Og hvilke kriterier, man vælger som markør, er afgørende for, hvem man opfatter som en del af det nationale fællesskab. Fredrik Barth deler kriterierne i to typer: ","spans":[{"start":28,"end":41,"type":"strong"}]},{"type":"o-list-item","text":"Åbenlyse tegn, såsom sprog, udseende, livsstil og beklædning.","spans":[]},{"type":"o-list-item","text":"Grundlæggende værdiorientering, altså moral, menneskesyn osv. ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b98c0e5d0e5fe8ae23154b3663308f8cc3cf9bee_dreamstime_s_125828018.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"På denne kampagneplakat har Martin Henriksen fra Dansk Folkeparti valgt en tydelig markør for, hvad det vil sige at være dansk. Foto: Francis Joseph Dean, Deanpictures via Dreamstime. ","spans":[{"start":0,"end":184,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Nationen og nationalstaten og det forestillede fælleskab","spans":[]},{"type":"paragraph","text":"Fædreland. Modersmål. Hjemland. Vi kender alle sammen ordene. Vi kunne kalde dem slægtskabsmetaforer, fordi de er et udtryk for, at der eksisterer et naturligt tilhørsforhold til et land eller en nation, på samme måde som et blodsbånd binder en slægt sammen. Når man taler om en nation, taler man om en gruppe, der føler et fællesskab med hinanden, og som har en følelse af at have en klar fælles identitet. En nation vil typisk være knyttet til et bestemt territorium, men ikke nødvendigvis en stat. Et eksempel på en nation uden en stat er Skotland, som hører under Storbritannien. En nation kan godt bestå af flere etniske grupper.","spans":[{"start":0,"end":32,"type":"em"},{"start":278,"end":285,"type":"strong"}]},{"type":"paragraph","text":"En nationalstat defineres af landegrænser, og befolkningen indenfor disse har som borgere visse rettigheder og pligter. Inden for en nationalstat kan der ligeledes være flere nationale og etniske grupper. Nogle etniske grupper er i stand til at kombinere deres kulturelle, etniske identitet med den politiske, nationale identitet i det land, hvor de bor. Andre etniske grupper identificerer sig udelukkende med den etniske gruppe, de tilhører og føler ikke en stærk national identitet. Nationalstater har ofte et officielt sprog, som er med til at styrke den indre sammenhængskraft i lande, hvor der findes flere forskellige sprog. For eksempel huser det afrikanske kontinent omkring 3000 forskellige etniske grupper med cirka 1800 forskellige sprog fordelt på 54 lande.","spans":[{"start":3,"end":15,"type":"strong"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/0c7abe0d567245917ce690811689f89ba232cf72_wcsa.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Store sportsbegivenheder kan få nationalfølelsen frem i de fleste. I 2010 var Sydafrika vært for verdensmesterskabet i fodbold, hvilket for en stund skabte et stærkt sammenhold i et ellers meget splittet land med mange forskellige befolkningsgrupper. Foto: Celso Flores via Flickr.","spans":[{"start":0,"end":281,"type":"em"}]},{"type":"paragraph","text":"Hvordan går det til, at der kan være en fælles national identitet i lande, hvor der findes forskellige etniske grupper, med forskellige kulturer, religioner og sprog? Det har historikeren og sociologen Benedict Anderson et bud på. Benedict Andersons bog Forestillede fællesskaber præsenterer en de mest anerkendte analyser af nationalismens opståen og udvikling. Den grundlæggende pointe er, at nationer eller nationalstater ikke består af ældgamle folk bundet sammen af historie, slægtsbånd, sprog eller kultur, som nationalister ofte forestiller sig. Nationer er derimod en moderne forestilling om, at der eksisterer et sådant fællesskab. Benedict Anderson argumenterer for, at nationer er forestillede fællesskaber, fordi de jo er for store til, at alle medlemmer faktisk kan lære hinanden at kende. Derfor er det kun muligt at forestille sig, at man har et fællesskab med de andre medlemmer af nationen. Men selvom man kan definere nationen som en forestilling, er den stadig for nogle så virkelig og betydningsfuld, at man i yderste konsekvens er parat til at dø og dræbe for den.","spans":[{"start":202,"end":219,"type":"strong"},{"start":253,"end":279,"type":"em"},{"start":692,"end":704,"type":"em"},{"start":831,"end":841,"type":"em"}]},{"type":"paragraph","text":"Tidligere var det lokalsamfundet og religiøst tilhørsforhold, der spillede en vigtig rolle for fællesskaber og gruppeidentitet. Med bogtrykkerkunstens udvikling blev de fælles forestillinger udviklet og udbredt. Cirkulationen af bøger og aviser gjorde det muligt for individer, der levede langt væk fra hinanden, at forholde sig til hinanden og udvikle en fælles bevidsthed om begivenheder, fortællinger og idéer inden for et land. Selvom globaliseringen har bragt verdenslande tættere sammen, så ser det ud til, at den samtidig har styrket nationalismen i mange lande. Måske fordi den tilbyder et tilhørsforhold i en usikker og uoverskuelig verden? Et forestillet fællesskab er måske alligevel mere trygt end intet fællesskab.","spans":[{"start":653,"end":665,"type":"em"},{"start":710,"end":715,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Rasicme og xenofobi","spans":[]},{"type":"paragraph","text":"Mennesker er ikke altid enige om, hvor grænserne mellem ”os” og ”dem” går, og nogle gange sker det, at kategorisering, fordomme og stereotyper kammer over i decideret racisme og xenofobi (fremmedhad) i forsøget på at afgrænse mig og mine slags fra dem og deres slags. Der er forskel på at danne stereotyper om en bestemt gruppe og at være racistisk. I Den store danske encyklopædi defineres racisme som forestillinger om visse menneskeracers overlegenhed over for andre samt de diskriminerende handlinger, der knytter sig til sådanne forestillinger. Racisme bygger på den opfattelse, at menneskeheden kan inddeles i racer, som ikke bare har forskellige fysiske kendetegn, men også forskellige mentale og moralske egenskaber, og at der eksisterer et hierarkisk forhold imellem disse, således at visse racer er andre overlegne. ","spans":[{"start":403,"end":548,"type":"em"},{"start":550,"end":557,"type":"strong"}]},{"type":"paragraph","text":"Under apartheid i Sydafrika herskede der meget tydelige racistiske forestillinger, hvor den hvide del af befolkningen så sig selv som overlegne i forhold til den sorte, asiatiske og farvede del af befolkningen. Sydafrikanske borgerne blev inddelt efter race, og de forskellige grupper havde meget forskellige rettigheder og muligheder. I USA er racedebatten glohed, og begreber som kulturel appropriation og bevægelser som Black Lives Matter spiller en stor rolle i den offentlige debat. Kulturel appropriation handler om, at krænke andre kulturers kulturelle udtryk med en overfladisk og egennyttig brug af dem. Fx er Justin Bieber blevet kritiseret for som hvid mand i en privilegeret position at få dreadlocks, fordi det er en frisure hentet i den jamaicanske rastafari-kultur, der netop er opstået som en protest mod den hvide mands imperialisme. ","spans":[{"start":423,"end":441,"type":"em"},{"start":850,"end":851,"type":"em"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/32111587c14e583a8599b182e41f06274e071ae2_blacklivesmatter.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Black Lives Matter er en international bevægelse, der blev startet af en gruppe afroamerikanere i USA. Bevægelsen fører kampagner mod vold og systematisk racisme mod sorte mennesker. Foto: “Demilitarize the Police, Black Lives Matter” af Johnny Silvercloud via Flickr.","spans":[{"start":0,"end":268,"type":"em"},{"start":190,"end":233,"type":"hyperlink","data":{"link_type":"Web","url":"https://www.flickr.com/photos/johnnysilvercloud/28476745294/in/album-72157661035041231/","target":"_blank"}}]},{"type":"paragraph","text":"Begreberne er svære at afgrænse, men det er alligevel vigtigt, at vi er i stand til at skelne mellem dem. I nogle tilfælde kunne det måske give mening at tale om xenofobi og ikke om racisme. Xenofobi betyder ”fremmedhad” eller ”fjendtlighed mod fremmede”. Nationalismen og xenofobien er blomstret frem i Europa i løbet af de seneste 20 år. Det er ikke kun en udvikling, vi ser i Europa, men også i Australien, USA og Sydafrika. Der kan være mange forklaringer på, hvorfor nogle mennesker er xenofobiske. Flygtninge og migranter bliver af nogle opfattet som repræsentant for det land, de kommer fra, og de problemer deres hjemland har. Derfor kan migranterne af nogle blive set som en trussel mod det system og det land, de kommer til. For tænk hvis de tog problemerne med sig. I nogle lande bliver migranter anklaget for at være kriminelle eller bare nassere, der ikke vil arbejde og dermed bidrage til samfundet. Andre steder, hvor arbejdsløsheden er stor, bliver migranter modsat beskyldt for at tage alt arbejdet. De bliver syndebukke for de udfordringer, det pågældende samfund står med. ","spans":[{"start":191,"end":199,"type":"strong"}]},{"type":"paragraph","text":"Alle samfund har begrænsede ressourcer, hvad enten det handler om velfærd eller arbejde. Mennesker har en tendens til at beskytte disse ved at sætte grænser for, hvem der ikke hører til, hvem der ikke burde høre til, og hvem der aldrig kommer til at høre til. Med andre ord, med xenofobiske forestillinger. ","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Diskurs og magt","spans":[]},{"type":"paragraph","text":"Selvom ordene migrant og indvandrer har den samme betydning, får mange forskellige associationer afhængigt af, hvilket ord man bruger. Hvis vi tager et hurtigt tilbageblik på de mennesker, der er kommet til Danmark fra andre lande, vil vi opdage, at der er blevet brugt mange forskellige ord gennem tiden til at omtale dem. I slutningen af 1960’erne og i 1970’erne kaldte vi dem fremmedarbejdere og gæstearbejdere. Det var nemlig mennesker, der hovedsagligt kom fra Tyrkiet, Pakistan, Mellemøsten og det tidligere Jugoslavien, der var blevet inviteret til Danmark for at arbejde, fordi her var mangel på arbejdskraft. Senere, da de hentede deres familie til Danmark eller stiftede familie med danske kvinder, blev de mindet om, at de var GÆSTEarbejdere og skulle huske at rejse hjem igen. I 1990’erne talte vi om flygtninge og indvandrere, som der efter mange danskeres opfattelse, kom alt for mange af til landet. De seneste år har vi talt meget om muslimerne som nogle, der kommer udefra og skaber problemer med deres religion på trods af, at mange muslimske familier har boet i Danmark i flere generationer. Såkaldt bekvemmelighedsflygtningene er kommet til Danmark siden flygtningekrisen i 2015, og lige nu skelnes der i den politiske debat mellem vestlig og ikke-vestlig indvandring. ","spans":[{"start":379,"end":395,"type":"em"},{"start":399,"end":413,"type":"em"},{"start":813,"end":823,"type":"em"},{"start":826,"end":838,"type":"em"},{"start":950,"end":960,"type":"em"},{"start":1119,"end":1146,"type":"em"},{"start":1175,"end":1191,"type":"em"},{"start":1252,"end":1287,"type":"em"}]},{"type":"paragraph","text":"De ord, vi bruger om ”de andre”, vil aldrig være neutrale. Hvis jeg fx taler om mennesker med anden etnisk baggrund, fremhæver jeg jo samtidig, at jeg tilhører majoriteten med ret til at kategorisere dem som etnisk minoritet. Det er følsomt, når en majoritetsbefolkning navngiver en minoritetsgruppe og dermed definerer minoritetsgruppens medlemmer som nogle, der afviger fra ”os”. Der eksisterer altså et magtforhold mellem majoritetsgrupper og minoritetsgrupper. Socialantropologen Richard Jenkins argumenterer for, at den kategorisering en majoritetsgruppe laver af en minoritetsgruppe kan få indflydelse på, hvordan den gruppe opfatter sig selv. Det er ikke sikkert, at dem, der bliver kaldt indvandrere, selv identificerer sig med den kategori, men bliver de kaldt det tilstrækkeligt tit, kommer de sandsynligvis efterhånden også til at opfatte sig selv som nogle, der ikke hører til i samfundet.  ","spans":[{"start":80,"end":115,"type":"em"},{"start":208,"end":226,"type":"em"},{"start":483,"end":499,"type":"strong"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/26161872495892c5e41a423aea6196803d77396d_dreamstime_s_55197869.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Der er mange forskellige diskurser omkring udlændingepolitikken i Danmark. Her repræsenterer statminister Lars Løkke Rasmussen regeringens på et pressemøde. Foto: Dreamstime. ","spans":[{"start":0,"end":175,"type":"em"}]},{"type":"paragraph","text":"Sprog er magt, og det kan defor være en god idé at være opmærksom på, hvilke ord, der bliver brugt i hvilke sammenhænge, og hvorfor. Det kan man gøre med en diskursanalyse. Filosoffen og idehistorikeren Michel Foucault kan hjælpe os med at forstå, hvad en diskurs er. En diskurs handler om den måde, vi taler om og forstår verden på. Diskurser bliver skabt gennem social interaktion; igennem samtaler, diskussioner, tv-udsendelser og blogindlæg, kunst, sportsbegivenheder med mere. Michel Foucault mener, at den måde vi taler om verden på, og dermed vores virkelighedsforståelse, ikke bygger på objektive sandheder. Det, vi siger, er nemlig et udtryk for den tid, vi lever i. Tidens diskurser er med til at forme og begrænse tanker og handlinger, fordi diskurser gør det muligt at forstå tingene på nogle bestemte måder, men udelukker samtidig andre måder at forstå tingene på – andre mulige virkeligheder. Diskurser er derfor både skabt og skabere af social orden. Diskurser opstår, når vi taler med andre mennesker, men diskurser er samtidig med til at skabe rammerne for, hvad vi siger. Som regel er der flere diskurser om det samme fænomen, og de forskellige diskurser slås om at blive den dominerende diskurs - den dominerende verdensopfattelse. Det er i bund og grund det politikere kæmper om, når de bliver ved med at gentage de samme ord og sætninger i en debat.","spans":[{"start":157,"end":171,"type":"strong"},{"start":203,"end":218,"type":"strong"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Til videre refleksion","spans":[]},{"type":"o-list-item","text":"Prøv, med dine egne ord, at beskrive forskellen på kategoriseringer, fordomme og stereotyper. Hvordan og hvorfor opstår de? Og er det godt, skidt eller helt naturligt, at vi har dem?","spans":[{"start":0,"end":182,"type":"em"}]},{"type":"o-list-item","text":"Hvornår, hvis nogensinde, føler du dig dansk?","spans":[{"start":0,"end":45,"type":"em"}]},{"type":"o-list-item","text":"Hvilke kriterier vil du opstille for, hvad det vil sige at være dansk? Ekskluderer du nogen med dine kriterier?","spans":[{"start":0,"end":111,"type":"em"}]},{"type":"o-list-item","text":"Hvornår kammer fordomme og stereotyper over i racisme og xenofobi?","spans":[{"start":0,"end":66,"type":"em"}]},{"type":"o-list-item","text":"Udvælg et politisk parti og lav en diskursanalyse på deres udlændingepolitik med eksempler fra deres partiprogram og udtalelser i medierne.","spans":[]},{"type":"paragraph","text":"(Find kilderne til dette tema HER.\nTemafoto: Kyle Loftus via Unsplash.)","spans":[{"start":30,"end":33,"type":"hyperlink","data":{"link_type":"Media","name":"kilder_temaer.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa0f4f587-8b24-462b-83b5-517329148ac6_kilder_temaer.pdf","size":"6462983"}}]}],"content_bits":[{"text":[],"fact_box":[],"fact_box_position":"Right","fact_box_border_color":null,"fact_box_width":null}],"meta_title":"Mentale mure","meta_description":"I temateksten \"Mentale mure\", der er en del af undervisningsmaterialet OVER MUREN, anlægger vi en sociologisk vinkel på mure og grænser og undersøger, hvordan \"mentale mure\" kan opstå mellem dem, der ligner mig, og dem, jeg opfatter som anderledes.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b64c1465dea82fcc795ea388265c7ed4dc24f948_mentalemure_header.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7542cdaddec54497fd8ef449e8a244ad1fa46200_michal-grosicki-235026.jpg"}},"navigation":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false},"home_link":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false}}}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"W1cEjh4AAOT15D8Y","type":"article","uid":"mure-i-historien","url":"/temaer/mure-i-historien","published":"2019-01-29T10:53:00+0000","lang":"da-dk","meta_title":"Mure i historien","meta_description":"I temateksten \"Mure i historien\", der er en del af undervisningsmaterialet OVER MUREN, bliver der blandt andet sat spot på tre ikoniske mure, der er gået over i historien, og én enkelt opdigtet.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b9b2d244a50ed5cc8b113488efbe4137e67cf5c2_robert-nyman-442988.jpg"},"alternate_languages":[],"data":{"pdf":{"link_type":"Media","name":"tema_historie_print.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fca65fba8-d7ff-4639-9d42-a0f1f4b28df8_tema_historie_print.pdf","size":"6639608"},"url":"/temaer/mure-i-historien","image":{"dimensions":{"width":750,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/24a6168318b32cc36c777cf984c9c41e8a89c07f_robert-nyman-442988.jpg","small":{"dimensions":{"width":375,"height":200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/70144b9f820c91525dece8274bcec4d9c36b7712_robert-nyman-442988.jpg"},"medium":{"dimensions":{"width":600,"height":320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0e937a48f32a3ca0f86a2592a1a84ec767af715a_robert-nyman-442988.jpg"}},"title":[{"type":"heading1","text":"Mure i historien","spans":[]}],"content":[{"type":"paragraph","text":"Mennesket har altid vandret. I søgen efter nye jagtmarker. På grund af sult og nød. På flugt fra krig. På udkig efter nye eventyr. Helt siden de første civilisationer har mennesket dog også trukket linjer og opført forskellige former for grænsebefæstninger. Vi kan stadig opleve ruinerne af nogle af de største og gætte på, hvilke opfattelser bygherrerne havde om dem på den anden side. Murene er på én gang fysiske beviser på de mentale og juridiske skel, vi har opført mellem os, og på samme tid kulturelle brudflader. Det er på samme tid her, vi mødes, og her, vi skilles. Sådan har det altid været, og sådan er det stadig. ","spans":[{"start":0,"end":627,"type":"strong"}]},{"type":"paragraph","text":"I dette tema kommer vi forbi tre af verdenshistoriens mest ikoniske murbyggerier og deres motivationer. Vi bliver klogere på Hadrians mur, Den Kinesiske Mur og Berlinmuren. Men vi lægger ud med en afstikker til en mur i fantasiens verden:","spans":[{"start":0,"end":238,"type":"em"}]},{"type":"preformatted","text":"\"Muren kommer før alt andet. Jeg kan spore inspirationen til den tilbage til 1981. Her var jeg på besøg hos en ven i England, og på vejen til grænsen mellem England og Skotland stoppede vi for at se Hadrians mur. Jeg stod deroppe og prøvede at forestille mig, hvordan det må have været at være en romersk legionær, der stod på muren og kiggede ud over alle de fjerne bakker. Det var en meget dyb følelse. For romerne på den tid var den her mur enden på civilisationen; det var enden på verdenen. Vi ved, at der var skotter bag bakkerne, men det vidste romerne ikke. Der kunne have været alle slags monstre. Det var en følelse af den her barriere imod de mørke kræfter - det plantede noget i mig. Men, når du skriver fantasy, er alt større og mere farverigt, så jeg tog muren og gjorde den tre gange så lang, over 200 meter høj, og lavede den af is.\"","spans":[]},{"type":"paragraph","text":"Citatet herover stammer fra et længere interview i magasinet Rolling Stone med George R.R. Martin, forfatteren til romanen bag den populære HBO-serie Game of Thrones. I George R. R. Martins fantasy-univers er “The Wall” - “Muren” - en lidt over 200 meter høj og godt 100 meter tyk befæstning, der strækker sig omtrent 500 kilometer ved kontinentet Westeros’ nordlige grænse. Fortællingen er, at Muren oprindeligt blev bygget for at beskytte et ældre kongedømme syd for muren mod nogle frygtindgydende skabninger ved navn “De Hvide Vandrere” (“The White Walkers”), der huserede langt mod nord. Når man som læser eller seer dumper ned i Game of Thrones-universet blandt beboerne syd for muren, er befæstningen dog allerede mange, mange tusinde år gammel, og her opfatter de fleste folk nu mere fortællingerne om De Hvide Vandrere som myter eller eventyr. Den generelle opfattelse er nu, at Muren først og fremmest fungerer som en barriere mod “De Vilde” (“The Wildings”) - det vil sige det folk, der har valgt at leve uden for Muren og dermed uden for de syv etablerede kongedømmer, der ligger syd for muren. ","spans":[{"start":61,"end":75,"type":"em"},{"start":150,"end":165,"type":"em"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b5c2763e3c201c756d3f5ecc328513b63d183356_thewall_got_hbo.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/49be961ce1282697ae9f5b8fffe828c5b4ecf2e9_hadrianswall_shutterstock.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Øverst: Muren i Game of Thrones. Foto: HBO.\nNederst: Hadrians mur. Foto: Shutterstock.","spans":[{"start":0,"end":86,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Hadrians mur","spans":[]},{"type":"paragraph","text":"I virkelighedens verden var Hadrians mur, den mur George R. R. Martin blev inspireret af, en del af de såkaldte Roman Limes. Roman Limes var et forsvarssystem langs Romerrigets nordlige grænse, der skulle kunne kontrollere bevægelserne over grænsen samt sikre riget mod “barbarerne” og de germanske stammer i nord. Mens etableringen af den første del af forsvarssystemet fandt sted allerede et par århundrederne før vores tidsregning, blev Hadrians mur først påbegyndt i år 122. Det skete på initiativ af den romerske kejser Hadrian, der havde været på besøg i England, som på det tidspunkt var en provins i det romerske rige. Seks år senere stod den godt seks meter høje og tre meter brede stenmur færdig og strakte samtlige 118 kilometer på tværs af landet fra kyst til kyst. Komplet med flere indbyggede forter, der tillod kontrolleret passage. Som en vigtig del af forsvarssystemet var der tilført voldgrave på begge sider af muren, ligesom der var placeret bemandede vagttårne med jævne mellemrum på den romerske side af muren. Herfra kunne vagterne signalere tilbage ind i landet til flere forskellige grupper af hjælpetropper i tilfælde af, at germanerne ville forsøge at trænge igennem muren. Hadrians mur blev opgivet igen i år 400, og i år 1987 blev de eksisterende spor af den optaget på UNESCO's Verdensarvsliste.","spans":[{"start":112,"end":125,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Den Kinesiske Mur","spans":[]},{"type":"paragraph","text":"Hadrians mur - eller Roman Limes - er kun ét af flere eksempler på grænsemure, der har vundet en varig plads i historien. Selvom Hadrians mur i dag har en vigtig plads i den britiske kultur, og at den for mange er et symbol på adskillelsen mellem England og Skotland, er det ikke nødvendigvis den mur, de fleste vil nævne, hvis man beder dem om at komme med et eksempel på en historisk mur. Her vil en mur som Den Kinesiske Mur nok være et mere bredtfavnende bud. Havde George R. R. Martin i stedet besøgt den verdenskendte mur uden for Beijing, er det da heller ikke utænkeligt, at forfatteren også her kunne være blevet inspireret til muren af is. Helt i tråd med fortællingen i Game of Thrones definerede kineserne muren som en skillelinje mellem menneskenes verden og åndernes og dæmonernes verden. Derfor blev det at dø uden for muren opfattet som en vanærende katastrofe, og da buddhismen vandt indpas i det kinesiske rige, blev fortællingen endnu værre: Hvis man døde uden for muren, ville man ikke kunne blive reinkarneret som kineser.","spans":[{"start":681,"end":697,"type":"em"}]},{"type":"paragraph","text":"Selvom titlen “Den Kinesiske Mur” i sin vanlige entalsform hentyder til én sammenhængende mur, har der i virkeligheden været tale om flere forskellige mure. Det berømte stykke af muren uden for Beijing, som turister i hobetal valfarter til året rundt, blev først bygget omkring 1600-tallet, mens de første dele af murene så dagens lys for mere end 2300 år siden. Det skete, da Kinas første kejser, kejser Qin Shi Huangdi, forenede murene og udbyggede dem som en forsvarsbefæstning. Selvom den syv-otte meter høje og cirka seks meter brede mur er blevet udbygget og forlænget af flere omgange og med forskellige materialer under tre dynastier, forblev det overordnede formål det samme: At beskytte Kinas nordlige grænser og ikke mindst det agerjord og de marker, der fandtes syd for den, mod de mongolske nomader og “barbarer” fra stepperne mod nord. ","spans":[]},{"type":"paragraph","text":"Udover at beskytte mod uønskede folk fungerede Den Kinesiske Mur også som et sted, hvor det kinesiske styre via de udstationerede grænsevagter kunne kontrollere de personer, der krydsede grænsen, holde øje med eftersøgte personer og kontrollere for smuglervarer som for eksempel de dyrebare silkeorme, som kineserne gerne ville beholde deres monopol på. Muren var nemlig også det sted, hvor steppefolket kom til for at handle med kineserne. Mens steppefolket kunne tilbyde heste og læder, blev der i bondesamfundene bag murene blandt andet produceret keramik og tøj. Området omkring muren var dermed også et livligt sted for handel og møder mellem de forskellige kulturer. Dermed blev grænseområdet også et sted, hvorfra nye idéer og fremmede religioner lige så stille kunne bevæge sig ind i det kinesiske samfund. ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/00633f6d1bc667e48d180c648899b17dd0cea6e4_denkinesiskemur.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Turister på Den Kinesiske Mur uden for Beijing. Foto: Melissa via Unsplash.","spans":[{"start":0,"end":75,"type":"em"}]},{"type":"paragraph","text":"I det 13. århundrede, lykkedes det for den mongolske hersker Djengis Khan at bryde igennem muren med sine tropper, og dermed også at rive den første flænge i myten om den kinesiske urørlighed. Da flere migranter og rejsende begyndte at ankomme via søvejene, mistede Den Kinesiske Mur efterhånden sin afgørende rolle for riget.","spans":[]},{"type":"paragraph","text":"Med den mere end 2300 år gamle historie har Den Kinesiske Mur i dag fået en ikonisk status og måske et lidt mere magisk skær, end hvad historien reelt kan bakke op om. For det første er murens længde stadig et åbent spørgsmål: Muren løb fra kystlinjen ved Det Gule Hav øst for Beijing til Gobi-ørkenen i det nordvestlige Kina og anslås til at have været alt mellem 3.600 km lang til det dobbelte. Den kan - modsat hvad rygtet ellers hårdnakket har lydt på - ikke ses fra rummet, og langt størstedelen af den er nærmest ikke synlig længere. Ifølge flere historikere var det at bygge videre på muren den sidste løsning, når alt andet fejlede. Det vil sige, når diplomati, bestikkelse, handel eller militærmagt ikke slog til. Da det desuden var dyrt i både midler og arbejdskraft at bygge på muren, var ideen om muren i sig selv også en betydelig belastning for de forskellige dynastier.","spans":[{"start":458,"end":462,"type":"em"}]},{"type":"paragraph","text":"Det får historikeren Helmut Langerbein til at konkludere, at: “The Great Wall of China er udtryk for et bemærkelsesværdigt ingeniørarbejde og for det kinesiske folks kulturelle præstationer og udholdenhed. På trods af sit prisende navn var muren imidlertid ikke en stor succes i sin defensive funktion. I bedste fald fungerede den rimeligt godt, når den blev ordentligt vedligeholdt og garneret af stærke regeringer. I værste fald ruinerede muren det ene kinesiske dynasti efter det andet.”","spans":[{"start":63,"end":86,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Berlinmuren","spans":[]},{"type":"paragraph","text":"Ligesom i Games of Thrones-universet har verdens mure ændret karakter over tid. Rent fysisk - fra at bestå af stampet jord, til de højteknologiske mure, der bliver opført i dag. Og i betydning - fra en tid, hvor en streng og grundig grænsekontrol endnu ikke var kommet til, til i dag, hvor det i lige så høj grad er de juridiske paragraffer og forskellige sikkerhedsforanstaltninger, der er afgørende. Der er for eksempel langt fra både Hadrians mur og Den Kinesiske Mur til en af den nyere histories mest berømte mure: Berlinmuren.","spans":[{"start":10,"end":26,"type":"em"}]},{"type":"paragraph","text":"Ligesom det også var tilfældet for Hadrians mur, og det stykke af Den Kinesiske Mur, der troner uden for Beijing, var Berlinmuren en del af en større befæstet grænsedragning. En grænsedragning, der løb ned gennem Tyskland og markerede grænsen mellem Vest og Øst - mellem det liberale Vesttyskland (Forbundsrepublikken Vesttyskland) og det kommunistiske DDR (Den Tyske Demokratiske Republik).","spans":[]},{"type":"paragraph","text":"Grænsen mellem Øst- og Vesttyskland blev trukket efter Anden Verdenskrig på den såkaldte Potsdam-konference. I kølvandet på Tysklands kapitulation besluttede de allierede styrker nemlig at dele Tyskland i fire lige store dele, da de ikke kunne blive enige om en fælles politik for landet. I praksis blev landet dog kun delt i to - på den ene side styrede USA, Storbritannien og Frankrig Vesttyskland, mens Sovjetunionen overtog kontrollen med Østtyskland. Hovedstaden Berlin, der lå i det nye Østtyskland blev også delt i en vestlig og en østlig side. Grænsen mellem de to sider kom til at udgøre en ny, stærkt kontrolleret nationalgrænse.","spans":[]},{"type":"paragraph","text":"Selve Berlinmuren blev opført den 13. august 1961, men allerede fra den 1. december 1946 begyndte det nyligt etablerede østtyske politi at rejse vejblokke, udrulle pigtråd og opstille andre forhindringer på grænsen for at sikre sig, at det kun var rejsende med det nye interzone pas, der kunne få lov at passere. De eneste, der var undtaget fra de nye regler, var pendlere og lokale landmænd. ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/549cc863745f95827cccfbcb6f1844856d13da48_berlinmuren_1988_shutterstock.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/1e52bbb2766218c8be0b56c6bbd72b5019b4ceef_berlinmuren_nutid.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Øverst: Berlinmuren, oktober 1988. Foto: Shutterstock.\nNederst: East Side Gallery - rester af Berlinmuren omdannet til et udendørs galleri, maj 2018. Foto: Jeanette Westh.","spans":[{"start":0,"end":171,"type":"em"}]},{"type":"paragraph","text":"Allerede seks år senere, i år 1952 begyndte den østtyske stat dog at tage endnu stærkere midler i brug ved ved grænseovergangene for at dæmme op for migrationen fra øst mod vest. Det skete blandt andet i form af øget kontrol, censorer og tre nye sikkerhedszoner, før man nåede frem til selve grænseovergangen. På trods af de nye tiltag, regner man dog stadig med, at ikke mindre end en million østtyske statsborgere formåede at flygte over grænsen til Vesttyskland. I Berlin, hvor grænsen på det tidspunkt stadig var åben, forlod yderligere godt 1,5 million indbyggere den østtyske del - flertallet af dem unge og veluddannede østberlinere. Derudover flygtede flere andre østeuropæere også gennem grænseovergangen i den delte hovedstad. Oven i det var der et større antal østberlinere, der hver dag pendlede til og fra arbejde i Vestberlin, men blev boende i den østlige del, fordi leveomkostningerne fortsat var betydeligt lavere der. Da både de og andre vestberlinere, havde adgang til at købe den østtyske møntfod Ostmark ekstra billigt på det sorte marked i vest, havde den gruppe betydeligt nemmere end resten af østberlinerne ved at købe sig til en højere levestandard.","spans":[]},{"type":"paragraph","text":"Alt dette førte tilsammen til den østtyske regerings beslutning om at bygge en egentlig mur - Berlinmuren. En mur, der skulle beskytte den østtyske økonomi, holde den kvalificerede arbejdskraft på den østtyske side - og som historikeren Helmuth Langerbein formulerer det - ultimativt skulle sikre eksistensen af den østtyske stat. Natten mellem den 12. og 13. august 1961 gik opførelsen af muren dermed igang. Soldater og grænsepoliti afskar med ét alle veje, jernbaner og metrolinjer til Vestberlin. I begyndelsen bestod muren af vejblokader og pigtrådshegn, dernæst blev muren bygget i mursten, og over tid udviklede der sig et nærmest uigennemtrængeligt sikkerhedssystem omkring muren med både censorer, vagttårne, patruljering.","spans":[]},{"type":"paragraph","text":"Med det udbyggede kontrolsystem formåede Berlinmuren succesfuldt at spærre østberlinerne inde i hele 28 år, til den endelig faldt igen den 9. november 1989. Muren delte både et land og en befolkning og blev et stærkt symbol på Den Kolde Krig mellem Øst- og Vesteuropa. Lige siden murens fald har den dog været et lige så stærkt symbol på håb og fred.","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Mure i fremtiden?","spans":[]},{"type":"paragraph","text":"Mens resterne af Hadrians Mur og Den Kinesiske Mur står i et nærmest mytisk lys og i dag opfattes som manifestationer af bygherrernes storhed, er det altså stik modsat for Berlinmurens eftermæle. Her er det nærmere faldet af muren, der har gjort de nutidige rester af den til et både yndet turistmål og et stærkt symbol. Mens det er murbyggernes bedrift, der bliver fremhævet i fortællingerne om de to andre mure, er det den 9. november 1989, hvor Berlinmuren faldt, der er klimakset i dens historie.","spans":[{"start":215,"end":221,"type":"em"}]},{"type":"paragraph","text":"Kun fremtiden vil afsløre, hvilke andre mure, der med tiden vil glide fra nutiden over i historien, når de enten falder eller mister deres betydning. Og hvilke nye mure, vi skal forholde os til. Men hvis vi kender historien, kan vi måske komme med et kvalificeret gæt ...","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Til videre refleksion","spans":[]},{"type":"o-list-item","text":"Hvorfor, tror du, har vi udvalgt netop disse tre mure til dette tema? Ville du have valgt nogle andre?","spans":[{"start":0,"end":102,"type":"em"}]},{"type":"o-list-item","text":"Hvordan og hvorfor er eftermælet blevet så forskelligt for Hadrians mur/Den Kinesiske Mur og Berlinmuren?","spans":[{"start":0,"end":105,"type":"em"}]},{"type":"o-list-item","text":"Hvordan og hvorfor opstår en myte, som at den kinesiske mur med det blotte øje kan ses fra rummet? ","spans":[{"start":0,"end":99,"type":"em"}]},{"type":"o-list-item","text":"De mure, vi har beskrevet her, hører historien til. Hvilke nutidige mure, tror du, vil falde i din generations levetid, og hvorfor? ","spans":[{"start":0,"end":132,"type":"em"}]},{"type":"o-list-item","text":"Tror du, der vil komme nye mure til? Hvor og hvorfor?","spans":[{"start":0,"end":53,"type":"em"}]},{"type":"paragraph","text":"  ","spans":[]},{"type":"paragraph","text":"(Find kilderne til dette tema HER. \nTemafoto: Robert Nyman via Unsplash.)","spans":[{"start":30,"end":33,"type":"hyperlink","data":{"link_type":"Media","name":"kilder_temaer.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa0f4f587-8b24-462b-83b5-517329148ac6_kilder_temaer.pdf","size":"6462983"}}]}],"content_bits":[],"meta_title":"Mure i historien","meta_description":"I temateksten \"Mure i historien\", der er en del af undervisningsmaterialet OVER MUREN, bliver der blandt andet sat spot på tre ikoniske mure, der er gået over i historien, og én enkelt opdigtet.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b9b2d244a50ed5cc8b113488efbe4137e67cf5c2_robert-nyman-442988.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}},"navigation":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false},"home_link":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false}}}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WyvFux8AAIic3dzK","type":"article","uid":"mure-og-gadekunst","url":"/temaer/mure-og-gadekunst","published":"2019-01-29T10:53:33+0000","lang":"da-dk","meta_title":"Mure og gadekunst","meta_description":"I temateksten \"Mure og gadekunst\", der er en del af undervisningsmaterialet OVER MUREN, bliver der stillet skarpt på den politiske kunst, som de mange nye grænsemure fungerer som et oplagt lærred for.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/276ad36b900339dc329f2e7c5a0d70587c844a57_fredsdue.jpg"},"alternate_languages":[],"data":{"pdf":{"link_type":"Media","name":"tema_gadekunst_print.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F045d7913-676b-4399-8501-5f7deb9c02c7_tema_gadekunst_print.pdf","size":"7043451"},"url":"/temaer/mure-og-gadekunst","image":{"dimensions":{"width":750,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/bf393dd93ae6b96f6a8e5af88751349f9c9d0159_fredsdue.jpg","small":{"dimensions":{"width":375,"height":200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/a1796a285b288e15d9d768c4225f5467ef2a2439_fredsdue.jpg"},"medium":{"dimensions":{"width":600,"height":320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/388cf893ce9a3e11b452cce82bdb772411d9dc43_fredsdue.jpg"}},"title":[{"type":"heading1","text":"Mure og gadekunst","spans":[]}],"content":[{"type":"paragraph","text":"Mennesker har udtrykt sig gennem kunst i årtusinder og gennem historien sat deres spor på mure og i klippehuler for at markere, at vi er til stede i verden, hvordan vi opfatter den, og hvad der er vigtigt for os. Nogle af de ældste kendte malerier er cirka 32.000 år gamle hulemalerier af vilde dyr. Også i dag finder man kunstneriske udtryk overalt i bybilledet. Den kunst, vi møder uden for museer og gallerier, som er uorganiseret og ukontrolleret af kuratorer og eksperter, og som indeholder et element af protest mod det etablerede system, kalder vi gadekunst. De mange nye grænsebefæstninger, der skyder op, fungerer som et oplagt lærred for gadekunst. Det skal vi se nogle eksempler på i dette tema. ","spans":[{"start":0,"end":707,"type":"strong"},{"start":555,"end":564,"type":"em"}]},{"type":"paragraph","text":"I det følgende dykker vi først ned i gadekunstens oprindelse og historie og sætter navn på nogle af de kunstnere, der har gjort sig ekstra bemærket. Derefter tager vi fat i gadekunst med klare politiske budskaber, der tildækker mure verden over.","spans":[{"start":0,"end":228,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Gadekunstens oprindelse","spans":[]},{"type":"paragraph","text":"Gadekunst, som vi kender den i dag, har mange forskellige former og udtryk. Derfor kan det være svært helt præcist at sige, hvor fænomenet stammer fra. Nogle mener, at det at lave kunst på gaden har sit egentlige udspring i en gryende hiphop-kultur i 1970’ernes New York. Her begynder uautoriserede skriblerier på offentlige vægge at samle sig under betegnelsen graffiti. Snart er undergrundsbanen overmalet med sære navne skrevet med skæve typer, de såkaldte tags. Unge på besøg i New York samler spraydåserne op og tager graffitien med til andre af verdens storbyer. Andre mener, at vi skal tilbage til politisk orienterede og aktivistiske kunstkredse i 1960’erne for at finde rødderne til fænomenet gadekunst. Selvom forskellige kilder og kunsthistorikere ikke er enige om præcis, hvor gadekunsten har sit udspring, er det et faktum, at gadekunst var en etableret kunstform ved slutningen af det 20. århundrede. Og den kan i dag opleves i næsten alle storbyer og byder på meget mere end “bare” graffiti. Gadekunsten ændrer sig hele tiden og ser forskellig ud afhængigt af hvilken storby, man besøger. Gadekunstnerne finder hele tiden nye motiver, nye metoder og nye lærreder.","spans":[{"start":235,"end":248,"type":"strong"},{"start":362,"end":370,"type":"strong"},{"start":460,"end":464,"type":"em"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/306b61a0044dea9a4438c78ad0d99db8f99806e0_nysubway.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"I 1970'erne brugte New Yorks bystyre store summer på at fjerne grafitti fra vægge og toge i Undergrundsbanen. Nogle kunsthistorikere mener, at det var her gadekunsten, som den kunstform vi kender i dag, blev født.","spans":[{"start":0,"end":213,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Hærværk eller kunstværk?","spans":[]},{"type":"paragraph","text":"Dét at være gadekunstner er ofte tæt knyttet til en aktivistisk, antiautoritær indstilling. Der er ingen kunstekspert eller kurator, der beslutter, hvor eller hvordan kunsten skal vises. Bevæbnet med spraydåser, stencils, maling og pensler dekorerer undercover-kunstnere byens murer med humor og kritiske kommentarer uden at spørge om lov. Derfor er det en vedvarende diskussion, om gadekunst skal betragtes som hærværk. Hvis kunstnerens værk bliver betragtet som hærværk, kan der indgives politianmeldelse og rejses erstatningssag. Gadekunstnere er gennem årene blevet idømt erstatninger på flere hundredetusinde kroner og endda fængselsstraffe. I andre tilfælde, hvor værket bliver betragtet som et kunstværk, kan det betyde en gevinst for den heldige ejer af den bygning, der er blevet dekoreret. For eksempel hvis den kendte og anerkendte britiske gadekunstner Banksy har sat sit aftryk på den (mere om ham senere).","spans":[{"start":864,"end":871,"type":"strong"}]},{"type":"paragraph","text":"Generelt er grænsen mellem gadekunst og \"almindelig\" kunst mere utydelig i dag, hvor gadekunstnere også finder vej til gallerier og nogle modtager udsmykningsopgaver på bestilling. Men i sin grundform er gadekunsten rebelsk - den kritiserer magthavere og gør op med undertrykkelse og ulighed vedrørende køn, race og klasse. Det samme gælder for gadekunstnere, der forholder sig til verdens grænser og mure. Det skal vi se nogle eksempler på i det følgende.","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Gadekunst på grænsemuren mellem USA og Mexico","spans":[]},{"type":"paragraph","text":"I nærheden af Tijuana lufthavn i Mexico, hvor vejen slutter og en jordvej begynder, finder man tre murmalerier på den gamle grænsemur mellem USA og Mexico. Et af malerierne forestiller Donald Trump med en rød knebel i munden, der er malet med graffiti. Der er også skrevet en instruktion på spansk om, hvordan man finder vej til Trump Tower i New York City. Murmalerierne blev lavet under valgkampen i USA i 2015, efter Donald Trump havde udtalt følgende: ”Den mexicanske regering tvinger deres mest uønskede borgere ind i USA. De er, i mange tilfælde, kriminelle, pushere, voldtægtsforbrydere og lignende.” Ved siden af murmaleriet af Trump kan man se hvide kors med navne på dem, der er døde i forsøget på at krydse grænsen. Det er kunstnere fra et kollektiv, der hedder Indecline, der er ansvarlige for malerierne. Gruppen består af anonyme politiske aktivister, filmskabere og graffitikunstnere og sætter spot på social og økonomisk uretfærdighed. ","spans":[{"start":456,"end":607,"type":"em"},{"start":773,"end":782,"type":"strong"}]},{"type":"embed","oembed":{"is_plus":"0","account_type":"pro","width":640,"height":360,"duration":142,"description":"www.thisisindecline.com","thumbnail_url_with_play_button":"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F541930936_640.jpg&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png","upload_date":"2015-10-30 14:57:18","video_id":144156578,"uri":"/videos/144156578","embed_url":"https://vimeo.com/144156578","type":"video","version":"1.0","title":"RAPE TRUMP","author_name":"Indecline","author_url":"https://vimeo.com/indecline","provider_name":"Vimeo","provider_url":"https://vimeo.com/","cache_age":null,"thumbnail_url":"https://i.vimeocdn.com/video/541930936_640.jpg","thumbnail_width":640,"thumbnail_height":360,"html":"<iframe src=\"https://player.vimeo.com/video/144156578?app_id=122963\" width=\"640\" height=\"360\" frameborder=\"0\" title=\"RAPE TRUMP\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"}},{"type":"paragraph","text":"En anden kunster, der har sat sit aftryk på muren mellem USA og Mexico er franske JR. JR startede som graffitimaler, men begyndte senere at installere fotografier i gadebilledet. I 2017 installerede han et kæmpe fotografi af den 1-årige dreng Kikito fra Mexico, der kigger over muren mellem USA og Mexico fra den mexicanske side af grænsen. JR har fortalt, at han valgte at fotografere et barn, fordi han ville udforske, hvordan muren opleves fra et barneperspektiv - se billede af installationen HER. Den dag, installationen skulle pilles ned, organiserede JR en skovtur på tværs af grænsen mellem USA og Mexico. Hundredvis af gæster fra begge sider af grænsen kom for at dele et måltid mad omkring et gigantisk spisebord påmalet store drømmende øjne - ét på hver side af muren. Mennesker fra begge sider af grænsen spiste den samme mad, delte det samme vand og nød den samme musik - halvdelen af bandet var på USA's side af grænsen og den anden halvdel på Mexicos. Se billede af skovturen HER.","spans":[{"start":82,"end":84,"type":"strong"},{"start":497,"end":500,"type":"hyperlink","data":{"link_type":"Web","url":"https://www.jr-art.net/news/jr-in-tecate","target":"_blank"}},{"start":699,"end":700,"type":"em"},{"start":991,"end":994,"type":"hyperlink","data":{"link_type":"Web","url":"https://www.jr-art.net/news/gigantic-picnic-at-the-us-mexico-border-fence","target":"_blank"}}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Gadekunst om Australiens immigrationspolitik","spans":[]},{"type":"paragraph","text":"I Australien har kunstneren Peter Drew brugt vægge og mure som opslagstavler for sine politiske plakater, der især har sat fokus på Australiens immigrationspolitik. Under det australske valg i 2013 udarbejdede Drew nedenstående plakater som kommentar til de to største partiers enighed om at ”stoppe bådene”, som de mange asylansøgere kom sejlende i til Australien. ”Stop the boats” blev et af de helt store slogans under valgkampen. Drew valgte at lave en parodi på den australske politik og satte først nogle plakater op i London og senere også i Australien. Med plakaterne knytter Drew en kritisk kommentar til ”stop bådene”-politikken ved at minde om de negative følger for australske aboriginere af den britiske immigration til Australien tilbage i 1800-tallet og sætte spørgsmålstegn ved, hvem der egentlig kan siges at være \"rigtig\" australier - en Aussie. ","spans":[{"start":28,"end":38,"type":"strong"},{"start":856,"end":862,"type":"em"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/a1d75cbe725b025ce4de6bd0187dbc92773699a3_ikke-navngivet-1.png","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Foto: Venligst udlånt af Peter Drew Arts, www.peterdrewarts.com.","spans":[{"start":0,"end":64,"type":"em"}]},{"type":"paragraph","text":"I 2015 satte Drew 1000 plakater op rundt omkring i Australien med ordene ”REAL AUSTRALIANS SAY WELCOME”. Inspirationen stammer fra den australske nationalsang og det ofte glemte andet vers, der indeholder ordene:","spans":[]},{"type":"preformatted","text":"For those who have come across the seas\n(For dem der er kommet over havene)\nWe’ve boundless plains to share;\n(Har vi ubegrænsede sletter at dele;)\nWith courage let us all combine\n(Med mod lad os alle forene)\nTo Advance Australia Fair\n(For at fremme Australien retfærdigt)","spans":[]},{"type":"paragraph","text":"Efter Drews eget udsagn lavede han plakaterne for at teste om australiere i virkeligheden har modet til at byde de mennesker velkommen, der rejser over havet. ","spans":[]},{"type":"paragraph","text":"Portrætterne på Aussie-plakaterne stammer fra rigtige ID-billeder, som Drew har fundet i det australske nationalarkiv. En af plakaterne portrætterer Monga Kahn. Billedet er taget i Australien i 1916 under White Australia politikken. Politikken betød, at man ikke kunne få adgang til Australien, med mindre man var hvid, men der var smuthuller. Monga Kahn arbejdede med at transportere varer mellem australske byer på sine kameler, hvilket gjorde Monga Kahn, og tusinde andre som ham, essentielle for Australiens økonomi. Det var nemlig før, der fandtes veje eller jernbaner mellem australske byer. Derfor fik Monga Kahn alligevel adgang til det dengang ”hvide” Australien. Drews projekt handler om at hylde australiere, der er blevet glemt i historiefortællingen om Australien, selvom de har været med til at gøre Australien til det land, det er i dag. Samtidig er det hans intention at udvide forestillingerne om australsk identitet. Peter Drew stiller spørgsmålet:","spans":[{"start":149,"end":159,"type":"strong"},{"start":205,"end":221,"type":"em"}]},{"type":"paragraph","text":"”Har Australien arvet sin identitet fra de mennesker, der skabte White Australia politikken eller har ”aussie” mere at gøre med de mennesker, der overlevede politikken? Mennesker som Monga Kahn spillede en afgørende rolle for landets udvikling”. ","spans":[{"start":0,"end":246,"type":"em"}]},{"type":"embed","oembed":{"is_plus":"1","account_type":"plus","width":640,"height":360,"duration":168,"description":"","thumbnail_url_with_play_button":"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F587830362_640.jpg&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png","upload_date":"2016-08-22 11:14:02","video_id":179767687,"uri":"/videos/179767687","embed_url":"https://vimeo.com/179767687 ","type":"video","version":"1.0","title":"How to Make an AUSSIE Poster","author_name":"Peter Drew","author_url":"https://vimeo.com/peterdrewarts","provider_name":"Vimeo","provider_url":"https://vimeo.com/","cache_age":null,"thumbnail_url":"https://i.vimeocdn.com/video/587830362_640.jpg","thumbnail_width":640,"thumbnail_height":360,"html":"<iframe src=\"https://player.vimeo.com/video/179767687?app_id=122963\" width=\"640\" height=\"360\" frameborder=\"0\" title=\"How to Make an AUSSIE Poster\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"}},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Banksys kommentar til flygtningekrisen i Europa","spans":[]},{"type":"paragraph","text":"Banksy, der er kendt for sine kunstneriske kommentarer til globale problemstillinger, var selvfølgelig også nødt til at kommentere på den europæiske såkaldte flygtningekrise. Det gjorde han blandt andet i form af et værk, der den 11. december 2015 dukkede op på en af de mure, der omkransede en uofficiel flygtningelejr i Calais i Frankrig, også kaldt The Calais Jungle, som i øvrigt blev ryddet i oktober 2017. Værket forestiller Steve Jobs, grundlæggeren af Apple, i sin karakteristiske rullekrave, med en sæk over skulderen og et Apple produkt i den anden hånd. Hvad de færreste måske ved er, at Steve Jobs er søn af en syrisk migrant, som tog turen til USA efter Anden Verdenskrig. Banksy kommenterer sjældent på sine værker, men med lige netop dette værk blev der udsendt en udtalelse fra kunstneren selv:","spans":[{"start":0,"end":6,"type":"strong"},{"start":352,"end":369,"type":"em"}]},{"type":"preformatted","text":"“We’re often led to believe migration is a drain on the country’s resources but Steve Jobs was the son of a Syrian migrant. Apple is the world’s most profitable company, it pays over $7billion a year in taxes – and it only exists because they allowed in a young man from Homs.” \n- Banksy","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/7069529fad9873930a001cffc23f612c7a637bcc_banksy2-med-tilladelse.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/c5a6d69331f2d34c6afea82d4f79aecdc724d05d_banksy-med-tilladelse.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Øverst: Den uofficielle flygtningelejr i Calais med Banksy værk på muren i baggrunden.\nNederst: Close up af Banksys portræt af Steve Jobs som flygtning.\nKilde: www.banksy.co.uk.","spans":[{"start":0,"end":177,"type":"em"}]},{"type":"paragraph","text":"Banksy har lavet politisk gadekunst over hele verden og er de senere år også blevet særligt kendt for sine sarkastiske kommentarer til og på muren mellem Israel og Vestbredden (temabilledet ovenfor er ét eksempel). Han var i mange år fuldstændig anonym, og hans identitet er stadig omstridt. Lige så kendt og elsket Banksy er for sin provokerende kunst, lige så kritiseret er han også for at være blevet for \"kommerciel\" - hans værker er i dag så værdifulde, at de skæres ud af mure for at blive solgt for millioner af kroner eller overdækkes med plexiglas for at beskytte dem. Selv tager han dog skarp afstand fra dem, der skaber profit på hans gadekunst og gør klart, at han ikke er repræsenteret af nogen. ","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Til videre refleksion","spans":[]},{"type":"o-list-item","text":"Hvad synes du - er et stykke gadekunst hærværk eller kunstværk? Hvorfor?","spans":[]},{"type":"o-list-item","text":"Er det overhovedet muligt at skelne mellem gadekunst og \"almindelig\" kunst? Hvordan ville du definere de to?","spans":[]},{"type":"o-list-item","text":"Hvordan forstår du budskabet bag kunsteren JR's værk Eyes of a Dreamer? ","spans":[{"start":53,"end":70,"type":"em"},{"start":53,"end":70,"type":"hyperlink","data":{"link_type":"Web","url":"https://www.jr-art.net/news/gigantic-picnic-at-the-us-mexico-border-fence","target":"_blank"}}]},{"type":"o-list-item","text":"Gå på Banksys website og se nogle flere af hans værker. Udvælg ét og lav en analyse af det. Eller vælg et værk af en helt anden gadekunstner, måske kan du finde én på gaden i din by.","spans":[{"start":6,"end":21,"type":"hyperlink","data":{"link_type":"Web","url":"https://www.banksy.co.uk","target":"_blank"}},{"start":175,"end":178,"type":"em"}]},{"type":"o-list-item","text":"Nytter gadekunsten noget? Tror du, det gør en forskel, for eksempel i debatten om mure og migration? ","spans":[]},{"type":"paragraph","text":"(Find kilderne til dette tema HER.\nTemafoto: Banksys Armored Peace Dove, som findes på muren mellem Israel og Vestbredden.)  ","spans":[{"start":30,"end":33,"type":"hyperlink","data":{"link_type":"Media","name":"kilder_temaer.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa0f4f587-8b24-462b-83b5-517329148ac6_kilder_temaer.pdf","size":"6462983"}},{"start":53,"end":71,"type":"em"}]}],"content_bits":[],"meta_title":"Mure og gadekunst","meta_description":"I temateksten \"Mure og gadekunst\", der er en del af undervisningsmaterialet OVER MUREN, bliver der stillet skarpt på den politiske kunst, som de mange nye grænsemure fungerer som et oplagt lærred for.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/276ad36b900339dc329f2e7c5a0d70587c844a57_fredsdue.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}},"navigation":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false},"home_link":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false}}}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"W1clXx4AAPIE5NFb","type":"article","uid":"mure-og-magt","url":"/temaer/mure-og-magt","published":"2019-01-29T10:47:53+0000","lang":"da-dk","meta_title":"Mure og magt","meta_description":"I temateksten \"Mure og magt\", der er en del af undervisningsmaterialet OVER MUREN, bliver der blandt andet sat fokus på, hvordan det stigende antal grænsebefæstninger hænger sammen med en følelse af kontroltab og behov for magtdemonstration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c24616da795df48c1d664ae71b9e8aef3cfad32a_753621.jpg"},"alternate_languages":[],"data":{"pdf":{"link_type":"Media","name":"tema_magt_print.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fcf01e04d-7641-42aa-9a30-088c56100b00_tema_magt_print.pdf","size":"6757147"},"url":"/temaer/mure-og-magt","image":{"dimensions":{"width":750,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/040cb3d104d49a3281da666736334e59cc1e1c1d_753621.jpg","small":{"dimensions":{"width":375,"height":200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/07c71bd99c4f477af4af6eec8b7e2dcf0d91e415_753621.jpg"},"medium":{"dimensions":{"width":600,"height":320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e18879d9151d5f97174e7e12b4dfbe8fe1833ceb_753621.jpg"}},"title":[{"type":"heading1","text":"Mure og magt","spans":[]}],"content":[{"type":"paragraph","text":"Den canadiske forsker Elisabeth Vallet har opgjort, at mens der var 7 befæstede grænser efter Anden Verdenskrig, er det tal nu steget til over 70. Når man kigger nærmere på, hvor grænsebefæstningerne rejser sig, og hvordan vi omtaler deres funktion og de mennesker, der forsøger at krydse dem, kan man samtidig konkludere, at der er en sammenhæng mellem mure og magt, som vi skal undersøge nærmere i dette tema.","spans":[{"start":0,"end":411,"type":"strong"}]},{"type":"paragraph","text":"Først ser vi på, hvor forskelligt grænsebefæstninger kan tage sig ud, inden vi går videre til et afsnit om ord, og hvordan vi taler om grænser og migranter. Vi runder UNHCR's rapport om en markant stigning i antallet af flygtninge disse år, som er én årsag til strengere grænsekontrol verden over, før vi dykker ned i Elisabeth Vallets forskning om årsager til og effekter af befæstningen af grænser. ","spans":[{"start":0,"end":401,"type":"em"}]},{"type":"preformatted","text":"“I de seneste år har grænser fået en enorm betydning. Over hele verden er de blevet ændret, konstrueret samt demonteret, og er blevet fysiske barrierer mellem socio-politiske ideologier. Nogle grænser adskiller samfund med meget forskellige kulturer, historier, nationale identiteter og økonomier. Andre adskiller folk med den samme etniske eller kulturelle identitet. Som manifestationer på nogle af verdens nøgleproblematikker inden for de politiske, økonomiske, sociale og kulturelle områder, har grænser og grænseregioner derfor fået stor opmærksomhed fra forskerne hen over det seneste ti år.”","spans":[]},{"type":"paragraph","text":"Sådan lyder det fra professor Doris Wastl-Walter i indledningen til en akademisk bogserie om grænseregioner med titlen Border Regions Series. En serie, hvor førende eksperter indvier læserne i den nyeste forskning på området. Oversat til et mere mundret dansk, beskriver indledningen det, vi kan høre og læse om i nyhederne igen og igen: At verdens grænser ændrer sig i de her år. Stik imod forventninger efter Berlinmurens fald om, at vi var på vej mod en grænseløs verden, lader det nemlig til, at grænserne nu igen bliver kraftigere og kraftigere optegnet. Nogle endda med både hegn og mure, som det for eksempel sker på grænsen mellem Mexico og USA. Andre med genindførelsen af grænsekontrol, som ved den dansk-tyske grænse i år 2016.","spans":[{"start":119,"end":140,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Forskellige former for mure","spans":[]},{"type":"paragraph","text":"I det her materiale har vi tolket ordet “mure” i bredeste forstand. Som I kan se i casene, er det faktisk kun to af dem, der handler om deciderede mure. Nemlig Israel/Palæstina-casen og casen om USA/Mexico. For Sydafrika/Zimbabwe er der dels tale om en flod og om et pigtrådshegn, mens det for de to sidste cases, EU/Middelhavet og Australien/de omkringliggende have, derimod er havets bølger, der udgør grænsen, ikke en menneskeskabt grænsemanifestation. Her består murene i stedet af juridiske paragraffer, der bestemmer, hvem der må sejle ind i farvandet og lægge til kyst. ","spans":[]},{"type":"paragraph","text":"Hvis man ser mere snævert på begrebet mure og kun forholder sig til dem, der kan gå ind under kategorien \"befæstede grænser\" - for eksempel grænsemure og -hegn eller pigtråd, vil man dog opleve, at der også her er flere forskellige kategorier at forholde sig til, alt efter hvilket eller hvilke formål grænsebefæstningen er blevet opført for at indfri. Derudover kan den samme grænsebefæstning sagtens høre til i flere forskellige kategorier, og alt efter hvilken side af befæstningen, man står på, kan der være vidt forskellige syn på den. For at gøre billedet endnu mere komplekst, kan det være politisk fordelagtigt for en regering/et land at hævde at grænsebefæstningen er blevet opført med ét bestemt formål, selvom det egentlige formål er et andet, og endeligt kan formålet med en grænsebefæstning også ændre sig over tid. Sidstnævnte har blandt andet være tilfældet for den befæstede grænse mellem Indien og Pakistan, der oprindeligt blev bygget for at dæmme op for illegal migration, men som i dag har som primære formål at forhindre terrorisme.","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d18e471b2a509f0d93c5bebaa39af79488740424_pakistan_indien.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Grænsemuren mellem Indien og Pakistan ved en flagceremoni. Grænsemuren her er et eksempel på en mur, der har ændret formål over tid. Foto: Shutterstock.","spans":[{"start":0,"end":152,"type":"em"}]},{"type":"paragraph","text":"Modsat tidligere i historien, hvor det primære formål med murene var at beskytte mod angreb fra en fjendtlig hær, peger eksperterne på, at størstedelen af verdens mure i dag er bygget enten for at forhindre illegale migranter og eller terrorister/militante grupper at komme ind over grænserne. Derudover findes der også flere mure, der er blevet opført på linjerne af en fastfrosset konflikt. Mens man finder et eksempel på sidstnævnte på grænsen mellem den cypriotske og tyrkiske del af Cypern, er muren mellem USA og Mexico et eksempel på en mur, hvor det primære formål er at dæmme op for illegal indvandring. ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/c46eb70c40de56700bad1e85d569362716d3ca07_ceuta_dreamstime.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Grænsehegn mellem den spanske enklave Ceuta og Marokko. Hegnets primære formål er at holde illegale migranter ude. Grænsen mellem Marokko og de spanske enklaver Ceuta og Melilla udgør de eneste landfaste grænser mellem Europa og Afrika. Foto: Miro9966 via Dreamstime.","spans":[{"start":0,"end":267,"type":"em"}]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/8e2928aaa8fb135988d2507467ae9b9101f87e96_cypern_border_shutterstock.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Den såkaldte \"grønne linje\" på Cypern adskiller den cypriotiske og tyrkiske del af landet. Grænsen, der bliver bevogtet af FN's fredsbevarende styrker, løber blandt andet tværs igennem byen Nicosia og deler den i to. Foto: Anatolii Lyzun via Shutterstock.","spans":[{"start":0,"end":255,"type":"em"}]},{"type":"paragraph","text":"For de barrierer, et land har opført for at kunne kontrollere indvandringen, gælder det typisk, at barrieren kun er ét af flere tiltag. Et supplerende tiltag kan være at indføre en strammere lovgivning eller en politik på området, der skal skræmme migranterne fra overhovedet at forsøge at komme ind i landet. Et eksempel på et supplerende juridisk tiltag så man blandt andet i foråret 2018 ved den mexicansk-amerikanske grænse, da Trump-administrationen vedtog en nultolerance-politik på immigrationsområdet. Det var en politik, der i praksis betød, at alle personer, der krydsede grænsen til USA illegalt ville blive retsforfulgt. Inden nultolerancen blev indført, blev de, der krydsede grænsen illegalt for første gang, blot sigtet for en mindre lovovertrædelse, og de blev derfor i de fleste tilfælde frigivet igen. Med nultolerancepolitikken blev migranterne i stedet fængslet og retsforfulgt. Da man ikke kan retsforfølge børn, betød ændringen derfor for de familier, der krydsede grænsen illegalt, at alle børn over 5 år blev adskilt fra deres forældre og i stedet anbragt i detentionscentre, før de skulle anbringes hos et familiemedlem, en værge, plejefamilie eller et børnehjem i USA. Af samme grund flød medierne verden over pludseligt over med billeder af børn i store bure i amerikanske detentionscentre i sommeren 2018 med en storm af både national og international fordømmelse til følge.","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/7223a9f2cdd226ac3528f3a6f220ca761ccec9b9_icedemo.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Demonstration i Minneapolis i juni 2018 mod præsident Trumps stramninger af den amerikanske immigrationslov, der blandt andet betød, at børn blev adskilt fra deres forældre ved grænsen. Foto: Fibonacci Blue via Flickr.","spans":[{"start":0,"end":218,"type":"em"}]},{"type":"paragraph","text":"Andre supplerende tiltag kan være grænsevagter, overvågningsudstyr og højteknologiske løsninger. Ifølge den russiske forsker Serghei Golunov vil de supplerende løsninger, lande tager i brug for at holde migranter ude, dog typisk være ‘blødere’, end de supplerende tiltag, der bliver brugt ved grænsebarrierer, der primært er opført for at hindre terrorister, militante grupper eller sågar en fjendtlig hær fra at komme ind i landet. Ved de sidstnævnte barrierer vil der for eksempel være en øget tendens til, at man benytter sig af forskellige mekanismer, der i yderste konsekvens kan være dødelige - som elektriske hegn eller miner. Sidstnævnte bliver eksempelvis brugt på grænsen mellem Nord- og Sydkorea.","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/ae1dd21f25bace109b503756204804bfe49c2345_dmz.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"\"Den Demilitariserede Zone\" - grænsen mellem Nord- og Sydkorea er et eksempel på en grænsebefæstning, hvis primære funktion er at holde en fjendtlig hær ude. Da flere nordkoreanere hvert år flygter til Sydkorea via Kina, kan man dog argumentere for, at grænsen i høj grad også er med til at holde den nordkoreanske befolkning indespærret. Foto: Jeanette Frank Nielsen.","spans":[{"start":0,"end":368,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Migranter, flygtninge og asylansøgere - ord og magt","spans":[]},{"type":"paragraph","text":"Med opførelsen af verdens mure og grænser er der med tiden også skabt flere forskellige definitioner på, hvem der er inde, og hvem der ude. Når man taler om grænser og grænsebefæstninger, er det dermed nærmest umuligt ikke også at tale om tre af de hovedkategorier, der er fulgt med: Migranter, flygtninge og asylansøgere.","spans":[]},{"type":"paragraph","text":"Ligesom en grænsebefæstning kan skifte betydning alt efter, hvilke øjne der ser på den, kan de tre kategorier også betyde forskellige ting. Man kan for eksempel skelne mellem en leksikal betydning og en normativ. Hvor den førstnævnte vil redegøre for ordets betydning i den almindelige sprogbrug, vil den normative defintion redegøre for, hvad ordet bør betyde, når det bliver brugt. At sætte sig på retten til at definere et ords betydning er også en måde at udøve magt på (se mere om det i temaet Mentale mure). Et eksempel på kampen om definitionsretten til ord, der har med migranter, flygtninge og asylansøgere at gøre, så man i september 2015, hvor den arabiske tv-station Al Jazeera meddelte, at den ikke længere ville bruge ordet \"migranter\" om de mennesker, der søgte mod Europas grænser, fordi der efter tv-stationens opfattelse var tale om \"flygtninge\". Selve ordet \"flygtninge\" kan i sig selv også blive både indskrænket og udvidet, når man begynder at sætte andre ord foran det, så man for eksempel kommer frem til ordene \"bådflygtninge\", \"klimaflygtninge\" og \"fattigdomsflygtninge\". Mens ordet \"bådflygtninge\" opstod som følge af Vietnamkrigen og alle de, der flygtede i både fra den, er ordet \"klimaflygtninge\" et forholdsvist nyt begreb. Ordet \"fattigdomsflygtninge\" skal man derimod helt tilbage til Hitlers Tyskland for at finde oprindelsen på. Her blev det i første omgang brugt om de jøder, der forsøgte at forlade landet.","spans":[{"start":350,"end":353,"type":"em"}]},{"type":"paragraph","text":"Hvis man tager de juridiske briller på, er definitionerne dog heller ikke klokkeklare her: Det er for eksempel forskelligt, hvordan de forskellige landes retssystemer opfatter dem. I skemaet herunder kan man se, hvordan de tre ord, og en række beslægtede, bliver officielt defineret i en dansk kontekst: ","spans":[]},{"type":"preformatted","text":"UDLÆNDING - En person, der er hjemmehørende i et andet land, eller som (for nylig) er indvandret fra et andet land.\n\nMIGRANT - En person, der flytter fra ét sted til et andet, ofte over landegrænser. Økonomisk migrant betegner en person, der flytter for at arbejde eller søge arbejde og/eller forbedre sine levevilkår.\n\nEXPAT - En person, der bor midlertidigt eller permanent i et andet land end deres hjemland. En expat er det samme som en migrant, men begrebet bruges hovedsagligt om veluddannede personer fra udviklede lande, der får en stilling uden for deres hjemland, enten fordi de selv vælger det, eller fordi de bliver sendt udenlands af deres arbejdsgivere. Arbejdsgiverne kan være firmaer, universiteter, regeringer, eller non-profit organisationer. \n\nIMMIGRANT/INDVANDRER - En person, der tager eller har taget varigt ophold i et land efter at have forladt sit hjemland.\n\nEMIGRANT/UDVANDRER - En person, der har forladt sit hjemland for at bo i et fremmed land.\n\nFLYGTNING - En person, der er tvunget til at forlade sin hjemegn eller sit hjemland fx pga. krig eller politisk eller religiøs forfølgelse. \n\nASYLANSØGER - En person, der søger om ret til at opholde sig som flygtning i et andet land og blive beskyttet af dette land, men som endnu ikke er anerkendt som flygtning.","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Flere flygtninge - strengere grænsekontrol","spans":[]},{"type":"paragraph","text":"Ifølge UNHCR (FN's flygtningehøjkommissariat) blev der i gennemsnit tvunget 44.000 mennesker på flugt hver dag i år 2017 - det er det højeste antal, organisationen nogensinde har målt. Det var specielt nye konflikter i Den Demokratiske Republik Congo og i Myanmar samt den fortsatte konflikt i Syrien, der stod for en stor del af flygtningestrømmen i år 2017, hvor det samlede antal flygtninge i verden nåede op på 68,5 millioner.  Antallet slog dermed endnu engang rekord og fulgte samme udvikling som i årene forinden med store stigninger i antallet af flygtninge: Alene fra 2013 til 2016 steg antallet således fra 51,3 millioner til 65,6 millioner mennesker på flugt. ","spans":[]},{"type":"paragraph","text":"Selvom langt de fleste af verdens flygtninge og fordrevne personer opholder sig i udviklingslandene - og de fleste flygtninge enten er internt fordrevne eller flygter til de umiddelbare nabolande, har den store stigning i antallet af både flygtninge, asylansøgere og migranter været en medvirkende årsag til, at især de europæiske lande i de senere år har styrket deres grænsekontrol markant - både med patruljering i havet og med opførelsen af nye grænsebefæstninger samt genindførelse af grænsekontrol internt mellem flere EU-lande. En udvikling der blandt andet er faldet UNHCR og Dansk Flygtningehjælp for brystet. I et længere indlæg i Politiken i juni måned 2018 skrev generalsekretæren, Christian Friis Bach således, at: \"Desværre er der en tendens til, at mange lande kæmper mere for at holde flygtninge ude, end for at bekæmpe årsagerne til, at mennesker må flygte. Derfor bliver der flere flygtninge i verden – og derfor er der stadig mennesker, der banker på vores dør og beder om beskyttelse.\"","spans":[]},{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://youtu.be/1MGRB5ZmKpU","type":"video","version":"1.0","title":"UNHCR Global Trends 2017 Report","author_name":"UNHCR, the UN Refugee Agency","author_url":"https://www.youtube.com/user/unhcr","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/1MGRB5ZmKpU/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/1MGRB5ZmKpU?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"\"Globaliseringsmuren\" som svar på kontroltab","spans":[]},{"type":"paragraph","text":"Som man kan læse i det indledende citat, bliver der forsket mere og mere i grænser og grænseregioner. En, der især har beskæftiget sig med området, er den førnævnte canadiske forsker Elisabeth Vallet. I modsætning til flere tidligere studier, hvor de fleste forskere på området oftest har beskæftiget sig med én bestemt mur og ét bestemt grænseland, er Elisabeth Vallets forskning global. Det vil sige, at hun kigger på verdens grænseområder og grænsebefæstninger som et samlet felt med en samlet udvikling. På baggrund af sin forskning peger Elisabeth Vallet på, at flertallet af de nye grænsebefæstninger synes at skyde op på grænsen mellem de rige og fattigere lande - den tendens er blevet kaldt globaliseringsmuren. Elisabeth Vallet forklarer, at mens globaliseringen er med til at udviske verdens grænser, er det stigende antal grænsebefæstninger omvendt med til at fremhæve dem. En udvikling man kunne kalde globaliseringens paradoks.(Gen)optegningen af landenes grænser med mure, hegn eller indførelse af en strammere grænsekontrol kan med andre ord opfattes som et politisk forsøg på at genvinde noget af den kontrol, de enkelte lande har mistet og fortsat mister som følge af globaliseringen, hvor mere og mere overgår til det internationale system. Ifølge Elisabeth Vallet er rationalet altså, at de fysiske grænser er med til at sikre og styrke den enkelte stat, og dens særegne identitet. Murene og grænsebefæstningerne kan med andre ord virke beroligende midt i en ellers flydende tid. ","spans":[{"start":700,"end":719,"type":"em"}]},{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://www.youtube.com/watch?v=X3nwbMguFGs","type":"video","version":"1.0","title":"Élisabeth Vallet: Expert on Border Fences in a Globalized World","author_name":"EUCAnet","author_url":"https://www.youtube.com/user/EUCAnet","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/X3nwbMguFGs/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/X3nwbMguFGs?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}},{"type":"paragraph","text":"Den 11. september 2001, hvor international terrorisme for alvor kom på verdens dagsordenen med angrebene på World Trade Center i New York, er ofte blevet angivet som startskuddet til en strengere grænsebefæstning verden over. Men Elisabeth Vallet argumenterer for, at den udvikling er startet langt tidligere, omend 9/11 utvivlsomt var med til at sætte tempoet op. Elisabeth Vallets forskning viser, at der, med indførelsen af skærpet grænsekontrol rundt omkring i verden, også har fundet en øget militarisering og barrikadering sted. - Mens en grænse i sig selv kan være et mødested for to kulturer, er en mur eller befæstning ensidig og eksklusiv. Her har brugen af private vagtværn, soldater og betjente samt en øget brug af forskellige former for overvågning, blandt andet vundet indpas flere steder. Det har på samme tid betydet, at de forskellige lande poster enorme summer i den sikkerhedsindustri, der befæster og vedligeholder deres grænser. Elisabeth Vallet argumenterer for, at den øgede brug af sikkerhedsindustrien  blandt andet har den konsekvens, at det kan være endda særdeles farligt at forsøge at komme uden om de grænsebarrierer, der ellers skulle høre til i den blødere kategori - nemlig dem, der primært er opført for at holde illegale migranter ude. Da der netop er tale om en illegal passage, må de personer, der forsøger at krydse grænsen, oftest ty til menneskesmuglere eller kriminelle grupper, forsøge at bestikke grænsevagterne/-soldaterne og eller forsøge at krydse grænsen på øde og barske områder, hvor der risiko for at fare vild og dø af tørst. Særligt farligt er det for de kvindelige migranter, der også er i fare for at blive udsat for seksuelle krænkelser og overgreb.","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Virker grænsebefæstningerne efter hensigten? ","spans":[]},{"type":"paragraph","text":"Ifølge Elisabeth Vallets forskning virker verdens mure langt fra altid efter hensigten - de har modsat været med til at optrappe konflikter og gøre grænseområderne mere militariserede, samt verden mere opdelt. En kritik, der flugter kritikken fra generalsekretæren i Dansk Flygtningehjælp, Christian Friis Bach. Den russiske forsker Serghei Golunov argumenterer ligesom Elisabeth Vallet for, at verdens mure kan opfattes som nationalstaternes svar på de udfordringer, der er fulgt med globaliseringen. Selvom han ligeledes argumenterer for, at det ikke er en holdbar løsning på nationalstaternes problemer, og at befæstningerne sjældent formår helt at holde de \"problemer\" for døren, som de er sat i verden for, påpeger han dog, at beslutningen om at befæste en grænse oftest ikke er et valg mellem en god og en dårlig løsning, men et valg mellem udelukkende dårlige løsninger under stærk pres fra udefrakommende begivenheder og et presserende ønske fra en befolkning om en løsning. Af samme grund efterlyser han, at de, der kritiserer verdens grænsebefæstninger i højere grad også selv er med til at pege på alternative løsninger for de stater, der tyr til dem, for eksempelvis at kunne kontrollere en stor migrantstrøm, dæmme op for narkotika- og våbensmugling samt at holde terrorisme ude. ","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Til videre refleksion","spans":[]},{"type":"o-list-item","text":"Kan du komme i tanke om andre grænsebefæstninger end dem, vi har nævnt her? Hvilken kategori(er) hører de under?","spans":[{"start":0,"end":112,"type":"em"}]},{"type":"o-list-item","text":"Lav en hurtig søgning på ord, der bruges i medierne og den offentlige debat om grænser og migration og find eksempler på, hvordan forskelige stemmer forsøger at sætte sig på \"definitionsretten\".","spans":[]},{"type":"o-list-item","text":"Prøv at forklare, hvad der menes med udtrykket \"globaliseringsmuren\" og undersøg den nærmere - kan du fx finde nogle tal og statistikker, der bekræfter, at det er de rigere lande, der barrikaderer sig mod de fattigere?  ","spans":[{"start":0,"end":220,"type":"em"}]},{"type":"o-list-item","text":"Opsummér årsagerne til grænsebefæstning ud fra, hvad du lige har læst. Hvad mener du selv er fordele og ulemper ved grænsekontrol? Kan du komme i tanke om et alternativ til grænsebefæstning med flere fordele og færre ulemper?","spans":[{"start":0,"end":225,"type":"em"}]},{"type":"o-list-item","text":"Ville du have valgt at fokusere på andre ting i en tekst om mure og magt? Hvilke? Og hvorfor dem?","spans":[{"start":0,"end":97,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"paragraph","text":"(Find kilderne til dette afsnit HER.\nTemafoto: FN's Sikkerhedsråd ved at tage stilling til borgerkrigen i Syrien. Situationen i Syrien er en af de konflikter, der har været stærkt medvirkende til, at antallet af flygtninge i verden er steget markant over de senere år. UN Photo/Evan Schneider.)","spans":[{"start":32,"end":35,"type":"hyperlink","data":{"link_type":"Media","name":"kilder_temaer.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa0f4f587-8b24-462b-83b5-517329148ac6_kilder_temaer.pdf","size":"6462983"}}]}],"content_bits":[],"meta_title":"Mure og magt","meta_description":"I temateksten \"Mure og magt\", der er en del af undervisningsmaterialet OVER MUREN, bliver der blandt andet sat fokus på, hvordan det stigende antal grænsebefæstninger hænger sammen med en følelse af kontroltab og behov for magtdemonstration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c24616da795df48c1d664ae71b9e8aef3cfad32a_753621.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}},"navigation":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false},"home_link":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false}}}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"W1bhBx4AAHz146Ap","type":"article","uid":"mure-og-miljo","url":"/temaer/mure-og-miljo","published":"2019-01-29T10:52:22+0000","lang":"da-dk","meta_title":"Mure og miljø","meta_description":"I temateksten \"Mure og miljø\", der er en del af undervisningsmaterialet OVER MUREN, bliver der blandt andet zoomet ind på fotoet \"Earthrise\" som symbol i klimakampen, og på hvordan klimaforandringer og -flygtninge udfordrer nationale grænser.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/2f47f2fe4f6b6fe51d2f28dacd7d310fed5bcac0_earthrise.jpg"},"alternate_languages":[],"data":{"pdf":{"link_type":"Media","name":"tema_miljoe_print.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F992134db-68c3-4bc4-b72c-678a999f8b40_tema_miljoe_print.pdf","size":"6541564"},"url":"/temaer/mure-og-miljo","image":{"dimensions":{"width":750,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5c11bc88935142f68af610a99c7d0a1eea1b8a53_earthrise.jpg","medium":{"dimensions":{"width":600,"height":320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8f6c7836939de4d28e5bf90da3827d41a3f6504e_earthrise.jpg"},"small":{"dimensions":{"width":375,"height":200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/99d447546c3db34589a07698011f2621f6dcb2e6_earthrise.jpg"}},"title":[{"type":"heading1","text":"Mure og miljø","spans":[]}],"content":[{"type":"paragraph","text":"Det er astronaut William A. Anders, der tager det siden verdensberømte fotografi ovenfor. “Earthrise” bliver det døbt, og det kommer til at gøre indtryk vidt og bredt, da det først bliver publiceret. Det er det første foto af os alle - og vores fælles jord - set fra rummet. Én jord uden grænser, men med begrænsede ressourcer. I dette tema ser vi nærmere på sammenhængen mellem jordens ressourcer og migration over grænser.","spans":[{"start":0,"end":424,"type":"strong"}]},{"type":"paragraph","text":"Først kommer vi ind på, hvordan verdenssamfundet i fællesskab forsøger at håndtere klimaudfordringerne på de årlige klimakonventioner. Derefter ser vi på, hvordan klimaforandringer kan gøre mennesker til flygtninge, og hvordan det udfordrer vores hidtidige definition af en flygtning. I afsnittet \"Klima og konflikter\" handler om, hvordan klimaforandringer kan sætte gang i eller forstærke allerede eksisterende konflikter om adgang til ressourcer. Til sidst kigger vi i krystalkuglen efter fremtiden udfordringer og løsningsforslag på det her område.","spans":[{"start":0,"end":551,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"\"Earthrise\" og en gryende klimabevidsthed","spans":[]},{"type":"paragraph","text":"Året er 1968, og det er juleaften. Mens familier og venner samles rundt omkring på jorden, samler de tre astronauter Frank Borman, William A. Anders og James A. Lovell sig ude i rummet om et syn, ingen mennesker tidligere har set: Jorden, der langsomt rejser sig over månens horisont. De tre astronauter er udsendt på Apollo 8-missionen og har netop - som de første mennesker nogensinde - bevæget sig rundt om månen. Med deres opgave fra NASA in mente har de fotograferet hundredvis af fotos af månens overflade, men heroppe i rummet, er det alligevel synet af jorden, der ender med at gøre størst indtryk. På gamle, knitrende lydoptagelser fra netop det øjeblik kan man høre begejstringen i stemmen, da en af dem pludseligt udbryder: “Åh Gud, se det billede derovre! Jorden, der står op!” På fotografiet fremstår jorden som en skrøbelig, fritsvævende, blåhvid marmorkugle - alene i et uendeligt mørke. Én jord, hvor alle og alt på den en del af et universelt system og dybt afhængige af hinanden. Af samme grund bliver både fotoet og astronauternes samstemmende fortælling om vores fælles fine og sarte jordklode et stærkt symbol i den gryende bevidsthed om nødvendigheden af at begrænse vores negative indflydelse på jordens klima. Fotoet af jorden i al dens pragt - og i al dens skrøbelighed.","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Klimakonventionen i 1992","spans":[]},{"type":"paragraph","text":"I 1992 mødtes de fleste af verdens landes ledere i Rio de Janeiro for at diskutere problematikken omkring udledning af drivhusgasser og global opvarmning. Hvor man tidligere diskuterede klima og miljø på et mere lokalt og nationalt plan, bliver det i disse år mere og mere tydeligt, at klimaproblematikker har en global karakter - når de store virksomheder i USA udleder drivhusgasser, påvirker det fx ozonlaget på den anden side af jorden, og når regnskoven bliver fældet i Brasilien, har det indflydelse på regnmængderne i Europa. Det står mere og mere klart, at klimaet ikke respekterer de grænser og nationale skel, som mennesker har skabt, og der er derfor enighed om, at verdens miljøudfordringer ikke kan løses lokalt. Derfor valgte størstedelen af verdens lande at underskrive den såkaldte klimakonvention i 1992. Konventionen sigter mod at stabilisere atmosfærens indhold af drivhusgasser og på den måde bremse den menneskelige påvirkning af klimasystemet. ","spans":[]},{"type":"paragraph","text":"Siden 1995 har alle de lande, der underskrev konventionen, mødtes årligt for at diskutere målsætningerne. Selvom resultaterne og opbakningen har været svingende, blev man ved et af disse COP-møder i 2015 enige om en aftale med et mål om at holde den globale opvarmning under 2 grader celsius (det, der blev kendt som ”Parisaftalen”). Men selv med en global temperaturstigning på 2 grader, står vi over for nogle store fremtidige forandringer. I en rapport forudser organisationen CARE, at en temperaturstigning på 2 grader vil medføre dramatiske klimaændringer, der vil påvirke alle dele af verden. Tørke, ekstremt vejr, vandmangel og stigende havniveau, vil tvinge millioner af mennesker til at forlade deres hjem.    ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/9de28c4747ea4210e17f839b392c10b08a8a1768_parisaftalen.png","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Hovedpunkterne i Paris-aftalen fra 2015. Kilde: DR.","spans":[{"start":0,"end":51,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Klimaflygtninge","spans":[]},{"type":"paragraph","text":"Pigtråd skal holde klimaflygtninge ude - sådan lyder overskriften på en artikel i Politiken fra 2011. I artiklen beskrives det, hvordan Indien er i færd med at bygge et 2.500 km langt pigtrådshegn på grænsen til Bangladesh. Bangladesh’ egen finansminister forudser, at over 20 millioner mennesker fra Bangladesh vil være fordrevet fra deres hjem på grund af klimaforandringer inden 2050, og pigtrådshegnet er en del af Indiens løsning på denne fremtidige strøm af migranter. ","spans":[{"start":0,"end":38,"type":"em"}]},{"type":"paragraph","text":"Miljøfaktorer har igennem historien til stadighed haft indflydelse på globale bevægelser af mennesker – når omgivelserne har forandret sig, har menneskene flyttet sig. Skalaen og hastigheden af disse miljøforandringer har dog ændret sig i nyere tid. Selvom det er umuligt at lave en direkte kausal relation mellem migration og klimaforandringer, vil vi i fremtiden opleve, at flere og flere mennesker bliver tvunget på flugt af klimarelaterede udfordringer. Man forudser ligefrem, at klimaforandringerne vil ændre de globale migrationsmønstre radikalt. Selvom man altid skal passe på med eksakte tal, når man snakker klimamigranter, estimerer man, at 23,5 millioner mennesker i verden var på flugt fra ekstremt vejr og klima i 2016 – det er 8,8 millioner flere end året før, og tre gange så mange, som samme år flygtede fra krig og konflikt. Frem mod år 2050 risikerer over 250 millioner mennesker at blive permanente klimamigranter, og det forventes at antallet af migranter, der søger til Europa som konsekvens af bl.a. forhøjede vandstand, voldsomt vejr og tørke, vil tredobles inden år 2100.","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/2235840c6d73483148d09d44e022cc40f27e0b8a_floodingbangla.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":400}},{"type":"paragraph","text":"Bangladesh, september 2017 - Rohingyaer, en muslimsk befolkninggruppe, for øjeblikket på flugt fra forfølgelser i blandt andet Myanmar, er igen på flugt. denne gang fra vandmasser, der har oversvømmet deres lejr. Bangladesh er et af de lande i verden, der er hårdest ramt af klimaforandringer. Foto: Sk Hasan Ali via Shutterstock.","spans":[{"start":0,"end":330,"type":"em"}]},{"type":"paragraph","text":"Selvom klimaforandringer har global karakter, findes der stadig ikke globale retningslinjer for, hvordan man skal håndtere de mennesker, der flygter pga. miljø og klima. I 1951 definerede FN i flygtningekonventionen, hvad det vil sige at være flygtning: En flygtning krydser grænser på flugt fra forfølgelse. Konventionen dikterer desuden, at såfremt man kan defineres som flygtning, har man ret til beskyttelse – altså asyl. Denne relativt klare definition afholder imidlertid hverken politikere, medier eller menigmand fra at diskutere flygtningekvoter, asylregler og udlændingepolitik. Diskussionen kompliceres af, at selvom den fælles konvention udgør en ramme, så findes der ikke klare fælles love eller regler, man kan henvise til. Dette gælder blandt andet, når det handler om mennesker, der forlader deres hjem og hjemland på grund af tørke, naturkatastrofer, sult eller på grund af konflikter, der har rod i klimaforandringer. ","spans":[]},{"type":"paragraph","text":"Grænser opstilles blandt andet i et forsøg på at kontrollere og regulere hvem og hvad, der bevæger sig på tværs af de nationale skel. Reglerne for disse bevægelser defineres i første omgang af den pågældende nationalstat, men der findes regulativer, så som den ovennævnte flygtningekonvention, der skal sikre nogle grundlæggende rettigheder for alle mennesker. Men hvilke rettigheder skal man have som klimaflygtning? Har man ret til at søge ophold i et andet land, hvis en tsunami har ødelagt ens hjem og levebrød, hvis man ikke længere kan dyrke sin jord og brødføde sin familie, eller hvis alle ens køer er døde af tørst? Ifølge flygtningekonventionen har man ikke ret til asyl på denne baggrund. Alligevel befinder millioner af mennesker sig verden over i en udfordrende livssituation på grund af ændrede leveforhold forårsaget af klimaforandringer. Mange af disse mennesker føler sig nødsaget til at forlade deres hjem og søge til andre lande. ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/98cf91b8f6cd2792b8542fefabbd840a2f024f9a_total-affected-by-natural-disasters.png","alt":null,"copyright":null,"dimensions":{"width":3400,"height":2400}},{"type":"heading2","text":"Klima og konflikter","spans":[]},{"type":"paragraph","text":"I en rapport fra CARE konkluderer man, at fremtidens klimaforandringer blandt andet kan betyde, at store dele af Nordafrika og Mellemøsten vil blive ubeboelige, at der kommer ekstreme storme i Sydøstasien, at lavtliggende øer vil forsvinde, og at der vil være betydelig mangel på mad og vand i Afrika. Disse forhold kan drive millioner af mennesker på flugt. Årsagerne til klima-migration skal dog ikke kun findes i de direkte klimaforhold, men også i de sociopolitiske og økonomiske forhold dér, hvor klimaet ændrer sig. Rammer klimaforandringerne områder, der i forvejen er ramt af fattigdom, dårlig infrastruktur, en svag stat og lignende, kan risici hurtigt udvikle sig til katastrofer. Konflikter afledt af klimaforandringer vil derfor i fremtiden ligeledes tvinge folk på flugt. ","spans":[]},{"type":"paragraph","text":"Som et eksempel på en krise, hvor klimaforandringer har haft indflydelse, peger forskere fra University of California og Columbia University på krigen i Syrien. Mellem 2007 og 2010 blev Syrien ramt af en voldsom tørke, der medførte en menneskevandring fra land til by. Særligt hårdt ramte tørken landmændene i det nordøstlige Syrien, der i forvejen kæmpede med for lidt vand. Tørken gjorde det umuligt at dyrke jorden, og mange flyttede derfor fra landområder til større byer. Byerne var allerede presset af en stigende befolkningstilvækst og en tilstrømning af flygtninge fra Irak. Disse forhold, samt den store gruppe frustrerede landmænd, skabte uro og pustede liv i det ulmende oprør mod Assad-styret. På denne måde blev de ændrede klimaforhold, én blandt mange faktorer, der satte gang i konflikten i Syrien. Udfordringen hér var mangel på vand, og netop vandmangel anses for at blive en af fremtidens helt store udfordringer. ","spans":[]},{"type":"paragraph","text":"Ifølge FN vil verdens vandressourcer kun opfylde 60% af efterspørgslen i 2030, og CARE forudser at 2,4 milliarder mennesker allerede i 2025 vil leve i områder, der periodevis bliver ramt af vandmangel. Det kommer både til at få store konsekvenser for den globale økonomi og for eksempel prisen på råvarer, men det vil ligeledes få betydning for den enkeltes adgang til rent drikkevand og muligheder for overlevelse. I Cape Town, Sydafrika, blev manglen på vand for nylig meget tydelig, da det blev meldt ud, at storbyen ville løbe tør for vand i løbet af 2018. Den såkaldte ”day zero”, altså den dag vandreserverne er så langt i bund, at myndighederne officielt vil lukke for vandforsyningen til folks private hjem, er på nuværende tidpunkt udsat til 2019. Det betyder dog ikke, at krisen er afblæst: Cape Town står stadig med en meget virkelig og presserende udfordringer med at skaffe vand nok til befolkningen.","spans":[]},{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://youtu.be/NbQ4GxUAivk","type":"video","version":"1.0","title":"City of Cape Town Drought Crisis: Day Zero","author_name":"City of Cape Town","author_url":"https://www.youtube.com/user/cctecomm","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/NbQ4GxUAivk/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/NbQ4GxUAivk?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}},{"type":"paragraph","text":"I denne video takker Cape Towns bystyre byens indbyggere for at have sparet på vandet, så \"day zero\" nu kan udskydes til 2019, men opfordrer dem samtidig til at blive ved med at gøre en indsats. Vandmanglen i Cape Town skyldes både tørke, men også dårlig planlægning. Man er kommet for sent i gang med at sikre vandforsyningen til et område, der er sårbart overfor tørke. ","spans":[{"start":0,"end":371,"type":"em"}]},{"type":"paragraph","text":"Klimaforandringerne kan altså på forskellige måder være med til at altså forringe menneskers levevilkår i en sådan grad, at de tvinges på flugt. Når i forvejen udsatte lande påvirkes af klimaets forandringer, kan det medvirke til nye, store konflikter, der igen kan sende mennesker på flugt. ","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Hvad med fremtiden? ","spans":[]},{"type":"paragraph","text":"Klimaforandringer er komplekse, og på tværs af grænser og nationer står vi over for nogle store udfordringer. På den ene side handler disse udfordringer om at bremse klimaforandringerne, og på den anden side at håndtere de konsekvenser, forandringerne allerede har ført med sig. Deriblandt klimamigranter. ","spans":[]},{"type":"paragraph","text":"I et forsøg på at foregribe nogle af fremtidens udfordringer formulerede FN i 2015 de 17 Verdensmål. Verdensmålene er en række fælles globale mål for klodens udvikling frem mod år 2030. Målene er ambitiøse - de skal sikre et godt liv for alle, og at vi kan give en sund og god jord videre til de fremtidige generationer. Målene spænder bredt - lige fra udryddelse af sult, til bedre uddannelse og indsatser for klimaet. På samme måde som klimaet har en global karakter, argumenterer FN for, at fremtidens store udfordringer er vævet ind i hinanden, og derfor ikke kan løses uafhængigt af hinanden. Vi kan ikke udrydde fattigdommen uden at løse sultproblemerne, som igen afhænger af klimaet. Samtidig kan vi heller ikke komme i mål med Verdensmålene på egen hånd, hverken som individ eller nationalstat. Udfordringerne skal løses i fællesskab, på global skala, og alle må bidrage. Selvom klimaforandringerne er et globalt fænomen, rammer de ikke alle lige. Mens det er den rigere del af verden, der sætter det største aftryk på klimaet, er det områder, der i forvejen er udsatte og udfordrede, der bliver hårdest ramt af, at klimaet forandres - blandet andet store dele af Afrika og Asien. ","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/3c364cb2b5e9999628bf75ef183f1b7a25e8c492_verdensmaal.jpg","alt":null,"copyright":null,"dimensions":{"width":750,"height":369}},{"type":"paragraph","text":"","spans":[]},{"type":"paragraph","text":"Én ting er at sætte mål for fremtiden, en anden er, hvordan vi griber det an i praksis? Der er allerede i dag iværksat mange tiltag i et forsøg på at bremse klimaforandringerne. Kina bygger for eksempel solcelleparker som aldrig før, her i Danmark er der fokus på madspild, vegetarisme og genbrug, og i Sahara har man siden 2007 arbejdet på at bygge et 8000 kilometer langt bælte af træer og buske, der skal fungere som en grøn mur og bremse spredningen af ørkenen samt skabe bedre levebetingelser for befolkningen. Når det handler om klimaflygtninge, er der dog stadig stor usikkerhed om, hvordan vi skal håndtere de nye strømninger. I både Sverige og Finland har man, som de eneste steder i verden, valgt at skrive klimaflygtninge ind i den officielle asyl- og immigrationspolitik. 40 afrikanske lande har desuden underskrevet den såkaldte Kampala-konvention og forpligter sig derved til at hjælpe og beskytte internt fordrevne mennesker.  ","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Til videre refleksion  ","spans":[]},{"type":"o-list-item","text":"Find definitioner af, hvad det vil sige at være flygtning, og prøv at lave en tilsvarende definition af en klimaflygtning.","spans":[{"start":0,"end":122,"type":"em"}]},{"type":"o-list-item","text":"Bør klimaflygtninge have samme rettigheder til asyl, som folk, der flygter fra krig og forfølgelse? Hvorfor? Hvorfor ikke?  ","spans":[{"start":0,"end":124,"type":"em"}]},{"type":"o-list-item","text":"Tror du, det er det muligt at lave fælles regler og love for det på et globalt plan? ","spans":[{"start":0,"end":85,"type":"em"}]},{"type":"o-list-item","text":"De fleste definerer sig stadig først og fremmest som borgere i en nationalstat, men, tror du, det er muligt at skabe en global identitet, så flere definerer sig som globale borgere? Og er det nødvendigt i forhold til klimaforandringer? ","spans":[{"start":0,"end":236,"type":"em"}]},{"type":"o-list-item","text":"Opsøg mere viden om Verdensmålene og overvej, om og hvordan du kan bidrage til opnåelsen af dem, særligt dem, der handler om klima og miljø.","spans":[{"start":0,"end":140,"type":"em"}]},{"type":"paragraph","text":"(Find kilderne til dette afsnit HER.\nTemafoto: NASA.)","spans":[{"start":32,"end":35,"type":"hyperlink","data":{"link_type":"Media","name":"kilder_temaer.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa0f4f587-8b24-462b-83b5-517329148ac6_kilder_temaer.pdf","size":"6462983"}},{"start":51,"end":52,"type":"em"}]}],"content_bits":[],"meta_title":"Mure og miljø","meta_description":"I temateksten \"Mure og miljø\", der er en del af undervisningsmaterialet OVER MUREN, bliver der blandt andet zoomet ind på fotoet \"Earthrise\" som symbol i klimakampen, og på hvordan klimaforandringer og -flygtninge udfordrer nationale grænser.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/2f47f2fe4f6b6fe51d2f28dacd7d310fed5bcac0_earthrise.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}},"navigation":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false},"home_link":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false}}}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"W4lOfiIAAAh1wCvr","type":"article","uid":"om","url":"/om","published":"2019-02-05T09:32:25+0000","lang":"da-dk","meta_title":"Om OVER MUREN","meta_description":"OVER MUREN er et webbaseret, gratis tilgængeligt undervisningsmateriale målrettet gymnasiet, særligt fagene historie og samfundsfag. Det består af en film, fem levende case-beskrivelser og fem tematiske oplæg til refleksion over temaerne grænser og migration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8a5a3ee9d9f2436c973d9e3c591e7b1b5a6f9533_omom.jpg"},"alternate_languages":[],"data":{"pdf":{"link_type":"Media"},"url":"/om","image":{"dimensions":{"width":750,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/4caa7812a4ee1ac565094fa9c1b3426c7b491386_omom.jpg","small":{"dimensions":{"width":375,"height":200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/114cb11edeebe55e6753bc0e61e72fa4a851dd2c_omom.jpg"},"medium":{"dimensions":{"width":600,"height":320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b2f6619215e803fc9911e68f34dc73ee1aaf5426_omom.jpg"}},"title":[{"type":"heading1","text":"Om OVER MUREN","spans":[]}],"content":[{"type":"paragraph","text":"OVER MUREN er et webbaseret undervisningsmateriale målrettet gymnasiet, særligt fagene historie og samfundsfag.","spans":[]},{"type":"paragraph","text":"Her, cirka tre årtier efter Berlin-murens fald, rejser nye grænsemure og -hegn sig som aldrig før. Faktisk har verden ikke set flere befæstede grænser siden anden verdenskrig. Og ser man nøjere efter, så opdager man, at mure og hegn især rejser sig på grænserne af den vestlige verden - et fænomen, der er blevet kaldt ”globaliseringsmuren”. OVER MUREN ansporer eleverne til at hæve sig op over muren, se den fra begge sider og undre sig over, hvorfor vores verden på samme tid bliver mere og mere integreret og mere og mere opdelt. ","spans":[{"start":390,"end":400,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Indhold og opbygning","spans":[]},{"type":"paragraph","text":"OVER MURENs tematiske fokus på grænser og migration har vide forgreninger, og det er klart, at materialet ikke giver et komplet billede af alle aspekter af det. Det leverer et udvalg af eksempler og perspektiver som tilsammen gerne skulle give eleven et godt udgangspunkt for at deltage i en højaktuel samfundsdebat, men opfordrer samtidig løbende eleven til at være kritisk og forholde sig til, hvilke eksempler og perspektiver man også kunne have anlagt.","spans":[{"start":433,"end":437,"type":"em"}]},{"type":"paragraph","text":"Over MUREN består i:","spans":[]},{"type":"list-item","text":"En dokumentarfilm på knap 25 min, som tager eleverne med til Senegal og Sicilien, hvor forskellige stemmer på hver sin side af den grænse, Middelhavet udgør, bringer temaerne i spil. FIND ARBEJDSARK TIL FILMEN HER.","spans":[{"start":0,"end":17,"type":"strong"},{"start":183,"end":213,"type":"hyperlink","data":{"link_type":"Media","name":"arbejdsark til film.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F0acb03da-ec05-41f5-aa9f-7edf634a870f_arbejdsark+til+film.pdf","size":"6733076"}}]},{"type":"list-item","text":"Fem cases, som fortæller historien bag fem af verdens mure/grænser i et visuelt fængende flow af tekster, billeder og filmklip. Casene er beskrevet i et levende sprog og beregnet til at give eleverne en grundig baggrundsviden og samtidig vække deres interesse og engagement for temaerne.","spans":[{"start":0,"end":9,"type":"strong"}]},{"type":"list-item","text":"Fem tværgående temaer, som dykkere dybere ned i forskellige emner vedrørende grænsebarrikadering og migration og trækker på faglige teorier til forståelsen af dem.   ","spans":[{"start":0,"end":21,"type":"strong"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Læreplaner","spans":[]},{"type":"paragraph","text":"OVER MUREN kan i SAMFUNDSFAG bidrage til opfyldelse af fagets didaktiske princip om \"tilrettelæggelse af undervisningen med tematisk afsæt i aktuelle samfundsmæssige problemstillinger og udviklingstendenser.\" Samtidig samler materialet en del af det supplerende stof i form af eksempler fra den aktuelle debat, som ifølge læreplanen skal inddrages i undervisningen. Materialet lægger blandt andet op til selvstændig fordybelse og giver anledning til, at eleven bringer faglig viden i spil i tilegnelsesprocessen. Således kan arbejdet med OVER MUREN medvirke til elevens udvikling frem mod mere selvstændige og studieforberedende arbejdsformer og bidrage til det faglige mål om at: ","spans":[{"start":17,"end":28,"type":"strong"}]},{"type":"list-item","text":"anvende og kombinere viden og kundskaber fra fagets discipliner til at undersøge aktuelle samfundsmæssige problemstillinger i Danmark og andre lande og diskutere foreliggende og egne løsninger herpå,","spans":[]},{"type":"paragraph","text":"og give et fundament for at:","spans":[]},{"type":"list-item","text":"argumentere for egne synspunkter på et fagligt grundlag og indgå i en faglig dialog.","spans":[]},{"type":"paragraph","text":"OVER MUREN er især materialet velegnet til at komme omkring faglige mål vedrørende EU og globale forhold samt økonomiske og velfærdsmæssige prioriteringer. Samfundsfagligt kernestof bliver behandlet forskellige steder i materialet:","spans":[{"start":156,"end":181,"type":"strong"}]},{"type":"paragraph","text":"Sociologi – Temaet \"Mentale mure\" kommer ind på identitetsdannelse og socialisering, mens temaet \"Mure og gadekunst\" berører politisk meningsdannelse og medier. Det samlede materiale kan anvendes som afsæt for en diskussion af social differentiering og kulturelle mønstre i forskellige lande – fx hvem migrerer, hvorfor, og hvilken rolle spiller familien for den beslutning?","spans":[{"start":0,"end":10,"type":"em"}]},{"type":"paragraph","text":"Politik og international politik – Materialet kan lægge op til en undersøgelse af de politiske partiers holdning til grænsekontrol og migration, og hvordan europæiske og globale forhold spiller ind på politiske beslutningsprocesser i Danmark. EU/Middelhavet-casen kommer ind på EUs politikker og procedurer på området, og international politik berøres især i temaerne \"Mure og magt\" og \"Mure og miljø\", hvor materialets overordnede tema relateres til globalisering og samfundsudvikling.","spans":[{"start":0,"end":32,"type":"em"}]},{"type":"paragraph","text":"Økonomi – Kernestoffet inden for økonomi er ligeledes fremtrædende i temaerne \"Mure og magt\" og \"Mure og miljø\", hvor konsekvenser af globaliseringen behandles specifikt. Generelt er globalisering et underliggende tema for det samlede materiale, og der trækkes løbende perspektiver til makroøkonomiske sammenhænge og bæredygtig udvikling. Økonomiske prioriteringer spiller også en rolle som motiv for både migration og grænsebarrikadering.","spans":[{"start":0,"end":7,"type":"em"}]},{"type":"paragraph","text":"","spans":[]},{"type":"paragraph","text":"I HISTORIE kan OVER MUREN bidrage til opfyldelse af fagets overordnede mål om at “stimulere elevernes interesse for og evne til at stille spørgsmål til fortiden for at opnå forståelse af den komplekse verden, de lever i.\" Historisk bevidsthed eller mangel på samme spiller en fremtrædende rolle i den aktuelle samfundsdebat om grænser og migration, og det er derfor et meget velegnet udgangspunkt for at gøre eleverne bevidste om historicitet, og hvordan historie kan bruges og misbruges eller være helt fraværende tilgangen til nutidige problemstillinger. Eleverne kan i arbejdet med materialet især blive trænet i de faglige mål, at:","spans":[{"start":2,"end":10,"type":"strong"}]},{"type":"list-item","text":"redegøre for sammenhænge mellem den lokale, nationale, regionale, europæiske og globale udvikling og ","spans":[]},{"type":"list-item","text":"reflektere over samspillet mellem fortid, nutid og fremtid samt over mennesket som historieskabt og historieskabende.","spans":[]},{"type":"paragraph","text":"OVER MUREN rammer kernestof i historie i og med, at materialets cases indeholder en historisk gennemgang af hovedlinjer i udviklingen i fem grænseområder, mens temaet \"Mure i historien\" giver en generel introduktion til verdens mure i et historisk perspektiv. Med grænser og migration som hovedtema kommer materialet også naturligt ind på kulturer og kulturmøder i Europas og verdens historie.","spans":[{"start":18,"end":38,"type":"strong"}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Kilder og referencer","spans":[]},{"type":"paragraph","text":"Hent lister med referencer og hovedkilder til cases og temaer.","spans":[{"start":46,"end":51,"type":"hyperlink","data":{"link_type":"Media","name":"samledekilder_cases.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F29ed7b98-6b74-4cce-a782-5cef41ce9a74_samledekilder_cases.pdf","size":"6488599"}},{"start":55,"end":61,"type":"hyperlink","data":{"link_type":"Media","name":"kilder_temaer.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa0f4f587-8b24-462b-83b5-517329148ac6_kilder_temaer.pdf","size":"6462983"}}]},{"type":"paragraph","text":"","spans":[]},{"type":"heading2","text":"Hvem står bag?","spans":[]},{"type":"paragraph","text":"OVER MUREN er produceret af MUNDU - center for global dannelse. En uafhængig organisation med speciale i at omsætte komplekse problemstillinger til engagerende undervisning. Se mere om os på www.mundu.dk.","spans":[{"start":27,"end":62,"type":"strong"}]},{"type":"paragraph","text":"","spans":[]},{"type":"paragraph","text":"Følgende personer har bidraget til udviklingen af materialet: ","spans":[{"start":0,"end":62,"type":"strong"}]},{"type":"list-item","text":"Jeanette Westh (projektleder, webdesign, filmoptagelse og -redigering, research og udarbejdelse af indhold)","spans":[]},{"type":"list-item","text":"Jeanette Frank Nielsen (filmoptagelse og -redigering, research og udarbejdelse af indhold)","spans":[]},{"type":"list-item","text":"Emilie Bohman Lange (research og udarbejdelse af indhold)","spans":[]},{"type":"list-item","text":"Karen Løfgren Hagelskær (research og udarbejdelse af indhold)","spans":[]},{"type":"list-item","text":"Kim Frost (research og udarbejdelse af indhold)","spans":[]},{"type":"list-item","text":"Didier Larsen (filmoptagelse og -redigering)","spans":[]},{"type":"list-item","text":"Sonja Salminen (research)","spans":[]},{"type":"list-item","text":"Giacomo Vito Cusenza (tolk og fixer på Sicilien)","spans":[]},{"type":"list-item","text":"Cheikhou Diarra (tolk og fixer i Senegal)","spans":[]},{"type":"list-item","text":"Henrik Malmgren (logo og animation til dokumentarfilm)","spans":[]},{"type":"list-item","text":"Mads Ulsø Østergaard (webudvikler)","spans":[]},{"type":"paragraph","text":"Tak til lektor Lene Koudal samt 3.A på Aarhus Katedralskole for feedback på materialet. ","spans":[]},{"type":"paragraph","text":"","spans":[]},{"type":"paragraph","text":"Materialet er støttet af:","spans":[{"start":0,"end":25,"type":"strong"}]},{"type":"list-item","text":"Undervisningsministeriets Udlodningsmidler","spans":[]},{"type":"list-item","text":"Columbus Fonden","spans":[]},{"type":"list-item","text":"Udenrigsministeriets Oplysningspulje","spans":[]},{"type":"list-item","text":"CISUs Oplysningspulje","spans":[]},{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b25b36f30a6a4e2c01845baad2d9e961f4fc7136_logolinje.png","alt":null,"copyright":null,"dimensions":{"width":750,"height":106}}],"content_bits":[],"meta_title":"Om OVER MUREN","meta_description":"OVER MUREN er et webbaseret, gratis tilgængeligt undervisningsmateriale målrettet gymnasiet, særligt fagene historie og samfundsfag. Det består af en film, fem levende case-beskrivelser og fem tematiske oplæg til refleksion over temaerne grænser og migration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8a5a3ee9d9f2436c973d9e3c591e7b1b5a6f9533_omom.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}},"navigation":{"link_type":"Document"},"home_link":{"id":"WvLD9CgAAIL-YiSX","type":"index","tags":["Index"],"slug":"over-muren---index","lang":"da-dk","uid":"index","link_type":"Document","isBroken":false}}}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WyvhsB8AALmi3lkq","type":"case","uid":"australien-havene","url":"/cases/australien-og-havene-omkring","published":"2019-02-27T13:28:17+0000","lang":"da-dk","meta_title":"Australien og havene omkring","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag Australiens befæstede grænse og møde Ali - en af de mange migranter, der har krydset den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/bb01a06484a8e25797825cbb0900bec234bc7fb9_stillehavetvendt.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"Australien og havene omkring","spans":[]}],"url":"/cases/australien-og-havene-omkring","body":[{"slice_type":"section","slice_label":null,"items":[],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1ed8386e063f142836826c087f4f005bac13f155_stillehavetvendt.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5938f2847a1e3fb5ea37c813b073d0f19c3d4f5b_stillehavetvendt.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/cf29310f88d6c5b583e0386b7c3ce38bb2c3c11d_stillehavetvendt.jpg"}},"color_overlay":"#000000","color_opacity":"0.35","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/87ed5a62ba5c8b38622423145b76a4356cc2b2be_orken-del.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":491}}],"information":[],"x_axis":"0","y_axis":"62","layer":10,"rotation":null,"background":null,"width":"1920","height":"491","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/4ec24ad4db00762bdf6e1aa914fd426b4bd78d68_orken-del2.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":491}}],"information":[],"x_axis":"0","y_axis":"62","layer":20,"rotation":null,"background":null,"width":"1920","height":"491","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Alis historie","spans":[]},{"type":"paragraph","text":"Det er nat, og en bidende kulde har sænket sig over ørkenen. Men det er her, de går. Ali, hans tre brødre, mor, far og bedsteforældre. Sammen med en større gruppe mennesker er de på vej til fods mod grænsen til Iran. Skjult af mørket og på flugt fra Irak og Saddam Husseins regime. For Alis familie har mistet et højt skattet medlem. Alis farbror, der er blevet tortureret og dræbt af Saddams styrker. Familien tør derfor ikke vente længere med at forlade hjemlandet. Beslutningen om at søge asyl i nabolandet Iran skyldes, at den udvidede familie allerede er flygtet netop dertil. Og så er Iran et af de få lande, der accepterer flygtninge fra Irak. Inden morgendagen gryr, og solen igen begynder at varme ørkenen op, er familien nået i sikkerhed på den anden side af grænsen.","spans":[]},{"type":"paragraph","text":"Her kunne historien om en flugt i princippet være slut, men som det altid sker, når man bøjer sig ind over menneskeliv, er virkeligheden - og fortællingen - en del mere kompliceret end som så. For 10 år senere - da kalenderen viser år 2001, og Ali er blevet en teenager på 15 år - er han, hans tre brødre og forældrene igen på flugt. Denne gang fra et tiltagende indvandrerfjendsk klima i Iran og fra en tilværelse som mere eller mindre statsløse borgere med stærkt begrænsede rettigheder. Denne gang er flugten delt i to, så første etape af flugten foregår med et fly fra Iran til Indonesien, anden etape på havet, og det hele er arrangeret af en menneskesmugler. Familien har solgt alt, den ejer, for at få råd til flugten, og da Saddams styre stadig hersker i Iran, er der ingen tvivl. Der er ingen vej tilbage. Ali, hans tre brødre og mor har ét eneste mål. At komme med den båd, som menneskesmugleren har arrangeret for dem. En båd, der skal føre dem sikkert over havet hen til Alis far, der allerede har taget turen før dem, og nu venter på dem i Australien.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Patrick Hendry via Unsplash.) ","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":30,"rotation":null,"background":"White","width":"576","height":"1280","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e57e05f933166a15092c4466cef2ed52f2b016b0_patrick-hendry-desert-unsplash.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/9fba2289feb54db378ac4b711253b26756e2614e_patrick-hendry-desert-unsplash.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f58c3b4377378069261735e5c435919ed26909e0_patrick-hendry-desert-unsplash.jpg"}},"color_overlay":null,"color_opacity":null,"layer":50}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/c748d4a4f706c81fe5807d386cc68f10caf4cf4f_hav-baggrund-3.png","alt":null,"copyright":null,"dimensions":{"width":1200,"height":937}}],"information":[],"x_axis":"0","y_axis":"20","layer":40,"rotation":null,"background":null,"width":"1200","height":"937","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/7bb6624c5c0783ec6e957340cc116e626e6f9574_hav-baggrund-4.png","alt":null,"copyright":null,"dimensions":{"width":1200,"height":937}}],"information":[],"x_axis":"21","y_axis":"15","layer":50,"rotation":null,"background":null,"width":"1200","height":"937","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"En skvulpende, blå mur","spans":[]},{"type":"paragraph","text":"Nogle grænser strækker sig gennem ensomme bjergpas, tundraer eller sumpede regnskove. Andre gennem tætbefolkede og hektiske områder. Nogle skærer sig lineært tværs gennem befolkningsgrupper og -fællesskaber. Andre igen bugter og snor sig i tilstræbt harmoni med kulturelle skel og etniske brudflader. Mens de landbaserede grænsedragninger kan være svære at redegøre for og bliver mere og mere utydelige, jo længere man hæver sig op i fugleperspektiv, er andre grænser ganske entydige. Naturlige, kunne man måske fristes til at sige. Det er her, i den sidstnævnte kategori, at grænsen til Australien befinder sig. ","spans":[]},{"type":"paragraph","text":"Med en landmasse på 7.692.024 kvadratkilometer er Australien det sjettestørste land i verden, og med en kystlinje på godt 26.000 kilometer grænser landet både op til Det Indiske Ocean i vest, til Det Sydlige Stillehav, Koralhavet og Det Tasmanske Hav i øst, til Arafurahavet og Timorhavet i nord og til Den Australske Bugt i syd. I dette skvulpende grænseland finder man hverken udrullet pigtråd, grove murstensbefæstninger eller andre former for barrikader, men derimod endeløse bølgetoppe, hvirvlende havstrømme og et særdeles mangfoldigt undervandsliv. Grænsedragningen løber tværs gennem flere forskellige tidszoner fra vest mod øst og gennem tre klimabælter fra det tempererede Tasmanien i syd til det subtropiske og dernæst tropiske klima i det nordligste territorium. Undervejs kan man blandt andet møde legesyge delfiner, aldrende havskildpadder, gigantiske blæksprutter, hvidprikkede hvalhajer, hurtige pingviner, livsfarlige gopler, frygtede hajer og tusindfarvede koralrev. Hvor fascinerende livet under bølgerne end er, er det dog her på havoverfladen - her i grænselandet - at man skal holde øje. ","spans":[]},{"type":"paragraph","text":"For det er her, de kommer. Bådene. Og med dem migranterne. Alle de, der gennem historien er stævnet ud med ét fælles mål. ","spans":[]},{"type":"paragraph","text":"Australien.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: lachlan Dempsey via Unsplash.) ","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":50,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d9fbd28b477341ff86d46945cec6b94a8d296b8e_hav-baggrund-5.png","alt":null,"copyright":null,"dimensions":{"width":1000,"height":624}}],"information":[],"x_axis":"0","y_axis":"40","layer":70,"rotation":null,"background":null,"width":"1000","height":"624","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/cd137b5a9bdda4ee37a447b3b68ae5e68b279a20_hav.jpg","tall":{"dimensions":{"width":600,"height":750},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/09551a11a31203c24aa0cb244dceb08554467397_hav.jpg"},"medium":{"dimensions":{"width":1024,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f117cb6c0fc6a7415b3da978a9b4dcd8109d87d9_hav.jpg"}},"color_overlay":null,"color_opacity":null,"layer":50}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"En ældgammel - og ganske ny - historie","spans":[]},{"type":"paragraph","text":"I det knastørre sand ved den udtørrede og forhistoriske sø Lake Mungo i staten New South Wales vandrer en enlig mand rundt. Året er 1968, manden hedder Jim Bowler, og han er geolog. Han er egentligt udsendt af Australian National University til at undersøge jordbunden i området, men det skal snart vise sig, at han vil blive kendt for en, ja faktisk to, helt andre opdagelser. Opdagelser der vil omskrive ikke blot Australiens, men hele menneskehedens historie. Her ved bredden af den udtørrede kæmpesø støder han først på flere forskellige lag og bunker af østersskaller, der tyder på forhistorisk liv, derefter på et menneskekranie, så en torso, og til sidst et helt skelet.","spans":[]},{"type":"paragraph","text":"I begyndelsen af det 20. århundrede var den gængse opfattelse, at aboriginerne, Australiens indfødte folk, kun havde været i Australien i omegnen af 400 år. Her i år 1968, da Jim Bowlers vandrestøvler finder vej til den udtørrede sø, har man løftet tidsestimatet til omkring 8.000 år. Men kraniet fra det skelet, han netop har fundet - et skelet, der senere vil blive kendt under navnet “Mungo Lady” - viser sig ved en kulstof-14 analyse at være op til 25.000 år gammel. Med andre ord bliver det med ét slag bevist, at aboriginerne har været i Australien hele 15.000 år tidligere, end man hidtil har antaget. Som om det ikke er skelsættende nok, finder Jim Bowler seks år senere, i februar 1974, endnu et skelet, den såkaldte “Mungo Man”, der viser sig at være mindst  40.000 år gammelt. De to videnskabelige fund slår, som de første af flere, fast, at aboriginerne har den ældste fortsat vedligeholdte kultur i verden. Fundene sætter derudover også en tyk streg under det, aboriginerne har fortalt igen og igen: At de som folk har været i Australien siden tidernes morgen.","spans":[]},{"type":"paragraph","text":"Når man har sat sig for at give et indblik i Australiens migrationshistorie, er der flere forskellige steder, man kan lade sin fortælling begynde. Med aboriginernes tilstedeværelse på kontinentet er den således både ældgammel og relativt ny. Man kan gå helt tilbage til begyndelsen, da de første mennesker satte deres fødder på den røde jord og fortsætte udforskningen af den fascinerende fortælling, om hvordan de, aboriginerne, nåede så langt, mens langt størstedelen af jordens befolkning stadig befandt sig på det afrikanske kontinent. Man kan springe mange, mange tusinder af år frem i tid og begynde ved Australiens løsrivelse fra Storbritannien og oprettelsen af en egentligt føderation og nationen Australien i år 1901. Man kan begynde med de såkaldte bådflygtningene i 1970’erne. Eller langt derfra i tid, i 1400-tallet, hvor man formoder, at kineserne fandt vej til Australien efter i århundrede at have købt søpølser fra indonesiske sejlere, der lagde til og fangede dem ved den Australske nordkyst. Eller man kunne begynde ved hollændernes kortlægning af dele af nord- og vestkysten af Australien, der førte til betegnelsen “New Holland”, eller ved Abel Tasmans opdagelse af ø-staten Tasmanien i 1642.","spans":[]},{"type":"paragraph","text":"Næstefter aboriginernes ankomst til landet, er der dog ingen tvivl om, at ankomsten af én bestemt person ikke kan forbigås. Det er med andre ord på tide at løfte blikket væk fra den udtørrede og rynkede jord ved den urgamle Lake Mungo i New South Wales og i stedet skue ud over Australiens østkyst. Hvis man på samme tid springer helt frem til år 1770, har man her en helt unik mulighed for at få et glimt af de udspilede sejl på det tremastede skib Endeavour. Det er under sejlene, her på dækket, at man at finder ham. Den person, der ikke kan forbigås. Den britiske søofficer og opdagelsesrejsende James Cook.","spans":[{"start":450,"end":461,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsbillede: Jeanette Frank Nielsen.)","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/9cadbf7082588b61718dbfd37b590ae5ed7de79c_fulge_skygge.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":1280}}],"information":[],"x_axis":"0","y_axis":"15","layer":10,"rotation":null,"background":null,"width":"1920","height":"1083","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/073a0d214316891e16afc3eeb5592c920e3251a5_dsc_0362.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0a127948603e8caa784f2aac004df57dde7a04a8_dsc_0362.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e36a207d0e7f154402d3113013ce411174f442f7_dsc_0362.jpg"}},"color_overlay":null,"color_opacity":"0.5","layer":45}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"En hemmelig rejse i en forseglet konvolut","spans":[]},{"type":"paragraph","text":"\"Hemmelig rejse.\nLøjtnant Cook afventer gode vinde. \nEftersøgning efter ukendt kontinent syd for Ækvator.\"","spans":[{"start":0,"end":106,"type":"em"}]},{"type":"paragraph","text":"Sådan lyder den tredelte overskrift på forsiden af avisen London Gazette fredag den 19. august år 1768. Overskriften tilhører en længere artikel, der tager læserne med til havnen i den engelske by Plymouth, hvor det imponerende skib Endeavour har lagt til kaj. Rygterne, som artiklen gengiver, går på, at skibet er udset af den britiske regering til at skulle føre løjtnant James Cook og en større besætning ud på en langvarig videnskabelig rejse for et af verdens ældste videnskabelige selskaber: Royal Society i London. Det er en rejse, der skal føre mandskabet til Tahiti, hvor holdet som et af tre rundt om i verden skal observere den Venus-passage, som videnskabsmænd har regnet sig frem til, der vil finde sted det følgende år. Og så er det vigtigst af alt en rejse, der derefter skal føre dem til Det Sydlige Stillehav, hvor de skal søge efter “det store kontinent, som det forlyder skulle være lige så stort som Europa og Asien tilsammen”, som der står i artiklen. Et kontinent, der på det her tidspunkt kun findes uklare beskrivelser af. Et kontinent, der på kort er markeret som “Terra Australia Nondum Cognita”. ","spans":[{"start":58,"end":73,"type":"em"},{"start":233,"end":243,"type":"em"},{"start":498,"end":511,"type":"em"}]},{"type":"paragraph","text":"Ifølge artiklen i London Gazette er den sidste del af rejsen mod det ukendte kontinent dog stadig omfattet af en stor mængde hemmelighedskræmmeri, da selve ordren om den del af rejsen efter sigende skulle befinde sig i en forseglet konvolut, der først må brydes, når observationen af Venus-passagen er udført. Ikke desto mindre mener korrespondenten bag artiklen i London Gazette at vide, at ordren i den forseglede konvolut indeholder instruktioner til Løjtnant James Cook om på hans majestæts vegne at tage de ubeboede lande, han måtte støde på, i britisk besiddelse, samt at observere samt kultivere et venskab med eventuelle indfødte.","spans":[{"start":18,"end":33,"type":"em"},{"start":365,"end":379,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsbillede: Jeanette Frank Nielsen.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":50,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/86e545f5285d5d78abd9fc910eed78446a48f5de_james_cook_-_a_chart_of_the_southern_hemisphere_1776_drejet.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":478}}],"information":[{"type":"paragraph","text":"Her ses henholdsvis et kort over den sydlige halvkugle tegnet af James Cook og et lille udklip fra hans notesbog fra rejsen til Australien. ","spans":[]},{"type":"paragraph","text":"Kilde: National Library of Australia","spans":[]}],"x_axis":"20","y_axis":"20","layer":20,"rotation":"20","background":null,"width":"500","height":"478","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/1d8d27b954d8f98cf053b09e1a6cfd4cbab25d76_captainjamescookportrait.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":627}}],"information":[{"type":"paragraph","text":"Et portræt af James Cook fra omkring år 1776 malet af Nathaniel Dance-Holland. I dag hænger maleriet på National Maritime Museum i London.","spans":[]}],"x_axis":"5","y_axis":"45","layer":30,"rotation":"0","background":"Shadow","width":"500","height":"627","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/422b74621a51ede5a49aa9799e8f5fcfec07412b_jamescook_frimaerke_shutterstock.png","alt":null,"copyright":null,"dimensions":{"width":350,"height":206}}],"information":[],"x_axis":"35","y_axis":"70","layer":40,"rotation":"-30","background":null,"width":"350","height":"206","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b6e53f2a8136fbc6c2433fa3ae2e785d1da1feea_james_cook_endeavour_journal_490b.png","alt":null,"copyright":null,"dimensions":{"width":488,"height":408}}],"information":[],"x_axis":"7","y_axis":"5","layer":10,"rotation":null,"background":null,"width":"488","height":"408","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/404b0083018ae1ee99a40faab7dfd20fbba5e355_mast_uden_dannebrog.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/4f44e0def612d4ec3488b3672a912bdfcdbb13f0_mast_uden_dannebrog.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/bb9f57fa2e347c067e165f77e7bebc31f4153c87_mast_uden_dannebrog.jpg"}},"color_overlay":"#fafafa","color_opacity":"0.20","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Terra Australia Nondum Cognita ","spans":[{"start":30,"end":31,"type":"strong"}]},{"type":"paragraph","text":"Klokken er 18 den 19. april 1770, da mandskabet på Endeavour første gang skuer Australien. Det er et helt år siden, at de succesfuldt udførte observationen af Venus-passagen på Tahiti, og i det forgange år har de blandt andet også nået at vende New Zealand. ","spans":[{"start":51,"end":60,"type":"em"}]},{"type":"paragraph","text":"Den 29. april lykkes det for mandskabet og James Cook at lægge til ved den Australske kyst, ved hvad der senere får navnet “Botany Bay”. I de næste mange måneder sejler skibet langs den australske østkyst, hvor det lægger til flere forskellige steder. Her oplever James Cook og det øvrige mandskab endelig det sagnomspundne land i syd. De støder igen og igen på mærkværdige dyr, blandt andet overdimensionerede rotter, der hopper afsted, overalt hvor de kommer frem - \"kænguruer\", kalder de indfødte dem. De fascineres af en ukendt og farverig flora. Og så møder de de indfødte, aboriginerne, som ikke tager udelt glædeligt imod dem. ","spans":[]},{"type":"paragraph","text":"Da Endeavour når tilbage til Storbritannien i sommeren år 1771, kan Løjtnant Cook berette, at han - uden forhandling med aboriginerne, i øvrigt - har taget et større område af Australien i besiddelse under den engelske trone. “New South Wales” har han kaldt det, og han beskriver det som frodigt og - måske vigtigst af alt - “velegnet til bosættelse”.","spans":[{"start":3,"end":12,"type":"em"}]},{"type":"paragraph","text":"Baggrundsbilledet - dyrene og klippen undtaget - er taget tæt ved den lille by ”Town of 1770” i østlige Australien. Det er, som navnet henviser til, netop et af de steder på den australske østkyst, man har fundet beviser på, at Endeavour lagde til i år 1770. ","spans":[{"start":0,"end":258,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsbillede: Jeanette Frank Nielsen.) ","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8089ab4a46dc572d32471c211d22d6a6fb9521a5_terraaustralis_2.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/be30f1f97c508a2d6fbb6dd116136ffb905ffd87_terraaustralis_2.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b001bb37fbe300637f38a6208d483eeb4259e104_terraaustralis_2.jpg"}},"color_overlay":null,"color_opacity":null,"layer":45}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Thi kendes for ret: I lænker til Australien","spans":[]},{"type":"paragraph","text":"Der går hele 18 år, fra aboriginerne første gang ser sejlene fra Endeavour, til det engelske flag endnu engang toner frem fra søsiden. Det er i januar 1788, hvor Den første flåde ligger til med ikke mindre end 11 skibe med blandt andet 759 straffefanger ombord: 568 mænd, 191 kvinder og 13 børn ifølge med deres mødre. Alle under ledelse af guvernøren, Kaptajn Arthur Phillip. Fra britisk side er det blevet besluttet, at man vil bruge det nyerhvervede land til at aflaste de engelske fængsler. Indtil nu har man brugt det amerikanske fastland til det, men med den nyligt vundne uafhængighed har amerikanerne sat en stopper for den ordning. Ud over at bruge den nye jord til at aflaste de britiske fængsler er planen også at oprette et selvforsørgende samfund her på den sydlige halvkugle med landbrug og lignende, der kan være den spæde start på en egentlig britisk koloni i Stillehavet - gerne før andre kolonimagter får planer om det samme. Med de første af mange, mange straffefanger på australsk jord, tager grundlæggelsen af byen Sydney dermed sin begyndelse. Ikke som et typisk fængsel, men som en koloni af fanger med en relativ stor grad af frihed. Fangerne bliver sendt fra Storbritannien, Irland og - i en mindre skala - fra de britiske kolonier, og fra 1788 til 1840 ankommer der 80.000 alene til staten New South Wales. ","spans":[{"start":65,"end":76,"type":"em"},{"start":162,"end":177,"type":"em"}]},{"type":"paragraph","text":"Selvom intentionerne er gode, går der ikke længe, før forholdet mellem straffefangerne og aboriginerne kører helt skævt. Allerede ved begyndelsen af 1800-tallet er aboriginerne omkring Sydney således helt frarøvet deres eksistensgrundlag. Det er en udvikling mellem de nyankomne og aboriginerne, der kommer til at gentage sig igen og igen rundt omkring i landet.","spans":[]},{"type":"paragraph","text":"(Baggrundstegningen af engelske straffefanger: State Library of NSW.) ","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":40,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/f000c13e851dc340ed5c3f41222a508811bf2d68_chain_gang_-_convicts_going_to_work_nr._sidney_n.s._wales.png","alt":null,"copyright":null,"dimensions":{"width":550,"height":339}}],"information":[{"type":"paragraph","text":"En skitse fra 1843 af Edward Backhouse. Skitsen forestiller en gruppe straffefanger, der bundet sammen og bliver bevogtet af vagter nær Sydney i staten New South Wales.\n(Kilde: National Library of Australia)","spans":[]}],"x_axis":"5","y_axis":"35","layer":10,"rotation":"-10","background":null,"width":"550","height":"339","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d8d46932ad3773ed58c6f339282246d1eef0e930_a-fleet-of-transport-under-convoy-dixson-library-state-library-of-new-south-wales.jpg","alt":null,"copyright":null,"dimensions":{"width":290,"height":407}}],"information":[{"type":"paragraph","text":"En tegning fra år 1781 med titlen \"A Fleet of Transports under Convoy\". På tegningen kan man se en mand gå afsted med en gruppe bundne straffefanger, der er dømt til at skulle transporteres til Australien. I baggrunden aner man facaden af Newgate Prison, der blev indviet i år 1769 i London, England.\n(Kilde: State Library of New South Wales)","spans":[]}],"x_axis":"25","y_axis":"55","layer":30,"rotation":"30","background":"Shadow","width":"290","height":"407","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/ded71619ecfb387692d3f04530b1cc0219b96a68_convict-barrack-sydney-ny_n.s.-wales-ca.-1820-from-collection-of-views-predominantly-of-sydney-liverpool-and-the-sunda-straits-and-portraits-ca-1807.jpg","alt":null,"copyright":null,"dimensions":{"width":550,"height":308}}],"information":[{"type":"paragraph","text":"På maleriet her fra omkring år 1807 kan man se en straffefangebarak i Sydney. \n(Kilde: State Library of New South Wales)","spans":[]}],"x_axis":"15","y_axis":"15","layer":10,"rotation":null,"background":"Shadow","width":"550","height":"308","speed":-2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e6360b6632ed99d59e86b528f485be40592bd5be_convict_gang_sydney_spejlvendt.jpg","medium":{"dimensions":{"width":1024,"height":702},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f157a24cd3b88fe7de35f629b87c7a21e77029dd_convict_gang_sydney_spejlvendt.jpg"},"tall":{"dimensions":{"width":600,"height":412},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5e8ae18d5115a8ad993713cecac3ceaf6c4de550_convict_gang_sydney_spejlvendt.jpg"}},"color_overlay":null,"color_opacity":null,"layer":40}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"GULD!","spans":[]},{"type":"paragraph","text":"Guld! Gyldent, skinnende og fuld af løfter for fremtiden. ","spans":[]},{"type":"paragraph","text":"Godt 200 kilometer ind i landet fra Sydney ligger byen Bathurst. I 1851 kommer den pludselig på alles læber, da der bliver opdaget guld her. Det er en opdagelse, der i den grad kommer til at ændre migrationen til Australien. De første migranter under den engelske trone blev sendt til Australien mod deres vilje, og frivillige migranter fra primært Storbritannien og Irland fulgte trop - nogle for egne penge, andre med økonomisk støtte fra den britiske regering. Men nu kommer migranterne rejsende fra hele verden og fra alverdens baggrunde. Guldfeberen raser. Fra 1851 til 1861 ankommer over 600.000 migranter til kontinentet. Størstedelen kommer stadig fra England og Irland, men derudover kommer 60.000 fra resten af Europa, 42.000 fra Kina, 10.000 fra USA og lidt over 5.000 fra New Zealand og det øvrige Stillehavsområde. ","spans":[]},{"type":"paragraph","text":"Selvom migrationsstrømmen falder mere til ro efter år 1861, er der stadig en øget interesse i resten af verden for at emigrere til Australien. I år 1901 er Australiens befolkning vokset til fire millioner indbyggere. I samme år får landet en føderal forfatning og bliver dermed en selvforvaltende koloni under det britiske imperium. Det er blandt andet den såkaldte ‘guldgravermentalitet’ samt den hastigt voksende befolkning, hvoraf de fleste (cirka tre-fjerdedele) nu er født i og aldrig har været uden for Australien, der har forstærket kravet om politisk selvstyre. I guldgraverbyerne er der dog også et andet ønske, der er vundet frem. Ønsket om at holde især én bestemt befolkningsgruppe ude af landet. Der er med andre ord en helt ny form for grænse på vej til landet på den sydlige halvkugle. ","spans":[]},{"type":"paragraph","text":"En juridisk en af slagsen.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Optimarc via Shutterstock.)","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":40,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/1d05b910864289add548ee0f0c32a4be5530314e_mand_med_guldstatelibraryofvictoria.jpg","alt":null,"copyright":null,"dimensions":{"width":627,"height":827}}],"information":[{"type":"paragraph","text":"Henholdsvis en bunke tegninger af livet i Bathurst - alle fra 1870'erne - og et foto af en succesfuld australsk guldmine-ejer, businessmand og politiker B.O. Holtermann med en guldklump fra omkring år 1873.\n(Kilder: Tegningerne er udført af (fra oven og ned): George Lay, George French Angas, Samuel Thomas Gill og en ukendt artist og er alle fra State Library of New South Wales. Fotografiet stammer fra: Mitchell Library, State Library of New South Wales.)","spans":[]}],"x_axis":"50","y_axis":"30","layer":20,"rotation":"10","background":"Shadow","width":"314","height":"414","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/280bbf918a3b61cc4ac6ed3af456c39c5dd9c551_guldstykker.png","alt":null,"copyright":null,"dimensions":{"width":150,"height":110}}],"information":[],"x_axis":"40","y_axis":"68","layer":30,"rotation":null,"background":null,"width":"150","height":"110","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/44e8bcc7cb709802554c1fe0f38a4af15754b7c4_gulgraverbilleder_samlet_1_redigering.png","alt":null,"copyright":null,"dimensions":{"width":751,"height":858}}],"information":[],"x_axis":"60","y_axis":"13","layer":10,"rotation":null,"background":null,"width":"751","height":"858","speed":-2}],"primary":{"id":"guld","background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7faafe37ea4e948166e95f547268dd14e1a9f700_guld-shutterstock_spejlvendt.jpg","tall":{"dimensions":{"width":600,"height":401},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e7799849b558b88e74b8e66c75a7133baba379a3_guld-shutterstock_spejlvendt.jpg"},"medium":{"dimensions":{"width":1024,"height":684},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/90fc211b7eb2082881ae4a0ac8a4364c66d5f2d6_guld-shutterstock_spejlvendt.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"White Australia Politikken: En effektiv mur af paragraffer","spans":[]},{"type":"paragraph","text":"Kineserne! Tænk nu, hvis de overtager det hele?! Allerede fra år 1850 og frem breder der sig en frygt i det australske samfund. En frygt for, at de mange kinesere, der kommer til landet i jagten på guld, skal blive så talrige, at de til sidst helt vil overtage guldminerne. Og en frygt for, at de vil oversvømme arbejdsmarkedet og presse lønningerne. Det er en frygt, der kommer til at bane vejen for et helt nyt tiltag på migrationsområdet, da de seks australske kolonier i 1901 bliver samlet til én fælles føderation under britisk styre. ","spans":[]},{"type":"paragraph","text":"En af de første handlinger, det nyvalgte parlament udfører, er derfor at vedtage \"The Immigration Restriction Act\". En politik, der i folkemunde bliver kendt som \"White Australia-politikken\". Formålet med politikken er at holde især kinesere, men også japanere og polynesiere, ude af Australian og på den anden side favorisere indvandrere fra Europa. Med andre ord: At sikre den hvide dominans i landet. Nøgleelementet i politikken er indførelsen af en diktat-test, man skal bestå for at kunne immigrere til Australien. I testen skal man stave til 50 forskellige ord, der alle bliver dikteret på et eller flere af de europæiske sprog. Og politikken virker: Mens der i år 1850 arbejdede cirka 50.000 kinesere i Australien, er tallet faldet til godt 7.000 i år 1947. ","spans":[]},{"type":"paragraph","text":"Først fra 1950’erne og frem bliver der løsnet gradvist op for politikken igen, før den i år 1973 officielt bliver ophævet. Herfra lyder det gældende princip i immigrationspolitikken, at det ikke skal være migranternes oprindelsesland, men derimod deres personlige og faglige kvalifikationer, der skal være udslagsgivende. Helt indtil år 1982 bliver de britiske immigranter dog stadig favoriseret gennem forskellige økonomiske sponsorater.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede af en kinesiske guldgraver foran William A. Sac’s Chinese Boarding House, Gulgong fra omkring år 1875: American & Australasian Photographic Company, State Library of New South Wales.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":459,"height":344,"embed_url":"https://youtu.be/6zb8yLammA0","type":"video","version":"1.0","title":"Voice of the People: The White Australia Policy (1962)","author_name":"ABCLibrarySales","author_url":"https://www.youtube.com/user/ABCLibrarySales","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/6zb8yLammA0/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"459\" height=\"344\" src=\"https://www.youtube.com/embed/6zb8yLammA0?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"Voxpop blandt australierne fra år 1962 om White Australia-Politikken. Året efter, i år 1963, blev politikken officielt ophævet.\n(Kilde: ABC (Australian Broadcasting Corporation) Library Sales)","spans":[]}],"x_axis":"10","y_axis":"63","layer":50,"rotation":null,"background":"Shadow","width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/c16be97afc9fdb40fed681c8e3ba41daa458b4fe_skrift_australia.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":159}}],"information":[],"x_axis":"10","y_axis":"25","layer":40,"rotation":"25","background":null,"width":"400","height":"127","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/3d8c62121a3410a150f5350c46304cf524a76756_skrift_white.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":232}}],"information":[],"x_axis":"15","y_axis":"10","layer":30,"rotation":"-10","background":null,"width":"400","height":"186","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/a88da7b793b5d032104a642994f05de951187d67_skrift_policy.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":331}}],"information":[],"x_axis":"10","y_axis":"35","layer":40,"rotation":null,"background":null,"width":"300","height":"199","speed":1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5e72ffde60fde0e4933eb25fe838a5fd8dbde0c0_kinesiskguldgraver.jpg","medium":{"dimensions":{"width":1024,"height":752},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/93179b8b244cb7ccdeb75d740118cfc195825dbd_kinesiskguldgraver.jpg"},"tall":{"dimensions":{"width":600,"height":441},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/eefd9b6a4203e669cf4dec2b20a3e0481331d6d9_kinesiskguldgraver.jpg"}},"color_overlay":"#968484","color_opacity":"0","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Verdenskrige, flygtninge og migranter","spans":[]},{"type":"paragraph","text":"Den 28. juni 1914 lykkes det for den serbiske nationalist, den nittenårige Gavrilo Princip, at skyde og dræbe den østrig-ungarske tronfølger, Frans Ferdinand. Attentatet giver Østrig-Ungarn et påskud for at erklære krig mod Serbien, og det sætter gang i en hel stribe af krigserklæringer på kryds og tværs af landene i Europa. Da kalenderen viser den 1. august 1914, er Første Verdenskrig en realitet. ","spans":[]},{"type":"paragraph","text":"Mens det i 1800-tallet var fundet af guld i Australien, der blev afgørende for immigrationen til landet, er det her i 1900-tallet hændelser langt væk fra landets grænser, der kommer til at være afgørende for migrationsmønstrene. For det første ophører indvandringen nærmest med udbruddet af Første Verdenskrig, og for det andet oplever nogle migrantgrupper, der førhen har været accepteret i det australske samfund, nu at blive stemplet som “fjender af staten” som direkte konsekvens af skillelinjerne i krigen. De, der er født i Tyskland, Østrig-Ungarn, Bulgarien og Tyrkiet bliver pludselig interneret eller underlagt skrappe restriktioner i deres hverdag, og nu er White Australia-Politikken også vendt mod dem. Under Anden Verdenskrig gentager mønstret sig påny, nu er det blot migrantgrupperne med italienske, japanske og - igen - tyske aner, der på lignende vis oplever at blive udråbt som fjender af staten og at blive udsat for en omfattende overvågning.","spans":[]},{"type":"paragraph","text":"Modsat krigsårene er både mellemkrigsårene og tiden efter Anden Verdenskrig præget af et sandt boom i migrationen. I mellemkrigsårene genindfører den britiske regering samt kirker og andre organisationer forskellige ordninger, så de britiske borgere kan søge om økonomisk hjælp til at migrere til en af de britiske domæner eller kolonier. Da USA på samme tid forsøger at bremse immigrationen fra Sydeuropa, får flere unge mænd fra Grækenland og Italien ligeledes øjnene op for Australien. ","spans":[]},{"type":"paragraph","text":"Mens Børskrakket i 1929 og Den Store Depression sætter en stopper for de økonomiske hjælpeordninger, og migrationsstrømmen dermed bliver betydeligt svækket, går den australske regering til gengæld all-in på igen at tiltrække så mange migranter som muligt, da Anden Verdenskrig ender i 1945. Da Japan under krigen kommer yderst tæt på at besætte Australien, går det nemlig op for de australske politikere, at en stor befolkning, der kan udfylde de tomme landområder og ikke mindst udgøre en kraftfuld arbejdsstyrke inden for de krigs-vigtige industrier (såsom jern-, stål-, jernbane-, mine- og ikke mindst vandkraftsindustrien) er et vigtigt og stærkt våben i kampen for at kunne modstå angreb udefra. Som den Australske Premierminister Ben Chiefly senere udtaler: “Vi må befolke Australien så hurtigt, som vi kan, før nogen andre beslutter sig for at gøre det for os.” ","spans":[]},{"type":"paragraph","text":"Til at hjælpe netop den udvikling på vej, bliver der i år 1945 oprettet et Immigrationsministerium, som sætter et mål på en årlig vækst i befolkningstallet på to procent. Da ministeriet anslår, at kun halvdelen af den ønskede vækst vil komme af sig selv, fastsætter regeringen et mål om at tiltrække 70.000 migranter om året, hvoraf man ønsker at størstedelen skal komme fra Storbritannien. Da det viser sig, at det ikke er muligt at tiltrække så stor en mængde migranter fra Storbritannien alene, indgår Australien i 1947 i stedet en aftale om at acceptere minimum 12.000 flygtninge om året fra specielt Polen, Jugoslavien, Letland, Ukraine og Ungarn. Lande, hvor flere millioner mennesker er blevet internt fordrevne blandt andet efter ophold i de nazistiske koncentrationslejre. ","spans":[]},{"type":"paragraph","text":"Igennem de næste syv år ankommer der næsten 171.000 personer til Australien gennem den aftale. På verdensplan er det dermed kun den nyoprettede stat Israel, der i de år accepterer flere flygtninge end Australien. For alle de nyankomne flygtninge gælder det, at de til gengæld for deres ophold skal arbejde for Australien. Et arbejde, der oftest er både hårdt og farligt. I takt med at antallet af flygtninge, som Australien kan hente til landet, lige så roligt ebber ud, vender den australske regering sig i stedet mod resten af Europa og forhandler flere forskellige immigrationsordninger igennem med landene her - fx en med Danmark i 1954. ","spans":[]},{"type":"paragraph","text":"Som følge af den nye politik ændrer Australiens befolkning med andre ord kraftigt karakter. Fra at være et engelsk-skotsk-irsk samfund med et mindre tysk islæt, er den australske befolkning nu betydelig mere mangfoldig i sit udtryk.","spans":[]},{"type":"paragraph","text":"(Fotografierne i denne sektion er alle fra The Australian National Maritime Museum. De viser forskellige episoder fra den store migrantbølge mod Australien efter Anden Verdenskrig. Fotografierne er taget i tidsrummet 1945-1954.)","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/8837588754833c7093dfc939d71a0b1b16a044b4_filmrullen6.png","alt":null,"copyright":null,"dimensions":{"width":925,"height":1546}}],"information":[{"type":"paragraph","text":"","spans":[]}],"x_axis":"45","y_axis":"-10","layer":10,"rotation":null,"background":null,"width":"925","height":"1546","speed":-2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7730f76a6b23141407e1f7f5b1f36982a42d99d9_shipofmigrants.jpg","medium":{"dimensions":{"width":1024,"height":718},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/905a3a9cc271436105ff7cef0851605dc79333be_shipofmigrants.jpg"},"tall":{"dimensions":{"width":600,"height":421},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/dbc206f2b0f647272781f7c98ff7881ef8349313_shipofmigrants.jpg"}},"color_overlay":null,"color_opacity":null,"layer":45}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":459,"height":344,"embed_url":"https://www.youtube.com/watch?v=I3Nfi2S4MiA","type":"video","version":"1.0","title":"Vietnamese Boat People Arrive in Darwin (1976)","author_name":"ABCLibrarySales","author_url":"https://www.youtube.com/user/ABCLibrarySales","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/I3Nfi2S4MiA/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"459\" height=\"344\" src=\"https://www.youtube.com/embed/I3Nfi2S4MiA?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"En gruppe vietnamesiske bådflygtninge ankommer til Darwin på en fiskerbåd den 13. november, 1976.","spans":[]},{"type":"paragraph","text":"(Kilde: ABC (Australian Broadcasting Corporation) Library Sales)","spans":[]}],"x_axis":"10","y_axis":"10","layer":30,"rotation":null,"background":"Shadow","width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"\"The Boat People\"","spans":[]},{"type":"paragraph","text":"I den nordlige, subtropiske del af Australien kaster Timorhavet sine bølger ind mod byen Darwin. Byen er den største i det tyndtbefolkede nordlige territorium af landet, og i april 1976 kommer den pludselig i fokus, da en båd lægger til her med fem flygtninge eller fem “boat people”, som de bliver døbt af de australske medier. ","spans":[]},{"type":"paragraph","text":"Igen skal årsagen findes langt fra de australske kyster: Mens den Den Kolde Krig har fikseret Vesten, er kampen mellem kommunismen og liberalismen alt andet end kold i Vietnam, og over halvdelen af den vietnamesiske befolkning er fordrevet fra deres hjem. Mens langt de fleste vietnamesere er flygtet enten internt til andre områder i landet eller til nabolandene, har en mindre gruppe af dem i stedet begivet sig ud på det skvulpende hav med en efterhånden ganske kendt destination: Australien. Gennem de næste fem år ankommer der lidt over 2000 vietnamesere, i hvad der sidenhen bliver beskrevet som “den første immigrationsbølge”. Anden bølge begynder i år 1989 med ankomsten af 27 bådflygtninge, og i de følgende ni år ankommer der omkring 300 flygtninge om året, de fleste af dem fra Cambodia, Vietnam og det sydlige Kina. ","spans":[]},{"type":"paragraph","text":"I begyndelsen er folkestemningen i Australien venligt stemt over for de bådflygtninge, der ankommer til landet i kølvandet på Vietnamkrigen. Ankomsten af de første fem flygtninge vækker faktisk nærmest ikke røre uden for Darwin. Sympatien rinder dog ud, i takt med at flere og flere både lægger til ved landets kyster, og en snigende frygt for, hvad flygtninge kan betyde for arbejdsløsheden, begynder at opstå. I aviserne bliver der nu spekuleret i, om der er tale om “egentlige” flygtninge, og deres ankomst bliver nu pludseligt omtalt som “an invasion\", “a tide\" og “a yellow peril\", og fra officielt hold bliver udtrykket “the boat people” pludselig til “irregular maritime arrivals”,  “unauthorized boat arrivals” og “unlawful boat arrivals”. Frygten, som medierne lader komme til orde, er, at Australien er ved at miste kontrollen med sine egne grænser - at landet er ved at blive oversvømmet af flygtninge.","spans":[]},{"type":"paragraph","text":"Selvom antallet af asylansøgere, der kommer til Australien, er relativt lille i sammenligning med antallet af flygtninge til de andre industrialiserede lande, har Australien i slutningen af 1970’erne opført tre detentionscentre, hvor asylansøgerne bliver placeret, mens de får deres sag behandlet. To centre i det sydøstlige Australien, i Sydney og Melbourne, og et i Perth i Vestaustralien.","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":40,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/62489a3ee5ab1050a2aaacf01311fff3648f4b68_maen_vietnam.jpg","alt":null,"copyright":null,"dimensions":{"width":600,"height":418}}],"information":[{"type":"paragraph","text":"Alle fotografierne af bådflygtnigene her er taget i byen Darwin i november 1977 af den australske fotograf Michael Jensen","spans":[]}],"x_axis":"5","y_axis":"60","layer":20,"rotation":"15","background":"Shadow","width":"600","height":"418","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/c3e9ee55def6de2e0d8c289d15bb32a8935d5bca_kvinder-og-born.jpg","alt":null,"copyright":null,"dimensions":{"width":600,"height":418}}],"information":[],"x_axis":"5","y_axis":"30","layer":10,"rotation":"-10","background":"Shadow","width":"600","height":"418","speed":-3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/83cfc737cde47f691482bb619b3c82aa8dacf68e_baggrund_vietnam.jpg","medium":{"dimensions":{"width":1024,"height":715},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5c310ee4f0800a490a64b7015130efa8a2c7ddcf_baggrund_vietnam.jpg"},"tall":{"dimensions":{"width":600,"height":419},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b6f2cc0e70aa968328040ccb306bc4bb71c5e561_baggrund_vietnam.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"“Stop the boats” - Tampa-sagen","spans":[]},{"type":"paragraph","text":"Langt væk fra Australiens nordvestkyst i det Indiske Ocean er det australske “søg-og-red”-hold kommet på sporet af en fiskerbåd, der er kommet i havsnød på grund af motorproblemer. Året er 2001, og det er vinter her på den sydlige halvkugle. I nærheden af den nødstedte fiskebåd er containerskibet MV Tampa, anført af den norske kaptajn Arne Rinnan, på vej mellem Fremantle i Australien og Singapore. Det er Arne Rinnans næstsidste tur som kaptajn, inden han skal på pension. Da de australske myndigheder tager kontakt til ham og beder ham om at komme fiskerbåden til undsætning, er det dog alt andet end en rolig pensionisttilværelse, Arne Rinnan får udsigt til. Tværtimod bliver opkaldet begyndelsen på 10 højspændte uger, der kommer til at ændre Australiens migrationspolitik for stedse. På trods af at Arne Rinnan og hans besætning får reddet samtlige af de over 400 flygtninge, der befinder sig på fiskerbåden, op på dækket af MV Tampa, går der nemlig ikke lang tid, før situationen bliver ganske kompliceret. Det sker, da den norske kaptajn, hans besætning og den store gruppe af bådflygtninge pludselig forvandles fra at være en gruppe almindelige og tilfældigt sammenbragte mennesker til at udgøre en særdeles vigtig brik i et storpolitisk spil. For, for første gang lyder den sætning nu hen over bølgerne, der sidenhen bliver synonym med den australske flygtningepolitik: ","spans":[]},{"type":"paragraph","text":"“Stop the boats!” - “Stop bådene!”","spans":[]},{"type":"paragraph","text":"På MV Tampa må Arne Rinnan kort efter redningsaktionen opgive sin oprindelige plan om at sejle gruppen af bådflygtninge, der både inkluderer børn, gravide og flere syge personer, til den nærmeste havn i Indonesien. Flygtningene kræver nemlig at blive sejlet til den lille ø, Christmas Island (Juleøen), der hører under det australske territorium, for herfra at kunne søge om asyl i Australien. Hvis Arne Rinnan ikke følger deres ønske, vil de “go crazy”, fortæller de. Selvom Arne Rinnan ikke helt ved, hvad han skal lægge i det, følger han kravet og ændrer kursen, blot for kort derefter at modtage kontraordre fra australierne over radioen. Her lyder det nu fra højeste sted, at australierne vil borde hans skib og potentielt fængsle ham, hvis han sejler ind i australsk farvand. Med andre ord: MV Tampa vil under ingen omstændigheder få lov at lægge til land i Australien.","spans":[]},{"type":"paragraph","text":"For at forstå hvorfor Tampa-affæren, som den siden er blevet døbt, udvikler sig, som den gør, må man træde et skridt tilbage og kigge nærmere på de to år, der leder op til redningsaktionen i Det Indiske Ocean: Siden 1999 har australierne gradvist kunnet følge med i, at den såkaldte tredje bølge af bådflygtninge efter flere stille år er begyndt at komme til landet. I modsætning til bådflygtningene fra de to tidligere bølger, hvor der maksimalt kom 1000 personer årligt, er der nu primært tale om flygtninge fra Mellemøsten i stedet for Asien, og der kommer nu fra 3.700 til 5.000 årligt - og flere af dem ankommer med hjælp fra menneskesmuglere. I flere dele af det australske samfund er der med andre ord begyndt at vokse en følelse frem af, at strømmen af flygtninge, der fortsat søger mod landet, bliver stærkere og stærkere, og at man ikke har en chance for hverken at kunne stoppe, bremse eller blot kontrollere udviklingen på. Derudover lyder der igen, som der gjorde i 70'erne, røster om, at de flygtninge, der kommer til landet via bådene, “snyder foran i køen” - altså at de snyder foran de flygtninge, der kommer til Australien som FN-kvoteflygtninge. ","spans":[]},{"type":"paragraph","text":"Flygtningene, som Arne Rinnan har samlet op på MV Tampa, er altså bare de seneste i en større gruppe af flygtninge, der har søgt mod Australien. Men denne gang er der alligevel noget, der er anderledes. Flygtningene er ikke nået ind i australsk farvand, da de bliver samlet op, og derudover er det denne gang heller ikke et australsk skib, der har samlet dem op. For første gang øjner den australske regering altså en reel chance for at kunne sige “nej”. En chance for at kunne udvise kontrol - og det endda i et valgår.","spans":[]},{"type":"paragraph","text":"Mens australierne og resten af verden, som også har fået øjnene op for dramaet på havet, kun kan følge med på afstand via grynede, langdistance tv-billeder, har Arne Rinnan i sit kontroltårn udsigt fra første parket. Her bliver han vidne til, at flygtningene på dækket begynder en sultestrejke, da de via en radio opfanger nyheden om, at Australien vil nægte dem indrejse. Da der derudover også er flere syge mennesker ombord på skibet, ser han til sidst ingen anden udvej end at opsende et mayday-signal, trodse den australske regering og sejle ind i australsk farvand. Det fører straks til, at de australske specialtropper, der har holdt øje med MV Tampa, border skibet og endnu engang beordrer Arne Rinnan til at vende om. Det nægter han.","spans":[]},{"type":"paragraph","text":"Mens kritikken tager til i det internationale samfund over håndteringen af Tampa-sagen, oplever den australske premierminister, John Howard fra partiet “The Liberals” en uhørt høj tilslutning til hans beslutning om ikke at lade MV Tampa komme i land. Ifølge meningsmålinger bakker hele 80 procent af befolkningen op om hans måde at tackle sagen på. Løsningen på den gotiske knude kommer derfor først efter flere dage, da New Zealand tilbyder at tage imod alle familierne ombord på Tampa, og Australien dernæst får overtalt det lille land Nauru til at tage imod resten af flygtningene i dertil oprettede detentionscentre på øen. En aftale, der indebærer, at Australien donerer lige godt 100 millioner danske kroner til ø-staten. ","spans":[]},{"type":"paragraph","text":"I de følgende seks uger forsøger yderligere ti både at nå frem til Christmas Island under stor dramatik. En af dem synker og tager 353 flygtninge med sig i døden. Tampa-sagen er dog utvivlsomt “begyndelsen på et vendepunkt”, som den daværende premierminister John Howard udtrykker det. Med håndteringen af Tampa-sagen er den australske regering nemlig gået fra at behandle ankomsten af bådflygtninge som et migrationsanliggende til at behandle det som et forsvarsanliggende. Et skifte, der kun bliver yderligere cementeret, da terrorangrebet på World Trade Center i New York finder sted kort derefter. De såkaldte offshore-detentionscentre er nu en realitet, det vil sige detentionscentre, der bliver placeret i andre lande end Australien, og politikken er klar: Migrantbådene skal forsøges stoppes og vendes om mod Indonesien, hvor de er stævnet ud fra. ","spans":[]},{"type":"paragraph","text":"Mens den nye politik bliver mødt med stærk kritik fra flere NGO’er, herunder Amnesty International, der argumenterer for, at de dårlige forhold i detentionscentrene blot vil forværre de mange asylansøgeres i forvejen skrøbelige mentale helbred, vinder John Howard, der før Tampa-sagen stod til at tabe, det australske valg - og det med et endnu større flertal end før. Af de bådflygtninge der kommer i foråret 2001, bliver 70 procent af dem anerkendt som egentligt flygtninge. I dag bor hovedparten, omkring 700 af dem, i Australien.","spans":[]},{"type":"paragraph","text":"(Baggrundsbilledet er et fotografi, som det norske rederi bag MV Tampa sendte ud til medierne, mens sagen stod på, for at gøre opmærksom på deres dilemma på havet.)","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1280","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/6f028ddf2ccabcdd58b477bab3874747dd5b4230_tampa_aap.jpg","tall":{"dimensions":{"width":600,"height":450},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/23c715fe2d617db34b246c191de97fe32b971de9_tampa_aap.jpg"},"medium":{"dimensions":{"width":1024,"height":768},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/364c5ebe16eabb3a0159ea268c96a31207a31809_tampa_aap.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"No Way - You Will Not Make Australia Home","spans":[]},{"type":"paragraph","text":"“13 afrikanere er forsvundet fra Commonwealth Games.” Sådan lyder en overskrift, der spreder sig i de internationale såvel som de danske nyheder midt i april-måned i år, år 2018. Australien er vært for det store sportsarrangement Commonwealth Games, hvor atleter fra hele Commonwealth deltager i flere forskellige discipliner. Da de 13 afrikanske atleter fra henholdsvis Cameroun, Rwanda, Uganda og Sierra Leone er kommet til Australien på et visum, der er gyldigt til midt i maj, opholder de sig, da artiklerne begynder at cirkulere, sådan set stadig lovligt i landet - de er blot forsvundet. Selvom den ansvarlige pressemand for Camerouns hold, Simon Molombe Lyonga, der bliver interviewet i artiklerne, understreger, at han hverken ved, hvor atleterne befinder sig, eller kender til deres konkrete planer, er han dog ikke sen til at komme med sit eget gæt på, hvorfor syv af atleterne, hans landsmænd, fire boksere og tre vægtløftere, har forladt deres hoteller: “Som vi nok ville sige i Afrika: De er taget ud for at finde grønnere græsgange i Australien,” svarer han.","spans":[]},{"type":"paragraph","text":"Da partiet Labor kommer til magten i 2007, løsner den nyvalgte premierminister op for den immigrationspolitik, der blev indført som følge af Tampa-sagen - blandt andet ved at lukke ned for offshore-detentionscentrene. En beslutning, der bliver rost af FN. Da der kort efter indførelsen af den nye politik kommer en stigning i antallet af bådflygtninge, forsøger regeringen dog at genindføre centrene. Det er ikke desto mindre først, da “The Liberals” igen kommer til magten i år 2013 anført af premierminister Tony Abbott, at der endnu engang kommer et dyk i antallet af asylansøgere. Støttet af Labor indfører Abbott-regeringen en immigrationspolitik kaldet “Operation Sovereign Borders”, der ligger i direkte forlængelse af den immigrationspolitik, der blev indført efter Tampa-sagen. Det vil sige en politik, hvor Australien gør brug af offshore-detentionscentre i andre lande, hvor bådflygtninge anses for at være et forsvarsanliggende, og hvor krigsskibe fra den australske flåde patruljerer i farvandene ud for Australien for enten at presse flygtningebådene til at vende tilbage til deres afgangssted, eller alternativt for at samle flygtningene op for at sejle dem til et offshore-detentionscenter. “Operation Sovereign Borders” får dog en yderst vigtig tilføjelse: Fra nu af vil ingen af de asylansøgere, der forsøger eller lykkes med at komme til Australien uden et gyldigt visum, nogensinde få lov til at slå sig ned i Australien. I stedet vil de, hvis de bliver anerkendt som flygtninge, blive tilbudt at blive genbosat i et af de lande, hvor Australien har offshore-detentionscentre. Sloganet “No Way - You Will Not Make Australia Home” er født.","spans":[]},{"type":"paragraph","text":"Hvis det viser sig, at de 13 afrikanerne, rent faktisk er taget ud for at finde grønnere græsgange i Australien, har de dermed skaffet sig selv en stor fordel. I modsætning til de flygtninge og migranter, der forsøger at nå til Australien over havet, er de nemlig kommet til landet med et gyldigt visum. Og efter den australske regering i 2013 indførte endnu en omfattende tilføjelse til landets immigrationspolitik, er dét den detalje, der kan komme til at gøre hele forskellen. Med det i hånden - og på australsk jord - vil de nemlig kunne søge asyl i Australien.","spans":[]},{"type":"paragraph","text":"To år efter “Operation Sovereign Borders” er sat i værk, er antallet af asylansøgere, der er kommet med båd til Australien faldet fra omkring 25.000 til mindre end 200. Siden er der ifølge de australske myndigheder ikke kommet bådflygtninge til Australiens kyster. Den australske praksis med brug af offshore-detentionscentre og en privatisering af behandlingen af asylansøgerne har både vist sig at være meget dyr, og ikke mindst er Australien gentagne gange blevet endda særdeles stærkt kritiseret af blandt andre FNs Flygtningehøjkommissariat, UNHCR, og af flere andre NGO'er for de forhold, som asylansøgerne lever under på offshore-detentionscentrene. Her har der flere gange været sultestrejker, gentagne anmeldelser af voldtægter og flere tilfælde af selvskade og selvmord blandt asylansøgerne. Ikke desto mindre har både den danske regering, flere europæiske lande og EU ad flere omgange vist interesse for at kopiere, hvad der nu er kendt som “Den australske Model”. Fra den australske regering lyder det, at der, siden politikken blev indført, ikke har været en eneste registreret drukneulykke blandt bådflygtninge, og at det er Nauru selv, der er ansvarlig for at sikre asylansøgerne ordentlige forhold. Med undtagelse af partiet “The Greens” er der en fortsat stærk opbakning til at føre en hård flygtningepolitik for fortsat at afskrække bådflygtningene fra overhovedet at forsøge at komme til Australien fra søsiden. Derudover lader det til, at de afgørende svingvælgere i Australien specielt stemmer ud fra bådflygtningepolitikken - og at de favoriserer de partier, der fører en hård linje.","spans":[]},{"type":"paragraph","text":"På samme tid med at Australien fører en hård flygtningepolitik, er Australien dog fortsat det land i verden, der tager imod næstflest FN-kvoteflygtninge - omkring 21.000 i 2016-2017.  Siden Anden Verdenskrig har Australien taget imod 840.000 flygtninge, og hvert år giver landet adgang til 190.000 arbejdssøgende migranter, der fra dag ét får permanent opholdstilladelse og mulighed for statsborgerskab efter fem år. Derudover er Australien i dag et af verdens mest multikulturelle lande, hvor 45 procent af befolkningen enten er født uden for landets grænser eller har mindst en forældre, der er det. En af dem er Ali.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Jeanette Frank Nielsen.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":40,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://youtu.be/rT12WH4a92w","type":"video","version":"1.0","title":"No Way. You will not make Australia home - English","author_name":"ABF TV","author_url":"https://www.youtube.com/user/AusCustomsNews","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/rT12WH4a92w/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/rT12WH4a92w?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[],"x_axis":"10","y_axis":"5","layer":30,"rotation":null,"background":"Shadow","width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/46724abf10025df50f02ce20934bb304f2531ab8_kvinderne.png","alt":null,"copyright":null,"dimensions":{"width":1079,"height":485}}],"information":[{"type":"paragraph","text":"","spans":[]}],"x_axis":"0","y_axis":"71","layer":20,"rotation":null,"background":null,"width":"1079","height":"485","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/fea233ee64c47f02a38ed3be01cf853a7bb5dc54_gruppen_af_demonstranter.png","alt":null,"copyright":null,"dimensions":{"width":1120,"height":537}}],"information":[{"type":"paragraph","text":"Demonstranter ved en demonstration mod landets hårde flygtningepolitik i den australske hovedstad Canberra i 2018. \n(Fotocredit: Leo Bild (Leo in Canberra) via Flickr)","spans":[]}],"x_axis":"0","y_axis":"50","layer":10,"rotation":null,"background":null,"width":"1112","height":"537","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1460613bb0d0aa407e22a02b9b98c21cefec4cfc_f1.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d25bbe222d56289698ad666a0b3d69d186532a21_f1.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/ca86ec6ac28d1341b61820e0dad3269effd1c24e_f1.jpg"}},"color_overlay":"#ffffff","color_opacity":"0.2","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Alis historie","spans":[]},{"type":"paragraph","text":"Det er aften, og i det gryende mørke er den australske by Melbourne så småt begyndt at lyse op. Året er 2018, og det er her i byen, de befinder sig: Ali, hans kone og lille søn. Alis far, mor og tre brødre bor også i Australien - og de klarer sig alle godt. Familien taler sjældent om deres farefulde færd over havet frem mod landet på den sydlige halvkugle, men når de gør, er det oftest i forbindelse med, at de hører om, hvordan Australien og flere andre vestlige lande gør det sværere og sværere at opnå asyl. På samme tid med at Ali priser sig lykkelig for, at han og hans familie selv nåede at flygte og blive tilkendt asyl, før det hele blev så meget sværere, rumsterer en tanke ofte i ham: \"Hvad er forskellen på dem, der flygter nu, og mig og min familie?\"","spans":[]},{"type":"paragraph","text":"For Ali, hans tre brødre og mor, ville skæbnen, at de endte med at blive samlet op af det samme flådeskib, der kort forinden også havde fået flere af flygtningene fra MV Tampa med. Ali, hans tre brødre og mor var dermed sammen med Tampa-flygtninge en del af den allerførste gruppe flygtninge, Australien sendte til et detentionscenter på Nauru. Her endte de med at opholde sig et helt år, før deres asylsag var færdigbehandlet. ","spans":[]},{"type":"paragraph","text":"Tiden i detentionscentret på Nauru er et kapitel, som Ali ikke har mange positive minder fra - usikkerheden og ventetiden har lagt et vis mørke ind over det. Han husker dog tydeligt, da beskeden endelig kom om, at de var blevet anerkendt som flygtninge og ville få asyl og - vigtigst af alt - blive genforenet med Alis far i Australien. Den dag i dag driller Alis voksne brødre ham stadig med, hvordan han stod i lejren og både græd af glæde over afgørelsen og af sorg over at skulle sige farvel til alle de andre i lejren, der forsat var ved at få deres sager behandlet. Tårer af både glæde og sorg, der flød ud af øjnene på ham, mens han forsatte med at spise det æble, han var igang med, da beskeden lød.","spans":[]},{"type":"paragraph","text":"I dag er langt de fleste af Alis venner indfødte australier, men han støder fra tid til anden ind i nogle af dem, han var på Nauru sammen med, når han kommer i sin lokale moské. En af Alis brødre, der har en butik, møder også nogle af de andre flygtninge fra tid til anden, når de kommer og handler ved ham - og Alis mor har fortsat også kontakt til flere af de andre mødre, hun mødte på Nauru.","spans":[]},{"type":"paragraph","text":"På trods af året på Nauru, føler Ali generelt, at australierne og Australien tog virkelig godt imod både ham og hans familie. I dag beskriver han sig som en irakisk australier, og selvom han gerne ville prøve at bo i Irak en dag og stadig betegner sit blod som irakisk, tænker han ikke længere på Irak som sit hjemland. For ham og hans familie er der ingen tvivl om, hvor hjem er. Det er lige her. ","spans":[]},{"type":"paragraph","text":"I Australien.","spans":[]},{"type":"paragraph","text":"Alis historie er en virkelig historie og bygger på et længere interview med ham.","spans":[{"start":0,"end":80,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsbillede af Melbourne: Shutterstock. Find de samlede kilder til denne case HER.)","spans":[{"start":84,"end":87,"type":"hyperlink","data":{"link_type":"Media","name":"samledekilder_cases.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F29ed7b98-6b74-4cce-a782-5cef41ce9a74_samledekilder_cases.pdf","size":"6488599"}}]},{"type":"paragraph","text":"","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"570","height":"1280","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/aa32737b0ad7b95747cff22e9871ec5166dabff3_melbourne_shutterstock.jpg","medium":{"dimensions":{"width":1024,"height":648},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/60c596b47fb59c17afd1f61e21aafa88a26a105c_melbourne_shutterstock.jpg"},"tall":{"dimensions":{"width":600,"height":380},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/dc6ac7dc41b8f0e61851be87b49e190be08f36a9_melbourne_shutterstock.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}}],"meta_title":"Australien og havene omkring","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag Australiens befæstede grænse og møde Ali - en af de mange migranter, der har krydset den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/bb01a06484a8e25797825cbb0900bec234bc7fb9_stillehavetvendt.jpg"},"hide_for_google":"false","navigation":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false},"home_link":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false}}}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WxfvViQAACsxGo0M","type":"case","uid":"eu-og-middelhavet","url":"/cases/eu-og-middelhavet","published":"2019-02-05T09:38:33+0000","lang":"da-dk","meta_title":"EU og Middelhavet","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på, hvordan EU blev til en enhed med en fælles ydre grænse, hvis opretholdelse i dag er så stor en udfordring, at den truer denne enhed.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/89c5a80439a4f5f8c34b743bb72e630cd8666135_italienkyst.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"EU og Middelhavet","spans":[]}],"url":"/cases/eu-og-middelhavet","body":[{"slice_type":"section","slice_label":null,"items":[],"primary":{"id":"section-1","background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/abcdd8db7f3cf55291b01d35d441bab33477da5b_italienkyst.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7ecfb7a9a5ab723cf6d5c3363e19b03f1ca1604f_italienkyst.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/895785bcaa12835f66fa70b185e95138be2875a1_italienkyst.jpg"}},"color_overlay":"#000000","color_opacity":"0.35","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/eb696d42f0a90bda90424183742bb5cd004815bc_odelaegelser_tyskland.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":344}}],"information":[{"type":"paragraph","text":"Mens befrielsen bliver fejret i Danmark, ligger Tyskland og flere andre lande i ruiner. Her ødelæggelserne i Berlin, maj 1945. \nFoto: Shutterstock.","spans":[]}],"x_axis":"65","y_axis":"40","layer":60,"rotation":"20","background":"Shadow","width":"500","height":"344","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/dd80c267824c8bd606e32af673b360f68b5f1a30_deforstebritisketropperankommer_nationalmuseet.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":500}}],"information":[{"type":"paragraph","text":"De første britiske tropper ankommer. \nFoto: Nationalmuseet.","spans":[]}],"x_axis":"65","y_axis":"10","layer":20,"rotation":"-10","background":null,"width":"500","height":"500","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/f064d4b6f507024b4d3b808490dc126b501e5239_flag-mennesker.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":350}}],"information":[{"type":"paragraph","text":"Mennesker på den flagsmykkede Frederiksberggade (Strøget) i København den 5. maj 1945. \nFoto: Nationalmuseet.","spans":[]}],"x_axis":"65","y_axis":"70","layer":50,"rotation":"-5","background":null,"width":"500","height":"350","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"”Aldrig igen!” \n- et europæisk fællesskab fødes","spans":[]},{"type":"paragraph","text":"Radioen knitrer varmt ud i de danske hjem. Klokken er omkring 20.30. Datoen er den 4. maj 1945. ","spans":[]},{"type":"paragraph","text":"\"Då-då-då-då. Då-då-då-då.\" ","spans":[{"start":1,"end":25,"type":"em"}]},{"type":"paragraph","text":"Lyder det med bløde, tunge trommeslag, før en storladen orkestermusik tager over. “Her er London, BBC sender til Danmark,” siger den danske radiospeaker Johannes G. Sørensen hen over musikken, da han indleder den illegale, dansksprogede nyhedsudsendelse. “Vi begynder med krigsnyhederne om Danmark, herefter Frihedsrådets proklamationer, de udenlandske nyheder i øvrigt, en skildring af forholdene i Danmark, og en beretning om det tyske sammenbrud i Nordtyskland,” fortsætter han, mens musikken fader, og nyhedsudsendelsen for alvor går igang. Godt fem minutter senere stopper Johannes G. Sørensen brat sin rapportering.","spans":[{"start":82,"end":120,"type":"em"},{"start":256,"end":464,"type":"em"}]},{"type":"paragraph","text":"Tavshed.","spans":[]},{"type":"paragraph","text":"Rundt omkring i landet bliver der udvekslet undrende blikke og stirret intenst mod radioerne, der de næste 12 lange sekunder kun udsender en småknitren. Så lyder Johannes G. Sørensens stemme endelig igen: “I dette øjeblik meddeles det, at Montgomery har oplyst, at de tyske tropper i Holland, Nordvesttyskland og i Danmark har overgivet sig. Her er London. Vi gentager: Montgomery har i dette øjeblik meddelt, at de tyske tropper i Holland, Nordvesttyskland og Danmark har overgivet sig.” Med ét er fem års tysk besættelse er pludselig slut. Dér, foran radioerne, begynder det overvældende budskab at synke ind. Mørklægningsgardinerne rives ned og brændes symbolsk på gaderne over hele landet, hvor folk strømmer ud for at fejre friheden sammen. De tyske troppers officielle kapitulation i Danmark finder egentligt først sted morgenen efter, den 5. maj klokken 8, men det er der ingen, der går op i her på denne forårsaften og -nat midt i befrielsens rus.","spans":[{"start":206,"end":487,"type":"em"}]},{"type":"paragraph","text":"Anden Verdenskrig er slut. Krigens afslutningen bliver fejret verden over de følgende dage. De allierede styrker har formelt set vundet, men i praksis har hele Europa tabt. Kontinentet er efterladt i ruin. Helt konkret, i økonomisk og i åndelig forstand. Hvordan kunne det dog ske, at naboer gik grassat på hinanden i så ødelæggende en krig? For anden gang inden for 25 år? ","spans":[]},{"type":"paragraph","text":"En ting er sikkert: Det må aldrig ske igen.","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":50,"rotation":null,"background":"White","width":"576","height":"1290","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1290},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8b7efa83911b927650151112ba786b1f151f9078_unionjack--paastroget.jpg","medium":{"dimensions":{"width":1024,"height":688},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7927e574aba19c3f70d719db2cb1d4ada62f1403_unionjack--paastroget.jpg"},"tall":{"dimensions":{"width":600,"height":403},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f4ea591216a5748a7f1e8c011ee8fb8e08d3f268_unionjack--paastroget.jpg"}},"color_overlay":null,"color_opacity":null,"layer":60}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"height":344,"width":459,"embed_url":"https://www.youtube.com/watch?v=FNaDYM7zGY0","type":"video","version":"1.0","title":"Founding fathers of the European Union: Konrad Adenauer","author_name":"European Commission","author_url":"https://www.youtube.com/user/eutube","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/FNaDYM7zGY0/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"459\" height=\"344\" src=\"https://www.youtube.com/embed/FNaDYM7zGY0?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"I klippet ses Tysklands første premierminister, Konrad Adenauer, der omtales som en af EU's ”founding fathers”. Løst oversat til dansk udtaler Adenauer i klippet at: “Hvis vi lykkes med at skabe en organisation, der vil gøre det muligt for franskmændene at følge med i alt det, der sker i stål- og kulproduktionen i Tyskland, og hvis tyskerne - på den anden side - kan følge med, i alt der sker inden for det samme område i Frankrig , så vil dette system med en gensidig kontrol være en ideel måde at opbygge en politik, der bygger på tillid.”","spans":[]}],"x_axis":"10","y_axis":"10","layer":10,"rotation":null,"background":null,"width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Stålfast forsoning","spans":[]},{"type":"paragraph","text":"Kul og stål bliver svaret på ønsket om at undgå en ny krig. Men hvad har kul og stål med forsoning at gøre, kan man så spørge? Jo, tanken er, at hvis de europæiske lande samarbejder om de industrier, der er forudsætning for en militær oprustning, kommer det til at udgøre en forsikring mod, at landene igen finder på at opruste mod hinanden. ","spans":[]},{"type":"paragraph","text":"Konrad Adenauer, Vesttysklands første kansler, er en af de stærke fortalere for et sådant fællesskab. På baggrund af sit utrættelige arbejde for at forsone Europa efter krigen bliver han i øvrigt kåret til årets mand af TIME Magazine i 1954. Det Europæiske Kul- og Stålfællesskab bliver en realitet i 1952. I første omgang med Belgien, Frankrig, Holland, Italien, Luxembourg og Vesttyskland som medlemmer. ","spans":[]},{"type":"paragraph","text":"Startskuddet til en omfattende europæisk integrationsproces har lydt.","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/6ba4a5152d4e3b6b9a19396ffa27ed35744f458d_kul_2stykker.png","alt":null,"copyright":null,"dimensions":{"width":250,"height":352}}],"information":[],"x_axis":"15","y_axis":"75","layer":30,"rotation":"-45","background":null,"width":"250","height":"352","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b11cab3cce9c85d3870c1340ea258100f4f123b1_kul1stykke.png","alt":null,"copyright":null,"dimensions":{"width":250,"height":205}}],"information":[],"x_axis":"15","y_axis":"75","layer":40,"rotation":null,"background":null,"width":"250","height":"250","speed":4},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b11cab3cce9c85d3870c1340ea258100f4f123b1_kul1stykke.png","alt":null,"copyright":null,"dimensions":{"width":250,"height":205}}],"information":[],"x_axis":"15","y_axis":"70","layer":35,"rotation":"20","background":null,"width":"250","height":"250","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/6ba4a5152d4e3b6b9a19396ffa27ed35744f458d_kul_2stykker.png","alt":null,"copyright":null,"dimensions":{"width":250,"height":352}}],"information":[],"x_axis":"27","y_axis":"45","layer":62,"rotation":"35","background":null,"width":"250","height":"352","speed":-2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/fe7204c66bcf5b404a60a3dce3b77fe6f6ca0e76_kulogstaal.jpg","tall":{"dimensions":{"width":600,"height":425},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/70579bda4d5e4b794c4279f5262470c19dd9f4c3_kulogstaal.jpg"},"medium":{"dimensions":{"width":1024,"height":725},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/98ed6c4aaff6cd850e3dd16155fc51753e929608_kulogstaal.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/75391f2adc0831479f547674e0b43b5c971168ae_kold_krig_kort.jpg","alt":null,"copyright":null,"dimensions":{"width":1026,"height":868}}],"information":[],"x_axis":"45","y_axis":"55","layer":10,"rotation":null,"background":null,"width":"513","height":"434","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Det europæiske fællesskab vokser langsomt","spans":[]},{"type":"paragraph","text":"Smilende mænd i mørke jakkesæt med vandkæmmet hår. Året er 1957, og mændene - Europas ledere - har netop underskrevet Rom-traktaten, det vil sige fødselsattesten på det Europæiske Økonomiske Fællesskab (EØF). Det er derfor, de smiler. For EØF kommer til at knytte medlemslandede endnu tættere sammen blandt andet gennem toldfri samhandel. Fællesskabet rummer dog stadig kun de seks føromtalte lande - Belgien, Frankrig, Holland, Italien, Luxembourg og Vesttyskland.","spans":[]},{"type":"paragraph","text":"I 1973 slutter også Danmark sig til det Europæiske Fællesskab sammen med Storbritannien og Irland, og støt og roligt bliver samarbejdet udvidet, omend det bestemt ikke er uden udfordringer.","spans":[]},{"type":"paragraph","text":"For samtidig med at de vesteuropæiske lande i disse år nærmer sig hinanden, er tiden præget af Den Kolde Krig. Europa bliver i årtier efter Anden Verdenskrig ikke mere forsonet, end at det er skåret midt over af ”Jerntæppet” - en grænse mellem Vesteuropa og det kommunistiske Central- og Østeuropa befæstet med pigtråd og landminer. ","spans":[]},{"type":"paragraph","text":"Og mens politikerne har store ambitioner, har de ikke altid befolkningerne med. For eksempel stemmer danskerne, til manges overraskelse og de europæiske lederes forfærdelse, i 1992 nej til Maastricht-traktaten. Traktaten lægger op til en kraftig udvidelse af det europæiske samarbejde og kræver godkendelse af alle medlemslande, så Danmarks “nej” er et stort problem. Problemet bliver dog løst med Edinburgh-aftalen, hvor Danmark får fire forbehold - dermed lykkes det at vende et snævert “nej” til et snævert “ja” ved en ny folkeafstemning den 18. maj 1993. Da Maastricht-traktaten samme år træder i kraft bliver EF i øvrigt til EU - nu er der ikke længere kun tale om et fællesskab, men om en union - den Europæiske Union.","spans":[]},{"type":"paragraph","text":"Men nu går vi for hurtigt frem, for fire år forinden - i 1989 - sker der noget afgørende. Og de fleste, der kan huske så langt tilbage, kan huske, hvor de var den dag i november, hvor Europas historie tog en uventet drejning i Berlin ...","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":50,"rotation":null,"background":"White","width":"576","height":"1230","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b1822e6331e9cc9ee8480e02b41b57c651a32324_stopper_biler_i_tyskland_shutterstock.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":373}}],"information":[{"type":"paragraph","text":"Det østtyske grænsepoliti stopper en bil på Charlottenburger Chaussee med en sømkæde.","spans":[]}],"x_axis":"70","y_axis":"70","layer":20,"rotation":null,"background":null,"width":"500","height":"373","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d1e74c8c71f93d0ce43fe5f0e5b1d7b05cc3b6c0_pigtraad_paa_brandenburgertorg_shutterstock.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":392}}],"information":[],"x_axis":"65","y_axis":"25","layer":30,"rotation":"12","background":null,"width":"500","height":"392","speed":-1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7bd8c62abb211fff481b09a98d80235e6e447436_e0px1y.jpg","tall":{"dimensions":{"width":600,"height":384},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b8d9f198663d0f973facfc3c98537db724fe90c8_e0px1y.jpg"},"medium":{"dimensions":{"width":1024,"height":656},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c9d544e2ee31910981e259c3cf8679f807e63545_e0px1y.jpg"}},"color_overlay":null,"color_opacity":null,"layer":45}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Murens fald","spans":[]},{"type":"paragraph","text":"En novemberaften i 1989 bliver pludselig til verdenshistorie, da Günter Schabowski, der er nyudnævnt presseansvarlig for det østtyske DDR’s regeringsparti SED, nægter at debutere med et ”det ved jeg ikke” på en tv-transmitteret pressekonference i Berlin. Han har netop informeret om nye regler, der skal gøre det nemmere for de østtyske DDR-borgere at få udrejsetilladelse ved grænseovergangene til Vesttyskland. En journalist vil vide, hvornår reglerne træder i kraft. Schabowski, der ikke selv har deltaget i dagens møde i det kommunistiske hovedkvarter, kaster et hastigt blik på et papir, han har fået stukket i hånden. Han har tydeligvis ingen anelse. Det forhindrer ham dog ikke i med overbevisning at svare, at de nye regler gælder ”fra nu af” og ”med det samme.”","spans":[]},{"type":"paragraph","text":"Schabowskis partikammerater rykker lidt uroligt rundt på deres sæder. Meningen var faktisk, at de nye regler først skulle annonceres i radioen meget tidligt næste morgen, mens flertallet sov. Man ville have undgået den opmærksomhedsvækkende folkeopstandelse, der nu vågner ude i stuerne foran tv-skærmene, vokser sig stor via glødende telefonforbindelser, bevæger sig ud på gaderne og marcherer i retning mod grænseovergangene. ”De mauer must weg!”, råber folkemængden euforisk og grænsevagterne tør ikke andet end at træde til side. ","spans":[]},{"type":"paragraph","text":"Pludselig er der fri passage. Øst og vest er genforenet og billeder af jubel, glædestårer, champagnebrus og kædedans og folk, der hakker muren i stykker, strømmer ud gennem TV-skærme over hele Europa. Et Europa på vej til at blive hel igen.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Sueddeutsche Zeitung Photo via Alamy Stock Photo.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1250","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":459,"height":344,"embed_url":"https://youtu.be/WiXVFoI5fVc","type":"video","version":"1.0","title":"Berlinmurens fald - 12. november 1989","author_name":"DR Nyheder","author_url":"https://www.youtube.com/channel/UC8tSbn8Q4rnsSQPY-1kzXuw","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/WiXVFoI5fVc/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"459\" height=\"344\" src=\"https://www.youtube.com/embed/WiXVFoI5fVc?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"DR Nyhederne den 12. november 1989. ","spans":[]}],"x_axis":"10","y_axis":"68","layer":20,"rotation":null,"background":null,"width":"570","height":"320","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1250},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/754964a8af9775c9c8ed943a5c4ed939996bba92_dytfrr.jpg","medium":{"dimensions":{"width":1024,"height":671},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0a7720a6aa20329fdee5da47f2919466c69956a4_dytfrr.jpg"},"tall":{"dimensions":{"width":600,"height":393},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b03efb34431436b32cc3051d3d565e3dd29c412d_dytfrr.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/3a67c0b59b7bc38047f7b5da7f4cf664e0935ad8_visa-skilt_ny.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":410}}],"information":[],"x_axis":"35","y_axis":"25","layer":10,"rotation":null,"background":null,"width":"500","height":"410","speed":-4},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Schengen-aftalen og Østudvidelsen\n- nye grænser for det grænseløse Europa","spans":[]},{"type":"paragraph","text":"Men nu er vi igen gået for hurtigt frem, for vi skal også lige omkring en vigtig begivenhed fire år før murens fald, der i særlig grad har med Europas grænser at gøre. I den lille luxembourgske by Schengen tager det Europæiske Fællesskab i 1985 nemlig endnu et historisk skridt. Her, i en by på grænsen mellem Luxemborg og Tyskland, på en båd på floden Mosel, der i 200 km udgør den grænse, blev den første aftale om fri bevægelighed meget symbolsk vedtaget. Den betød en afskaffelse af grænsekontrollen mellem \"Schengenlandene\" - i første omgang var det Belgien, Holland, Luxembourg, Frankrig og Vesttyskland. Men på grund af den frie bevægelighed mellem Schengenlandene, opstod nu behovet for at skærpe grænsekontrollen ved landenes ydre grænser for at modvirke illegal indvandring og international kriminalitet. Derfor blev der nu også skabt et større politisamarbejde mellem landene. ","spans":[]},{"type":"paragraph","text":"I første omgang gjaldt Schengen-aftalen som sagt kun Belgien, Holland, Luxembourg, Frankrig og Vesttyskland, men med årene tilsluttede flere og flere lande sig aftalen, og EU's ydre grænser flyttede længere og længere ud. Danmark blev en del af Schengenaftalen i 1996, og i 2004 kom den største udvidelse af EU, da ti lande blev optaget i EU. Den store udvidelse går under navnet Østudvidelsen og tæller landene: Estland, Letland, Litauen, Polen, Tjekkiet, Slovakiet, Ungarn, Slovenien, Malta og den græske del af Cypern. EU er blevet større, landenes forskellighed er blevet større, og de ydre grænser har igen flyttet sig.","spans":[{"start":380,"end":393,"type":"em"},{"start":393,"end":394,"type":"strong"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":30,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b0a088382ea7944e262663c649f6e6450f77197e_eu_flagene_lidt_gennemsigtige.png","alt":null,"copyright":null,"dimensions":{"width":1000,"height":1200}}],"information":[],"x_axis":"48","y_axis":"29","layer":21,"rotation":null,"background":null,"width":"1000","height":"1200","speed":4}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c5473c34d3b781e4320df689a4160141faf83265_schengen_landsby.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e297011a4be9544c5fd8fd9731dff61e55ab020f_schengen_landsby.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/24c3afe2506148276370bfa1c387564c500f5aff_schengen_landsby.jpg"}},"color_overlay":null,"color_opacity":null,"layer":45}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Dublin-forordningen","spans":[]},{"type":"paragraph","text":"I 1990 blev Dublinkonventionen vedtaget. Den er blevet justeret et par gange siden og på nuværende tidspunkt gælder aftalen fra 2013 - Dublinforordningen lll. Denne forordning beskriver den fælles asylpolitik, der omfatter medlemslandene af EU og Schengenaftalen. Målet med forordningen er at spare ressourcer og i praksis betyder det, at det land, der modtager en flygtning, har ansvaret for vedkommendes sagsbehandling. Dermed skal hver asylansøgning kun behandles én gang inden for EUs grænser. ","spans":[]},{"type":"paragraph","text":"Selvom det lyder smart, har der været stor kritik af forordningen, og kritikken er med de seneste flygtningestrømme ikke blevet mindre. Kritikerne mener, at forordningen lægger for stor en byrde på lande som Italien, Malta og Grækenland, da de er geografisk placeret ved EUs ydre grænse og nærmest de områder, hvorfra mennesker flygter på grund af krig, forfølgelse og dårlige levevilkår. ","spans":[]},{"type":"paragraph","text":"Dér, hvor en flygtning først bliver registreret og får sit fingeraftryk taget, er også der, hvor vedkommendes asylsag skal behandles, og hvor han skal bo, hvis han altså får asyl. Rejser en asylansøger illegalt videre op igennem Europa og senere bliver taget af myndighederne, skal vedkommende altså, ifølge Dublinforordningen, sendes tilbage til modtagerlandet. Asylansøger kan altså ikke frit bevæge sig rundt inden for EUs grænser. Nogle flygtninge kender til denne regel og forsøger derfor at undgå kontakt med myndighederne, før de er ankommet til et sted, hvor de kan forestille sig at slå sig ned, og hvor de måske har familie.","spans":[]},{"type":"paragraph","text":"Kritikere af Dublinforordningen påpeger også, at der er for stor forskel i behandlingen af asylansøgere fra land til land. I visse lande kan flygtninge nemlig ikke engang vide sig sikre på at modtage en behandling i overensstemmelse med menneskerettighederne. Ifølge Danmarks nuværende udlændingepolitik skal man dog altid forsøge at returnere flygtninge til det land, hvor de først er blevet registreret - det kan imidlertid være svært at få disse lande til at undersøge og svare på disse såkaldte \"Dublin-sager\", hvorfor asylansøgere i Danmark kan komme til at vente meget længe på at få deres sag behandlet.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede af flygtninge og migranter netop ankommet til Grækenland: Ververidis Vasilis via Shutterstock.com.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/74a0cfefb7949dcbe8d84ebc47fe49425a59ea65_fingerprint.png","alt":null,"copyright":null,"dimensions":{"width":800,"height":1000}}],"information":[],"x_axis":"0","y_axis":"35","layer":30,"rotation":"35","background":null,"width":"800","height":"1000","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/67e7950b9ae13501d821f9540a1820ffe80f9080_attheborder.jpg","tall":{"dimensions":{"width":600,"height":399},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c74d3c541d1f596781b7c0914574c95222aa0b84_attheborder.jpg"},"medium":{"dimensions":{"width":1024,"height":681},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/fadb874fb22c5a841e47281362ffa427b2d3e981_attheborder.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Flygtninge- og migrantkrisen i 2015","spans":[]},{"type":"paragraph","text":"Det er ikke noget nyt, at flygtninge og migranter ankommer til Europa. Det har de gjort i længe. Men i 2015 ankom der så mange, at det fik betegnelsen \"flygtninge- og migrantkrisen.\" Du husker måske billederne i medierne af redningsveste, der ligger og skvulper i vandkanten på græske øer. Eller af flygtninge, der kom vandrende i hobetal - også helt heroppe hos os på den sønderjyske motorvej.","spans":[]},{"type":"paragraph","text":"Ifølge UNHCR modtog ankom over en million flygtninge og migranter til Europa i 2015. Alle med hver sin grund til at søge mod Europa, men med en fælles drøm om en bedre fremtid. De fleste var flygtninge fra krig og konflikt, hovedsageligt fra Syrien, Afghanistan og Irak, men blandt dem var også en del såkaldte økonomiske migranter fra især Nord- og Vestafrika. ","spans":[{"start":311,"end":331,"type":"em"}]},{"type":"paragraph","text":"Termen \"økonomisk migrant\" dækker over, at migranten ikke er personligt forfulgt, men har valgt at migrere på grund af fattigdom og ringe fremtidmuligheder i hjemlandet. Et ord som \"bekvemmelighedsflygtning\" fandt også vej ind i det danske sprog og den offentlige debat på denne tid, mens flygtninge- og migrantkrisen var på sit højeste. Og nu vi er ved ord, så kan man også fundere over, hvordan man i denne sammenhæng skulle forstå betydningen af \"krise\" ... ","spans":[]},{"type":"paragraph","text":"Når det ikke længere er usædvanligt, at døde mennesker skylder i land på Europas kyster, så kan man vist med rette bruge ordet \"krise\" om situationen i 2015, hvor næsten 4000 mennesker druknede i Middelhavet, og nyheden om, at endnu en overfyldt båd med flygtninge og migranter var gået under med flere hundrede døde til følge, næsten blev hverdagskost. Men hvem er det en krise for? Europæerne, hvis grænser er under massivt pres? Eller de mennesker, der af forskellige årsager føler sig presset til at begive sig ud på så farefuld en færd, som rejsen til Europa bliver for dem.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Nicolas Economou via Shutterstock.) ","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":30,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/cecf0287eb54a943cdfb9d4f4d7e3bd1e478592d_redningsveste_bund_ny.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":621}}],"information":[],"x_axis":"0","y_axis":"80","layer":10,"rotation":null,"background":null,"width":"1920","height":"621","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://www.youtube.com/watch?v=xFHK7vgSRTQ&feature=youtu.be","type":"video","version":"1.0","title":"Følg syv danskere på nødhjælpsmission: Drivvåde flygtninge får en kold nat - DR Nyheder","author_name":"DR Nyheder","author_url":"https://www.youtube.com/channel/UC8tSbn8Q4rnsSQPY-1kzXuw","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/xFHK7vgSRTQ/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/xFHK7vgSRTQ?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"Indslag i DR Nyheder den 3. september 2015. Den redaktionelle tekst til indslaget lyder: \"Følg syv danskere på nødhjælpsmission: Drivvåde flygtninge får en kold nat. Hundredvis af bådflygtninge overnatter på stranden på Lesbos. De danske frivillige hjælper til med tørt tøj og mad.\"","spans":[{"start":89,"end":282,"type":"em"}]}],"x_axis":"60","y_axis":"10","layer":30,"rotation":null,"background":null,"width":"570","height":"320","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5e6e44e5a62198e2359fa2a51aa602939b1e97e1_flygtninge_greece_baggrund_shutterstock_tilrettet.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b788e65ce90f353a2257659e8aa048b7d5de7754_flygtninge_greece_baggrund_shutterstock_tilrettet.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/16d96158775be6a7d5cae5350d82b51e9dbd7811_flygtninge_greece_baggrund_shutterstock_tilrettet.jpg"}},"color_overlay":"#f5f3f3","color_opacity":"0.2","layer":50}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"EU i opbrud som følge af migration?","spans":[]},{"type":"paragraph","text":"Uanset svaret på ovenstående spørgsmål, så har den såkaldte flygtninge- og migrantkrise afsløret, at EU-landene ikke står så samlet, som dets grundlæggere nok havde drømt om, at de ville gøre på det her tidspunkt i historien. På spørgsmålet om, hvordan EU skal håndtere det store antal flygtninge og migranter, der banker på Europas dør i disse år står landene utroligt splittet, og den indbyrdes solidaritet kan ligge på et meget lille sted. Mange lande kæmper stadig med følgerne af finanskrisen i 2008, som jo ramte de sydeuropæiske lande ekstra hårdt - de samme lande, der nu står med størstedelen af opgaven med at tage imod de mange, mange mennesker, der siden 2015 (og i øvrigt lang tid før det) er ankommet til Europas yderste grænser.","spans":[]},{"type":"paragraph","text":"Det betyder, at lande som Grækenland, Italien og Spanien er hårdt spændt for, selvom de modtager støtte fra EU i form en økonomisk håndsrækning, hjælp fra EUs grænseagentur Frontex til at patruljere i Middelhavet, og assistance fra EU's asylstøttekontor til at behandle de mange tusinde asylansøgninger. Derfor efterspørger de, sammen med mange politiske partier ud over Europa, en mere gennemgribende fælles politik på området, hvor landene arbejder sammen om at løse udfordringen, og hver især tager en fair andel af asylsagerne. Men det er endnu ikke lykkedes at nå til enighed om en sådan aftale.  ","spans":[]},{"type":"paragraph","text":"I flere tilfælde er flygtninge og migranter helt konkret blevet gidsler i striden mellem EU-landene, når de er blevet samlet op ude på havet, men ingen lande vil tillade redningsskibet at lægge til ved deres kyst. Samtidig er tonen i debatten blevet skærpet over hele Europa, og frygten for, hvad de mange nyankomne kan betyde for europæernes egen levestandard har medført en politisk højredrejning. I mange europæiske lande vokser tilslutningen til nationalistiske partier, og senest har vi set den britiske befolkning helt melde sig ud af det europæiske fælleskab, da et flertal i 2017 stemte for, at Storbritannien skulle forlade EU. Mange gav som begrundelse for at have stemt sådan, at de selv ville kunne bestemme, hvem der skulle have lov at komme ind landet. Ifølge en rapport fra European Political Strategy Centre angiver et flertal af europæerne immigration som en de allervigtigste udfordringer for EU. Samme rapport gør dog opmærksom på, at mange europæeres bekymring baserer sig på misforståelser og overdrivelser af, hvor mange immigranter, der faktisk bor i deres land.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede af street art-kunstneren Banksys kommentar til Brexit, altså Storbrittaniens udmeldelse af EU: Paul Bissegger via Wikimedia Commons. Find de samlede kilder til denne case HER.)","spans":[{"start":65,"end":71,"type":"em"},{"start":189,"end":192,"type":"hyperlink","data":{"link_type":"Media","name":"samledekilder_cases.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F29ed7b98-6b74-4cce-a782-5cef41ce9a74_samledekilder_cases.pdf","size":"6488599"}}]},{"type":"paragraph","text":"Hvis du ikke allerede har set filmen om den vestafrikanske fisker André, der som tusinder af andre unge nord- og vestafrikanere har forsøgt at komme til Europa via Middelhavet for at skabe sig et bedre liv, kan du se den her på sitet via forsiden.","spans":[{"start":0,"end":247,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":60,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/e158901f973ba7586ce4776f99da3543845dd005_teltene.jpg","alt":null,"copyright":null,"dimensions":{"width":400,"height":250}}],"information":[{"type":"paragraph","text":"Idomeni, Grækenland, marts 2016. Flygtninge har slået lejr ved grænsen efter Makedonien har lukket for grænsen. \nFoto: Shutterstock.","spans":[]}],"x_axis":"5","y_axis":"5","layer":30,"rotation":"10","background":"Shadow","width":"400","height":"250","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/0083b7444bd42fdf19e53f807b5e5494de7e041b_hegn_i_eu.jpg","alt":null,"copyright":null,"dimensions":{"width":350,"height":200}}],"information":[{"type":"paragraph","text":"Serbien ved den lukkede grænse til Ungarn, september 2015.\nFoto: Shutterstock.","spans":[]}],"x_axis":"7","y_axis":"25","layer":20,"rotation":"-5","background":"Shadow","width":"350","height":"200","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/159f59fd1b6d8771d29b339646cf9d668b301074_britiske_aviser.jpg","alt":null,"copyright":null,"dimensions":{"width":400,"height":250}}],"information":[{"type":"paragraph","text":"London, England, 23. juni, 2016. Britiske avisforsider på aftenen for Brexit-afstemningen.\nFoto: Shutterstock.","spans":[]}],"x_axis":"5","y_axis":"42","layer":19,"rotation":null,"background":"Shadow","width":"400","height":"250","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/b61ed4738719151d3a2cce6a003e3945de88b4c1_syrereiistanbul.jpg","alt":null,"copyright":null,"dimensions":{"width":450,"height":350}}],"information":[{"type":"paragraph","text":"Den store stigning i antallet af flygtning og migranter til Europa i 2015 bestod især af syrere på flygt fra krigen i deres hjemland. Mange syrere rejser til Europa via nabolandet Tyrkiet, hvorfra de ved hjælp af menneskesmuglere sejler over Middelhavet til Grækenland. For at stoppe den trafik indgik EU i marts 2016 en aftale med Tyrkiet, ifølge hvilken EU giver Tyrkiet økonomisk kompensation for at holde flygtningene i Tyrkiet. Aftalen har betydet et drastisk fald i antallet af migranter, der kommer til Europa via Tyrkiet, og den har på den måde været effektiv. Men spørgsmålet er, hvilken behandling de så får i Tyrkiet. Aftalen har af den grund været stærkt kritiseret af flere menneskerettighedsorganisationer. \nFoto: Ukendte flygtninge beder om hjælp på gaden i Istanbul. Oleg Doroshenko via Dreamstime.","spans":[]}],"x_axis":"5","y_axis":"68","layer":18,"rotation":"-1","background":null,"width":"450","height":"350","speed":1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/781bb043d358084594552e2d707ddb96f35b2c89_brexitbanksy.jpg","medium":{"dimensions":{"width":1024,"height":768},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/11b4e6bbd7e36f5af537823ed9bfa1cb2dc016a6_brexitbanksy.jpg"},"tall":{"dimensions":{"width":600,"height":450},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1f033354b2596e07bfaf76df941bdf8061a271d1_brexitbanksy.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}}],"meta_title":"EU og Middelhavet","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på, hvordan EU blev til en enhed med en fælles ydre grænse, hvis opretholdelse i dag er så stor en udfordring, at den truer denne enhed.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/89c5a80439a4f5f8c34b743bb72e630cd8666135_italienkyst.jpg"},"hide_for_google":"false","navigation":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false},"home_link":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false}}}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"W1sWyB4AAAgl9kvg","type":"case","uid":"israel-og-palaestina","url":"/cases/israel-og-palaestina","published":"2019-02-08T10:43:43+0000","lang":"da-dk","meta_title":"Israel og Palæstina","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag den befæstede grænse mellem Israel og Palæstina og møde Abu, som hver dag står i kø i timevis for at krydse den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/40a1176d49fb986d11b8ecea84a0b71a78289568_israelwall.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"Israel og Palæstina","spans":[]}],"url":"/cases/israel-og-palaestina","body":[{"slice_type":"section","slice_label":null,"items":[],"primary":{"id":"section-1","background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/58a884838a8cbe0e60945297f3cc8c0a61c4646b_israelwall.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e7b66fd91f5f19ee01fcd01968496dfdbbbda4cb_israelwall.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/20979eeaa8e07c6c73d40e8eb3b5eaf3d74c2390_israelwall.jpg"}},"color_overlay":"#000000","color_opacity":"0.25","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Abus historie","spans":[]},{"type":"paragraph","text":"Abu står op før solen. Hans vækkeur varsler en ny dags begyndelse klokken 03.00. Han skynder sig at slukke det og står op i en stille hast for ikke at vække sin kone Fatima. Han vasker sig, hopper i arbejdstøjet og kigger til sine sovende børn på vej ud i køkkenet for at hente den madpakke, Fatima har forberedt til ham i aftes. Den er stor, for han har en lang dag foran sig. Han undgår at tænke på hvor lang, mens han vandrer af de morgenøde, halvmørke gader i den palæstinensiske landsby på Vestbredden, han kalder hjem. ","spans":[{"start":401,"end":405,"type":"em"}]},{"type":"paragraph","text":"Ligesom omkring 100.000 af sine landsmænd arbejder Abu på den anden side af den befæstede grænse til Israel. Selvom han er en af de cirka 65.000 palæstinensere med en officiel arbejdstilladelse, er det alt andet end enkelt at krydse grænsen hver morgen.","spans":[]},{"type":"paragraph","text":"Det er derfor, Abu er så usandsynligt tidligt på færde. Der er ikke andet at gøre, hvis han vil nå på arbejde til tiden. Og det vil han. For mister han sit job i Israel, er alternativet ret sikkert arbejdsløshed eller løsarbejde i Palæstina til en fjerdedel af hans nuværende løn. Så også selvom den løn, Abu får nu, kun er halvdelen af, hvad en israeler får for samme arbejde, finder han sig i at skulle stå i kø i timevis ved checkpointet. Han har ikke andet valg. ","spans":[]},{"type":"paragraph","text":"For det meste passerer ventetiden i en søvndrukken og morgenstille atmosfære, men indimellem - når processen bliver forsinket, eller nogen bliver afvist uden begrundelse - vågner den slumrende frustration og vækker uretfærdighedsfølelsen i den flere hundrede mand lange og langsomme kø. Det kommer til tumult, men den overdøves snart af en skrattende højtaler, der overbringer en israelsk officers trussel om ikke at lukke flere igennem, hvis ikke roen genoprettes.","spans":[]},{"type":"paragraph","text":"Abu køber en varm kop kaffe at styrke sig på af en stor dreng, der har øjnet en forretningsmulighed i at holde de mange ventende forsynede med forfriskninger. Køen rykker frem. Et skridt af gangen. Hvis han er heldig, kommer han igennem på under 2,5 time i dag. ","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Palæstinensiske mænd viser deres id-papirer ved et checkpoint nær Bethlehem på Vestbredden for at søge om adgang til Jerusalem. Ryan Rodrick Beiler via Shutterstock.com.) ","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1278","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://youtu.be/Z7ZxPCQiifQ","type":"video","version":"1.0","title":"לילות שימורים במחסום תרקומיא, 2013","author_name":"btselem","author_url":"https://www.youtube.com/user/btselem","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/Z7ZxPCQiifQ/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/Z7ZxPCQiifQ?feature=oembed\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"}}],"information":[],"x_axis":"60","y_axis":"60","layer":15,"rotation":"0","background":"Shadow","width":"576","height":"320","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1278},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/a79509406426b2d06880a78be6a3755dfc16be8f_checkpoint.jpg","tall":{"dimensions":{"width":600,"height":399},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1898bd425262546b0ff48dd819e760576842d69c_checkpoint.jpg"},"medium":{"dimensions":{"width":1024,"height":681},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/ccb2fec8391b3627fdb2ccb383a3e8842ec8ccad_checkpoint.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Det lovede land","spans":[]},{"type":"paragraph","text":"På baggrundsbilledet står vi på toppen af Nebobjerget i Jordan og ser ind over grænsen til … ja, hvad skal vi kalde det? - Palæstina? - Palæstinensisk selvstyreområde? - Den israelsk-besatte Vestbred? Israel-Palæstina-konflikten er så betændt, at det er svært overhovedet at tale om den uden mere eller mindre uforvarende at komme til at tage stilling og vælge side. Vi kunne også lidt højstemt vælge at kalde det, vi ser, for ”det hellige land” eller ”det forjættede land”. En forjættelse er det samme som et løfte, og ifølge Bibelen lovede Gud, at dette land skulle tilhøre det jødiske folk. Løftet lød først til Abraham, stamfar til både jøder og muslimer, siden til Moses, der befriede jøderne fra slaveri i Egypten. Ifølge overleveringen var det netop her, på Nebobjerget, at Gud gentog løftet til Moses, der dog kun fik lov at nyde udsigten til landet, inden han døde. Det land, som samtidig har udgjort kulissen for vigtige begivenheder i islams historie, og derfor lægger grund til flere vigtige muslimske helligsteder.","spans":[]},{"type":"paragraph","text":"Dette religiøse bagtæppe - som ortodokse fra de tre store religioner - jødedom, kristendom og islam - gerne holder op - er med til at gøre konflikten kompliceret at navigere i. Men i sin kerne handler den, som de fleste konflikter mellem folkegrupper, helt enkelt om ret og adgang til land og resurser. Konflikten drejer sig basalt set om to folks konkurrerende krav på det samme landområde, men den er tilsat religiøse og etniske over- og undertoner, filtret ind i det jødiske folks traumatiske historie og koblet op på transnationale politiske alliancer. En hårknude af en konflikt, som adskillige verdensledere har forsøgt at få viklet ud - \"løsning af Israel-Palæstina konflikten og fred i Mellemøsten\" pynter jo gevaldigt på CV'et - men ethvert skridt frem er snart blevet afløst af to tilbage. I dag har konflikten meget konkret materialiseret sig i en fysisk barriere mellem Israel og Palæstina i form mure, hegn og afspærringer langs de to palæstinensiske områder Gaza og Vestbredden. Barrieren vender vi tilbage til. Først skal vi lige have styr på, hvordan det er kommet så vidt, at en 700 km lang mur er blevet løsningen.","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":null,"rotation":null,"background":"White","width":"576","height":"1200","speed":null}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7af44d03172d39144172da5013d5162c693400df_mosespaamountnebo.jpg","tall":{"dimensions":{"width":600,"height":375},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/90163c1988bf3ee4a89895b7e64e86e81bcf20da_mosespaamountnebo.jpg"},"medium":{"dimensions":{"width":1024,"height":640},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/ccae8371c9b2f1c2a45fc9a276a0388c2a4b064d_mosespaamountnebo.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Jødisk migration til Palæstina","spans":[]},{"type":"paragraph","text":"Hvis vi hopper tre til fire tusinde år tilbage i tiden, kan vi i det landområde, der i dag udgør Israel og Palæstina, hilse på folk, fra hvem både jøder og palæstinensere nedstammer. Et par tusinde år senere opstår der her en jødisk stat, som er nævnt i Bibelen. Jøderne blev dog fordrevet i år 70, hvorefter området blev underlagt kristne herskere og sidenhen muslimske magthavere, der regerede i området indtil Første Verdenskrig. Både jøder og palæstinensere, og for den sags skyld kristne, føler altså en vis historisk tilknytning til det, vi i dag kender som Israel og Palæstina. I hvilken grad, den er berettiget, er et stående stridspunkt i konflikten.","spans":[]},{"type":"paragraph","text":"Under alle omstændigheder er denne tilhørsfølelse medvirkende til, at jøder i slutningen af 1800-tallet begynder at migrere til Palæstina på grund af stigmatisering, diskriminering og forfølgelse i Rusland og andre europæiske lande. På det tidspunkt hører landområdet Palæstina under Det Osmanniske Rige og er hovedsageligt beboet af arabere og et lille antal jøder. Araberne er begyndt at udvikle en nationalidentitet som palæstinensere, og på samme tid opstår zionismen blandt europæiske jøder. Ifølge zionismen beskriver dét at være jøde ikke blot et religiøst tilhørsforhold, men også et nationalt. Zionisterne ønsker derfor at samle det jødiske folk i en nation - allerhelst i det hellige land, hvorfra jøderne stammer. Den østrigsk-jødiske journalist Theodor Herzl argumenterer ihærdigt og højlydt for, at det er den eneste løsning på den voksende antisemitisme. Herzl (1860-1904) regnes for grundlæggeren af den politiske zionistiske bevægelse. Kritikere af det zionistiske projekt argumenterer for, at det er useriøst at bruge Bibelen som sandhedsvidne på jødernes historiske ret til Palæstina, og at der i øvrigt heller ikke findes historiske kilder, der bakker op om forståelsen af jøderne som ét samlet folk. ","spans":[]},{"type":"paragraph","text":"I lang tid forbliver zionisternes drøm om deres eget land da også blot en drøm. Men da englænderne under Første Verdenskrig søger allierede, lover den engelske udenrigsminister sin støtte til de jødiske bestræbelser på at oprette en national stat i Palæstina. Denne sympatierklæring bringer zionisterne tættere på realiseringen af deres drøm. Da Palæstina efter Første Verdenskrig kommer under britisk kontrol, migrerer yderligere 120-150.000 jøder til området. De tidligste migranter er eventyrlystne pionerer, der opkøber jord, bygger huse og anlægger landbrug. Med jødeforfølgelserne i 1930’erne og 40’erne begynder migrationen til Palæstina for alvor at tage fart - og nu flygter jøderne af nød for at undslippe den grusomme forfølgelse, der bliver millioner af jøders skæbne under Anden Verdenskrig. ","spans":[]},{"type":"paragraph","text":"Til at begynde med lever jøderne stort set fredeligt sammen med de arabere, der boede i Palæstina i forvejen. Men efterhånden som jøderne bliver flere og flere, og både deres og palæstinensernes nationalfølelse vokser sig stærkere, stiger spændingerne imellem dem. Nu har vi altså to store folkegrupper i Palæstina med hver deres nationale identitet - den ene med en stærk drøm om at udleve denne i en nationalstat. Kimen til konflikt er lagt. ","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/587362a532e4140d26eb699dff64d9105dc33ab7_idkort.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":360}}],"information":[{"type":"paragraph","text":"En id-kort på en jødisk migrant.","spans":[]}],"x_axis":"70","y_axis":"55","layer":15,"rotation":"2","background":"Shadow","width":"500","height":"350","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d797ef04cc1126dbf49c17a4e355e4bb0696c31e_zionism.jpg","alt":null,"copyright":null,"dimensions":{"width":351,"height":524}}],"information":[{"type":"paragraph","text":"En zionistisk propaganda-plakat med opfordring til at komme til Palæstina og være med til at bygge landet på.","spans":[]}],"x_axis":"65","y_axis":"62","layer":20,"rotation":"-3","background":"Shadow","width":"351","height":"524","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/dd30d5595a9509dc837e50b5c55fe6975a94881f_brev.png","alt":null,"copyright":null,"dimensions":{"width":403,"height":532}}],"information":[{"type":"paragraph","text":"I dette brev til Lord Rothschild, der var leder af Storbritanniens jødiske samfund, tilkendegiver den britiske udenrigsminister, Arthur James Balfour, den britiske regerings støtte til zionisternes ønske om at oprette en jødisk stat i Palæstina. Dokumentet, der har fået navnet Balfour-deklarationen af 1917, var oprindeligt hemmeligt. Det originale dokument findes på British Library i London.","spans":[{"start":278,"end":307,"type":"em"}]}],"x_axis":"46","y_axis":"60","layer":25,"rotation":"0","background":"Shadow","width":"403","height":"532","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/66705f634e363cb3174b5e2b3844ef7ecbe95333_jewishimmigrants.jpg","medium":{"dimensions":{"width":1024,"height":726},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/850733c782d4f37884016b9c00a917d22497f16f_jewishimmigrants.jpg"},"tall":{"dimensions":{"width":600,"height":425},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/fc4b9960a611a7686517c09586ff0d8cf72c4155_jewishimmigrants.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Israel bliver til","spans":[]},{"type":"paragraph","text":"Den 14. maj 1948 stiller den zionistiske leder og Israels kommende premierminister David Ben-Gurion sig på talerstolen og erklærer, at staten Israel er født. Aftenen før havde England, der havde siddet på landet siden Første Verdenskrig, erklæret sit exit og spillet ”God save the Queen” i radioen i Palæstina for sidste gang, hvorefter de britiske militærkonvojer forlod landet.","spans":[]},{"type":"paragraph","text":"Briterne havde besluttet at overlade ansvaret for området til det nyoprettede FN, som var kommet med et forslag om at opdele det i en palæstinensisk del (42%) og en jødisk del (56%). Jøderne tog godt imod forslaget, mens palæstinenserne anså det for uretfærdigt, da de jo havde beboet området længe før, de jødiske migranter ankom, så hvorfor skulle de nu bare sådan uden videre afgive over halvdelen af landet til dem? Før FN fik afsluttet sagen, erklærede Israel sin uafhængighed. Det bringer os tilbage til maj 1948 og til det første af mange krigeriske sammenstød mellem Israel og dets arabiske naboer, der opfatter Israels oprettelse som endnu et udtryk for vestlig imperialisme. Allerede dagen efter sin tilblivelse må Israel forsvare sin eksistensberettigelse. Den 15. maj 1948 angriber Egypten, Syrien, Libanon, Irak og Jordan den nyoprettede stat.","spans":[]},{"type":"paragraph","text":"Krigen, der af israelerne kaldes Uafhængighedskrigen, og af palæstinenserne ”katastrofen”, varede et år. Da den var forbi, var 70 procent af den palæstinensiske befolkning drevet på flugt. De søgte tilflugt i omkringliggende lande, men også i områder i Palæstina, hvor israelerne ikke havde magten - Vestbredden og Gaza. Israel havde udvidet sit territorium med en tredjedel og kontrollerede 78 procent af det samlede landområde. Jordan tog kontrollen på Vestbredden, og Gaza-striben kom under egyptisk herredømme. Den nye fordeling blev illustreret med en grøn streg på landkortet over området - denne linje bliver kendt som ”den grønne linje”, og den kommer vi til at høre mere om senere.","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/1acf64d50f0cc2cd8c5498ed992bff39e5f58cb3_unppp.jpg","alt":null,"copyright":null,"dimensions":{"width":400,"height":829}}],"information":[{"type":"paragraph","text":"FN's delingsplan for Palæstina fra 1947. De gule områder skulle tilfalde palæstinenserne, mens de blå - lidt over halvdelen af området - skulle udgøre en ny israelsk stat. Planen blev ikke effektueret, før Israel erklærede sin uafhængighed, og der udbrød krig.","spans":[{"start":0,"end":39,"type":"em"}]}],"x_axis":"10","y_axis":"30","layer":25,"rotation":"-2","background":"Shadow","width":"400","height":"829","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/289c89074bf3ac0697f7a96807132b429bccc4bd_israeliflags.png","alt":null,"copyright":null,"dimensions":{"width":777,"height":837}}],"information":[],"x_axis":"5","y_axis":"5","layer":15,"rotation":"0","background":null,"width":"777","height":"837","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://youtu.be/BJ4vYsw12zc","type":"video","version":"1.0","title":"Israeli Declaration of Independence (Short Version), with English and Persian (Farsi) subtitles","author_name":"Simon Sanati","author_url":"https://www.youtube.com/channel/UCecfKgIo2HD2Htmj-bzkHxw","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/BJ4vYsw12zc/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/BJ4vYsw12zc?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"I videoen citerer israelere fra Israels Uafhængighedserklæring, som den zionistiske leder og Israels kommende premierminister David Ben-Gurion læste op den 14. maj 1948, da staten Israel blev udråbt. Find den i sin fulde længe på Wikipedia.","spans":[{"start":230,"end":239,"type":"hyperlink","data":{"link_type":"Web","url":"https://en.wikipedia.org/wiki/Israeli_Declaration_of_Independence","target":"_blank"}}]}],"x_axis":"25","y_axis":"60","layer":30,"rotation":"0","background":"Shadow","width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/f018e39e431aeb3dd1bd02c8744b5c733bb0fbad_israeliflags2.png","alt":null,"copyright":null,"dimensions":{"width":972,"height":1047}}],"information":[],"x_axis":"5","y_axis":"5","layer":20,"rotation":null,"background":null,"width":"972","height":"1047","speed":-3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/a7ab0ecef4b0c2cd632f88060042ad391510c591_palestinian-post-1948.jpg","tall":{"dimensions":{"width":600,"height":398},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/08ba45b8ad2b5dc23cd39a83940fb27bde71e338_palestinian-post-1948.jpg"},"medium":{"dimensions":{"width":1024,"height":678},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/02c33b4a5ea3706d55992a03a247c2318964b6a4_palestinian-post-1948.jpg"}},"color_overlay":"#ffd8d8","color_opacity":"0.25","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Seks dages krig uden ende","spans":[]},{"type":"paragraph","text":"Tidligt om morgenen den 5. juni 1967 sætter israelske bombefly kurs mod Egyptens vigtigste flyvebaser med ordrer om at ødelægge så meget som muligt. Samtidig rykker 70.000 landtropper ind på Egyptens territorium i Gaza og på Sinai-halvøen. Det bliver starten på en lynkrig mellem Israel på den ene side, og Egypten, Jordan og Syrien på den anden.","spans":[]},{"type":"paragraph","text":"Selvom der var gået en tid med store spændinger og stridigheder om adgang til vandforsyninger og strategiske vandveje forud for krigen, kommer Israels pludselige og voldsomme angreb alligevel bag på Egypten. Man når simpelthen ikke at komme i omdrejninger, før en stor del af militærapparatet er lammet, og det er for sent. Angrebet tvinger Syrien og Jordan til at reagere med det samme, selvom de reelt set heller ikke er klar til krig. Det betyder, at Israel allerede den 10. juni - efter blot seks dages kamp - står som sejrherre. Nu med magt over dobbelt så stort et landområde. Sinai-halvøen, Gaza, Golan-højderne og Vestbredden – herunder Jerusalem – er nu på israelske hænder. ","spans":[]},{"type":"paragraph","text":"Lilleputten Israels sejr ydmyger de arabiske stormagter. I nyhedsrapporter verden over lyder referencer til den bibelske historie om den unge Davids sejr over kæmpen Goliat. Udover at sende endnu tusindvis af palæstinensere på flugt betyder krigens udfald også, at magtbalancen mellem israelerne og palæstinenserne for alvor forskubbes. Israel er nu besættelsesmagt og skal regere over den palæstinensiske befolkning. Konflikten mellem Israel og de arabiske lande bliver de følgende årtier mere specifikt til en israelsk-palæstinensisk konflikt. I en fredsaftale fra 1979 leverer Israel Sinai-halvøen tilbage til Egypten, men bliver siddende på de palæstinensiske områder Gaza og Vestbredden. ","spans":[]},{"type":"paragraph","text":"Erobringen af Jerusalem har en særlig symbolsk betydning. For første gang siden år 70 regerer jøderne over den hellige stad og har fri adgang til at bede ved grædemuren – resterne af et gammel tempel omtalt i Bibelen og en af jødernes vigtigste helligsteder. Det er meget følelsesladet for mange jøder. ","spans":[]},{"type":"paragraph","text":"Men sejren i Seksdageskrigen kommer med en pris, som man stadig betaler af på den dag i dag. Kontrollen med Jerusalems helligdomme, magten over Vestbredden og adgang til jord og vand er nemlig stadig de centrale stridspunkter i konflikten mellem Israel og Palæstina.      ","spans":[]},{"type":"paragraph","text":"(Baggrundsbilledet viser israelske soldater ved Grædemuren efter erobringen af Jerusalem. Foto: Dan Hadani, Israel Press and News Agency.)","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1200","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c0ae50158bed5991734ae81d95ad73056ea30cfc_danhadani_israelpressandphotoagency.jpg","tall":{"dimensions":{"width":600,"height":402},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/a9e69baecd95d3f49888ca1ae6143e48b706b198_danhadani_israelpressandphotoagency.jpg"},"medium":{"dimensions":{"width":1024,"height":687},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/55ae5e4e3f0a39932c079071397ee4ece8307554_danhadani_israelpressandphotoagency.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Besættelse gennem bosættelse","spans":[]},{"type":"paragraph","text":"Israel står med et særligt dilemma vedrørende Vestbredden efter sejren i Seksdageskrigen. Skal man give området tilbage til Jordan? Annektere det – altså gøre det til en del af staten Israel – og dermed give de over en million palæstinensere, der bor der, israelsk statsborgerskab og borgerrettigheder? Eller er den bedste løsning at lade palæstinenserne skabe deres egen stat her? Man gør ingen af delene. Men mens man debatterer, begynder tusindvis af civile israelere at rykke ind og bosætte sig på Vestbredden. For denne første bølge af bosættere er Israels overtagelse af Vestbredden i Seksdageskrigen en bekræftelse af deres tro på jødernes historiske ret til området. De bliver en del af en bevægelse, der de næste mange årtier kommer til at stikke en kæp i hjulet på ethvert tilløb til fredsforhandlinger. Bosættelserne møder stærk kritik fra det internationale samfund, alligevel er de fortsat frem til i dag, hvor over en halv million jøder lever og bor i bevogtede enklaver på Vestbredden – nogle i dag så store som større danske provinsbyer.","spans":[]},{"type":"paragraph","text":"Nogle opfatter bosættelserne som en bevidst strategi fra Israels side for at bevare kontrol over området. Bosætterne selv har flere forskellige grunde til at slå sig ned i de besatte områder:","spans":[]},{"type":"o-list-item","text":"Nogle er som sagt religiøst motiveret. For dem handler det om at vende tilbage til det hellige land, som det jødiske folk har fået lovet af Gud selv. For dem hedder området i øvrigt ikke Vestbredden, men Judæa og Samaria - de bibelske stednavne.","spans":[{"start":18,"end":37,"type":"em"}]},{"type":"o-list-item","text":"Andre er politisk motiveret. De flytter ind i de besatte områder for på den måde at gøre krav på jorden på vegne af nationalstaten Israel.","spans":[{"start":9,"end":27,"type":"em"}]},{"type":"o-list-item","text":"Andre igen motiveres slet og ret af lave jord- og ejendomspriser og muligheden for at opnå støtte fra den israelske stat.","spans":[{"start":36,"end":64,"type":"em"}]},{"type":"paragraph","text":"Bosættelserne er kontroversielle først og fremmest, fordi de er ulovlige i forhold til international ret, og FN fordømte dem i resolution 446 fra 1979. Dertil kommer måden, hvorpå bosættelserne er blevet oprettet. I mange tilfælde er der ikke blevet taget hensyn til de folk, der boede der i forvejen. Palæstinensiske boliger, marker og olivenlunde er blevet ryddet for at gøre plads til bosættelserne, og ofte er det kommet til tumultariske scener med buldrende bulldozere, israelske soldater, aggressive mænd og grædende kvinder i hovedrollerne.","spans":[]},{"type":"paragraph","text":"Bosættelserne tilspidser på kort sigt konflikten mellem israelere og palæstinensere endnu mere, og på længere sigt gør de det næsten umuligt at forestille sig en uafhængig palæstinensisk stat på Vestbredden – for hvad stiller man i så fald op med hele byer af israelske bosættere, der måske allerede har boet der i flere generationer?","spans":[]},{"type":"paragraph","text":"(Baggrundsbilledet er et satellitfoto fra Google Maps af den største israelske bosættelse på Vestbredden, Betar Illit. Byen har over 50.000 indbyggere og er, som det fremgår af billedet, veletableret med veje, store huse, skoler og indkøbsmuligheder. Øverst til venstre i billedet ses en stiplet linje - det er den såkalde \"grønne linje\", Israels ydre grænse indtil seksdageskrigen. Betar Illit ligger altså på besat område.) ","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":20,"rotation":"0","background":"White","width":"576","height":"1115","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://www.youtube.com/watch?v=SJIxhXLH3SY","type":"video","version":"1.0","title":"Israel beskytter udpost, der er forbudt efter israelsk lov - DR Nyheder","author_name":"DR Nyheder","author_url":"https://www.youtube.com/channel/UC8tSbn8Q4rnsSQPY-1kzXuw","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/SJIxhXLH3SY/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/SJIxhXLH3SY?feature=oembed\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"Udover de store veletablerede bosættelser er der også mange mindre og mere uformelle bosættelser på Vestbredden, hvor få familier på eget initiativ har slået sig ned og bygget hus på palæstinensisk jord. Selvom det er ulovligt ifølge både international og israelsk lov, beskytter den israelske stat dem. I filmen her, kan du møde en bosætter. Klippet er fra DR Nyheders YouTube-kanal. Den redaktionelle tekst til indslaget lyder: \"På Vestbredden har jødiske bosættere etableret omkring 100 ulovlige udposter. DR har besøgt en af dem.\"","spans":[]}],"x_axis":"10","y_axis":"60","layer":30,"rotation":"0","background":"Shadow","width":"570","height":"320","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1115},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/af76d7fd8640aa55ccdb7a0be158435626e72673_betarillit.png","medium":{"dimensions":{"width":1024,"height":595},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7306beccaa5a608d6ded91e676bbb81f07d99002_betarillit.png"},"tall":{"dimensions":{"width":600,"height":348},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d99282982c589d180588acd6c67caf4efcc5ba14_betarillit.png"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Palæstinensisk modstand","spans":[]},{"type":"paragraph","text":"Som allerede antydet, bliver Israels sejr i Seksdageskrigen til en forbandelse - i hvert fald for den del af israelerne, der ønsker fred med palæstinenserne. Nu er de arabiske naboer nemlig endnu mindre indstillede på at anerkende staten Israel, og da det er den israelske regerings betingelse for at trække sig ud af de besatte områder, står fredsforhandlingerne i stampe i årevis. ","spans":[]},{"type":"paragraph","text":"Imens vokser frustrationen hos de statsløse palæstinensere, hvoraf flere hundrede tusinde lever under kummerlige forhold i flygtningelejre. Mange af dem går aktivt ind i kampen for en palæstinensisk stat organiseret i Den palæstinensiske Befrielsesfront (PLO) ledet af Yasser Arafat - manden med det karakteristiske sort- og hvidternede tørklæde på hovedet. Det bliver begyndelsen på en kompromisløs guerillakrig mod Israel og israelske interesser i udlandet anført af PLOs mest militante gruppering Fatah. Bomber sprænger i busser og på pladser i Israels større byer, og i udlandet bliver palæstinensernes sag bragt til verdens opmærksomhed af spektakulære terrorangreb. Mest kendt er nok drabet på 11 israelske atleter under OL i München 1972. I hele denne periode er der ingen frugtbar dialog mellem de to parter i konflikten på trods af FNs forsøg på at etablere en.","spans":[]},{"type":"paragraph","text":"I 1987 tager konflikten en ny form, der bliver kendt som ”intifadaen” – det arabiske ord for opstand. I de tyve år, Israel indtil videre har besat Gaza, Golan, Vestbredden og Østjerusalem, er uretfærdighedsfølelsen hos almindelige palæstinenserne kun taget til. Alt imens israelske bosættelser i de besatte områder vokser, stiger arbejdsløsheden blandt palæstinenserne, og der er generelt mere afvikling end udvikling i området. For at finansiere besættelsen beskatter israelerne palæstinenserne og smider dem i fængsel, der ikke kan betale. ","spans":[]},{"type":"paragraph","text":"Alle tilløb til protest bliver hårdt slået ned. Men nu går almindelige palæstinensere på gaden i hobetal, og børn og unge danner fortrop. Nu er det nok! Palæstinenserne kræver frihed fra den undertrykkende besættelse, og de kæmper for den med det, de har ved hånden – sten. Nyhedsbilleder af stenkastende børn og unge overfor tungt bevæbnet israelsk militær går verden rundt og rykker ved opfattelsen af Israel som lilleputnationen, der bare forsvarer sig selv. Det er svært at tolke palæstinensernes opstand som andet end et folks desperate kamp for frihed. På trods af økonomiske afstraffelser, massearrestationer, udgangsforbud og mere end 500 dræbte og 8500 sårede i de første to år er palæstinenserne utrættelige, og sympatien for deres sag vokser. Nu er rollerne i den bibelske historie om David og Goliat byttet om. Nu er Israel Goliat overfor de protesterende palæstinensere, der ligesom David ikke har andet end en stenslynge at forsvare sig med.","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/f09cc9ab86aaa72317211dd073d529c3a0b43bc2_arafat_keffiyeh.jpg","alt":null,"copyright":null,"dimensions":{"width":350,"height":450}}],"information":[{"type":"paragraph","text":"Yasser Arafat var fra 1969 formand for Den palæstinensiske Befrielsesfront, der arbejdede for at samle kræfterne i en kompromisløs kamp mod Israels besættelse og en selvstændig palæstinensisk stat. Da palæstinenserne i 1994 fik selvstyre blev Arafat den første leder. Han døde den 11. november 2004, og der spekuleres stadig i dødsårsagen - en af teorierne hedder et giftmord bestilt af Israelerne. ","spans":[]},{"type":"paragraph","text":"Foto: Wikimedia Commons.","spans":[]}],"x_axis":"50","y_axis":"30","layer":15,"rotation":"-3","background":"Shadow","width":"350","height":"450","speed":4},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/4765ed042147af9678ef15782d0a8417fa73e5fe_intifada.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":350}}],"information":[{"type":"paragraph","text":"Dewi Putra via Shutterstock.com.","spans":[]}],"x_axis":"67","y_axis":"33","layer":20,"rotation":"2","background":"Shadow","width":"500","height":"350","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/5cac11b0bbab7d626c7c7b386c4674445927abaa_flag_of_hamas.png","alt":null,"copyright":null,"dimensions":{"width":520,"height":380}}],"information":[{"type":"paragraph","text":"I løbet af Intifadaen opstår en ny gruppering, for hvem Islam spiller en stor rolle. Gruppen kalder sig Hamas og opfatter kampen mod Israel som Guds kamp og som en del af en større kamp for oprettelsen af et islamisk kalifat i området. Hamas religiøse ideologi og den rolle, bevægelsen senere kommer til at spille i Gaza, strammer konfliktens hårdknude yderligere.","spans":[]},{"type":"paragraph","text":"Foto: Hamas' flag. Wikimedia Commons. ","spans":[]}],"x_axis":"60","y_axis":"55","layer":10,"rotation":"-1","background":"Shadow","width":"520","height":"380","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/955997132fff5ef4eaf5201af15ca107055dded7_barnmedsten.jpg","medium":{"dimensions":{"width":1024,"height":675},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8ff3820eaaa4214a6ab3905b74efcb3409fb9b71_barnmedsten.jpg"},"tall":{"dimensions":{"width":600,"height":396},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e122339329ad4616b14983c2159a4ad460cffa52_barnmedsten.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Forsøg på fred","spans":[]},{"type":"paragraph","text":"En solbeskinnet septemberdag i 1993 giver to mænd en anelse tøvende hinanden hånden på plænen foran Det Hvide Hus i Washington. Mændene er PLO-leder Yasser Arafat og Israels premierminister Yitzhak Rabin. Hvis de ser lidt trætte ud, er det fordi, de har været igennem en lang og sej forhandlingsproces fuld af svære kompromisser i håb om at bringe fred til de folk, de hver især repræsenterer. Bag dem står en tredje mand - den daværende amerikanske præsident Bill Clinton - han ligner en glad og stolt far. Og der er da også grund til at være stolt. For denne historiske dag - den 13. september 1993 - har de to mænd har netop underskrevet en officiel aftale, der bringer parterne tættere på fredelig sameksistens end nogenside før. I hvert fald på papiret. I aftalen anerkender parterne hinandens legitimitet og forpligter sig på en ambitiøs femårsplan for en endelig fred og fordeling af land. Aftalen er så ambitiøs, at den året efter udløser Nobels Fredspris. Men desværre også for ambitiøs, skal det vise sig. For de to ledere har ikke deres befolkningers fulde opbakning.","spans":[{"start":983,"end":986,"type":"em"}]},{"type":"paragraph","text":"Arafat bliver efterfølgende heftigt kritiseret for overhovedet at anerkende staten staten Israel, og den palæstinensiske modstandsgruppe Hamas fortsætter deres angreb på Israelske mål. Og i 1995 bliver Rabin skudt og dræbt på åben gade - ikke af en palæstinenser, men af en af sine egne landsmænd - en ultranationalistisk jøde, der ønsker at forpurre fredsprocessen. Det lykkes i den grad. Mordet på Rabin starter en heftig debat blandt israelerne for og imod fredsforhandlingerne, og det ender med, at et flertal vælger en ny premiereminister, Shimon Peres, som er modstander af overdragelsen af kontrol over landområder til palæstinenserne. Fronterne bliver igen trukket op.  ","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: PLO-leder Yasser Arafat og Israels premierminister Yitzhak Rabin giver hånd efter underskrivelsen af Oslo-aftalen den 13. september 1993. Mark Reinstein via Shutterstock.com.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":20,"rotation":"0","background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/2495002a4b42a2e2049a9e192f66a9d0b97956ef_nobelsfredspris.jpg","alt":null,"copyright":null,"dimensions":{"width":550,"height":350}}],"information":[{"type":"paragraph","text":"Modtagere af Nobels Fredspris i 1994: Fra venstre er det PLO-leder Yasser Arafat, Israels udenrigsminister Shimon Peres og Israels premierminister Yitzhak Rabin. ","spans":[]},{"type":"paragraph","text":"Government Press Office via Wikimedia Commons.","spans":[]}],"x_axis":"5","y_axis":"62","layer":30,"rotation":"-4","background":"Shadow","width":"550","height":"350","speed":4},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/66d02ae58b13e85f42f17a98b19e012b5aa89970_mindesrabin.jpg","alt":null,"copyright":null,"dimensions":{"width":450,"height":300}}],"information":[{"type":"paragraph","text":"Premierminister Yitzhak Rabin er blevet et symbol for de israelere, der ønsker fred, og han mindes hvert år på den dag, hvor attenteten på ham fandt sted. Her tænder israelere lys på Rabin Square i Tel Aviv på 21-årsdagen for hans død.","spans":[]},{"type":"paragraph","text":"Foto: Avivi Aharon via Shutterstock.com.","spans":[]}],"x_axis":"30","y_axis":"70","layer":25,"rotation":"3","background":"Shadow","width":"450","height":"300","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/6d37055175be99c90716d8faec4591243c8d8637_osloaftalen.jpg","tall":{"dimensions":{"width":600,"height":401},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/ff32cf3b4af6e584df01e73cdd3583711d821e08_osloaftalen.jpg"},"medium":{"dimensions":{"width":1024,"height":684},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/50e1bf84ccb2a44ce1156a47d958e26fd76f5aad_osloaftalen.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Konflikten eskalerer igen","spans":[]},{"type":"paragraph","text":"Tempelbjerget i Jerusalem er, og har altid været, et af de sværeste stridspunkter mellem israelerne og palæstinenserne, da det er et helligt og vigtigt sted for både jøder og muslimer. Her står Grædemuren - den eneste tilbageværende del af et templet omtalt i Torahen, jødernes hellige skrift, hvor jøder hver dag kommer fra nær og fjern for at bede. Hvis man træder lidt tilbage fra muren og løfter blikket, får man øje på en strålende guldkuppel. Den sidder på Al Aqsa-moskeen, muslimernes tredjevigtigste helligdom, der troner i al sin herlighed blot 50 meter fra Grædemuren på det sted, hvor jødernes tempel en gang stod.","spans":[]},{"type":"paragraph","text":"Da den israelske oppositionsleder Ariel Sharon i september 2000 besøger tempelpladsen omkring Al Aqsa-moskeen, bryder helvede løs. Besøget bliver opfattet som en direkte provokation af palæstinenserne på et tidspunkt, hvor den politiske situation i forvejen er højspændt. De sikkerhedsvagter, der følger Sharon, kommer på hårdt arbejde med at beskytte Sharon mod vrede palæstinensere. Hans besøg kommer ovenpå en skuffende Oslo-aftale, der aldrig udmøntede sig i noget konkret, og i kølvandet på flere forliste forsøg på at etablere nye fredsforhandlinger.","spans":[]},{"type":"paragraph","text":"Palæstinenserne er fulde af frustration over forringede levevilkår og israelernes fortsatte bosættelser på palæstinensisk territorium, og Sharons demonstrative besøg på tempelpladsen bliver dråben, der får bægeret til at flyde over. Han bliver mødt med tilråb og stenkast, og urolighederne eskalerer de følgende timer og dage. Startskuddet til den anden intifada har lydt. Ligesom med den første intifada kommer oprøret nedefra, fra befolkningen, og er på sin vis ude af politikernes kontrol. Denne gang er intifadaen dog præget af endnu voldsommere sammenstød mellem de to parter. Palæstinensiske selvmordsbombere gør tilværelsen usikker for civile israelere ved at sprænge bomber i busser og på cafeer, og det israelske militær slår hårdt igen med nådesløse gengældelsesangreb og genbesætter store dele af Vestbredden. ","spans":[]},{"type":"paragraph","text":"De næste 5 år mister op mod 5000 palæstinensere og 1100 israelere livet i denne tilspidsede konflikt.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Luftfoto af Tempelbjerget i Jerusalem. Andrew Shiva via Wikimedia Commons. Billede af Ariel Sharon: Wikimedia Commons.)","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":"0","background":"White","width":"576","height":"1120","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/aae8bdba31d6610ddef323b0c38c39e11bb6ad45_angrymob.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":800}}],"information":[],"x_axis":"0","y_axis":"50","layer":10,"rotation":"0","background":null,"width":"1920","height":"800","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/2c01ba222fc125e8973917df3e3c59eb9e1e436b_arielsharon.png","alt":null,"copyright":null,"dimensions":{"width":573,"height":841}}],"information":[{"type":"paragraph","text":"","spans":[]}],"x_axis":"65","y_axis":"35","layer":5,"rotation":"0","background":null,"width":"573","height":"841","speed":4}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1120},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/aa65cea9faee873de8746cbdbfcd9a0b2157cbec_tempelbjerget.jpg","tall":{"dimensions":{"width":600,"height":351},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/51476236bd97ac826368c317b9299ac47e7e9d66_tempelbjerget.jpg"},"medium":{"dimensions":{"width":1024,"height":599},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/66fce6f4696093d49c7b39ba86a424288bc5aa59_tempelbjerget.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"En mur rejser sig","spans":[]},{"type":"paragraph","text":"2002. Ariel Sharon er nu premierminister, og vi er to år inde i den anden intifada, eller Al-Aqsa-intifadaen, som den også kaldes på grund af den måde, den startede på. Bombesprængninger på israelsk territorium udført af palæstinensiske selvmordsaktivister er efterhånden hverdagskost og gør livet surt og usikkert for almindelige israelere. Det samme gør israelernes vedvarende besættelse og nådesløse gengældelsesangreb for palæstinenserne. Noget må gøres. Sharons løsning bliver en mur.","spans":[]},{"type":"paragraph","text":"Sommeren 2002 begynder Israel opførelsen af, hvad de kalder ”sikkerhedsbarrieren”, og palæstinenserne kalder ”adskillelsesmuren”. Det bliver over de næste år til et godt 700 kilometer langt spærringsanlæg mellem Israel og Vestbredden. Barrieren består på de fleste strækninger af et højt pigtrådshegn med grøfter og sikkerhedsanlæg på begge sider. På cirka ti procent af strækningen, særligt omkring de større byer, står en høj betonmur med bemandede vagttårne og elektronisk overvågning.","spans":[]},{"type":"paragraph","text":"Opførelsen af barrieren får skarp kritik fra mange kanter, særligt fordi den ikke følger \"den grønne linje\", altså grænsen fra 1949 mellem Israel og Vestbredden. Barrieren slanger sig nemlig flere steder ind på palæstinensisk territorium for at indlemme de større bosætterbyer lige på den anden side af grænsen. Samtidig er barrieren blevet kritiseret for at afskære palæstinensiske landsbyer fra dele af deres vandforsyning og skære tværs igennem olivenlunde og landbrugsjorde, som udgør mange familiers levebrød. Kritikere kalder barrieren for ”apartheidmuren” med reference til den racistiske adskillelsespolitik i Sydafrika (se Sydafrika og Zimbabwe-casen), fordi den ganske enkelt gør livet meget besværligt for mange palæstinensere, der må vente i lange køer for måske - hvis de har de rette papirer - at komme igennem et checkpoint for fx at arbejde, studere eller besøge familie og venner på den anden side af barrieren. ","spans":[{"start":629,"end":659,"type":"em"}]},{"type":"paragraph","text":"Israelerne retfærdiggør opførelsen af barrieren med, at de ikke ser nogen anden mulighed for at beskytte deres borgere mod de mange terrorangreb, og henviser til, at mange andre nationer verden over bygger mure for at sikre deres grænser. At en del af barrieren er bygget på palæstinensisk territorium, og at disse landområder dermed er ulovligt annekteret, går den israelske regering let hen over. Fra israelsk perspektiv er muren en succes - den har haft den ønskede effekt i og med, at antallet af terrorangreb er faldet drastisk.","spans":[]},{"type":"paragraph","text":"Ikke desto mindre har FN fordømt barrieren, og Den Internationale Domstol i Haag tilkendegav allerede i 2004, at barrieren strider mod international lov. I dommen afgjorde man, at den på visse strækninger skulle rives ned, og at palæstinensere, hvis ejendomsværdi er blevet forringet af barrieren, skulle kompenseres. Effektueringen af denne kendelse har vi dog stadig til gode at se. Og som Israels allierede er mange vestlige nationer tilbageholdende med at presse på...","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Badahos vis Shutterstock.com.)","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/e94e49f750176bedc462c52d39b1dd8eb942c384_seperationwall.png","alt":null,"copyright":null,"dimensions":{"width":650,"height":800}}],"information":[{"type":"paragraph","text":"Når man taler om Israels \"sikkerhedsbarriere\", så taler man især om befæstningen til Vestbredden. Men grænsen til det palæstinensiske område Gaza er også stærkt befæstet og strengt bevogtet og har været det siden 1994. Det betyder, at 1,8 millioner palæstinensere er nærmest indespærret på et område på størrelse med Langeland.","spans":[]},{"type":"paragraph","text":"Grafik: Wikimedia Commons.","spans":[]}],"x_axis":"5","y_axis":"20","layer":20,"rotation":"-2","background":"Shadow","width":"650","height":"800","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/04124541a701d2763ee7abfe52fbc604dd8e2562_muren.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/730a3556b3473a710cfff1590e9f10c74f39a6df_muren.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/ba64b2e80b9d93df190cc91a01170e3ca4e32c14_muren.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Det betændte Gaza","spans":[]},{"type":"paragraph","text":"Som en del af endnu et forsøg på at sætte skub i en fredsproces rydder Israel i 2005 sine bosættelser og trækker sine tropper ud af et lille område kaldet Gaza. Det smalle stykke land er nu det eneste område, hvor palæstinenserne har fuld kontrol.","spans":[]},{"type":"paragraph","text":"I 2006 vinder Hamas-bevægelsen en overraskende, men overbevisende sejr i Gazas første demokratiske valg. Hamas gik til valg med et løfte om forandring, de udstrålede integritet og engagement og havde renset valgprogrammet for de mere antisemitiske og ekstremistiske holdninger, bevægelsen også står for. Valget kan uden tvivl tolkes som et protestvalg, der bunder i skuffelsen over tidligere politikeres manglende resultater i fredsforhandlingerne. Reaktionerne fra omverdenen kommer prompte. EU og store dele af det internationale samfund definerer Hamas som en terrororganisation, fordi de ikke anerkender staten Israels eksistensberettigelse og griber til vold for at bekæmpe den. Hamas’ valgsejr i Gaza medfører en international finansboykot og politisk isolering af Gaza, der forværrer situationen i området både socialt og økonomisk. Interne stridigheder præger området, der er på grænsen til borgerkrig. ","spans":[]},{"type":"paragraph","text":"At palæstinenserne har fuld kontrol over Gaza er måske også så meget sagt, for det er israelerne, der kontrollerer Gazas ydre grænser, og bestemmer hvem og hvad, der kommer ud og ind af det tætbefolkede område via grænsen til Israel. Det vil sige, at 1,8 millioner mennesker er så godt som indespærret på et område på størrelse med Langeland, og det gør konflikten ekstra tilspidset her.","spans":[]},{"type":"paragraph","text":"De følgende år helt frem til i dag er præget af gentagne sammenstød og flere deciderede krige mellem Hamas og Israel. Hamas sender raketter ind over grænsen til Israel, og Israel svarer igen med bombeangreb fra luften. I 2008-2009 kommer det til decideret krig, og Gaza bliver lagt i ruiner af den største israelske offensiv siden krigen i 1967. Krigen kræver mange civile ofte, hvilket fører til skarp kritik af både Hamas og Israel – Hamas for  at bruge civile som skjold, og Israel for at have dem som mål. Kritikken ændrer ikke ved hverken Hamas’ eller Israels fremfærd, og i 2014 er den gal igen. Denne gang koster en krig mellem Israel og Hamas flere tusinde civile liv og gør 100.000 hjemløse.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Spændingerne i Gaza-striben bryder i slutningen af 2008 endnu en gang ud i lys lue i en tre ugers væbnet konflikt. ChameleonsEye via Shutterstock.com.) ","spans":[]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":"0","background":"White","width":"576","height":"1278","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/a0ea62e2c52c1130df256400cf1340be3f7dadc3_sloer.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":1278}}],"information":[],"x_axis":"0","y_axis":"0","layer":15,"rotation":"0","background":null,"width":"1920","height":"1278","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://www.youtube.com/watch?v=I1jfjqNPX-g","type":"video","version":"1.0","title":"Krasnik i ophedet interview om Gaza - Deadline","author_name":"DR Nyheder","author_url":"https://www.youtube.com/channel/UC8tSbn8Q4rnsSQPY-1kzXuw","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/I1jfjqNPX-g/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/I1jfjqNPX-g?feature=oembed\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"Terrorisme eller frihedskamp? Er der noget, der kan få en følelserne i kog, så er det debatten om, hvorvidt palæstinenserne i Gaza får som fortjent med Israels voldsomme krigsførsel i Gaza, fordi de selv har valgt Hamas, der ikke anderkender Israels eksistensberettigelse og bekæmper, hvad de opfatter som en besættelsesmagt, med raketangreb og selvmordsaktioner mod israelske mål. ","spans":[{"start":0,"end":29,"type":"em"}]},{"type":"paragraph","text":"Klippet er fra en Deadline-udsendelse på DR2 i 2014, hvor endnu en krig hærgede i Gaza. Den redaktionelle tekst til indslaget lyder: \"Deadline på DR2 var tirsdag aften temmelig højrøstet, da vært Martin Krasnik interviewede mellemøstkenderen Michael Irving Jensen.\" ","spans":[]},{"type":"paragraph","text":"Se også Krasniks ophedede interview med en norsk læge, der arbejdede på et hospital i Gaza under samme krig, her. ","spans":[{"start":109,"end":112,"type":"hyperlink","data":{"link_type":"Web","url":"https://www.youtube.com/watch?v=49glcoCvM9E"}}]}],"x_axis":"60","y_axis":"10","layer":25,"rotation":"0","background":"Shadow","width":"570","height":"320","speed":null}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1278},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/4c0e142e9cf52f56f20683921d818110a798f61f_gaza.jpg","tall":{"dimensions":{"width":600,"height":399},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c21dbf366385b84234b9e2317fd58fed2d6465b8_gaza.jpg"},"medium":{"dimensions":{"width":1024,"height":682},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8265f2084f94255ed090e878d37302c8c5754150_gaza.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Abus historie","spans":[]},{"type":"paragraph","text":"Der er desværre ikke mange lyspunkter at fæste håb om fred mellem israelere og palæstinensere til. Selvom sikkerhedsbarrieren eller adskillelsesmuren har nedbragt antallet af terrorangreb på israelsk område, er det som om den samtidig har trukket fronterne tydeligere op. På begge sider vokser frustrationen og ekstremismen. Og man strides fortsat om de samme punkter som i årtier: De palæstinensiske flygtninges fremtid, bosættelserne på Vestbredden, en endelig grænsedragning og ikke mindst Jerusalems status. Og det har bestemt ikke gavnet situationen, at USA's præsident, Donald Trump, har erklæret, at hans administration anser Jerusalem for Israels retmæssige hovedstad og agter at flytte sin ambassade dertil fra Tel Aviv, og at Australien og flere andre lande lader til at ville følge trop.","spans":[]},{"type":"paragraph","text":"Mens Israel og Palæstinas ledere strides om en løsning på konflikten, forsøger almindelige palæstinensere at få en hverdag til at hænge sammen. Mens verden venter på fred, er solen stået op over køen til det checkpoint, hvor Abu nu er nået frem til de sidste indhegnede etaper. Klokken nærmer sig seks. På den anden side af grænsen holder busser klar til at fragte ham og de andre arbejdere videre til deres respektive arbejdspladser. Abu skal til Tel Aviv, hvor han arbejder på en byggeplads. Hans dag har allerede været i gang i tre timer, og der kommer til at gå yderligere ti, før han returnerer gennem den trange åbning i grænsen mellem Israel og Palæstina. Det giver ham et par timer til at være sammen med familien, tage et bad og få noget mad, inden han må i seng for at kunne komme op igen i morgen og gøre det hele en gang til.","spans":[]},{"type":"paragraph","text":"Abu er en fiktiv person, hvis historie er baseret på øjenvidneberetninger beskrevet af forskellige organisationer, der dokumenterer forholdene ved de israelske checkpoints, bl.a. Palestine Monitor og B’Tselem - The Israeli Information Center for Human Rights in the Occupied Territories.","spans":[{"start":0,"end":287,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsbillede: Palæstinensiske mænd står i kø ved et checkpoint nær Bethlehem på Vestbredden for at søge om adgang til Jerusalem. Ryan Rodrick Beiler via Shutterstock.com. Find de samlede kilder til denne case HER.)","spans":[{"start":214,"end":217,"type":"hyperlink","data":{"link_type":"Media","name":"samledekilder_cases.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F29ed7b98-6b74-4cce-a782-5cef41ce9a74_samledekilder_cases.pdf","size":"6488599"}}]},{"type":"paragraph","text":"","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":"0","background":"White","width":"576","height":"1200","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c261704764482f643070ef9915785e5310d68100_waitinginline.jpg","medium":{"dimensions":{"width":1024,"height":681},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f70ac6d544f781cb21a0f6bb13b3187e07b61b41_waitinginline.jpg"},"tall":{"dimensions":{"width":600,"height":399},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d5798f37510d49f6b4a55000cf496b9bea34f7c1_waitinginline.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}}],"meta_title":"Israel og Palæstina","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag den befæstede grænse mellem Israel og Palæstina og møde Abu, som hver dag står i kø i timevis for at krydse den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/40a1176d49fb986d11b8ecea84a0b71a78289568_israelwall.jpg"},"hide_for_google":"false","navigation":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false},"home_link":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false}}}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"W1sWPh4AAEEk9kl4","type":"case","uid":"sydafrika-og-zimbabwe","url":"/cases/sydafrika-og-zimbabwe","published":"2019-02-05T09:41:04+0000","lang":"da-dk","meta_title":"Sydafrika og Zimbabwe","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag den befæstede grænse mellem Sydafrika og Zimbabwe og møde Vimbai - en af de mange migranter, der har krydset den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/818096c10b3c05f32559e4cae99e8ae8ea27bc9d_beitbridge.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"Sydafrika og Zimbabwe","spans":[]}],"url":"/cases/sydafrika-og-zimbabwe","body":[{"slice_type":"section","slice_label":null,"items":[],"primary":{"id":"section-1","background_image":{"dimensions":{"width":1920,"height":1255},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b74b95b2a4a1773e078ef8b9e5363249ce2ccece_beitbridge.jpg","tall":{"dimensions":{"width":600,"height":392},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/ae9c019737a6c01506ace49a7b32a07c95b22136_beitbridge.jpg"},"medium":{"dimensions":{"width":1024,"height":669},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b41dc6e551d20ede1764cf98637ead6c9b0f8363_beitbridge.jpg"}},"color_overlay":"#000000","color_opacity":"0.2","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Vimbais historie","spans":[]},{"type":"paragraph","text":"Den sydafrikanske by Musina ligger kun 16 kilometer fra grænsen til Zimbabwe, så byens hullede veje bærer en regelmæssig trafik til og fra grænsen mellem de to lande. Her, på Musinas støvede hovedgade, står en 19-årig kvinde, Vimbai, og betragter mennesker og køretøjers færden. Klokken er 8 om morgenen, og varmen begynder så småt at tage til. Det er første gang Vimbai er i Musina, og hun har gået hele natten for at nå hertil. ","spans":[]},{"type":"paragraph","text":"Den eneste officielle grænseovergang mellem Sydafrika og Zimbabwe går via Beitbroen, da de to lande er adskilt af Limpopofloden. Alle, der ikke har et pas, må finde en anden vej. Det har Vimbai ikke, så hendes rejse mod Sydafrika fra Zimbabwe begyndte i hendes hjemby Masvingo, 250 kilometer fra Beitbroen. Sammen med en gruppe kvinder tog hun en minibus fra Masvingo til grænsen, hvor de fandt en mandlig guide, som før - mod betaling - havde hjulpet dem ind i Sydafrika. Uden en guide, der kender ruterne i grænselandet, er man som kvinde ekstra udsat i mørket, hvor voldelige røvere er på jagt efter lette ofre. Flokken begyndte turen, da mørket faldt på. Vimbai kunne ikke se ret langt for sig, men hendes bare fodsåler fortalte hende, at de passerede forbi fugtige marker og tørre jordområder. De gik i tavshed, men der var ikke stille. Cikaderne lagde et konstant lydspor, og da de nærmede sig Limpopofloden stemte kassinafrøerne i. Guiden gennede dem ud i floden et sted, hvor den ikke var for dyb, og strømmen ikke så stærk. De løftede deres tasker op over hovedet, og bevægede sig ud i vandet en efter en. Vimbai prøvede ikke at tænke på krokodillerne, der efter sigende er mere aktive om natten, mens hun vadede gennem floden med lange målrettede skridt og blikket fast fokuseret mod den modsatte bred. Lettelsen var til at føle på, da hun og de andre kvinder nåde den. Så langt, så godt. Næste forhindring - grænsehegnet. Med hinandens hjælp og guidens bidetang kom de igennem de tre grænsehegn, dog ikke uden ridser fra de barberbladslignende pigge, grænsehegnet er beklædt med. Men adrenalinniveauet hos Vimbai og de andre kvinder var så højt, at de knap nok ænsede det. Derefter var der kun nogle få timers nattevandring til Musina foran dem.","spans":[]},{"type":"paragraph","text":"Vimbais hjemby Masvingo er den største by i en provins af samme navn i det sydlige Zimbabwe. Her sælger hun varer for at forsørge sin familie i en nærliggende landsby. Hun har sparet op i lang tid for at tage turen til Sydafrika for at købe sukker, olie, grøntsager, frugt, sko, tøj og kosmetik, som hun vil sælge i Zimbabwe. De fleste grænsehandlere, Vimbai kender, har et pas, men Vimbai har først for nylig udfyldt sin pasansøgning. Hun skulle både betale for ansøgningskemaet, for at aflevere det igen og for at få det videre i systemet. Hun kender mange, der har ventet flere år på at få deres pas. Vimbai kan ikke vente i flere år. Hun har brug for penge, så hendes familie kan få mad og hendes to brødre kan gå i skole. Vimbai har selv gået i skole i 5 år, men da hendes familie fik økonomiske problemer, tog de hende og hendes storesøster ud af skolen. Da Vimbai var 13 år, begyndte hun at arbejde som hushjælp i Masvingo. De sidste to år har Vimbai tjent penge på at købe varer fra kvindelige grænsehandlere, som hun sælger videre. Men det er blevet for dyrt at købe varer fra grænsehandlerne, hvis hun skal tjene noget på at sælge dem videre. Så nu må hun selv tage turen til Sydafrika.  Nu står Vimbai midt i Musinas travle gadeliv med morgensolen i sit ansigt. Hun skal bruge de næste par dage på at lave gode handler i byen.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Timo Arnall via Flickr)","spans":[{"start":0,"end":42,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/a71c9690dda993c59f8e8975ed1e54d1af2ec7d6_7866182_795f8a51d0_o.jpg","medium":{"dimensions":{"width":1024,"height":768},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c84e0815f590f10381a53a76e5ea165b31ed64a0_7866182_795f8a51d0_o.jpg"},"tall":{"dimensions":{"width":600,"height":450},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/891ad687aa7b183e94d5fca37e4988cf9345d216_7866182_795f8a51d0_o.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Limpopofloden og ildslangen","spans":[]},{"type":"paragraph","text":"Limpopoflodens rislen akkompagneres af fuglesang fra et væld af forskellige fuglearter - gule piroler med sorte vinger, ellekrager i alle regnbuens farver, orange drosselsangere med grå kapper og grønne kapturakoer med blå haler og strithår. Her tæt på flodens bred strækker træerne sig langt op over resten af landskabet. De fleste dyr er søgt væk fra middagsheden og gemmer sig i træernes og buskenes skygge. Kun de koldblodede krokodiller dovner ved flodens bred og lader sig varme af solens stråler. En farvestrålende fugl letter fra et Mopanetræ med sommerfugleformede blade på den ene side af flodbredden og flyver til et kraftigt baobabtræ på den anden side. Hvad fuglen ikke ved er, at den netop har krydset grænsen mellem Sydafrika og Zimbabwe.","spans":[]},{"type":"paragraph","text":"Grænsen mellem de to lande udgøres af Limpopofloden, der bugter sig tværs gennem hele det sydlige Afrika. Fra Botswana i øst zigzagger den gennem landskabet på grænsen mellem Sydafrika og Botswana og videre ind i det 230 kilometer lange grænseland mellem Sydafrika og Zimbabwe, inden den fortsætter ind i Mozambique og ender sin rejse i Det Indiske Ocean. ","spans":[]},{"type":"paragraph","text":"Alfred Beit Road Bridge er den eneste formelle vej over grænsen mellem Zimbabwe og Sydafrika. Broen stod færdigbygget i 1929 og er opkaldt efter den britiske guld- og diamantmagnat Alfred Beit. I 1995 blev den oprindelige bro erstattet med en ny bro med samme navn, der kunne klare vægten af den tiltagende trafik mellem de to lande. ","spans":[{"start":0,"end":23,"type":"em"}]},{"type":"paragraph","text":"For folk uden tilladelse til at krydse grænsen via Alfred Beit Road Bridge er Limpopofloden ikke den eneste forhindring. På den sydafrikanske side af floden, et par hundrede meter fra bredden, støder man ind i et grænsehegn. Grænsehegnet, der følger flodens forløb og snor sig gennem det sydafrikanske landskab, er blevet døbt Ildslangen, da der før i tiden løb elektricitet i hegnet, og det var meningen, at det skulle give et dødeligt elektrisk chok til enhver, der kom i kontakt med det. I dag er hegnet slukket og står tilbage som et levn fra apartheidtiden i Sydafrika, men det tjener stadig et formål som en hindring på vejen for illegale immigranter. Hegnet består flere steder af et bredt snoet pigtrådshegn samt endnu et hegn beklædt med skæreblade på hver sin side. Det har sikkert fået mange til at opgive deres forehavende og vende op, men ikke sjældent vidner en tøjrest i hegnet om, at nogen har haft en drøm om Sydafrika, der var stærkere end den smerte, de sylespidse pigge og skarpe blade kunne påføre dem.","spans":[{"start":326,"end":337,"type":"em"}]},{"type":"paragraph","text":"Selvom grænsen mellem Sydafrika og Zimbabwe kan forekomme næsten naturgiven, har Limpopofloden ikke altid udgjort grænsen mellem de to nationalstater. Det var europæerne, der bragte idéen om nationalstater med sig til det afrikanske kontinent. Indtil da var der ikke noget, der hed Sydafrika og Zimbabwe, og dermed heller ingen barrikaderet grænse mellem de to landområder. For at finde ophavet til det, der senere blev til Ildslangen, skal vi et godt stykke tilbage i tiden og til Europa, nærmere bestemt Berlin.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Limpopofloden på grænsen mellem Sydafrika og Zimbabwe. Okyela via Shutterstock)","spans":[{"start":0,"end":98,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1100","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/6aeb95225486a2eabb80dbaa0db4d115803aca46_hegn_fri.png","alt":null,"copyright":null,"dimensions":{"width":1200,"height":988}}],"information":[],"x_axis":"-1","y_axis":"60","layer":8,"rotation":null,"background":null,"width":"1200","height":"988","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/8bd576edaf9e4f6e313ce3e9b48aa63acd84d1e0_beskaret.png","alt":null,"copyright":null,"dimensions":{"width":309,"height":300}}],"information":[],"x_axis":"0","y_axis":"78","layer":13,"rotation":null,"background":null,"width":"309","height":"300","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/4c12e7e710015a18f4fbf394c3d6789b2899bd49_beskaaret2.png","alt":null,"copyright":null,"dimensions":{"width":350,"height":205}}],"information":[],"x_axis":"0","y_axis":"20","layer":5,"rotation":null,"background":null,"width":"350","height":"205","speed":null}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1100},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/03b5d23cb1228021098edc159e54d2e348ec3b98_limpopoweb.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/12371dbf1e75da98a939afc2a81b2e90a4de05a4_limpopoweb.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b4cd0d7437fc6978373f928cfd561ee19f663796_limpopoweb.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Kapløbet om Afrika ","spans":[{"start":18,"end":19,"type":"strong"}]},{"type":"paragraph","text":"Den kolde novembervind fyger gennem Wilhelmstrasse i Berlin. Lige nu er gaden tom, men om ganske få timer vil den vrimle med repræsentanter fra 13 europæiske lande og fra USA. Året er 1884, og her på Wilhelmstrasse har den tyske rigskansler Otto von Bismarck officiel bopæl. På denne novemberdag er han vært og formand for Berlinkonferencen, hvor formålet er at udstykke en ramme for \"Kapløbet om Afrika\". ","spans":[]},{"type":"paragraph","text":"Storbritannien, Frankrig og Tyskland er på dette tidspunkt i fuld gang med at udforske Afrikas naturressourcer og råstoffer, som de vil anvende i deres voksende industrier. De ser på samme tid det afrikanske kontinent som et potentielt marked for de varer, deres fabrikker producerer. Europæiske regeringer sender spejdere afsted til Afrika for at sikre aftaler med de indfødte og komme andre europæiske lande i forkøbet. Det har allerede medført konflikter europæerne imellem, og derfor har de aftalt at mødes i Berlin for at forhandle deres ønsker og interesser i det afrikanske kontinent.","spans":[]},{"type":"paragraph","text":"Her i slutningen af 1800-tallet er det kun ganske få europæere, der sætter spørgsmålstegn ved deres overlegenhed over andre ’laverestående’ racer. Derfor er heller ikke en eneste afrikaner inviteret med til mødet. Udryddelse af slaveriet én gang for alle er godt nok også en del af dagsordenen, men vigtigst er de kommende kolonimagters strategiske og økonomiske interesse i at beskytte gamle markeder og handelsruter samt at sikre sig magten over nye. ","spans":[]},{"type":"paragraph","text":"Berlinkonferencen slutter i februar 1885, hvor alle de europæiske lande underskriver en traktat for Afrika. De europæiske lande er blevet enige om at tillade fri handel mellem kolonierne i Afrika og har udstykket rammerne for, hvordan de skal forhandle fremtidige europæiske krav på afrikanske landområder. Berlinkonferencen legitimerer og skaber hermed reglerne for den europæiske kolonialisering af Afrika, og sidst, men ikke mindst, antænder konferencen nye europæiske interesser i det afrikanske kontinent. ","spans":[]},{"type":"paragraph","text":"De nye koloniers grænser bliver ikke tegnet Afrika - i langt de fleste tilfælde bliver grænserne trukket i Europa med udgangspunkt i landkort over Afrika. Derfor kommer nogle af de nye landegrænser til at følge floder eller bjergkæder, der kan ses på kortene, mens europæerne andre gange vælge at følge kortets bredde- og længdegrader med linealførte linjer. Grænserne bliver med andre ord skabt uden hensyntagen til det afrikanske kontinents mange forskellige etniske grupper med forskellige sprog og kulturer - den samme etniske gruppe kan efter opdelingen nu være spredt ud over to eller tre forskellige nationalstater. ","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Shutterstock)","spans":[{"start":0,"end":32,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1700","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/0bcf8fc3141043ba7547b091eb3a51eacc08f4b2_berlin_conference_1884.jpg","alt":null,"copyright":null,"dimensions":{"width":690,"height":500}}],"information":[{"type":"paragraph","text":"I 1870’erne, bare ti år før Berlinkonferencen, er kun ti procent af det afrikanske kontinent under direkte europæisk kontrol, særligt i kraft af de handelsfirmaer, der allerede opererer på kontinentet specielt langs kysten i Vestafrika, hvor især guld, elfenben og slaver er eftertragtede handelsvarer. Fem år efter Berlintraktaten er underskrevet, har de europæiske stater gjort krav på næsten 90 procent af det afrikanske territorium.\nBillede: Wikimedia Commons","spans":[{"start":437,"end":463,"type":"em"}]}],"x_axis":"55","y_axis":"50","layer":20,"rotation":"2","background":"Shadow","width":"690","height":"500","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1700},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e66c125b3cb1d26f5426ea390050efec28c288aa_shutterstock_98776595.jpg","tall":{"dimensions":{"width":600,"height":575},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c45f5c3c5918132aaad7bbd80746f9a4aa4562fc_shutterstock_98776595.jpg"},"medium":{"dimensions":{"width":1024,"height":981},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e340fcd56929d845a9ab36a14f9e896013cc06f4_shutterstock_98776595.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Sydafrika bliver til","spans":[]},{"type":"paragraph","text":"Tilblivelsen af nutidens Sydafrika tager sin begyndelse i 1600-tallet. Her opretter hollandske handelsrejsende en forsyningsstation på søvejen mod Asien i det nuværende Cape Town på Afrikas sydlige spids. En del hollændere slår sig permanent ned i området og begynder en tilværelse som farmere ved hjælp af sorte slavers arbejdskraft. Efterkommere af hollandske migranter bliver i dag kaldt boere, det hollandske ord for bønder, og de taler afrikaans - en blanding af hollandsk og låneord fra afrikanske og asiatiske sprog.","spans":[{"start":391,"end":398,"type":"em"},{"start":421,"end":427,"type":"em"},{"start":441,"end":450,"type":"em"}]},{"type":"paragraph","text":"I 1806 erobrer Storbritannien store områder i Sydafrika, fordi landet ligger strategisk godt på handelsruten til Indien, hvor briterne driver stor forretning disse år. Da der ovenikøbet bliver fundet guld og diamanter i Sydafrika i perioden mellem år 1860 og 1880, bliver briternes interesse i området skærpet. Af samme grund står Sydafrika højt på Storbritanniens ønskeliste, da \"Kapløbet om Afrika\" sætter i gang. ","spans":[]},{"type":"paragraph","text":"Boerne og briterne udkæmper den ene krig efter den anden, med både hinanden og med andre etniske grupper i området, indtil år 1910, hvor Den Sydafrikanske Union - svarende til det, der i dag er kendt som Sydafrika - ser dagens lys. Med unionens dannelse opnår landet officielt uafhængighed fra Storbritannien under ledelse af et hvidt mindretal. Der går dog cirka 20 år, før selvstændigheden er en praktisk realitet. Og som den efterfølgende historie skal vise, så betyder landets selvstændighed på ingen måde frihed og lighed for alle dets indbyggere, især ikke den oprindelige sorte befolkning.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Guldgravere fra det britiske Republic Gold Mining Company fotograferet i 1888. Wikimedia Commons)","spans":[{"start":0,"end":116,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1260},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1114f68ec1393e0bd9fa27384bbd3774d88b6550_guldgravere.jpg","medium":{"dimensions":{"width":1024,"height":677},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8cc62a4850531aee2d7d72ad6dd618076dc36372_guldgravere.jpg"},"tall":{"dimensions":{"width":600,"height":397},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/723eb382a96c5f9724b1c874ee5373f5c1c2b8b1_guldgravere.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Afrikas brødkurv","spans":[]},{"type":"paragraph","text":"Ghana er det første land i Afrika syd for Sahara, der opnår selvstændighed i 1957, derefter tager afkoloniseringen af Afrika fart. Modstanden mod kolonimagten og de hvide minoritetsstyrer breder sig som en steppebrand ud over det afrikanske kontinent. Langt de fleste lande i Afrika opnår selvstændighed i 1960’erne, og Zimbabwe opnår også selvstændighed fra Storbritannien i 1965, men modsat andre afrikanske lande er det ikke den sorte afrikanske befolkning, der overtager styringen af landet. I Zimbabwe er det et hvidt mindretal ledet af premierminister Ian Smith, der erklærer landet, der dengang gik under navnet Rhodesia, for uafhængigt.","spans":[]},{"type":"paragraph","text":"Landet bliver kendt som Afrikas Brødkurv på resten af det afrikanske kontinent på grund af et enormt og meget veludviklet landbrug. Landet er rigt på naturressourcer og er længe en de mest udviklede økonomier i Afrika, selvom indkomst- og formuefordelingen er meget ulige fordelt mellem dets sorte og hvide indbyggere. På det her tidspunkt er det en sjældenhed, at et afrikansk land modtager særligt mange migranter, men mange valfarter til Rhodesia for at arbejde i minerne og på farmene. De kommer fra de afrikanske nabolande, men også fra Europa og Asien.","spans":[{"start":24,"end":41,"type":"em"}]},{"type":"paragraph","text":"Rhodesias premierminister Ian Smith viderefører den hårde apartheidlignende politik, der dominerede landet før afhængigheden. Den medfører blandt andet, at landets hvide indbyggere, der udgør mindre end én procent af befolkningen, kommer til at eje mere end 70 procent af landbrugsjorden. Utilfredsheden hos den sorte befolkning, der for en stor del er dømt til lavt lønnet og uendeligt slidsomt arbejde i plantager og miner, vokser støt. De vil også have del i kagen.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Tobaksplanter på en farm i Zimbabwe. Munya Chawora via Shutterstock)","spans":[{"start":0,"end":87,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/cffb41831df71a9fa688a3b544ac8641412f84fe_beskaaret1.png","alt":null,"copyright":null,"dimensions":{"width":250,"height":215}}],"information":[],"x_axis":"62","y_axis":"13","layer":30,"rotation":"10","background":null,"width":"250","height":"215","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/75ba408cf97ba02ee05e6606acab77e3433bab30_beskaaret2.png","alt":null,"copyright":null,"dimensions":{"width":260,"height":306}}],"information":[],"x_axis":"75","y_axis":"35","layer":40,"rotation":"10","background":null,"width":"260","height":"306","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/3a6ba5a8e729eede2a0e275c2747ea0b9517782c_beskaaret6.png","alt":null,"copyright":null,"dimensions":{"width":250,"height":215}}],"information":[],"x_axis":"72","y_axis":"25","layer":50,"rotation":"-5","background":null,"width":"250","height":"215","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/01eee151e09b94a27adba495c400e1d5eddd34c7_cecilrhodes.jpg","alt":null,"copyright":null,"dimensions":{"width":450,"height":580}}],"information":[{"type":"heading4","text":"Rhodesias navnefader","spans":[]},{"type":"paragraph","text":"Zimbabwes tidligere navn stammer fra Cecil Rhodes, der er premierminister i Capekolonien i Sydafrika fra 1890 til 1896. Han er også forretningspartner med Alfred Beit, der financierer den første bro over Limpopofloden. Sammen grundlægger de British South Africa Company i 1889 i håb om, at det vil kunne sætte gang i kolonialiseringen og den økonomiske udvikling i det sydcentrale Afrika, så de kan udnytte områdernes ressourcer og bygge en jernbane på tværs. ","spans":[{"start":241,"end":270,"type":"em"}]},{"type":"paragraph","text":"Rhodes får efter lang tids tovtrækkeri en mineaftale i stand med ndebelekongen, Lobengula af Matabeleland, et stort område i det nuværende, vestlige Zimbabwe, der er rig på metal og mineraler. Kongen er stædig og stoler ikke på de hvide mænd, og det skulle han heller ikke have gjort i dette tilfælde, for Rhodes overholder ikke sin del af aftalen. Da konsekvenserne af aftalen går op for Lobengula, forsøger han at trække den tilbage, men han bliver ignoreret af den britiske regering. Ndebelefolket og shonafolket, der også bliver berørt af de hvide mænds indtrængen i deres område, går derpå i krig mod British South Africa Company. Men deres våben kan ikke måle sig med de hvide mænds. Omkring 1000 indfødte ender med at blive dræbt, herunder Kong Lobengula. Det nyerhvervede land bliver opkaldt efter Cecil Rhodes og får navnet Rhodesia, der inkluderer det nuværende Zimbabwe (Sydrhodesia) og Zambia (Nordrhodesia).","spans":[{"start":606,"end":634,"type":"em"}]},{"type":"paragraph","text":"Storbritannien er i øvrigt meget interesseret i også at inkludere det nyerhvervede Zimbabwe, det daværende Sydrhodesia, i Den Sydafrikanske Union. Men det ønsker den hvide minoritet i Sydrhodesia ikke. Derfor eksisterer der i dag en grænse mellem Sydafrika og Zimbabwe.","spans":[]},{"type":"paragraph","text":"Foto: Wikimedia Commons","spans":[{"start":0,"end":23,"type":"em"}]}],"x_axis":"50","y_axis":"40","layer":15,"rotation":"-3","background":"Shadow","width":"450","height":"580","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/db40656be87c3be5018b4e34475520ff169a815c_shutterstock_1119230573.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/39d2e47ea90de8facb2fdf558c1a45e5a0e26546_shutterstock_1119230573.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d2b462345d1986c4f0a018fa45587c9cfc147b50_shutterstock_1119230573.jpg"}},"color_overlay":null,"color_opacity":null,"layer":10}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://www.youtube.com/watch?v=n2EvZ8cYcC8 ","type":"video","version":"1.0","title":"Sharpeville massacre was turning point in anti-apartheid movement","author_name":"CBS News","author_url":"https://www.youtube.com/user/CBSNewsOnline","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/n2EvZ8cYcC8/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/n2EvZ8cYcC8?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[],"x_axis":"10","y_axis":"50","layer":30,"rotation":null,"background":"Shadow","width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/9d4e92349560104e955ee278ab828b425cf753c9_blyanttesten-redigeret.png","alt":null,"copyright":null,"dimensions":{"width":341,"height":450}}],"information":[{"type":"paragraph","text":"Blyantstesten blev brugt under apartheid i Sydafrika for at bestemme, om et barn skulle vokse op som hvid eller farvet (blandet). Hvis dit hår havde en tekstur, der kunne holde en blyant, blev du kategoriseret som farvet. Hvis dit hår ikke kunne holde en blyant, blev du kategoriseret som hvid. ","spans":[{"start":0,"end":13,"type":"em"},{"start":294,"end":295,"type":"em"}]},{"type":"paragraph","text":"Illustration: Anne-Sofie Rudolph Christensen","spans":[{"start":0,"end":44,"type":"em"}]}],"x_axis":"10","y_axis":"10","layer":40,"rotation":"-10","background":"Shadow","width":"341","height":"450","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d9d01968b37e1fcbd6307a16280d473b18efc16b_redigeret.png","alt":null,"copyright":null,"dimensions":{"width":350,"height":330}}],"information":[{"type":"heading3","text":"Fakta om apartheid i Sydafrika","spans":[]},{"type":"paragraph","text":"Apartheid betyder ”adskillelse” på afrikaans. Apartheidstyret opdelte befolkningen i racer: Hvide, sorte, farvede og asiater. Den hvide minoritet i Sydafrika så sig selv som en højerestående race og sad på den politiske og økonomiske magt i landet. Især den sorte befolkningsgruppe blev voldsomt undertrykt under apartheidstyret, hvor den hvide minoritet benyttede alle midler såsom drab, tortur og vilkårlige fængslinger uden rettergang for at bibeholde magten. ","spans":[]},{"type":"paragraph","text":"Apartheidpolitikken bestod af fire lovkomplekser:","spans":[{"start":0,"end":49,"type":"strong"}]},{"type":"list-item","text":"Geografisk raceadskillelse: Befolkningen blev delt op i bestemte grupper efter hudfarve og race, og landet blev delt op i områder, som var forbeholdt de forskellige befolkningsgrupper. 87 % af Sydafrikas areal blev tildelt den hvide befolkning. Cirka tre millioner sorte blev tvangsforflyttet til særlige reservater, de såkaldte bantustans. ","spans":[{"start":0,"end":27,"type":"em"},{"start":329,"end":341,"type":"em"}]},{"type":"list-item","text":"Økonomisk raceadskillelse: Alle ikke-hvide arbejdere blev, i de fleste tilfælde, udelukket fra faglært arbejde og fra medlemskab af fagforeninger. ","spans":[{"start":0,"end":26,"type":"em"}]},{"type":"list-item","text":"Social raceadskillelse: Alle samfundsinstitutioner og alt samkvem mellem mennesker blev opdelt og reguleret efter race – lige fra ægteskab og seksuelle forhold til offentlig transport, undervisning og sportsarrangementer.","spans":[{"start":0,"end":23,"type":"em"}]},{"type":"list-item","text":"Politisk undertrykkelse: Den sorte befolknings politiske rettigheder gjaldt kun inden for bantustans, hvor kun nogle få udvalgte havde valgret. De sortes borgerretsorganisationer blev forbudt, og deres politiske ledere blev fængslet eller måtte gå i landflygtighed.","spans":[{"start":0,"end":24,"type":"em"}]}],"x_axis":"27","y_axis":"10","layer":30,"rotation":null,"background":null,"width":"350","height":"330","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Apartheid i Sydafrika","spans":[]},{"type":"paragraph","text":"Mens sorte zimbabwere arbejder i markerne og sår, gror og høster indholdet af Afrikas brødkurv, er apartheidpolitikken omkring 1960 blevet en levende og vidtrækkende realitet i Sydafrika. Sydafrika har opnået uafhængighed fra Storbritannien for mange år siden, men det er stadig hvide sydafrikanere, der dominerer landet økonomisk og politisk. Det hvide, nationalistiske parti National Party (NP) har siden 1948 siddet på magten. Raceadskillelsesideologien er blevet formuleret som en samlet politik kaldet apartheid, der består af 15.000 dekreter og 200 love. ","spans":[{"start":78,"end":94,"type":"em"},{"start":507,"end":517,"type":"em"}]},{"type":"paragraph","text":"Der er flere modstandsgrupper, der kæmper mod det hvide apartheidstyre i Sydafrika. Modstandskampen eskalerer i 1960 i en massakre, der får tilnavnet \"Sharpeville-massakren\", som er navnet på det område, hvor det hele finder sted. Befolkningen protesterer mod diskriminerende paslove, som er en måde, hvorpå det hvide apartheidstyre kontrollerer ikke-hvide borgeres bevægelsesfrihed i Sydafrika. Under demonstrationen skyder sikkerhedstyrkerne ind i den ubevæbnede folkemængde - 69 mennesker dør og 180 bliver sårede. Massakren udløser en landsdækkende strejke. Apartheidregimet svarer igen ved at forbyde de sortes førende modstandspartier og politisk valgdeltagelse for ’radikale’. Fra da af tager den ellers hovedsageligt fredelige protestbevægelse også voldelige midler i brug i deres modstandskamp. Blandt de 'radikale' finder vi Nelson Mandela, der senere bliver Sydafrikas første sorte præsident. Men først efter at have siddet fængslet i 27 år for sin medvirken i modstandskampen mod apartheidstyret.","spans":[]}],"information":[],"x_axis":"60","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1280","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1c8b876c387d2b166d8e2fcd0c97067db2fa5a7b_flikr-amy-barr.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/9127d611eebb3105f3e716e6ca1cbe71e3d205ab_flikr-amy-barr.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e159bd016cd6f99f9bc85e0b0fd4683b21d32798_flikr-amy-barr.jpg"}},"color_overlay":null,"color_opacity":null,"layer":10}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Zimbabwe bliver født \n- og grænsen til Sydafrika befæstet","spans":[]},{"type":"paragraph","text":"Også i Rhodesia fører den sorte befolknings modstand mod det hvide minoritetsstyre til arrestationer og fængslinger. Og også her er en senere præsident blandt frontkæmperne. Socialisten Robert Mugabe tilbringer årene 1964 til 1974 i fængsel på grund af sin deltagelse i modstandskampen. The Rhodesian Bush War hærger landet i 1970’erne. De sortes modstandspartier er vokset sig større, og mange hvide zimbabwere migrerer til Sydafrika i denne periode, fordi de forudser det kommende magtskifte og afskaffelsen af det apartheidlignende styre i Zimbabwe. Det bliver en realitet i 1980, hvor Robert Mugabe overtager magten i landet.","spans":[{"start":287,"end":309,"type":"em"}]},{"type":"paragraph","text":"På samme tid begynder der at ske noget på grænsen mellem Sydafrika og Zimbabwe. På den sydafrikanske side af grænsen, går mænd og kvinder rundt og lægger frø i jorden. Sisalfrø. Sisalplanten vokser hurtigt og kan blive meget høj. Stammen ligner en stor tyk ananas, og bladene bliver lange, tykke og kraftige. Men apartheidstyret i Sydafrika indser snart, at sisalplantehegnet ikke er nok til at holde modstandskræfterne ude af Sydafrika, så de udvider i stedet et elektrificeret hegn opsat på grænsen til Mozambique i 1975 og fører det videre ind i grænselandet mellem Zimbabwe og Sydafrika. Grænsehegnet, som de lokale døber\" Ildslangen\", fordi det udsender 3300 volt, har allerede taget mange liv på grænsen til Mozambique. Det er et tydeligt tegn på, at det hvide apartheidstyre i Sydafrika føler sig truet. - Flere og flere lande omkring Sydafrika opnår selvstændighed fra den hvide kolonimagt, men revolutionen skal ikke have lov at krydse den sydafrikanske grænse.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Pigtrådshegn på grænsen mellem Sydafrika og Zimbabwe. Antonius Lecuona via Dreamstime)","spans":[{"start":0,"end":105,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/a24a12f22acc72b33c6e7ed0a74681c69102bc3f_robert-mugabe-1982---wiki-commons.jpg","alt":null,"copyright":null,"dimensions":{"width":450,"height":600}}],"information":[{"type":"paragraph","text":"Zimbabwes første sorte præsident, Robert Mugabe, udvikler et af Afrikas mest effektive skole- og sundhedssystemer. Efter selvstændigheden bliver grundskolen tilgængelig for alle, sorte og hvide, og elevdeltagelsen bliver næsten fordoblet. Robert Mugabe bliver set som en frihedskæmper og vinder befolkningens anseelse for sin kamp mod de hvides dominans. Også internationalt høster Mugabe anerkendelse for sine visioner for uddannelse og sundhed, og han overtager en overvejende god økonomi takket være Zimbabwes indbringende landbrug, som især henter penge hjem på eksport af tobak og bomuld. Det er stadig hvide zimbabwere, der ejer majoriteten af landbrugsjorden. De bliver tolereret, så længer de forholder sig i ro og bidrager positivt til Zimbabwes økonomi. Mugabes popularitet falmer dog efterhånden som det viser sig, at heller ikke han går af vejen for korruption og brutale metoder for at bevare magten. ","spans":[]},{"type":"paragraph","text":"Foto: Wikimedia Commons","spans":[{"start":0,"end":23,"type":"em"}]}],"x_axis":"55","y_axis":"45","layer":20,"rotation":"4","background":"Shadow","width":"450","height":"600","speed":1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0633712a81cef93a032d8dbfd85598a8c9818eae_dreamstime_m_49043923.jpg","tall":{"dimensions":{"width":600,"height":389},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0d27f8714c2883492fa2b89be52adbdce9bafaa2_dreamstime_m_49043923.jpg"},"medium":{"dimensions":{"width":1024,"height":664},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/2234d4dfed6aa963c3d5dd337c68aa252dd7d555_dreamstime_m_49043923.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Fra apartheid til regnbuenation","spans":[]},{"type":"paragraph","text":"I slutningen af 1980’erne må apartheidstyret i Sydafrika kaste håndklædet i ringen under pres fra det internationale samfund. Styret er hårdt ramt af internationale økonomiske sanktioner og får problemer med at dække de store udgifter til politi og militær, som opretholder de uretfærdige love samt ro og orden. Frygten for et koordineret angreb fra den den del af befolkningen, apartheidsystemet undertrykker, tvinger styret til at gå ind på reformer. De priviligerede hvide er voldsomt i undertal, og det internationale samfund har endelig åbnet munden over for den racisme, apartheid er udtryk for. Der er ingen vej tilbage - det er tid til forandring i Sydafrika, og på mirakuløs vis sker overgangen til demokrati forholdsvist fredeligt. Et vigtigt skridt på vejen er løsladelsen af en mand, der i mange år var international kendt som terrorist, men senere blev et symbol på frihedskamp og fredelig sameksistens.","spans":[]},{"type":"paragraph","text":"I 1990 er sydafrikanere i alle farver samlet foran Victor Verster Prison i Sydafrika. Der er også mange journalister og fotografer fra hele verden til stede. Ud fra fængslet kommer en ældre mand i jakkesæt med sin kone ved sin side. Det er ham, de allesammen har ventet på. Tilskuerne jubler og pifter. Manden løfter en knyttet næve højt i vejret til stor begejstring for de forsamlede. Manden er Nelson Mandela, der er blevet løsladt efter 27 år i fængsel, og kvinden ved hans side hans kone Winnie Mandela. ","spans":[]},{"type":"paragraph","text":"Apartheid i Sydafrika bliver formelt afskaffet i 1991, hvor apartheidlovene bliver ophævet, men først reelt i 1994, da der bliver indført en ny forfatning i Sydafrika. Nelson Mandela bliver valgt som landets præsident under det første frie valg. Mandela vinder sammen med den tidligere præsident FW De Klerk Nobels Fredspris for deres indsats for fred og forsoning i Sydafrika. Det lykkes Mandela at dæmme op for en naturlig hævntrang blandt den store del af befolkningen, der i årtier blev undertrykt i et racistisk styresystem, med vidtløftig tale om Sydafrika som en \"regnbuenation\" med plads til alle. Her knap tre årtier senere står Sydafrika stadig som et mønstereksempel på et samfunds fredelige overgang til demokrati, men virkeligheden lader stadig meget tilbage at ønske i forhold til Mandelas vision.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Den nyudnævnte præsident, Nelson Mandela, til et event på Library of Congress i USA. Maureen Keating, Library of Congress) ","spans":[{"start":0,"end":142,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":459,"height":344,"embed_url":"https://www.youtube.com/watch?v=3hmUdYRsiMc","type":"video","version":"1.0","title":"Optimisme efter Nelson Mandelas løsladelse - 12. februar 1990","author_name":"DR Nyheder","author_url":"https://www.youtube.com/channel/UC8tSbn8Q4rnsSQPY-1kzXuw","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/3hmUdYRsiMc/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"459\" height=\"344\" src=\"https://www.youtube.com/embed/3hmUdYRsiMc?feature=oembed\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"}}],"information":[],"x_axis":"10","y_axis":"60","layer":20,"rotation":"0","background":"Shadow","width":"570","height":"320","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0c750de89e3fb722a4b4ea9835e9d80d609ba2c2_president-of-south-africa-nelson-mandela-with-members-of-the-congressional-black-caucus-including-representative-kweisi-mfume-at-an-event-at-the-library-of-congress.jpg","medium":{"dimensions":{"width":1024,"height":725},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/048343dfe5f0a503f034f4650c2cec461e7d83d1_president-of-south-africa-nelson-mandela-with-members-of-the-congressional-black-caucus-including-representative-kweisi-mfume-at-an-event-at-the-library-of-congress.jpg"},"tall":{"dimensions":{"width":600,"height":425},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/030e922113ce7526ac654e84efc11078923d5884_president-of-south-africa-nelson-mandela-with-members-of-the-congressional-black-caucus-including-representative-kweisi-mfume-at-an-event-at-the-library-of-congress.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Krise i Zimbabwe øger migrationen","spans":[]},{"type":"paragraph","text":"Mens Sydafrika bevæger sig ind i en ny æra uden apartheid, går det i 1990’erne ned ad bakke for Zimbabwe, der er på vej ud i en økonomisk krise. Således bliver Sydafrika en mere og mere attraktiv destination for sorte zimbabwere, der lider under stigende arbejdsløshed. I Sydafrika fører den stigende immigration fra Zimbabwe til en opfattelse af, at landet er ved at blive ”oversvømmet” af zimbabwere, hvilket fører til en skærpelse af visumreglerne i 1996. Samtidig stiger antallet af udokumenterede immigranter fra Zimbabwe til Sydafrika, fordi mange zimbabwere ikke kan leve op til de nye sydafrikanske visumregler og har svært ved at skaffe et zimbabwisk pas. ","spans":[]},{"type":"paragraph","text":"Migrationen fra Zimbabwe til Sydafrika er dog mestendels cirkulær - det vil sige, at zimbabwere rejser frem og tilbage over grænsen. Mange kvinder begynder at rejse til Sydafrika for at købe og sælge varer. Tidligere har zimbabwere og sydafrikanere ikke tænkt videre over, at der eksisterer en grænse mellem de to lande. Arbejdere, der bor tæt på grænsen, er tidligere taget derhen, hvor der har været arbejde, om det så har været i sydafrikanske miner eller på zimbabwiske farme.","spans":[]},{"type":"paragraph","text":"I starten af 1990’erne bliver det sydlige Afrika ramt af tørke. Tørken har så stor effekt på Zimbabwe, at der bliver erklæret national katastrofe i 1992. Regeringen må optage store lån for at importere majs og andre fødevarer til landet, og det bliver snart tydeligt, at Zimbabwe er ude i alvorlige økonomiske problemer. Robert Mugabe har brugt flere penge på skolesystem og sundhedssektor, end økonomien kunne bære, og der er ikke noget at stå imod med i denne krisetid.","spans":[]},{"type":"paragraph","text":"Den Internationale Valutafond (IMF) og Verdensbanken igangsætter et markedsøkonomisk reformprogram, der skal hjælpe Zimbabwe med at tilbagebetale de mange lån og få økonomien på ret kurs igen. Men befolkningen er allerede hårdt ramt som følge af arbejdsløshed. Derfor søger mange zimbabwere i 1990'erne til Sydafrika for at finde arbejde. Mange migranter ønsker at vende hjem igen, når Zimbabwes økonomiske og politiske situation forbedres. Men det kommer de til at vente længe på.","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Udtørret majsmark. Sarin Kunthong via Shutterstock)","spans":[{"start":0,"end":70,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/8c52f9c03b923c0b3e2482e5ef359068f21e8831_zimpas.png","alt":null,"copyright":null,"dimensions":{"width":398,"height":561}}],"information":[{"type":"heading3","text":"Fakta om visumregler for zimbabwere ","spans":[]},{"type":"paragraph","text":"Mange zimbabwere har måtte vente flere år på at få udstedt et pas, fordi ansøgningen skulle igennem et omfattende bureaukratisk system. Andre har ikke haft råd til at anskaffe sig et pas, fordi der er mange mellemmænd, der skal have betaling, før ansøgningen kommer videre i systemet. Derfor kommer mange zimbabwere til den sydafrikanske grænse i 1990’erne og 2000’erne med et akut rejsedokument som erstatning for et pas. De bliver imidlertid afvist ved grænsen til Sydafrika, selvom statsborgere i andre afrikanske lande med et lignende dokument bliver accepteret indrejse.","spans":[]},{"type":"paragraph","text":"Fra 1996 til 2009 skulle statsborgere i Zimbabwe (og Congo) også søge om visum til Sydafrika forud for deres rejse. Statsborgere i andre afrikanske lande kunne søge visum ved grænsen til Sydafrika. Zimbabwere skulle bl.a. opfylde følgende krav for at få visum til Sydafrika:","spans":[]},{"type":"list-item","text":"Fremvise bevis på, at man havde et overnatningssted i Sydafrika, der var bekræftet og betalt \neller\nFremvise et invitationsbrev fra en forretningspartner, ven eller slægtning der var statsborger i Sydafrika.","spans":[{"start":94,"end":100,"type":"em"}]},{"type":"list-item","text":"Fremvise kontoudtog eller rejsechecks for at bevise, at man var i stand til at forsørge sig selv, mens man opholdt sig i Sydafrika.","spans":[]},{"type":"list-item","text":"Medbringe et brev fra sin arbejdsgiver, der kunne bekræfte, at man havde lønarbejde i Zimbabwe, og at man ville vende tilbage efter at have færdiggjort sit arbejde i Sydafrika.","spans":[]},{"type":"list-item","text":"Arbejdsløse zimbabwere skulle bevise, at de var gift i Zimbabwe eller skulle fremvise en edsvoren erklæring fra en ægtefælle.","spans":[]},{"type":"paragraph","text":"I 2009 blev det muligt for zimbabwere at købe et 3-måneders turistvisum ved grænsen til Sydafrika, og i 2012 blev det muligt at rejse til Sydafrika i max 90 dage uden visum. Det er dog stadig påkrævet, at man skal være i besiddelse af et pas.","spans":[]},{"type":"paragraph","text":"I dag kan man rejse til 61 lande med et zimbabwisk pas - herunder Sydafrika, hvor man må opholde sig i 90 dage. Hvis man er i besiddelse af et dansk pas, kan man i dag rejse til 185 lande.","spans":[]}],"x_axis":"60","y_axis":"30","layer":30,"rotation":"5","background":null,"width":"398","height":"561","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/49e875c80bd4e265f080563063e74999abd329f7_shutterstock_125339342.jpg","tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e7a05bad21e0a6265b2215f6e176bb83ef34949a_shutterstock_125339342.jpg"},"medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/4b099f8c7ea5dfea5770015aeb8ccb6004769e38_shutterstock_125339342.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Zimbabwes fattigste og rigeste på flugt","spans":[]},{"type":"paragraph","text":"Harare ligger i det nordøstlige Zimbabwe og ligner på mange måder enhver anden storby. Høje bygninger med store glaspartier skyder op over byens tage. Tæt trafik bevæger sig ad asfalterede veje forbi travle forretningsdistrikter, shoppingområder og grønne oaser. Men hvis man bevæger sig en smule væk fra centrum, støder man på brune jordveje som sideveje til de asfalterede. Følger man en af disse jordveje, vil man pludselig befinde sig i et tætpakket område med små etværelses huse beklædt med bliktage. Over tagene hænger ureglementerede strømkabler som filtrede guirlander, og farvestrålende tøj blafrer i vinden på tørresnore spændt ud mellem husene. Langs jordvejen sælger gadehandlere grøntsager fra små hjemmebyggede boder, og en skarp lugt af urin og affald skærer gennem luften. Her er et af Harares slumkvarterer. ","spans":[]},{"type":"paragraph","text":"Slumkvartererne bliver opfattet som en skamplet på Harare. Derfor iværksætter regeringen i 2005 Operation Murambatsvina, der kan oversættes til ”ryd skidtet væk”.  Slumkvarterenes huse og forretninger er bygget på offentlig grund og uden tillladelse, og med den begrundelse retfærdiggør regeringen sin plan om at tvangsflytte store menneskemængder fra slumområderne til landet. Hvis de ikke har råd til at bo i byen, må de flytte, er tanken. Og planen bliver ført ud i livet. Regeringen rydder et af de største slumkvarterer til grunden med store maskiner. Omkring 700.000 mennesker mister deres hjem og eksistensgrundlag, og mange af dem vælger at migrere til Sydafrika og søge asyl der. Operation Murambatsvina er en af hovedårsagerne til at migrationen fra Zimbabwe til Sydafrika stiger voldsomt i 2000’erne. ","spans":[{"start":96,"end":119,"type":"em"}]},{"type":"paragraph","text":"Det er i samme årti, at angreb på hvide farmere begynder at tage til. De føres an af veteraner fra frihedskampen, der ikke længere vil finde sig i, at den hvide minoritet stadig ejer majoriteten af landbrugsjorden i Zimbabwe. Regeringen støtter krigsveteranernes aktioner, og omkring 4000 hvide storfarmere bliver tvunget til at forlade deres farme sammen med deres arbejdere, som hovedsageligt er sorte zimbabwere. Farmene bliver videregivet til sorte zimbabwere, der ikke har erfaring med at drive landbrug i så stor skala. Det fører til en enorme prisstigninger på landbrugsvarer og kæmpe fald i eksporten af tobak, som er en af Zimbabwes primære eksportvarer. Zimbabwes økonomi bryder sammen, og inflationen kommer ud af kontrol. Den zimbabwiske dollar kollapser og al handel forgår den dag i dag i amerikanske dollar, sydafrikanske rand og syv andre valutaer. I 2008 rammes Zimbabwe af decideret hungersnød. Zimbabwes dage som Afrikas brødkurv er definitivt forbi. ","spans":[]},{"type":"paragraph","text":"(Baggrundsfotografiet: Zimbabwes hovedstad Harares hovedgade. Ulrich Mueller via Shutterstock)","spans":[{"start":0,"end":94,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d53fae51d410ab2566a7f749fc6f3cfeb6b992f7_five-hundred-million-dollars.png","alt":null,"copyright":null,"dimensions":{"width":300,"height":154}}],"information":[],"x_axis":"15","y_axis":"20","layer":20,"rotation":"-10","background":null,"width":"300","height":"154","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/de80b937b5d19aaad1b710f6bb1724ef42443ebd_one-hundred-million-dollars.jpeg","alt":null,"copyright":null,"dimensions":{"width":300,"height":151}}],"information":[],"x_axis":"20","y_axis":"30","layer":25,"rotation":"5","background":null,"width":"300","height":"151","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/cc06ec09026f51499dca9ee651ec86324d28c287_one-hundred-trillion-dollars.png","alt":null,"copyright":null,"dimensions":{"width":300,"height":148}}],"information":[{"type":"paragraph","text":"Under Zimbabwes vilde inflation, så man pengesedler som disse - med astronomiske tal, men uden særlig værdi.","spans":[]}],"x_axis":"15","y_axis":"57","layer":40,"rotation":"-5","background":null,"width":"300","height":"148","speed":3},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/79b8f1386b061df0c18ed078925346e419ee40ab_ten-trillion-dollars.png","alt":null,"copyright":null,"dimensions":{"width":300,"height":157}}],"information":[],"x_axis":"20","y_axis":"40","layer":35,"rotation":"20","background":null,"width":"300","height":"157","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/5ee8f171b921bc6b506653863a51252db3e40eea_fifty-trillion-dollars.jpeg","alt":null,"copyright":null,"dimensions":{"width":300,"height":151}}],"information":[],"x_axis":"10","y_axis":"37","layer":40,"rotation":"7","background":null,"width":"300","height":"151","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c832adabdcfb67ca1d62c03c3aabd06606f7ebc6_shutterstock_153346895.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/3904f4c6d2f87ce5cd534fdffb525a6447bf0256_shutterstock_153346895.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/3cbd646ee51b3e2f9a456533d45765750cef5c99_shutterstock_153346895.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Plads til de fremmede i regnbuenationen?","spans":[]},{"type":"paragraph","text":"Den dag i dag er Sydafrika stadig præget af store sociale forskelle og fattigdom og hårdt plaget af kriminalitet. Sorte sydafrikanere dominerer statistikkernes negative tal og har generelt dårligere levevilkår, sundhedstilstand og økonomi end den hvide befolkning. Ligesom i Zimbabwe bor, også i Sydafrika, mange af de fattigste i trøstesløse slumkvarterer i udkanterne af de større byer. Og det er også her, de fleste migranter ender. ","spans":[]},{"type":"paragraph","text":"I 2008 udbryder voldsomme optøjer i slumområderne ved de sydafrikanske storbyer, Johannesburg og Cape Town. Sorte sydafrikanere angriber sorte afrikanske migranter, 62 mennesker bliver dræbt og flere hundrede såret, og migranters huse og butikker bliver brændt ned. Bestialske drabsmetoder, kendt fra apartheidtiden, bliver igen taget i brug. Men denne gang er det sorte afrikanere, der bruger dem mod andre sorte afrikanere. Angrebene bliver kaldt xenofobiske, altså fremmedfjendske, fordi der til grund for dem ligger en opfattelse af, at det er de fremmede, der er skyld i, at situationen for den fattigste del af befolkningen i Sydafrika ikke bliver bedre bedre: Migranterne sælger deres arbejdskraft billigt og stjæler alle jobs, og de åbner den ene forretning efter den anden og øger konkurrencen, lyder nogle af anklagerne. Migranterne bliver af mange sydafrikanere holdt ansvarlige for alt fra kriminalitet, over prostitution og stof- og alkoholmisbrug, til dødelige sygdomme. Fortællingen om alle de dårligdomme, migranterne bringer med sig, kæmper med visionen om Sydafrika som regnbuenationen med plads til alle. ","spans":[]},{"type":"paragraph","text":"I dag er det sydafrikanske militær sat på opgaven som grænsevagter ved Limpopofloden. De patruljerer både i biler og til fods langs grænsehegnet og spejder efter illegale migranter fra Zimbabwe, der har bevæget sig ind i grænselandet. Hvis de finder nogle migranter, der forsøger at krydse grænsen til fods uden pas, bliver de anholdt og deporteret tilbage til Zimbabwe, men den generelle holdning i den sydafrikanske befolkning er, at grænserne er porøse. Det er for nemt at krydse grænserne illegalt. Nogle hævder, at flere tusinde krydser grænsen illegalt hver dag - og det er ud over det store antal zimbabwere, der krydser grænsen lovligt. Den sydafrikanske regering har forsøgt at reparere grænsehegnet nogle steder, men det holder ikke zimbabwere fra at krydse grænsen. Nogle mener, at grænsevagterne er korrupte og tager imod bestikkelse for at lade zimbabwere krydse grænsen, andre sydafrikanere mener, at militæret skal bruge flere kræfter på at patruljere grænsen, og at det gamle apartheidhegn skal forstærkes og genopbygges. ","spans":[]},{"type":"paragraph","text":"Det er svært at sige præcis, hvor mange migranter, der bor i Sydafrika, fordi mange er udokumenterede, men det anslås, at det drejer sig om mellem 2-5 millioner, hvoraf omkring 75 procent er fra andre afrikanske lande. Majoriteten af de afrikanske migranter regnes for at være fra Zimbabwe. Det er blevet nemmere for zimbabwere at rejse lovligt til Sydafrika i dag, men der er stadig mange, der krydser grænsen ulovligt hver dag. Afhængig af situationen i Zimbabwe har det været muligt for zimbabwere at søge asyl i Sydafrika, selvom det er meget få, der har haft succes med at opnå status som flygtning. Zimbabwere har nemlig ikke status som flygtninge ifølge internationale definitioner, men bliver i højere grad defineret som økonomiske migranter. Mange tusinde zimbabwere bliver hvert år pågrebet i Sydafrika uden den nødvendige dokumentation og deporteret tilbage til Zimbabwe. ","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: En moddemonstration som reaktion på endnu en opblusning af xenofobiske angreb i 2015. GovernmentZA via Flickr)","spans":[{"start":0,"end":129,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":null,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://www.youtube.com/watch?v=sksbw4l-EkY","type":"video","version":"1.0","title":"Pritz om xenofobi: \"Den lever på frygt\"","author_name":"MUNDU - center for global dannelse","author_url":"https://www.youtube.com/channel/UCtIG8KdCs8l0RdohvgZ-oZQ","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/sksbw4l-EkY/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/sksbw4l-EkY?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[],"x_axis":"60","y_axis":"65","layer":10,"rotation":"0","background":"Shadow","width":"570","height":"320","speed":null},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/229a27cbe0a5b5e7f3c1104636b5d82881e5b46c_wizard-data-1.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":280}}],"information":[{"type":"paragraph","text":"Kilde: Statistics South Africa, flere rapporter.","spans":[{"start":0,"end":48,"type":"em"}]}],"x_axis":"50","y_axis":"40","layer":20,"rotation":"-3","background":"Shadow","width":"500","height":"280","speed":3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/909eb0a35f3e661b03cba405e0b9facf42d4dd66_antixenofobidemo.jpg","medium":{"dimensions":{"width":1024,"height":715},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e938ab367a743e9652b489d2d3f62034e08868da_antixenofobidemo.jpg"},"tall":{"dimensions":{"width":600,"height":419},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/93362802e1901fe6cd01d729bc23099eba79998a_antixenofobidemo.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Vimbais historie","spans":[]},{"type":"paragraph","text":"Det mest travle sted i den sydafrikanske grænseby Musina er uden for Indenrigsministeriets bygning, som huser Musina Flygtningemodtagelseskontor. Her finder man en stor, summende menneskemængde bestående af zimbabweske mænd, kvinder og børn. Og her er Vimbai. Hun står i kø for at søge om asyl i Sydafrika. Dagen efter befinder hun sig på et kvindehjem i byen, hvor hun venter på, at hendes asylansøgning bliver behandlet. Vimbai kan se, hvilke af de andre kvinder, der har krydset grænsen for første gang - chokket står malet i deres ansigter. Vimbai selv har - efter tre års behandlingstid og mange betalinger - endelig fået et pas, som giver hende adgang til at opholde sig i Sydafrika i 90 dage af gangen. Nu behøver hun ikke længere tage den risikable rute over grænsen på illegal vis, men hun er træt af den udmattende og ikke særligt indbringende grænsehandel. Vimbai ønsker at blive i Sydafrika og finde et mere permanent job, der kan give hende og den familie, hun forsørger, en større økonomisk sikkerhed. ","spans":[]},{"type":"paragraph","text":"I september 2010 åbnede Sydafrika muligheden for, at zimbabwere, der opholdt sig ulovligt i Sydafrika, kunne få ændret deres status til lovlige migranter. Hvis man havde boet i Sydafrika en vis periode, havde et gyldigt zimbabwisk pas og kunne bevise, at man havde fast arbejde i Sydafrika, kunne man få en 4-årig arbejdstilladelse. Der blev givet en deadline til udgangen af 2010, hvorefter deporteringerne af illegale zimbabweske migranter blev genoptaget. Vimbai nåede lige nøjagtigt ikke at ansøge - hendes pas kom for sent. Derfor forsøger hun sig nu med en asylansøgning i stedet. Hvis vi skal tro statistikkerne, er chancen for, at Vimbais ansøgning går igennem meget lille. Men Vimbai lytter ikke til statistikker. Vimbai holder fast i håbet. Hun har ikke meget andet.","spans":[]},{"type":"paragraph","text":"Vimbais historie bygger på en virkelig historie, der er beskrevet i en længere afhandling om migranter i grænselandet mellem Sydafrika og Zimbabwe.","spans":[{"start":0,"end":147,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsbillede: IOM uddeler fornødenheder til flygtninge og asylansøgere ved Musina Flygtningemodtagelseskontor. IOM South Africa via Flickr. Find de samlede kilder til denne case HER.)","spans":[{"start":183,"end":186,"type":"hyperlink","data":{"link_type":"Media","name":"samledekilder_cases.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F29ed7b98-6b74-4cce-a782-5cef41ce9a74_samledekilder_cases.pdf","size":"6488599"}}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5fd60d90d8937f9e880a4d12ad97b4e7bc427b01_iom_musina.jpg","tall":{"dimensions":{"width":600,"height":399},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/26ce478a8330d4475a73dbafc8de518fef115023_iom_musina.jpg"},"medium":{"dimensions":{"width":1024,"height":680},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0cf5bb6f8742b1319d208093227df94c11409de0_iom_musina.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}}],"meta_title":"Sydafrika og Zimbabwe","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag den befæstede grænse mellem Sydafrika og Zimbabwe og møde Vimbai - en af de mange migranter, der har krydset den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/818096c10b3c05f32559e4cae99e8ae8ea27bc9d_beitbridge.jpg"},"hide_for_google":"false","navigation":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false},"home_link":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false}}}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WzIEZiwAALZhZA0K","type":"case","uid":"usa-og-mexico","url":"/cases/usa-og-mexico","published":"2019-02-05T09:40:22+0000","lang":"da-dk","meta_title":"USA og Mexico","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag den befæstede grænse mellem USA og Mexico og møde Helena - en af de mange migranter, der har krydset den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/9ab3f358ebb39db00edcf6b587e34af9220388d0_border_usa_mexico.tijuana.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"USA og Mexico","spans":[]}],"url":"/cases/usa-og-mexico","body":[{"slice_type":"section","slice_label":null,"items":[],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1320},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/371915c7e502f4b1481e2ed4a1a4893af4296655_border_usa_mexico.tijuana.jpg","medium":{"dimensions":{"width":1024,"height":704},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/0f613cf8f45bb3b9f9f0011ca6dd7e57a297f9a3_border_usa_mexico.tijuana.jpg"},"tall":{"dimensions":{"width":600,"height":413},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c4290debea34e652f6a72e3da98a1710999b1eef_border_usa_mexico.tijuana.jpg"}},"color_overlay":"#000000","color_opacity":"0.35","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Helenas historie","spans":[]},{"type":"paragraph","text":"Det er 9 timer siden, at den højeste af de to coyotes - ham med de ru hænder og de udtryksløse øjne - gennede Helena ned under gulvbelægningen i den ombyggede ladvogn med en ordre om at holde mund og ligge stille. Helena fryser, og hun kan se frygten i øjnene på den yngre kvinde, hvis ansigt ligger kun få centimeter fra hendes eget. De har klaret det hertil. Helena forsøger at tænke positive tanker og holde fast i et forestillet billede af Juán, der smilende står og tager imod hende i en klassisk amerikansk forstad med solbrændt hud og smart, nyt tøj.  ","spans":[]},{"type":"paragraph","text":"Det var Juán, der havde fået kontakt til coyoterne gennem en kollega på byggepladsen. Coyoterne havde ry for at være de bedste, og de benyttede en ny rute gennem ørkenen og gennem en underjordisk tunnel, hvor grænsepolitiet endnu ikke havde fået færden af dem. ","spans":[]},{"type":"paragraph","text":"Pludselig var det hele gået meget hurtigt. Helena tog afsked med sin mor, far og sine tre søskende, der også boede i den lille lejlighed i Tijuana. Hendes far, der altid så træt ud efter de lange nattevagter, gav hende et bekymret farvelknus. Men han vidste lige så godt som hende, at USA var den bedste mulighed for at sikre familien en mere tålelig tilværelse. Selvom Juán sendte penge hjem så ofte, han kunne, og selvom alle i familien knoklede, var der aldrig penge nok. Helena havde været bange. Hun vidste lige så godt som sin bekymrede far, at det var en farefuld rejse, hun skulle ud på. ","spans":[]},{"type":"paragraph","text":"Helena ligger nu i ladvognen på den sidste strækning før sit mål. Den mad, hun havde pakket til turen, slap op for to dage siden. Hendes ben føles uendelig tunge efter fem dages vandring gennem ørkenen, og hun er helt tør i munden efter alt for lang tid uden vand. Men adrenalinen og håbet, der fylder hele hendes krop, holder hende i gang. Hun ved, at hun har været heldig. Heldig fordi Juán havde sparet nok op til at betale coyoterne de 3000$, de forlangte. Heldig fordi en af de andre migranter havde delt sit varme tæppe med hende, da nattefrosten slog hårdest i ørkenen. Heldig fordi patruljebilens lygter ikke var trængt igennem det buskads, de gemte sig bagved, da de var tættest ved grænsen. Og heldig fordi hun om kort tid skal gense sin elskede mand efter flere års adskillelse. ","spans":[]},{"type":"paragraph","text":"(Baggrundsfotografiet: Anthony Albright via Flickr)","spans":[{"start":0,"end":51,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/ab0c95f6a139da0b2cd3915242ff2a7e1c9db1a3_sloer.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":1282}}],"information":[],"x_axis":"0","y_axis":"0","layer":10,"rotation":null,"background":null,"width":"1920","height":"1282","speed":-1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1282},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b1a1ba0d925519e008b81dd8f2c111c7b6bbb3cf_us-border-anthony-albright-via-flickr.jpg","medium":{"dimensions":{"width":1024,"height":684},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/4da708af730be9a24c415678a3a5d0f619c51ee5_us-border-anthony-albright-via-flickr.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d7738ecc765d6a5c6a20c23c3c77bce3c44bb21d_us-border-anthony-albright-via-flickr.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Grænsen mellem USA og Mexico ","spans":[]},{"type":"paragraph","text":"Der har boet mennesker i Mellem- og Nordamerika i årtusinder, og i lige så lang tid har de bevæget sig over den skiftende grænse mellem de to områder - helt fra de tidlige mesoamerikanske samfund i Mexico og Mellemamerika, til bosætterne under den spanske krone i 1500-tallet og frem til nutidens migranter, der hver dag krydser grænsen. I dag strækker grænsen mellem Mexico og USA sig 3.245 kilometer fra den Mexicanske Golf i øst, bruser gennem Rio Grande mod vest, skærer gennem forskelligt terræn for til sidst at ende i Stillehavet syd for San Diego. Der er opsat forskellige grænsehegn, der varierer i art og kvalitet, på cirka 1.100 kilometer af strækningen, og derudover er der 48 grænseposter, hvor man efter inspektion kan få lov til at krydse grænsen. Det er verdens travleste grænse, og over 300 millioner mennesker krydser den hvert år. ","spans":[]},{"type":"paragraph","text":"På den amerikanske side er det staterne Californien, Arizona, New Mexico og Texas, der ligger op ad grænsen, mens det på den mexicanske side er staterne Baja California, Sonora, Chihuahua, Coahuila, Nuevo León og Tamaulipas. Grænseområdet er både præget af stor kulturel og social diversitet og af en gensidig afhængighed.","spans":[]},{"type":"paragraph","text":"Selvom migration på tværs af grænsen ikke er et nyt fænomen, er det først i det 20. århundrede - og særligt i de seneste 50 år - at antallet af mennesker, der krydser grænsen, for alvor er begyndt at stige.","spans":[]},{"type":"paragraph","text":"(Baggrundsfotoet: US Federal Government)","spans":[{"start":0,"end":40,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1198","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/43c63787e55a9487462e7dc6a7776f026445702a_usa_mexico_endeligfoerstelag.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":1198}}],"information":[],"x_axis":"-1","y_axis":"0","layer":10,"rotation":null,"background":null,"width":"1920","height":"1198","speed":-1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1198},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d0e8141d982bfdb1372272dbc75be46bb78b7345_usa_mexico_endeligbaggrund.jpg","medium":{"dimensions":{"width":1024,"height":639},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/54afa1593f9853be3354a5bf9df31c34cf91b8d4_usa_mexico_endeligbaggrund.jpg"},"tall":{"dimensions":{"width":600,"height":374},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/bc38eda2f75045533b5e30b7d022dfd2fed2d7b1_usa_mexico_endeligbaggrund.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Grænsen bliver konstitueret","spans":[]},{"type":"paragraph","text":"Fredsforhandleren Nicholas P. Trist står på denne blæsende vinterdag i 1847 overfor karrieres sværeste valg. Han har netop modtaget et notat fra hans overordnede, USA’s præsident James Polk, med besked om, at han skal vende tilbage til Washington. Men Trist har ikke fuldendt sin mission i Mexico: At få underskrevet en fredstraktat mellem de to lande efter snart to års krig. Den mexicanske kommission venter på ham i forhandlingslokalerne, og Trist føler sig tvunget til at vælge mellem at adlyde sin chef eller følge sin egen mavefornemmelse og få afsluttet forhandlingerne. Velvidende at beslutningen vil være altødelæggende for hans ellers så flotte karriere, retter Trist ryggen, går mexicanerne i møde og sætter derefter efter flere måneders svære forhandlinger sit navn på en fredstraktat, der officielt afslutter den Mexicansk-amerikanske krig og konstituerer en ny grænse mellem de to lande.","spans":[]},{"type":"paragraph","text":"Det er uenigheder om grænselandet ved Texas, der to år tidligere har ført til, at den amerikanske kongres har erklæret krig mod Mexico. Efter et afgørende nederlag i Mexico City, overgiver Mexico sig. Fredsforhandlingerne munder ud i en aftale, hvor Mexico på den ene side vinder fred og en kompensation fra USA på 15 millioner dollars, men samtidig må Mexico afgive næsten halvdelen af sit territorium. Den nye grænsen følger nu Rio Grande (ved Texas), og på denne måde vinder USA det landområde, der i dag inkluderer bl.a. Texas, Arizona, New Mexico og dele af Utah, Californien, Wyoming, Colorado og Nevada. Udover den økonomiske kompensation lover USA samtidig at beskytte de bosiddende mexicaneres rettigheder og ejendom. På trods af dette løfte vælger mange mexicanere efterfølgende at forlade det nye amerikanske territorium, da de pludselig har status som migranter uden at have bevæget sig.","spans":[]},{"type":"paragraph","text":"(Baggrundsmaleriet bærer titlen \"The Battle of Chapultepec\"/\"Storming of Chapultepec\" og er malet af James Walker i år 1857)","spans":[{"start":0,"end":124,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/24fb712a5491553384bd8cd81a71d981f4c8747e_nicholas_philip_trist.jpg","alt":null,"copyright":null,"dimensions":{"width":326,"height":400}}],"information":[{"type":"paragraph","text":"Et fotografi af Nicholas P. Trist, der er dateret til perioden 1855 og 1865\nKilde: Library of Congress Prints and Photographs Division. Brady-Handy Photograph Collection","spans":[{"start":76,"end":169,"type":"em"}]}],"x_axis":"60","y_axis":"15","layer":9,"rotation":"-5","background":"Shadow","width":"326","height":"400","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/1516e3a89f0ea39ef9c6cbe166d2f368347b008a_treaty-of-guadalupe.jpg","alt":null,"copyright":null,"dimensions":{"width":440,"height":700}}],"information":[{"type":"paragraph","text":"Her ses den sidste side af den originale Treaty of Guadalupe Hidalgo med underskrifterne og segl.\nKilde: Hispanic Reading Room, Library of Congress","spans":[{"start":98,"end":147,"type":"em"}]}],"x_axis":"69","y_axis":"15","layer":7,"rotation":"10","background":"Shadow","width":"440","height":"700","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/897f914082a341648225bde43c556de95e3f64a7_mexicoborderoldmapnewversion.png","alt":null,"copyright":null,"dimensions":{"width":400,"height":265}}],"information":[{"type":"paragraph","text":"Kortet viser det territorium som Mexico afgav til USA med traktaten af Guadalupe Hidalgo, der afsluttede den mexicansk-amerikanske krig (1846-1848). Det tabte land udgjorde en tredjedel af Mexicos samlede territorium. \nFotokredit: Wikimedia Commons, Kballen","spans":[{"start":219,"end":257,"type":"em"}]}],"x_axis":"50","y_axis":"40","layer":8,"rotation":null,"background":null,"width":"400","height":"265","speed":-2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7a28cf27cda662e6fce12b0db63e4a7a861b280c_mexico-1847.jpg","medium":{"dimensions":{"width":1024,"height":730},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/19342985ccab90ee0b625e89903eb16d4bb6eb50_mexico-1847.jpg"},"tall":{"dimensions":{"width":600,"height":428},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/91c94739a9333ca1365bcbdefb3f489960254e6f_mexico-1847.jpg"}},"color_overlay":null,"color_opacity":null,"layer":51}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Den Mexicanske Revolution og den første store migration mod nord","spans":[]},{"type":"paragraph","text":"Den 16-årige José de la Cruz Porfirio Díaz Mori har netop meldt sig ind i militæret. Han vil beskytte Mexico mod amerikanerne, og han har store drømme og visioner for sit land. Mexico skal være stærkt, moderne og rigt. Her i 1846 ved han ikke, at han både kommer til at opleve at blive politiker, præsident, diktator, og være skyld i en lang og blodig borgerkrig i hans elskede Mexico. ","spans":[]},{"type":"paragraph","text":"På trods af Díazs intentioner om at modernisere og udvikle Mexico, slutter hans drømme og hans 30 år lange præsidentperiode i 1910, da en voksende uro i befolkningen ender ud i en borgerkrig. Díazs udprægede favorisering af de rige og privilegerede mexicanere har ført til en voksende utilfredshed. Efter et valg der er præget af snyd, bliver Díaz tvunget til at forlade både præsidentposten og sit fædreland. Den blodige revolution varer i et årti og resulterer i afslutningen på et 30-års diktatur. Revolutionen bliver anset for at være et af det 20. århundredes første og vigtigste politiske, sociale og kulturelle oprør. Det bliver et årti med tumult og kampe mellem forskellige fraktioner og alliancer. Borgerkrigen mærkes ikke kun internt i Mexico men også i nabolandene og særligt i USA, hvor et stort antal mexicanere søger fred, arbejde og beskyttelse. ","spans":[]},{"type":"paragraph","text":"Under hele revolutionen er Mexico præget af stor usikkerhed og politisk uro. Mange mexicanere ser ingen anden udvej end at forlade deres hjemland. I samme periode kommer der færre europæiske arbejdsimmigranter til USA, og der er mangel på arbejdskraft i landet. Mexicanerne tager det arbejde, de kan finde – ofte hårdt og dårligt betalt - og de mexicanske arbejdere bliver derfor eftertragtede blandt de amerikanske arbejdsgivere. ","spans":[]},{"type":"paragraph","text":"På 20 år krydser cirka 1,5 millioner mexicanere grænsen mod nord og bosætter sig i USA. De fleste af migranterne vender dog hjem til Mexico igen, da situationen bliver mere stabil i hjemlandet. Samtidig bevæger USA sig ind i ”The Great Depression” – Den Store Depression.  Befolkningstilvæksten stiger derfor kun meget lidt i USA i denne periode. ","spans":[]},{"type":"paragraph","text":"(På baggrundsfotografiet, der er taget omkring år 1911, kan man se en gruppe mexicanske oprørere med en hjemmelavet kanon. Fotograf: Ukendt. Kilde: U.S. Library of Congress - Prints & Photographs Online Catalog)","spans":[{"start":0,"end":211,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1200","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/571f062a917fdfa2fbddcecf3d964cc86de9657e_jose-de-la-cruz-porfirio-diaz-mori1-.jpg","alt":null,"copyright":null,"dimensions":{"width":255,"height":400}}],"information":[{"type":"paragraph","text":"Et fotografi af José de la Cruz Porfirio Díaz Mori fra 1860'erne. \nFotograf: Ukendt. ","spans":[{"start":67,"end":85,"type":"em"}]},{"type":"paragraph","text":"Kilde: \"Enrique Krauze y Fausto Zerón-Medina, Porfirio. La guerra (1854-1867), tomo 2\", México, Editorial Clío, 1993)","spans":[{"start":0,"end":117,"type":"em"}]}],"x_axis":"10","y_axis":"60","layer":10,"rotation":"-5","background":"Shadow","width":"255","height":"400","speed":1},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/d86a7bcc92237f718da98cf450461571b69b60f1_mexican_revolution_50.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":319}}],"information":[{"type":"paragraph","text":"Fotografiet her er taget på et tidspunkt i perioden 1910-1917 af en ukendt fotograf.\nKilde: Beinecke Rare Book & Manuscript Library, Yale University ","spans":[{"start":85,"end":149,"type":"em"}]}],"x_axis":"20","y_axis":"60","layer":null,"rotation":"5","background":"Shadow","width":"500","height":"319","speed":-1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1200},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b5414e457d953b5366c656baa67a1d47a1a39ac0_mexican-revolution-.jpg","tall":{"dimensions":{"width":600,"height":476},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/66c845d3c672bd0452699ed9aba5078c75e59ee1_mexican-revolution-.jpg"},"medium":{"dimensions":{"width":1024,"height":812},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/1477130f419b1b253df9fc550913d9d0db6c1abd_mexican-revolution-.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Den Store Depression ","spans":[]},{"type":"paragraph","text":"Klokken er lidt over 10 den 29. oktober 1929. Panikken på børsen på Wall Street er taget til de seneste par dage men kulminerer i dette øjeblik, i takt med at aktiekurserne styrtdykker. Skrig og skrål: ”Køb!” ”Sælg!” Fuldvoksne mænd der river sig i håret, nogle der beder til gud, og andre der græder uhæmmet. Børslokalet er med ét forvandlet til et kaos af frustration og ulykke.","spans":[]},{"type":"paragraph","text":"Børskrakket på Wall Street markerer begyndelse på den største økonomiske krise den industrialiserede verden endnu har oplevet. Krisen bringer USA’s økonomi i knæ og fører til udbredt arbejdsløshed. Da krisen er på sit højeste, er over 15 millioner amerikanere arbejdsløse, og over halvdelen af landets banker er gået konkurs. Krisen rammer alle dele af det amerikanske samfund, men særligt de mennesker, der i forvejen lever under de sværeste kår, må kæmpe for deres egen overlevelse.","spans":[]},{"type":"paragraph","text":"Amerikanernes forhold til migranter, særligt de mexicanske, har fra starten været ambivalent. På den ene side bidrager mexicanerne med billig arbejdskraft, men på den anden side bliver de stadig set som fremmede, og de har hverken de samme rettigheder eller får samme anerkendelse som de amerikanske statsborgere. Da depressionen lammer industrien i USA, er de første, der mister deres arbejde, også de mexicanske migranter. På samme tid vokser modstanden og fjendtligheden mod mexicanerne, og mange bliver deporteret, mens andre vender tilbage til Mexico som følge af de problematiske forhold i USA. I 1930’erne falder det mexicanske indbyggertal i USA, og der er for første gang større migration fra nord til syd. Der er dog nogle mexicanere, der vælger at blive i USA. De organiserer sig i fagforeninger, strejker og kæmper for bedre arbejdsvilkår. Den fælles kamp for forbedrede forhold og lige rettigheder samler mexicanerne og puster liv i en anderledes oplevelse af tilhørsforhold og national identitet.","spans":[]},{"type":"paragraph","text":"Depressionen begynder først langsomt at slippe sit greb om USA i midten af 1930’erne, og det er først for alvor med USA’s deltagelse i Anden Verdenskrig, at der kommer skub i industrien.\n\n(Baggrundsfotoet: Aktiehandlere i New York Stock Exchange, år 1936. Kilde: Shutterstock).","spans":[{"start":188,"end":277,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren%2Fa53eb4f5-edfb-4b1c-b6dc-b06c6a3ea137_great+depression.gif","alt":null,"copyright":null,"dimensions":{"width":600,"height":472}}],"information":[{"type":"paragraph","text":"Fotografiet her er fra juni år 1936 og er taget i et supperkøkken i USA under Den Store Depression.","spans":[]},{"type":"paragraph","text":"Kilde: U.S. National Archives and Records Administration","spans":[{"start":0,"end":56,"type":"em"}]}],"x_axis":"65","y_axis":"15","layer":20,"rotation":"8","background":"Shadow","width":"400","height":"200","speed":-2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren%2F6df4cf06-f846-4bb8-bb7d-35e4dd1c3682_great+depression+1935.gif","alt":null,"copyright":null,"dimensions":{"width":600,"height":447}}],"information":[{"type":"paragraph","text":"En mand sover på havnen i New York under Den Store Depression","spans":[]},{"type":"paragraph","text":"Fotograf: Lewis W. Hine. Kilde: Franklin D. Roosevelt Presidential Library and Museum ","spans":[{"start":0,"end":86,"type":"em"}]}],"x_axis":"50","y_axis":"50","layer":30,"rotation":"-10","background":"Shadow","width":"400","height":"200","speed":2},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/ca70874c794f1bb2829e87b38d3f1fe48e9c5214_den_store_depression3.png","alt":null,"copyright":null,"dimensions":{"width":500,"height":405}}],"information":[{"type":"paragraph","text":"På fotografiet ser man en lang kø af arbejdsløse mænd uden for et suppekøkken i Chicago under Den Store Depression\nKilde: Shutterstock","spans":[{"start":115,"end":134,"type":"em"}]}],"x_axis":"60","y_axis":"75","layer":40,"rotation":"10","background":null,"width":"400","height":"200","speed":1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/97847891e2b44f6467f196b17bfc100bbc0e578d_wall-street.jpg","tall":{"dimensions":{"width":600,"height":490},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e40c939b4b333f321b44978e5866a5711b914bbe_wall-street.jpg"},"medium":{"dimensions":{"width":1024,"height":836},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/6c1b29e92cca6943d4a83fa99adbe187056e8e5e_wall-street.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Bracero-aftalen og den anden store migration til USA    ","spans":[]},{"type":"paragraph","text":"Flygtning, indvandrer, migrant, udlænding, fremmed – kært barn har mange navne. I perioden fra 1940’erne til 1960’erne er den mest anvendte betegnelse for de mexicanere, der kommer til USA for at arbejde \"braceros\". Brazos er det spanske ord for arme, og man kan derfor oversætte braceros til ”dem som arbejder med armene”. Vendingen dækker med andre ord over, at de mange mexicanere, der kommer til USA som gæstearbejdere her efter Anden Verdenskrig, primært påtager sig hårdt manuelt arbejde – altså arbejde med hænderne/armene. ","spans":[{"start":213,"end":222,"type":"em"},{"start":280,"end":288,"type":"em"}]},{"type":"paragraph","text":"USA’s engagement i Anden Verdenskrig betyder, at en stor del af den amerikanske arbejdsstyrke må tage afsted som soldater. Det fører til en mangel på arbejdskraft – særligt i landbrugssektoren. USA indgår derfor en gæstearbejderaftale med Mexico i 1942 – den såkaldte Bracero-aftale. Aftalen giver mexicanere mulighed for at komme til USA på lovlig vis og arbejde, og i begyndelsen bliver de mexicanske arbejdere desuden lovet særligt attraktive arbejdsvilkår, et garanteret minimumlån, arbejdsbolig og gratis måltider. ","spans":[]},{"type":"paragraph","text":"I samme periode oplever Mexico en tid med vækst og fremgang. Den mexicanske revolution har været altoverskyggende i flere årtier, men nu bliver der endelig sat skub i økonomien og industrien. Mexico bevæger sig i de følgende årtier fra primært at være et landbrugsland til at blive semiindustrialiseret. Mexicos nye velstand er dog ulige fordelt – de rige bliver rigere, mens de fattige, der hovedsageligt bor i landområderne, bliver ved med at være fattige. Forskellen mellem rig og fattig fører til sociale og politiske spændinger i den mexicanske befolkning. Selvom den mexicanske regering stadig støtter landbrugssektoren, bliver der færre og færre jobs at få i landbruget. I 1950 er 60 % af dem mexicanske befolkning beskæftiget i landbrugssektoren. Tallet er faldet til 35 % i 1975. I samme periode bliver indbyggertallet i Mexico mere end fordoblet. Selvom økonomien og industrien er i vækst i Mexico, kan arbejdsmarkedet ikke skabe nok jobs til den voksende arbejdsstyrke. Det fører til, at mange mexicanere igen søger mod USA i jagten på arbejde. ","spans":[]},{"type":"paragraph","text":"Bracero-aftalen er tænkt som en midlertidig aftale, der skal afhjælpe krigstidens mangel på arbejdskraft i USA, men den viser sig at være meget indbringende for amerikanske landmænd. Bracero-programmet kører derfor indtil 1964. Under programmets levetid kommer over 4,6 millioner mexicanere til USA på legale arbejdskontrakter. Programmet medfører dog også utilsigtede konsekvenser for de lokale amerikanske arbejdere. Mindstelønnen bliver mindre og mindre, amerikanske arbejdere bliver fyret og de generelle arbejdsvilkår bliver dårligere. Selve Bracero-programmet bliver også senere kritiseret for at udnytte mexicanske arbejdere, dårlige arbejdsvilkår og for lav løn. ","spans":[]},{"type":"paragraph","text":"Mens Braceros bliver kaldenavnet for de mexicanske arbejdere, der anskaffer sig arbejdsvisum til USA på lovlig vis, vinder et andet navn også frem i perioden: \"Mojados\" - de våde. Da der bliver ved med at mangle arbejdere i USA, er der nemlig også et stort antal mexicanere, der rejser illegalt til USA, og for dem går den udokumenterede vej til USA oftest går gennem floden Rio Grande - med våde fødder til følge. Øgenavnet Mojados inspirerer senere navnet på deportationen af to millioner udokumenterede mexicanske migranter - Operation Wetback. Deportationen sker som følge af en spirende bekymring i den amerikanske befolkning for det kraftigt stigende antal af dokumenterede og udokumenterede migranter i 1940’erne. Bracero-aftalen mellem USA og Mexico sætter for alvor skub i den anden store migrationsbølge fra syd til nord. Migrationen bliver en integreret del af de sociale og økonomiske systemer både i USA og Mexico. Arbejdsmarkedet i USA er afhængig af arbejdskraften, mens mexicanske familier og det mexicanske samfund er økonomisk afhængige af den økonomiske støtte fra emigrerede familiemedlemmer.","spans":[{"start":5,"end":14,"type":"em"},{"start":425,"end":432,"type":"em"},{"start":529,"end":546,"type":"em"}]},{"type":"paragraph","text":"\n(På baggrundsfotoet: Mexicanske arbejdere i kø får 1954 for at få adgang til et lovligt arbejde i USA. Kilde: Los Angeles Times photographic archive, UCLA Library - Los Angeles Times / the History Departments at The Ohio State University and Miami University.)","spans":[{"start":1,"end":261,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://www.youtube.com/watch?v=qZgFgNgNyT8","type":"video","version":"1.0","title":"Part 1 || Remember Bracero Project","author_name":"Bracero Tequila","author_url":"https://www.youtube.com/user/RememberBracero","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/qZgFgNgNyT8/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/qZgFgNgNyT8?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"I filmen her fortæller en søn til en af de mexicanske braceros. Filmen og historien i den er en af flere under \"The Remember Bracero Project\", der er skabt som en form for reklamefilm for Bracero Tequila.","spans":[]}],"x_axis":"10","y_axis":"15","layer":20,"rotation":null,"background":"Shadow","width":"570","height":"320","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/f4925c16e888e509d9ff0bb46fc6ecccea3e549c_bracero_workers.jpg","alt":null,"copyright":null,"dimensions":{"width":500,"height":320}}],"information":[{"type":"paragraph","text":"Mexicanske arbejdere under Bracero-programmet ved Horst ranch i Polk County, Oregon.\nKilde: Oregon State Univeristy Archives via Flickr","spans":[]}],"x_axis":"10","y_axis":"70","layer":30,"rotation":"-10","background":"Shadow","width":"500","height":"320","speed":1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/2fb254fac34256de01a984973a970e7c627af9d6_bracero-1954.jpg","medium":{"dimensions":{"width":1024,"height":808},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d88d9f5f562dd3ba5d6ab4c317d15842120d677f_bracero-1954.jpg"},"tall":{"dimensions":{"width":600,"height":474},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/fb3c4e01bbc729af8b62b980e35027b84dea66f1_bracero-1954.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Immigrationsreformer, udokumenteret migration og pesokrise ","spans":[]},{"type":"paragraph","text":"Da Bracero-programmet bliver nedlagt, bliver det begyndelsen på en ny migrationsæra, der er domineret af udokumenteret immigration fra Mexico til USA. Stigningen i den udokumenterede immigration fra Mexico til USA medfører en række store immigrationsreformer i USA og en tid med stor økonomisk usikkerhed i Mexico. ","spans":[]},{"type":"paragraph","text":"I 1965 bliver der implementeret en ny immigrationslovgivning i USA. Det er den første af en lang række reformer, der i de følgende årtier bliver implementeret med det overordnede formål at give USA større kontrol og mulighed for at begrænse immigrationen til landet. Den nye lovgivning giver fra starten store udfordringer for de amerikanske arbejdsgivere, da de nu har sværere ved at bringe legal arbejdskraft til USA. Migrationen til USA er i 1965 en integreret del af det strukturelle og økonomiske system. Det fortsatte behov for arbejdskraft i USA og mange mexicaneres fortsatte behov for at finde arbejde tvinger mexicanerne til at krydse grænsen uden visum. Hvor migrationen fra Mexico til USA tidligere var cirkulær, fordi mexicanske arbejdere rejste frem og tilbage mellem Mexico og USA, er migrationen nu præget af at være udokumenteret og mere permanent. De mexicanske migranter ønsker at blive boende i USA.","spans":[]},{"type":"paragraph","text":"Mexico træder ind i en periode med store økonomiske udfordringer. I starten af 1970’erne er den offentlige gæld i Mexico vokset, og inflationen eksploderer. De økonomiske udfordringer fører til en økonomisk krise og en devaluering af pesoen. Det betyder, at pesoens kursværdi falder og bliver mindre værd. Mellem 1984 og 1989 stiger antallet af fattige i Mexico fra 20 millioner til 26 millioner. Den ekstreme fattigdom er stadig mest udbredt i landområderne, hvor næsten halvdelen af husholdene lever i ekstrem fattigdom. Familierne bruger forskellige strategier for at overleve. Flere kvinder kommer ind på arbejdsmarkedet, og mange emigrerer til USA for at finde arbejde. ","spans":[]},{"type":"paragraph","text":"I takt med at den illegale immigration stiger, sker der også noget med den måde, man taler om migranterne på i USA. Uligheden i USA er stigende, og migranterne fra syd bliver i højere og højere grad opfattet og omtalt som en trussel mod nationen. Immigrationen bliver nu fremstillet som en ”krise” i amerikanske medier. I begyndelsen bliver der brugt maritime metaforer til at beskrive mexicanernes immigration til USA: ”rising tide” (stigende tidevand), ”tidal wave” (tidevandsbølge) og ”flooding” (oversvømmelse). Efter noget tid ændrer metaforerne karakter og bliver mere krigeriske og aggressive. Nu fremstilles mexicanerne som ”alien invaders” (fremmede angribere), der invaderer landet, og de amerikanske myndighederne må beskytte sig selv mod angreb. Det dramatiske medie-billede af en grænse under angreb inspirerer også politikere, forfattere og bureaukrater. Præsident Ronald Reagan udråber immigrationen som en trussel mod den nationale sikkerhed. I 1976 udgiver kommisæren for immigrationsmyndighederne artiklen ”Illegal Aliens: Time to Call a Halt!”. Billedet af migranterne som angribende, fjendske fremmede, der truer USA’s suverænitet, påvirker også den almindelige amerikaners holdning til migranterne, og USA oplever en stigende konservatisme i forhold til immigrationsspørgsmålet. ","spans":[{"start":421,"end":432,"type":"em"},{"start":456,"end":466,"type":"em"},{"start":489,"end":497,"type":"em"},{"start":633,"end":647,"type":"em"},{"start":1025,"end":1063,"type":"em"}]},{"type":"paragraph","text":"Efter pesokrisen i 1980’erne forsøger Mexico sig med forskellige økonomiske justeringer for at sikre stabilitet i landet. Mexico indgår bl.a. en frihandelsaftale med USA og Canada (NAFTA), hvilket åbner op for nye industrier, og mindsker landets afhængighed af oliereserverne. Formålet med NAFTA er at skabe flere og bedre jobs i Mexico og på den måde bremse den illegale emigration til USA. Aftalen har dog ikke helt de tilsigtede konsekvenser. Emigrationen falder nemlig ikke. Den stiger. I takt med at den udokumenterede immigration stiger i USA, kommer der større og større fokus på illegale migranter. I løbet af 1970’erne og 1980’erne skærper USA grænsekontrollen. Dog bliver det nemmere for migranter, der allerede bor i USA, at få arbejds- og opholdstilladelse. Det fører til, at over tre millioner mennesker ændrer status fra illegal til legal migrant i starten af 1990’erne. Det bliver desuden nemmere for migranter, der bor i USA, at få deres familier til landet. Hvor mange familier tidligere var afhængige af de midler manden kunne bringe hjem til familien, får kvinderne nu både mere indflydelse, et større netværk og mulighed for at arbejde. De amerikanske immigrationsreformer har ikke den ønskede effekt i forhold til at skærpe tilstrømningen af udokumenterede migranter, men den får stor betydning for de migranter, der kom illegalt til USA, som nu får mulighed for at få permanent opholdstilladelse og senere statsborgerskab. ","spans":[]},{"type":"paragraph","text":"(Baggrundsfotoet er taget af Charles O'Rear den 1. maj 1972 og viser en kø af landarbejdere, der er blevet fanget af grænsekontrollen ved Calexico efter at have indvandret ulovligt til USA). Kilde: The U.S. National Archives via Flickr)","spans":[{"start":0,"end":236,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":30,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"height":270,"width":480,"embed_url":"https://youtu.be/YsmgPp_nlok","type":"video","version":"1.0","title":"George H. W. Bush And Ronald Reagan Debate On Immigration In 1980 | TIME","author_name":"TIME","author_url":"https://www.youtube.com/user/TimeMagazine","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/YsmgPp_nlok/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/YsmgPp_nlok?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"Tv-klippet her fra år 1980 viser de forhenværende præsidenter George H. W. Bush og Ronald Reagan komme med deres tanker om den ulovlige immigration fra Mexico. Debatten, der er arrangeret af \"The League of Women\" bliver styret af den amerikanske journalist Howard K. Smith.","spans":[]}],"x_axis":"60","y_axis":"65","layer":20,"rotation":null,"background":"Shadow","width":"560","height":"315","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/9798ff66b8d530dbd5ff3b6a87ff4fc02a1dc7a7_andetskemamexico.png","alt":null,"copyright":null,"dimensions":{"width":534,"height":423}}],"information":[{"type":"paragraph","text":"Grafen herover er udarbejdet af organisationen MPI - Migration Policy Institute. I grafen refererer termen \"immigrant\" til mennesker, der bor i USA, der ikke er født amerikanske statsborgere. Skemaet viser antallet af immigranter der bor i USA, og den procentdel de udgør af den samlede amerikanske befolkning over tid.","spans":[]}],"x_axis":"65","y_axis":"20","layer":10,"rotation":"10","background":"Shadow","width":"534","height":"423","speed":-1}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/29ceb435f1aee0965362043589e55bbd97aace1f_illegal-immigrants-1972.jpg","tall":{"dimensions":{"width":600,"height":407},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/2107faeabd04fdd15e9caf42fd5b5a84e25a3c67_illegal-immigrants-1972.jpg"},"medium":{"dimensions":{"width":1024,"height":694},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/91170f67281cf77c7a7b1ced8d5b00821ecc07fc_illegal-immigrants-1972.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Grænsekontrol efter 9/11","spans":[]},{"type":"paragraph","text":"Nogle begivenheder har det med at brænde sig fast i hukommelsen. Spørger du en tilfældig person, der er over 25 år, kan de fleste huske præcis, hvor de var, og hvad de lavede d. 11. september 2001. Billedet af flyveren der smadrer ind i det ene tvillingetårn og af de skrækslagne mennesker, der kaster sig ud fra 20. etage, står for de fleste klart og levende. ","spans":[]},{"type":"paragraph","text":"Terrorangrebet var ikke blot en isoleret begivenhed, der rystede verden den 11. september men en begivenhed, der markerede begyndelsen på en tid med et helt anderledes fokus på sikkerhed, beskyttelse, terror og kontrol. ","spans":[]},{"type":"paragraph","text":"Allerede fra starten af 1990’erne har USA større fokus på at beskytte sine grænser. På grund af den økonomiske krise i Mexico og den stigende illegale migration, synes strømmen af mennesker over grænsen mod syd ude af kontrol. Det fører til en række politiske reformer, der skal begrænse flowet af udokumenterede migranter – dog uden den store succes. Efter terrorangrebet i 2001 bliver der gennemført en række nye love, der skal begrænse immigrationen til landet.  Her er tankegangen: En stigende immigration betyder en øget usikkerhed. En begrænset immigration betyder en øget sikkerhed. USA begynder at arbejde ud fra en ide om, at en tydelig grænsebevogtning vil afskrække de illegale immigranter ved grænsen. Derfor bliver der bygget hegn på de mest trafikerede dele af grænsen. Man sætter kameraer og overvågning op, og antallet af grænsevagter stiger fra 3000 i 1986 til over 20.000 i 2010. ","spans":[]},{"type":"paragraph","text":"Illegal indvandring bliver i højere og højere grad et politisk og samfundsmæssigt konfliktemne. Det er ikke blot fra den amerikanske regering, at nye grænseinitiativer blomstrer op. Lokale borgere på den amerikanske side af grænsen påtager sig et ansvar for grænsebevogtningen og patruljerer frivilligt langs grænsen. Den skærpede kontrol bremser dog ikke migranterne fra syd, men tvinger dem blot til at søge mod alternative grænseovergange i bjerge eller ørkener. Overfarten bliver derfor også farligere og mere udfordrende. Antallet af migranter der dør af tørst, nedkøling, drukning og overophedning i forsøget på at komme til USA stiger i 2010’erne. ","spans":[]},{"type":"paragraph","text":"(På baggrundsfotoet kan man se billedet på infrarød skærm, der viser et fastfrosset øjeblik i år 2014 i Rio Grande dalen, hvor en gruppe grænsevagter er ved at pågribe flere immigranter, der ellers var igang med at blive smuglet ind over den mexicansk-amerikanske grænse. Kilde: Georgia Army National Guard. Foto: Maj Will Cox)","spans":[{"start":0,"end":327,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/e6fbea25d5a64329686d3b30041219c6bb18a3d1_surveillance_kryds.png","alt":null,"copyright":null,"dimensions":{"width":1920,"height":1280}}],"information":[],"x_axis":"0","y_axis":"0","layer":5,"rotation":"-1","background":null,"width":"1920","height":"1280","speed":2}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/37278f4000917d372c350df0a6a1d9d608d00bc3_surveillance-kryds-fjernet.jpg","medium":{"dimensions":{"width":1024,"height":682},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/769904b9ab5355bacf7e1511bcca6d975dda2a63_surveillance-kryds-fjernet.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/523f6f279898c5286d5a700c5e1632e7379be6ab_surveillance-kryds-fjernet.jpg"}},"color_overlay":"#fdfbfb","color_opacity":"0.2","layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"”The war on drugs” ","spans":[]},{"type":"paragraph","text":"På helt filmisk og meget gammeldags facon brød Mexicos mest eftersøgte narkobaron ud af et højsikkerhedsfængsel en juli-nat i 2015. Bedst som myndighederne (og USA) troede, at de endelig havde fået lagt den berygtede El Chapo i lænker, flygtede han gennem en underjordisk tunnel, der førte ham fra brusekabinen i hans celle og ud i friheden.  ","spans":[]},{"type":"paragraph","text":"El Chapos flugt er på mange måder et billede på de udfordringer, Mexico har haft og stadig har med narkotika og narkorelateret kriminalitet. Siden 1990’erne har handel med og smugling af narko givet store udfordringer for det mexicanske samfund og for forholdet mellem USA og Mexico. Det, der i daglig tale kaldes ”narkokrigen” ,har stået på i Syd- og Mellemamerika siden 1970’erne - særligt i Colombia og Mexico. Det er en væbnet konflikt dels mellem forskellige narkobander og mellem banderne og de respektive landes myndigheder. I begyndelsen er det Colombia, der er centrum for narkotikahandlen, men efter at de colombianske myndigheder i 1990’erne får bedre kontrol med de bander, der dominerer markedet, overtager en række mexicanske karteller den primære handel i regionen efter årtusindeskiftet. ","spans":[]},{"type":"paragraph","text":"I over 70 år ser den mexicanske regering igennem fingre med narkohandlen. Da et nyt parti kommer til magten i år 2000, mister kartellerne det netværk af beskyttelse fra myndighederne, de har nydt godt af. Det fører til en opblusning af stridigheder mellem de forskellige kartelgrupperinger. Selvom den mexicanske præsident fra 2006 sætter en hårdere kurs mod narkokartellerne og lykkes med at fange nogle af bagmændene, er kartellernes magt ikke blevet mindre. Kartellerne er blot blevet splittet i mindre grupper, hvilket gør det endnu sværere for myndighederne at få styr på dem. Siden årtusindeskiftet har den organiserede narkotikahandel vokset sig større, hvilket har medført kidnapninger, mord, hvidvaskning, korruption og smugling. Antallet af mord i Mexico er steget fra 9000 om året i 2007 til over 27.000 i 2011. FN anslog at 90 % af narkotikasmuglingen til USA i 2007 gik gennem Mexico – en fordobling siden 1990. ","spans":[]},{"type":"paragraph","text":"USA gik allerede ind i ”The War on Drugs” i 1970’erne både i USA men også i Mellemamerika, men heller ikke deres indsatser har haft den ønskede effekt - hverken på karteller eller på de mennesker, der tager stofferne. De narkorelaterede uroligheder i Syd- og Mellemamerika har haft stor effekt på migrationsflowet, da mange har taget flugten væk fra de væbnede narkokonflikter. ","spans":[{"start":24,"end":40,"type":"em"}]},{"type":"paragraph","text":"(På baggrundsfotoet kan man se Joaquín \"El Chapo\" Guzmán da hen blev udleveret fra Mexico til retsforfølgelse i USA den 19. januar 2017. KILDE: Immigration and Customs Enforcement/Servicio de Inmigración y Control de Aduanas de los Estados Unidos - Ted Psahos)","spans":[{"start":0,"end":260,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1280","speed":null}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/2fd708fde1f8219e5df2532f6e2af5c0109a71ab_el_chapo_in_u.s._1commons.jpg","tall":{"dimensions":{"width":600,"height":370},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8e4a708ae59a361ffa20013ccee457e10beb143f_el_chapo_in_u.s._1commons.jpg"},"medium":{"dimensions":{"width":1024,"height":631},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/323b6ada65bae2d0ccfab8f5b4a3ad354ebd5f2d_el_chapo_in_u.s._1commons.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Nye komplekse migrationsmønstre","spans":[]},{"type":"paragraph","text":"Antallet af mexicanere der immigrerer til USA har været stigende de sidste fire årtier og toppede i 2007. Men siden 2009 er der flere mexicanere, der har forladt USA, end der har været mexicanere, der er immigreret til USA. Finanskrisen, der ramte USA i 2007-2009, en intensiveret grænsebevogtning og en forbedret økonomisk situation i Mexico har været nogle af grundende til denne udvikling. I 2015 oplevede man det laveste antal af grænsepågribelser i 50 år. Dog er antallet af udokumenterede, illegale migranter fra andre dele og Syd- og Mellemamerika steget. Et stigende antal mennesker fra The Northern Triangle (El Salvador, Guatemala og Honduras) søger humanitær beskyttelse i USA på grund af voldelige konflikter og narkorelaterede krige i deres hjemlande. Mennesker søger fra syd til nord i jagten på sikkerhed og fred. I dag ankommer de fleste migranter fra henholdsvis Indien og Kina. ","spans":[{"start":595,"end":617,"type":"em"}]},{"type":"paragraph","text":"Udover en større diversitet i flowet fra syd til nord, ser man nu en stigende migration fra nord mod syd. Mexico er derfor ikke længere hovedsageligt afsenderland men i højere og højere grad modtager- og transitland. Mellem 2000 og 2010 oplevede Mexico en fordobling af udenlandske indbyggere. Mange mennesker fra Mellemamerika rejser ligeledes gennem Mexico på vej mod USA og Canada, og Mexico står derfor også overfor nye udfordringer som modtagerland. Der tegner sig altså et nyt billede på den amerikansk-mexicanske grænse. Nye befolkningsgrupper, nye motiver, nye ruter, destinationer og oprindelseslande. De nye migrantionsmønstre giver nye udfordringer, og udfordringen bliver at lovgivningen og den politiske debat i højere grad skal tage højde for den nye kompleksitet i migrationen.","spans":[]},{"type":"paragraph","text":"Forholdet mellem Mexico og USA er stadig præget af ambivalens, men også en gensidig afhængighed. USA er afhængig af den arbejdskraft mexicanerne tilbyder, og den ser ikke ud til at blive mindre i fremtiden. Ligesom man i Danmark og mange andre lande står over for en udfordring, hvor der bliver flere ældre og samtidig færre i den arbejdsdygtige alder, er tendensen den samme i både Nord- og Mellemamerika. Flere eksperter spår, at der bliver mangel på arbejdskraft i Nord- og Mellemamerika, og derfor vil færre måske søge mod nord i jagten på arbejde. ","spans":[]},{"type":"paragraph","text":"(Baggrundsfotoet: Mexico 2012: Migranter fra Mellemamerika gør sig klar til at tage med et tog mod USA. Kilde: Shutterstock) J","spans":[{"start":0,"end":126,"type":"em"}]}],"information":[],"x_axis":"60","y_axis":"0","layer":10,"rotation":null,"background":"White","width":"576","height":"1000","speed":null},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://youtu.be/_8jg2U1hvf4","type":"video","version":"1.0","title":"Living on US-Mexico Border, Native Americans Face Daily Struggles","author_name":"ABC News","author_url":"https://www.youtube.com/user/ABCNews","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/_8jg2U1hvf4/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/_8jg2U1hvf4?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"Tv-indslag fra ABC News, juni 2013, der sætter spot på grænselandet mellem USA og Mexico og den øgede militarisering som følge af de hyppigere konfrontationer mellem grænsevagterne og narkosmuglere.","spans":[]}],"x_axis":"20","y_axis":"60","layer":30,"rotation":null,"background":"Shadow","width":"567","height":"317","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/0f3e613eb3cb342187030dbeaf99888038763d14_pewresearchcenter.jpg","alt":null,"copyright":null,"dimensions":{"width":576,"height":567}}],"information":[],"x_axis":"7","y_axis":"10","layer":20,"rotation":"-15","background":"Shadow","width":"576","height":"567","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1000},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7babdaf6d7aac708f2915873df839a4d5697c4ae_nyemigrationsstroemme.jpg","tall":{"dimensions":{"width":600,"height":399},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/869545818d87fa51676d6b424d078c14a161b07d_nyemigrationsstroemme.jpg"},"medium":{"dimensions":{"width":1024,"height":681},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f19b0a06a4eb3d5ffb5fc74fa461bd4c2f6613f8_nyemigrationsstroemme.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"”Make America Great Again”","spans":[]},{"type":"paragraph","text":"Præsident Trump vil bygge en mur. Den skal være stor. Den skal være smuk. Og mexicanerne skal betale for den. Direkte budskab, ingen dikkedarer. Sådan taler rigmanden Donald J. Trump til de amerikanske borgere under valgkampen i 2016. Han er kontroversiel, men han er til at forstå. Han taler til folket og direkte ind i den amerikanske nationalfølelse. Da Trump annoncerer, at han stiller op som præsidentkandidat for Republikanerne og skal kæmpe mod demokraternes Hillary Clinton om præsidentposten, er der ingen, der spår ham mange chancer – faktisk bliver han i lang tid ikke taget helt seriøst. Alle der har tvivlet på Trump bliver gjort til skamme. På trods af kritik og kontroversielle udtalelser, vinder Trump stor opbakning særligt blandt USA’s arbejderklasse. Under sloganet ”Make Amerika great again” kæmper Trumps bl.a. for toldbarrierer, lavere virksomhedsskat og for amerikanernes ret til at bære våben. Og hans holdninger vinder genklang i befolkningen. Derudover bliver Trump kendt for hans noget kontroversielle holdninger til indvandring. Han udtaler bl.a., at alle muslimer skal nægtes adgang til USA, og at mexicanerne bringer narko og voldtægtsforbrydere til landet. ","spans":[{"start":786,"end":810,"type":"em"}]},{"type":"paragraph","text":"Trump ender som bekendt med at vinde valget i november 2016. Han står nu over for at indfri sine valgløfter – herunder opførelsen af den mexicanske grænsemur. Mexico er dog ikke med på Trumps ide om at udbygge grænsemuren, og endnu mindre at de skal betale for den. Uenigheden handler ikke kun om grænsemuren, men hænger også sammen med det historisk ulige forhold mellem de to lande: USA som den magtfulde storebror, og Mexico som den splittede og fattige lillebror. Forholdet er de seneste år blevet mere ligeværdigt i kraft af politisk dialog og handelsaftaler, men Trumps retorik kaster Mexico tilbage i den underlegne position. Retorikken mellem Mexicos præsident Nieto og Trump bliver mere ophedet, mexicanerne demonstrerer mod muren og forholdet mellem de to lande når et nyt lavpunkt. ","spans":[]},{"type":"paragraph","text":"Nyhederne verden over fører nærmest time for time (og tweet for tweet) nye kapitler til historien om muren på grænsen mellem de to lande. Indtil videre er der kun bygget prototyper til den nye grænsemur, og Trump er udfordret med at finde pengene til at finansiere muren. Formålet med muren er relativt klart: Trump ønsker at begrænse og kontrollere flowet af ting og mennesker på tværs af grænsen. Men spørgsmålet er, om grænsebyggeriet overhovedet har den ønskede effekt. Det 1100 kilometer grænsehegn, der allerede findes på grænsen har ikke stoppet hverken den illegale indvandring eller ulovlig handel. Mange mexicanske migranter kommer i dag til USA på lovlig vis men vælger at blive i landet efter deres visum er udløbet og skifter status til illegale migranter. Den form for illegalt ophold vil en mur ikke kunne bremse. Derudover peger flere forskere og analytikere på, at omend en fysisk grænsemur kan agere som et stærkt symbol og føre en følelse af tryghed med sig (for folk på den amerikanske side af muren),  er det dog sjældent, at en mur løser de bagvedliggende udfordringer, der medfører at mennesker vælger at rejse fra deres hjemland og søge lykken i et andet land. ","spans":[]},{"type":"paragraph","text":"(Baggrundsbillede: Gage Skidmore via Flickr.)","spans":[{"start":1,"end":45,"type":"em"}]}],"information":[],"x_axis":"10","y_axis":"0","layer":11,"rotation":null,"background":"White","width":"576","height":"1280","speed":null},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/a706421926baec4c60201e1b89e74523cf6937d4_donald_trump_visits_san_diego_border_wall_prototypes.png","alt":null,"copyright":null,"dimensions":{"width":650,"height":639}}],"information":[{"type":"paragraph","text":"Dette foto stammer fra Donald Trumps egen Instagram-profil den 14. marts 2018, hvor det blev publiceret med teksten: \"We will #BuildTheWall. #USA #MAGA #AmericaFirst\". På fotografiet kan man se præsident Donald Trump ved grænsen til Mexico i Otay Mesa i Californien.","spans":[]}],"x_axis":"57","y_axis":"5","layer":10,"rotation":"5","background":null,"width":"650","height":"639","speed":-1},{"animation":{"link_type":"Any"},"content":[{"type":"embed","oembed":{"width":480,"height":270,"embed_url":"https://youtu.be/k7lEt_Yr6-w","type":"video","version":"1.0","title":"Trump speaks on immigration, separating parents and children at border","author_name":"CBC News","author_url":"https://www.youtube.com/user/cbcnews","provider_name":"YouTube","provider_url":"https://www.youtube.com/","cache_age":null,"thumbnail_url":"https://i.ytimg.com/vi/k7lEt_Yr6-w/hqdefault.jpg","thumbnail_width":480,"thumbnail_height":360,"html":"<iframe width=\"480\" height=\"270\" src=\"https://www.youtube.com/embed/k7lEt_Yr6-w?feature=oembed\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"}}],"information":[{"type":"paragraph","text":"CBC News, 18. juni 2018: Facing a rising tide of outrage from Democrats and some Republicans over the forced separation of migrant children and parents at the U.S.-Mexico border, U.S. President Donald Trump dug in Monday, during a speech at the National Space Council meeting.","spans":[]}],"x_axis":"60","y_axis":"65","layer":20,"rotation":null,"background":"Shadow","width":"560","height":"315","speed":0}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1280},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/326d68f5e697914a5f8ed7852861059379aed590_25324820593_655a503813_k.jpg","medium":{"dimensions":{"width":1024,"height":683},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/5bae4bf87057183808fa1cb8a5305741ab8dfde9_25324820593_655a503813_k.jpg"},"tall":{"dimensions":{"width":600,"height":400},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b770066245e0bd197d30dce93d5421753aa84bbd_25324820593_655a503813_k.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}},{"slice_type":"section","slice_label":null,"items":[{"animation":{"link_type":"Any"},"content":[{"type":"heading2","text":"Helenas historie","spans":[]},{"type":"paragraph","text":"Plask. Marías fødder rammer småvaklende vandet, mens hun holder godt fast i - eller i hvert fald bliver holdt fast af - sin mors hænder. Helenas hænder. Solen står højt på himlen denne sommerdag, og luften flimrer på stranden ud for byen Corpus Christi i Texas,  hvor floden Nueces River løber ud i den Mexicanske Golf. Somrene er lange og varme og vintrene korte og milde her, hvor de bor nu, Helena, Juan og deres lille datter María.  Helena og Juan har flere gange været ved at opgive det hele og rejse tilbage til Mexico og deres familier igen. Men det hårde og dårligt betalte slid - som privat rengøringshjælp rundt omkring i byen for Helenas vedkommende og som byggearbejder for Juans - den evige frygt for at blive opdaget af myndighederne og det store og rungende savn efter familien derhjemme bliver alligevel ved med at blive trængt tilbage, når de ser på deres datter. Hun er grunden til, at de holder ud. Modsat sine forældre og mange af de børn, som Helena og Juans mexicanske venner her i Texas har, er María nemlig amerikansk statsborger. Det blev hun takket været den såkaldte 14. ændring til den amerikanske forfatning helt automatisk, da hun blev født på amerikansk jord. Og for hende er de villige til at kæmpe videre. Kæmpe for at sikre hende alle de muligheder, de ikke selv havde. Og kæmpe for måske selv en dag at kunne få lovligt ophold her på den forjættede nordlige side af den amerikansk-mexicanske grænse. ","spans":[{"start":1015,"end":1017,"type":"em"}]},{"type":"paragraph","text":"Helenas historie er fiktiv, men er inspireret af flere forskellige biografiske fortællinger fra mexicanske indvandrere i USA - blandt andet fra siderne iamamigrant.org og myimmigrantstory.com. ","spans":[{"start":0,"end":193,"type":"em"}]},{"type":"paragraph","text":"(Baggrundsfotografiet: Philippe Murray via Unsplash. Find de samlede kilder til denne case HER.)","spans":[{"start":91,"end":94,"type":"hyperlink","data":{"link_type":"Media","name":"samledekilder_cases.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F29ed7b98-6b74-4cce-a782-5cef41ce9a74_samledekilder_cases.pdf","size":"6488599"}}]}],"information":[],"x_axis":"60","y_axis":"0","layer":20,"rotation":null,"background":"White","width":"576","height":"1272","speed":0},{"animation":{"link_type":"Any"},"content":[{"type":"image","url":"https://over-muren.cdn.prismic.io/over-muren/643d45b5992283cb1560d00a80368cc64ee674f4_grafikovermexico.png","alt":null,"copyright":null,"dimensions":{"width":639,"height":519}}],"information":[{"type":"paragraph","text":"Grafen her er udarbejdet af den organisationen MPI - Migration Policy Institute. I grafen defineres immigranter som mennesker, der bor i USA, som ikke er født amerikanske statsborgere. MPI indleder grafen med følgende tekst: \"Siden 1980 har immigranter fra Mexico været den største gruppe af indvandrere med samme oprindelige nationalitet i USA. Grafen her viser væksten af populationen siden 1970 og den efterfølgende tilbagegang, omend i lav grad, efter 2007-09-recessionen.\"","spans":[]}],"x_axis":"4","y_axis":"40","layer":10,"rotation":"-11","background":"Shadow","width":"639","height":"519","speed":-3}],"primary":{"id":null,"background_image":{"dimensions":{"width":1920,"height":1272},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/9c9c7c99dfb3504a9f164d0637256330edb7b568_helena_last-chapter.jpg","medium":{"dimensions":{"width":1024,"height":678},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/53703c7b5e07248be472da304492672dcdec3ee7_helena_last-chapter.jpg"},"tall":{"dimensions":{"width":600,"height":398},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e884e349c33b9cb5e050784bb4bc286518ef3ee3_helena_last-chapter.jpg"}},"color_overlay":null,"color_opacity":null,"layer":null}}],"meta_title":"USA og Mexico","meta_description":"I denne case, som er en del af undervisningsmaterialet OVER MUREN, kan du blive klogere på historien bag den befæstede grænse mellem USA og Mexico og møde Helena - en af de mange migranter, der har krydset den.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/9ab3f358ebb39db00edcf6b587e34af9220388d0_border_usa_mexico.tijuana.jpg"},"hide_for_google":"false","navigation":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false},"home_link":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false}}}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WvLD9CgAAIL-YiSX","type":"index","uid":"index","url":"/","published":"2019-01-29T12:59:03+0000","lang":"da-dk","meta_title":"OVER MUREN","meta_description":"OVER MUREN er et webbaseret, gratis tilgængeligt undervisningsmateriale målrettet gymnasiet, særligt fagene historie og samfundsfag. Det består af en film, fem levende case-beskrivelser og fem tematiske oplæg til refleksion over temaerne grænser og migration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8a5a3ee9d9f2436c973d9e3c591e7b1b5a6f9533_omom.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"Over Muren - index","spans":[]}],"call_to_action":"Se film","url":"/","info":[{"type":"paragraph","text":"","spans":[]}],"video_url":"https://player.vimeo.com/video/289265904","additional_content":[{"type":"paragraph","text":"Dette website opleves bedst i en moderne browser","spans":[]}],"work_sheet":{"link_type":"Media","name":"arbejdsark til film.pdf","kind":"document","url":"https://over-muren.cdn.prismic.io/over-muren%2F0acb03da-ec05-41f5-aa9f-7edf634a870f_arbejdsark+til+film.pdf","size":"6733076"},"work_sheet_link_text":"Download arbejdsark","meta_title":"OVER MUREN","meta_description":"OVER MUREN er et webbaseret, gratis tilgængeligt undervisningsmateriale målrettet gymnasiet, særligt fagene historie og samfundsfag. Det består af en film, fem levende case-beskrivelser og fem tematiske oplæg til refleksion over temaerne grænser og migration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8a5a3ee9d9f2436c973d9e3c591e7b1b5a6f9533_omom.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}}}}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WvLZpigAALoFYoRM","type":"navigation","uid":"cases","url":"/cases","published":"2019-01-29T13:09:13+0000","lang":"da-dk","meta_title":"Cases","meta_description":"På undervisningsmaterialet OVER MURENs case-sider udforsker vi fem af verdens grænseområder.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e80f517e1ad3b3745cd50244eaf8edf40f773b27_cases_nav.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"Navigation - cases","spans":[]}],"url":"/cases","navigation_items":[{"page":{"id":"WxfvViQAACsxGo0M","type":"case","tags":["Case"],"slug":"eu-og-middelhavet","lang":"da-dk","uid":"eu-og-middelhavet","link_type":"Document","isBroken":false},"navigation_title":"EU og Middelhavet","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f8a9c410d074d599517ddb56196f18fbc163e680_italienkyst.jpg"}},{"page":{"id":"WzIEZiwAALZhZA0K","type":"case","tags":["Case"],"slug":"usa-og-mexico","lang":"da-dk","uid":"usa-og-mexico","link_type":"Document","isBroken":false},"navigation_title":"USA og Mexico","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/6e4c2bc37e090bf80813770404b7af9b6ff11f97_border_usa_mexico.tijuana.jpg"}},{"page":{"id":"WyvhsB8AALmi3lkq","type":"case","tags":["Case"],"slug":"australien-og-havene-omkring","lang":"da-dk","uid":"australien-havene","link_type":"Document","isBroken":false},"navigation_title":"Australien og havene omkring","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/8422ea88deb4b967922834abdeee1d1cae3ef1f0_stillehavetvendt.jpg"}},{"page":{"id":"W1sWPh4AAEEk9kl4","type":"case","tags":["Case"],"slug":"sydafrika-og-zimbabwe","lang":"da-dk","uid":"sydafrika-og-zimbabwe","link_type":"Document","isBroken":false},"navigation_title":"Sydafrika og Zimbabwe","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/159ac518e219d1bbcd3aa76d6e50a13a5adcd739_beitbridge.jpg"}},{"page":{"id":"W1sWyB4AAAgl9kvg","type":"case","tags":["Case"],"slug":"israel-og-pal%C3%A6stina","lang":"da-dk","uid":"israel-og-palaestina","link_type":"Document","isBroken":false},"navigation_title":"Israel og Palæstina","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/dbb691767f260fb0b6750c3f4d1619e20fadee85_israelwall.jpg"}},{"page":{"id":"WvLJgSgAAIL-Yj0f","type":"navigation","tags":["Navigation"],"slug":"navigation---temaer","lang":"da-dk","uid":"temaer","link_type":"Document","isBroken":false},"navigation_title":"Temaer","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/9cafc8967c1cfa5b0214aa5779e5d3092133fe46_temaer_nav.jpg"}}],"meta_title":"Cases","meta_description":"På undervisningsmaterialet OVER MURENs case-sider udforsker vi fem af verdens grænseområder.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/e80f517e1ad3b3745cd50244eaf8edf40f773b27_cases_nav.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}}}}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = {"pageid":"WvLJgSgAAIL-Yj0f","type":"navigation","uid":"temaer","url":"/temaer","published":"2019-01-29T13:07:07+0000","lang":"da-dk","meta_title":"Temaer","meta_description":"På undervisningsmaterialet OVER MURENs temasider anlægger vi fem spændende vinkler på mure, grænser og migration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d024b84ce8bf77dbc522c7f3577c8104dd8c2955_temaer_nav.jpg"},"alternate_languages":[],"data":{"title":[{"type":"heading6","text":"Navigation - temaer","spans":[]}],"url":"/temaer","navigation_items":[{"page":{"id":"W1cEjh4AAOT15D8Y","type":"article","tags":["Tema"],"slug":"mure-i-historien","lang":"da-dk","uid":"mure-i-historien","link_type":"Document","isBroken":false},"navigation_title":"Mure i historien","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/7d64b6abd46172db3b92fde7c9e0cc1cb536eee6_robert-nyman-442988.jpg"}},{"page":{"id":"W1clXx4AAPIE5NFb","type":"article","tags":["Tema"],"slug":"mure-og-magt","lang":"da-dk","uid":"mure-og-magt","link_type":"Document","isBroken":false},"navigation_title":"Mure og magt","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c2b8d14c7ca11221c539d9d94f45511675d9cc1e_753621.jpg"}},{"page":{"id":"W1bhBx4AAHz146Ap","type":"article","tags":["Tema"],"slug":"mure-og-milj%C3%B8","lang":"da-dk","uid":"mure-og-miljo","link_type":"Document","isBroken":false},"navigation_title":"Mure og miljø","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/dab7ec46000139ea117a11b3e112e322b6fa0ffd_earthrise.jpg"}},{"page":{"id":"WyvFux8AAIic3dzK","type":"article","tags":["Tema"],"slug":"mure-og-gadekunst","lang":"da-dk","uid":"mure-og-gadekunst","link_type":"Document","isBroken":false},"navigation_title":"Mure og gadekunst","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/f478c9e2e9f8dd3993dc50de0f1f6dd76c0fe089_fredsdue.jpg"}},{"page":{"id":"WvAj9CgAAB5zVqkS","type":"article","tags":["Tema"],"slug":"mentale-mure","lang":"da-dk","uid":"mentale-mure","link_type":"Document","isBroken":false},"navigation_title":"Mentale mure","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/fa6d3743fe1228126ba51d08de5fb346b6d1b668_mentalemure_header.jpg"}},{"page":{"id":"WvLZpigAALoFYoRM","type":"navigation","tags":["Navigation"],"slug":"navigation---cases","lang":"da-dk","uid":"cases","link_type":"Document","isBroken":false},"navigation_title":"Cases","navigation_image":{"dimensions":{"width":368,"height":230},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/c8bb16cdcbc4b2ed07209d27e3a81a4143dc5078_cases_nav.jpg"}}],"meta_title":"Temaer","meta_description":"På undervisningsmaterialet OVER MURENs temasider anlægger vi fem spændende vinkler på mure, grænser og migration.","meta_image":{"dimensions":{"width":1200,"height":630},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/d024b84ce8bf77dbc522c7f3577c8104dd8c2955_temaer_nav.jpg"},"hide_for_google":"false","background_image":{"dimensions":{"width":1920,"height":1080},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/947391e8c625bfc67d18dcbbdcb48ef9378beabb_michal-grosicki-235026.jpg","tall":{"dimensions":{"width":600,"height":900},"alt":null,"copyright":null,"url":"https://over-muren.cdn.prismic.io/over-muren/b523b6331996f91a6c8ca911600501568b4375b7_michal-grosicki-235026.jpg"}}}}

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(160);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(105);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(98);
	var invariant = __webpack_require__(99);
	var ReactPropTypesSecret = __webpack_require__(450);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(484);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(289);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(452);
	
	var _HelmetConstants = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(113);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(115);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(172);
	
	var _warning = __webpack_require__(116);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(170);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(466);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(460);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(461);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(462);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(463);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(120);
	
	var _wrapMapToProps = __webpack_require__(171);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(171);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(173);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(464);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(116);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(100);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(117);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(154);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(117);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(477);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(175);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(174);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(478);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(479);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(480);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(481);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(119);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(483);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(155);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(118);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(32);
	
	var _Router = __webpack_require__(118);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(119);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(349)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(156);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(176);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(298);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(493);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(177);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(178);
	
	var _isPlainObject = __webpack_require__(107);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(179);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 488 */,
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(292);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(293);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(294);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(295);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(296);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget,
	            xTarget = _windowScrollTarget[0],
	            yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore else: Travis browsers all support this */
	    if ('scrollRestoration' in window.history &&
	    // Unfortunately, Safari on iOS freezes for 2-6s after the user swipes to
	    // navigate through history with scrollRestoration being 'manual', so we
	    // need to detect this browser and exclude it from the following code
	    // until this bug is fixed by Apple.
	    !(0, _utils.isMobileSafari)()) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      try {
	        window.history.scrollRestoration = 'manual';
	      } catch (e) {
	        this._oldScrollRestoration = null;
	      }
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	      _this._saveWindowPositionHandle = null;
	
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	        _requestAnimationFrame2.default.cancel(scrollElement.savePositionHandle);
	        scrollElement.savePositionHandle = null;
	
	        // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame2.default)(saveElementPosition);
	        }
	      }
	    };
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on2.default)(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var _scrollElements$key = this._scrollElements[key],
	        element = _scrollElements$key.element,
	        onScroll = _scrollElements$key.onScroll,
	        savePositionHandle = _scrollElements$key.savePositionHandle;
	
	
	    (0, _off2.default)(element, 'scroll', onScroll);
	    _requestAnimationFrame2.default.cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      try {
	        window.history.scrollRestoration = this._oldScrollRestoration;
	      } catch (e) {
	        /* silence */
	      }
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	    this._checkWindowScrollHandle = null;
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key2 = this._scrollElements[key],
	        element = _scrollElements$key2.element,
	        shouldUpdateScroll = _scrollElements$key2.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	    return [0, 0];
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  ScrollBehavior.prototype._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  ScrollBehavior.prototype.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      }
	
	      // Fallback to scrolling to top when target fragment doesn't exist.
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	
	    (0, _scrollLeft2.default)(element, left);
	    (0, _scrollTop2.default)(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobileSafari = isMobileSafari;
	function isMobileSafari() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent)
	  );
	}

/***/ }),
/* 492 */,
/* 493 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(495);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(121)(module)))

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 496 */,
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// commons-25db16ebe009c3c5fc2d.js